{
	"backoffice": {
		"billType": {
			"actions": "Opciones",
			"addCategory": "Agregar categoría de cuenta",
			"addType": "Agregar tipo de cuenta",
			"categories": "Categorías",
			"categoryName": "Nombre de la categoría de cuenta",
			"createCategory": "Crear categoría de cuenta",
			"createType": "Crear tipo de cuenta",
			"createTypeIn": "Crear tipo de cuenta en {{categoryName}}",
			"editCategory": "Editar categoría de cuenta",
			"editType": "Editar tipo de cuenta",
			"editTypeIn": "Editar tipo de cuenta en {{categoryName}}",
			"name": "Nombre",
			"typeName": "Nombre del tipo de cuenta"
		},
		"costCenter": {
			"action": "Opciones",
			"addCostCenter": "Agregar centro de costo",
			"costCenter": "Centros de coste",
			"editCostCenter": "Editar centro de coste",
			"name": "Nombre",
			"namePlaceholder": "Nombre del centro de coste"
		},
		"reports": {
			"graphs": {
				"balance": "Saldo disponible",
				"category": "Categoría",
				"costCenterCaps": "CENTRO DE COSTE",
				"date": "Fecha",
				"dateCaps": "FECHA",
				"description": "Descripción",
				"descriptionCaps": "DESCRIPCIÓN",
				"expense": "Gasto",
				"expenseCaps": "GASTO",
				"expenses": "Gastos",
				"finalBalance": "Saldo final",
				"finalBalanceExtract": "Saldo total",
				"period": "Periodo",
				"periodBalance": "Saldo durante periodo",
				"periodBalanceExtract": "Saldo durante período",
				"previousBalance": "Saldo anterior",
				"previousBalanceExtract": "Saldo anterior",
				"profit": "Beneficio",
				"receipt": "Recibo",
				"receiptCaps": "RECIBO",
				"receipts": "Recibo",
				"result": "Ingresos antes de impuestos",
				"supplierCaps": "PROVEEDOR",
				"tax": "Impuesto",
				"totalCaps": "TOTAL",
				"totalExpenses": "Gastos totales",
				"totalPaid": "Total pagado",
				"totalReceipts": "Total de ingresos",
				"totalReceived": "Total recibido",
				"type": "Tipo",
				"typeCaps": "TIPO",
				"until": "hasta",
				"value": "Valor",
				"valueCaps": "VALOR"
			},
			"noComponent": "Espera, pronto estará disponible",
			"reportNames": {
				"cashFlow": {
					"demonstrative": "Demonstrative",
					"expensses": "Gastos/Recibos",
					"extract": "Extract",
					"history": "Historial"
				},
				"expense": {
					"perAnything": "Gastos pagados a...",
					"perCategory": "Gastos por categoría",
					"perCostCenter": "Gastos por centro de coste",
					"perDay": "Gasto por día",
					"perDescripion": "Gasto por descripción",
					"perHistory": "Historial de gastos",
					"perType": "Gastos por tipo"
				},
				"receipts": {
					"perAnything": "Recibos recibidos de...",
					"perCategory": "Recibos por categoría",
					"perCostCenter": "Recibos por centro de costo",
					"perDay": "Recibos por día",
					"perDescripion": "Recibos por descripción",
					"perHistory": "Historial de recibos",
					"perType": "Recibos por tipo"
				}
			}
		},
		"cashFlow": {
			"pageTitle": "Flujo de efectivo",
			"pageParagraph": "Esta herramienta permite calcular el saldo disponible en el momento y proyectar el futuro, para que siempre haya capital de trabajo disponible tanto para cubrir los costos operativos de la empresa como para invertir en mejoras.",
			"tooltipMessage": "Las líneas de categorías del nivel {{level}} muestran la suma de todos los niveles agrupados dentro de ella.",
			"fileName": "flujo-de-efectivo",
			"topActions": {
				"lblAccountName": "Buscar por Cuenta",
				"plhAccountName": "Ingrese el nombre de la cuenta",
				"lblDate": "Filtrar por vencimiento",
				"btnPdf": "Exportar a PDF",
				"btnExcel": "Exportar a Excel"
			},
			"totalizers": {
				"income": "Total de Receitas",
				"costs": "Total de Custos",
				"expenses": "Total de Despesas",
				"balance": "Total de Receitas, Custos e Despesas"
			},
			"rowTotal": "Saldo del Período",
			"rowHead": "Saldo inicial",
			"rowTail": "Saldo del día",
			"viewPerDay": "Visualizar por día",
			"viewPerMonth": "Visualizar por mes",
			"columns": {
				"income": "Ingresos",
				"costs": "Costos",
				"expenses": "Gastos",
				"level": "Nivel",
				"name": "Nombre",
				"day": "Día",
				"month": "Mes"
			}
		},
		"viewLevel": "Ver nivel {{level}}",
		"stockTransferHistory": {
			"titlePage": "Transferencias de stock",
			"tabLabel": "Transferencias",
			"description": "Este informe permite seguir los movimientos entre existencias proporcionando una visibilidad adecuada de las transferencias para almacenistas y gestores.",
			"actionButtons": {
				"print": "Imprimir",
				"downloadExcel": "Descargar en Excel"
			},
			"filterToPeriod": "Filtrar por período",
			"column": {
				"dateTransfer": "Fecha de transferencia",
				"employee": "Empleado",
				"outgoingStock": "Stock de salida",
				"incomingStock": "Stock de entrada",
				"inputAndProduct": "Insumo/Producto",
				"amount": "Cantidad"
			},
			"employeePlaceholder": "Empleado",
			"storagePlaceholder": "Stock",
			"searchBy": "Buscar por"
		}
	},
	"event": {
		"barReports": {
			"bar": "Bar {{name}}",
			"tabs": {
				"chipsBurned": {
					"byEmployee": {
						"label": "Chips quemados por empleado",
						"sheetFileName": "chips-burned-employee"
					},
					"columns": {
						"count": "Importe",
						"discount": "Descuentos",
						"fracionalCount": {
							"grams": "Gramos",
							"kg": "Kilos",
							"label": "Importe en fracciones",
							"lt": "Litros"
						},
						"name": "Nombre",
						"subtotal": "Subtotal",
						"totalValue": "Total",
						"unitaryCount": "Cantidad unitaria",
						"unitaryValue": "Valor unitario",
						"type": "Tipo"
					},
					"label": "Total chips quemadas",
					"loading": "Generando spreadsheet",
					"mountableModal": {
						"count": "Importe",
						"name": "Nombre",
						"section": "Mountable session"
					},
					"mountables": {
						"category": "Categoría",
						"count": "Importe",
						"fiscalCode": "SKU",
						"label": "Mountables",
						"name": "Mountable item",
						"product": "Producto",
						"section": "Mountable step"
					},
					"sheetFileName": "total-chips-quemadas",
					"since": "Desde",
					"total": "TOTAL",
					"totalItem": "Total",
					"until": "Hasta"
				},
				"consolidatedBarReport": {
					"tab": "Facturación por bar",
					"filter": "Filtrar por tipo de transacción",
					"label": "Financiero por barra",
					"sheet": {
						"title": "Facturación por bar",
						"fileName": "facturacion-por-bar",
						"name": "Producto",
						"quantity": "Cantidad",
						"totalDiscount": "Descuento total",
						"totalValue": "Valor total",
						"value": "Valor neto",
						"totalTax": "Impuesto total",
						"vat": {
							"totalValue": "Valor con IVA",
							"valueWithDiscount": "Valor con descuento",
							"value": "Valor sin IVA",
							"totalTax": "Monto del IVA",
							"totalTaxPercentage": "Porcentaje total del IVA (%)"
						}
					},
					"total": "Total",
					"paymentMethodReport": {
						"titleBar": "Método de pago en el bar",
						"titleEmployee": "Método de pago del empleado",
						"info": "Los valores de este informe pueden haber sido estimados y, por lo tanto, puede haber pequeñas diferencias",
						"sheet": {
							"titleBar": "Método de pago en el bar",
							"filenameBar": "metodo-pago-bar",
							"titleEmployee": "Método de pago del empleado",
							"filenameEmployee": "metodo-pago-empleado"
						},
						"columns": {
							"App": "Aplicación",
							"Cash": "Efectivo",
							"DebitCard": "Tarjeta de débito",
							"CreditCard": "Tarjeta de crédito",
							"Voucher": "Vale",
							"ZigPosDebit": "Zig Débito",
							"ZigPosCredit": "Zig Crédito",
							"PostEvent": "Post Evento",
							"Dashboard": "Tablero",
							"Anticipated": "Anticipado",
							"DeliveryOnline": "Entrega en línea",
							"Consumption": "Consumo",
							"Ame": "Ame",
							"Rappi": "Rappi",
							"Uber": "Uber",
							"Ifood": "Ifood",
							"Bonus": "Bono",
							"Pix": "Pix",
							"Opened": "Abierto",
							"Other": "Otro",
							"ZigPosCreditInInstallments": "Zig Crédito en Cuotas",
							"IntegratedFoodVoucher": "Vale de Alimentación",
							"name": "Nombre",
							"total": "Total",
							"MBWay": "MBWay",
							"Cashless": "Cashless"
						}
					}
				},
				"deliveredProductsByBar": {
					"label": "Productos entregados por barra"
				},
				"soldProductReport": {
					"filter": "Filtrar por tipo de transacción",
					"label": "Producción general de productos",
					"sheet": {
						"count": "Cantidad",
						"fileName": "product_general_output_report",
						"fiscalCode": "SKU",
						"name": "Producto",
						"title": "Producción general de productos"
					}
				},
				"soldProducts": {
					"columns": {
						"category": "Categoría",
						"count": "Cantidad",
						"discount": "Descuento",
						"fiscalCode": "SKU",
						"variable": "Variable",
						"devolution": "devolución",
						"variableTooltip": "El valor unitario de los productos con valor variable es el promedio de los valores vendidos",
						"fracionalCount": {
							"grams": "gramos",
							"kg": "Kilos",
							"label": "Cantidad en fracciones",
							"lt": "Litros"
						},
						"grossTotalValue": "Total bruto",
						"mountable": "Mountable",
						"name": "Nombre",
						"net_sales": "Ventas netas",
						"subtotal": "Subtotal",
						"tax_money": "Impuesto {{currencySymbol}}",
						"tax_percentage": "Impuesto %",
						"totalValue": "Valor total",
						"unitaryCount": "Cantidad unitaria",
						"unitaryValue": "Valor unitario",
						"operationType": "Operación",
						"type": "Tipo"
					},
					"downloadAllSales": "Descargar todas las ventas",
					"filter": {
						"all": "Todo",
						"balcony": "Balcony",
						"cashless": "Cashless",
						"dashboard": "Dashboard",
						"delivery": "Delivery",
						"ficha": "Ficha",
						"grabngo": "Grab n Go",
						"label": "Filtrar por tipo de transacción",
						"onlineBill": "Factura online",
						"placeholder": "Seleccione un tipo de transacción",
						"zigQrCode": "Zig QR Code"
					},
					"label": "Total de productos vendidos",
					"loading": "Generación de hojas de cálculo",
					"mountableModal": {
						"count": "Cantidad",
						"name": "Nombre",
						"section": "Mountable Session"
					},
					"mountables": {
						"category": "Categoría de producto",
						"count": "Cantidad",
						"fiscalCode": "SKU",
						"label": "Mountable",
						"name": "Mountable Item",
						"product": "Producto",
						"section": "Mountable Step"
					},
					"selectDate": "Seleccione la fecha",
					"selectTime": "Seleccione la hora",
					"selectTimeTooltip": "Seleccione la fecha antes de seleccionar la hora",
					"sheetFileName": "total-products-sold",
					"since": "Desde",
					"total": "TOTAL",
					"totalItem": "Total",
					"until": "Hasta"
				},
				"waiterReport": {
					"filter": "Filtrar por tipo de transacción",
					"label": "Clasificación de ventas"
				},
				"reprintReport": {
					"title": "Reimpresión de tarjetas",
					"filename": "reimpresion-de-tarjetas",
					"byTransaction": "Por transacción",
					"variable": "Variable",
					"variableTooltip": "El valor unitario de estos productos es el valor variable que es el artículo más valioso que se vende",
					"byProduct": "Por producto",
					"table": {
						"authorizedBy": "Empleado autorizante",
						"date": "Fecha/hora",
						"employee": "Empleado registrado",
						"transactionId": "ID de transacción",
						"device": "Máquina",
						"product": "Producto",
						"total": "Total",
						"reprintTotal": "Total en reimpresiones",
						"reprintProductTotal": "Total de productos reimpresos",
						"authorizedByPassword": "Autorizado por contraseña",
						"quantity": "Cantidad",
						"productName": "Nombre del producto",
						"unitValue": "Valor unitario",
						"value": "Valor"
					},
					"tooltipTitle": "Este informe solo traerá datos si el POS tiene la versión 5.0.190 o superior."
				},
				"productReturnsReport": {
					"title": "Devolución de productos",
					"product": "Producto",
					"quantity": "CANT",
					"returnValue": "Valor de devolución",
					"totalValue": "Total",
					"noRecords": "Sin registros",
					"noReturnedProducts": "No hubo devoluciones en este período",
					"noReturnsThisEvent": "No hubo devoluciones en este evento",
					"productReturnReport": "Informe de devolución de productos",
					"totalReturnedProducts": "Total de productos devueltos",
					"productsReturnedByEmployee": "Productos devueltos por el personal",
					"employee": "Empleado",
					"summary": "Resumen"
				}
			},
			"undefinedBar": "Barra sin definir"
		},
		"booking": {
			"reserve": {
				"bookDetail": {
					"confirmed": "{{count}} confirmado",
					"copyModal": {
						"copy": "Copiar",
						"defaultReserveName": "Copia de {{name}}",
						"errors": {
							"inputs": "Los campos no se rellenaron correctamente.",
							"length": "El nombre del paquete no ha alcanzado el número mínimo de caracteres.",
							"name": "El nombre del paquete es el mismo que el nombre original."
						},
						"placeholder": "Nombre copiado del paquete ",
						"text": "¿Desea crear una copia de seguridad?",
						"title": "Crear copia del paquete"
					},
					"delete": "¿Está seguro de que desea eliminar este producto?",
					"guests": "Invitados",
					"guestsCount": "{{count}} invitados",
					"invoices": "Facturas generadas",
					"issueInvoice": "Emitir factura",
					"modal": {
						"add": "Agregar grupo de impuestos",
						"addDiscount": "Agregar descuentos a la factura",
						"basket": "CARRITO",
						"chooseOptions": "Elige una de las opciones",
						"cnpj": "CNPJ",
						"completeValue": "Complete el valor del paquete",
						"cpf": "DNI",
						"discount": "Descuentos",
						"errors": {
							"inputs": "Los campos no se rellenaron correctamente",
							"value": "Incluir algún producto con valor para usar esta funcionalidad"
						},
						"fiscalGroup": "Grupo Fiscal",
						"fiscalProfile": "Perfil fiscal",
						"inputMultiplePaymentsManual": {
							"add": "Añadir pago",
							"label": "Método de pago",
							"placeholder": "Escoger",
							"value": "Valor"
						},
						"invoiceAlert": "Las facturas con un valor superior a € 1.000 se dividirán.",
						"invoiceValue": "Valor de la factura",
						"issueInvoice": "Emisión de nota",
						"ncm": "NCM",
						"none": "None",
						"optionalTip": {
							"add": "Añadir propina",
							"title": "Propina (opcional)"
						},
						"packageValue": "Valor del paquete",
						"paymentMethod": "Método de pago",
						"remove": "Eliminar",
						"removeTip": "Eliminar propina",
						"title": "Emitir factura para {{name}}",
						"total": "Total",
						"type": "Propina",
						"value": "Valor"
					},
					"none": "No se ha seleccionado ninguna promoción",
					"of": "de",
					"peopleArrived": {
						"subtitle": "Ya fuera",
						"title": "En el evento"
					},
					"peopleDidntArrive": {
						"subtitle": "Sin información",
						"title": "Desconocido"
					},
					"promotions": "Promociones de paquetes",
					"tableMultiplePayment": {
						"columns": {
							"paymentMethod": "Método de pago",
							"value": "Valor"
						},
						"total": "Total añadido"
					},
					"title": "Paquete de",
					"value": "Valor del paquete"
				},
				"create": "Crear paquete",
				"empty": {
					"subtitle": "Cree su primer paquete haciendo clic en el botón 'Crear paquete' en la parte superior de esta página",
					"title": "No hay paquetes para este evento"
				},
				"label": "Paquetes",
				"reserveCard": {
					"guests": "{{count}} invitados",
					"none": "No se ha seleccionado ninguna promoción",
					"people": "{{count}} Personas confirmadas",
					"promotions": "{{count}} Promociones"
				},
				"reserveModal": {
					"clientInfo": "Información del cliente",
					"create": "Crear",
					"edit": "Editar paquete",
					"errors": {
						"inputs": "Por favor, rellene todos los campos obligatorios para la categoría seleccionada.",
						"promotion": "No se ha seleccionado ninguna promoción",
						"selectedTemplate": "No se pudo encontrar la plantilla"
					},
					"estimatedPeopleCount": "Número de huéspedes",
					"expiresAt": "Caduca en",
					"inactive": "(Promoción inactiva)",
					"modalTitle": {
						"create": "Crear paquete",
						"edit": "Editar {{name}}",
						"newTemplate": "Crear plantilla",
						"template": "Crear a partir de plantilla"
					},
					"models": "Modelos",
					"name": "Nombre",
					"newTemplate": "¡Atención! La plantilla creada puede ser utilizada por todos los eventos en esta ubicación.",
					"promotion": "Promoción",
					"promotionLabel": "Promoción {{number}}",
					"template": "El paquete se puede personalizar, pero creará una asociación con el modelo que se utilizará en informes y métricas..",
					"updateModal": {
						"description": "Descripción",
						"percentage": "Porcentaje",
						"productName": "Nombre del producto",
						"promotionName": "Nombre de la promoción"
					},
					"value": "Valor del paquete"
				},
				"reserveOptions": {
					"allEvents": "Todos los eventos",
					"canBeUsedIn": "Se puede utilizar en",
					"create": {
						"label": "Define cómo se ofrecerá el paquete y si quieres incluir una promoción.",
						"name": "Crear paquete personalizado"
					},
					"createTemplate": {
						"label": "Crear una plantilla de paquete personalizada para usarla en el futuro en tus eventos.",
						"name": "Crear nuevo modelo"
					},
					"createWithTemplate": {
						"label": "Crear un paquete para sus clientes basado en las plantillas creadas anteriormente.",
						"name": "Crear a partir de plantilla"
					},
					"fromThisPlace": "desde esta ubicación",
					"managePackages": "Administrar paquetes"
				},
				"reserveTemplate": {
					"empty": "El local no tiene ningún modelo registrado.",
					"guests": "Invitados",
					"loading": "Cargando ...",
					"modalConfirm": {
						"content": "Ya no se puede utilizar en ningún caso en este local.",
						"title": "¿Está seguro de que desea eliminar la plantilla?"
					},
					"promotions": "Promociones",
					"remove": "Eliminar",
					"value": "Valor del paquete"
				},
				"search": "Buscar paquetes"
			},
			"reserveReport": {
				"label": "Informe del paquete",
				"subtitle": {
					"default": "{{count}} Paquetes activos durante el evento",
					"none": "No hay paquetes activos durante el evento",
					"one": "Un paquete está activo durante el evento"
				}
			}
		},
		"clients": {
			"atEventNameTitle": "en {{eventName}}",
			"details": {
				"ticketByUserReport": {
					"excel": {
						"title": "Control de fichas - {{userName}}",
						"filename": "control_de_fichas_{{userName}}"
					},
					"columns": {
						"product": "Producto",
						"burnedTickets": "Fichas quemadas",
						"refundedTickets": "Fichas reembolsadas",
						"purchasedTickets": "Fichas compradas"
					},
					"emptyState": {
						"title": "Ninguna ficha consumida",
						"description": "El usuario aún no ha comprado ninguna ficha"
					}
				},
				"bonusAndDiscounts": {
					"bonus": {
						"columns": {
							"date": "Fecha",
							"givenBy": "Dado por",
							"reason": "Motivo",
							"totalValue": "Cantidad recibida",
							"usedValue": "Cantidad gastada"
						},
						"label": "Bonus"
					},
					"discounts": {
						"columns": {
							"date": "Date",
							"givenBy": "Dado por",
							"percentage": "Percentaje",
							"reason": "Motivo",
							"value": "Descuento"
						},
						"label": "Descuentos"
					},
					"sheet": {
						"bonus": {
							"clientTitle": "Bonus de {{client}}",
							"columns": {
								"date": "Fecha",
								"givenBy": "Dado por",
								"reason": "Motivo",
								"totalValue": "Cantidad recibida",
								"usedValue": "Cantidad gastada"
							},
							"title": "Bonus"
						},
						"discount": {
							"clientTitle": "Descuentos de {{client}}",
							"columns": {
								"date": "Fecha",
								"givenBy": "Dado por",
								"percentage": "Percentaje",
								"reason": "Motivo",
								"value": "Descuento"
							},
							"title": "Descuentos"
						},
						"fileName": "discounts-and-bonus"
					}
				},
				"clientDetails": "Datos del cliente",
				"confirm": "¿Está seguro de que desea cambiar la información de este cliente?",
				"consolidatedHistory": {
					"action": "Action",
					"balance": "Saldo disponible",
					"bonusAndConsumption": "Consumición/Bonus",
					"consumption": "Consumición",
					"consumptionObligations": "Valor mínimo de consumo",
					"consumptionObligationsNotUsed": "Remanente",
					"discount": "Descuento",
					"formatters": {
						"attachCount": "Tarjetas ZIG adjuntas",
						"bonusReceived": "Bonus recibido",
						"consumptionObligations": "Consumiciones mínimas",
						"consumptionObligationsNotUsed": "Sobras de consumo mínimo",
						"entrances": "Entradas",
						"minimumConsumptionUsed": "Consumo utilizado",
						"notSyncRecharges": "Recargas no sincronizadas",
						"notUsedMinimumConsumption": "Consumo no utilizado",
						"notUsedRecharges": "Recargas no utilizadas",
						"openedBill": "Cuentas abiertas",
						"openedBillPayments": "Pago de cuentas abiertas",
						"packages": "Paquetes",
						"paymentsInEvent": "Pagos en el evento",
						"paymentsInOtherEvents": "Pagos en otros eventos",
						"postPaidLimitChanged": "Cambio de límite de pospago",
						"productRefunds": "Devolución d eproducto",
						"products": "Productos",
						"promotionsUsed": "Promociones utilizadas",
						"rechargeDevolutions": "Recargas devueltas",
						"rechargeDevolutionsFromOtherEvents": "Recargas devueltas de otros eventos",
						"rechargesFromOtherEvents": "Recargas de otros eventos",
						"rechargesInEvent": "Recargas en el evento",
						"removedTip": "Propinas eliminadas",
						"tip": "Servicio",
						"bonusPayments": "Pago con bonus restante",
						"singleProductReturns": "Devolución de producto"
					},
					"isShared": "-(shared)",
					"label": "Historial consolidada",
					"method": "Método",
					"name": "Nombre",
					"others": "Otros",
					"payments": "Pagos",
					"printInfo": "Imprimir información",
					"product": "Producto",
					"qntt": "Qntt.",
					"quantity": "Cantidad",
					"recharges": "Recargas",
					"totalConsumption": "Consumo total",
					"totalValue": "Valor",
					"unknown": "Desconocido",
					"value": "Valor",
					"toolTipMarketPlaceDiscount": "Descuento del delivery (ifood, rappi, etc.). Descuento en el valor total del pedido."
				},
				"data": {
					"at": "en",
					"birthDate": "Fecha de nacimiento",
					"checkIn": "Entrada",
					"checkOut": "Salida",
					"cpf": "DNI",
					"email": "Email",
					"hasApp": "Tiene APP",
					"noEmail": "Email no registrado",
					"noPhone": "No hay teléfono registrado",
					"noRegistry": "Sin registro",
					"notDefined": "No ocurrió",
					"notRegistered": "Fecha no registrada",
					"phone": "Teléfono",
					"remaningValue": "Saldo disponible onsite",
					"clientsAtTag": "Número de clientes en la mesa"
				},
				"downloadTable": {
					"actions": {
						"columns": {
							"attachCount": "Tarjetas zig adjuntas",
							"date": "Fecha",
							"packages": "Paquetes",
							"postPaidLimitChanged": "Cambio de límite de pospago",
							"productRefunds": "Devolución de productos",
							"promotionsUsed": "Promociones utilizadas",
							"removedTips": "Propinas eliminadas"
						},
						"title": "Actions"
					},
					"bonusAndConsumption": {
						"columns": {
							"bonusReceived": "Bonus recibido",
							"consumptionUsed": "Consumo utilizado",
							"date": "Fecha",
							"notUsedConsumption": "Consumo no utilizado"
						},
						"title": "Bonus y Consumo"
					},
					"consumption": {
						"columns": {
							"date": "Fecha",
							"entrances": "Entradas",
							"products": "Productos",
							"service": "Servicio",
							"totalConsumption": "Consumo total"
						},
						"title": "Consumo"
					},
					"fileName": "consolidated-history",
					"payments": {
						"columns": {
							"date": "Fecha",
							"openedBill": "Cuentas abiertas",
							"paymentsInEvent": "Pagos en el evento",
							"paymentsInOtherEvents": "Pagos por otros eventos",
							"bonusPayments": "Pago con bonus restante"
						},
						"title": "Pagos"
					},
					"recharges": {
						"columns": {
							"date": "Fecha",
							"notSynchRecharges": "Recargas no sincronizadas",
							"notUsedRecharges": "Recargas no utilizadas",
							"rechargeDevolutions": "Devolución de recargas",
							"rechargesFromOtherEvents": "Recargas de otros eventos",
							"rechargesInEvent": "Recargas en el evento"
						},
						"title": "Recargas"
					}
				},
				"edit": "Editar",
				"fiscalNotes": {
					"at": "en",
					"cancelInvoice": {
						"okText": "Sí, cancelar factura",
						"title": "¿Está seguro de que desea cancelar la factura?"
					},
					"columns": {
						"links": "Links",
						"status": "Estado",
						"time": "Fecha/Hora",
						"type": "Tipo"
					},
					"emit": "Emitir factura",
					"empty": "No hay facturas de clientes para el período seleccionado.",
					"generate": "A generar {{type}}",
					"image": "Imagen",
					"invoiceStatus": {
						"canceled": "Factura cancelada",
						"error": "Error al emitir",
						"issued": "Factura emitida",
						"issuing": "Emisión de factura"
					},
					"label": "Facturas",
					"modalError": {
						"content": "Póngase en contacto con el soporte técnico y presente este error",
						"error": "Error",
						"title": "Error descripción"
					},
					"mode": {
						"nfe": "NF-e",
						"nfse": "NFS-e",
						"nfsen": "NFS-e Nacional",
						"nfce": "NFC-e",
						"sat": "SAT"
					},
					"send": "Enviar facturas por correo electrónico",
					"showError": "Error de visualización"
				},
				"goBack": "VOLVER",
				"invoices": {
					"alert": "Si desea agrupar las facturas de otros clientes a las ya seleccionadas, simplemente agréguelas a continuación",
					"client": "Cliente",
					"cnpj": "CIF",
					"cnpjPlaceholder": "Introduzca CIF",
					"count": "Cantidad",
					"cpf": "DNI",
					"cpfPlaceholder": "Introduzca DNI",
					"date": "Fecha y hora",
					"discountValue": "Descuento",
					"empty": "No hay transacciones que emitar.",
					"id": "Transacción",
					"issueTo": "Emitir a",
					"nif": "NIF",
					"nifPlaceholder": "Introduzca  NIF",
					"generateServiceFee": "Generar tarifa de servicio proporcional",
					"noCPForCNPJ": "Emisión sin DNI y sin CIF",
					"noNIF": "Emisión sin NIF",
					"otherCNPJ": "Emisión a otro CIF",
					"otherCPF": "Emisión a otro DNI",
					"otherNIF": "Emisión a otro NIF",
					"products": "Productos",
					"razaoSocial": "RAZÃO SOCIAL",
					"inscricaoEstadual": "INSCRIÇÃO ESTADUAL",
					"indicadorInscricaoEstadual": "INDICADOR INSCRICÃO ESTADUAL",
					"indicadorInscricaoEstadualOptions": {
						"ContribuinteICMS": "Contribuinte ICMS",
						"ContribuinteIsento": "Contribuinte Isento",
						"NaoContribuinte": "Não contriibuinte",
						"none": "Não informar"
					},
					"shouldAddAddressQuestion": "Adicionar endereço do tomador?",
					"issueWithAdress": "Sim, adicionar endereço do tomador",
					"issueWithoutAdress": "Não, emitir sem endereço",
					"infoCNPJSection": "Dados do CNPJ",
					"addressSection": "Endereço",
					"address": {
						"cep": "CEP",
						"logradouro": "logradouro",
						"numero": "numero",
						"bairro": "bairro",
						"municipio": "municipio",
						"uf": "UF",
						"complemento": "complemento"
					},
					"steps": {
						"buyers": "Compradores",
						"consumption": "Consumo mínimo no emitido",
						"emission": "Emisión",
						"transactions": "Operaciones no emitidas",
						"receipientExtraInfo": "Informações extras"
					},
					"totalNotissued": "Total no emitido",
					"unitValue": "Valor total",
					"value": "Valor",
					"valueToEmit": "Valor A emitir"
				},
				"issueNotes": "Emisión de facturas",
				"consummationGiven": "Consumación dada",
				"rechargesReturned": "Recargas devueltas",
				"refundedPostPayments": "Reversión de pagamento",
				"singleProductReturns": "Devolución de productos",
				"paymentMethods": {
					"ame": "Ame",
					"anticipated": "Anticipado",
					"app": "APP",
					"cash": "Efectivo",
					"creditCard": "Crédito",
					"dashboard": "Dashboard",
					"debitCard": "Débito",
					"deliveryOnline": "Entrega online",
					"foodVoucher": "Vale de Alimentación",
					"ifood": "Ifood",
					"installment": "Pago a plazos",
					"noMethod": "Sin información de método de pago",
					"pix": "Pix",
					"postEvent": "Post evento",
					"rappi": "Rappi",
					"total": "Total",
					"uber": "Uber",
					"voucher": "Voucher",
					"zigPosCredit": "Zig post credito",
					"zigPosDebit": "Zig post debito",
					"online": "Online",
					"mbway": "Mbway"
				},
				"printable": {
					"author": "Autor",
					"bonus": "Bonus",
					"cashier": "Cajero",
					"count": "Cantidad",
					"cpf": "DNI",
					"date": "Fecha",
					"discount": "Descuento",
					"email": "Email",
					"expired": "Caducado",
					"method": "Método",
					"name": "Nombre",
					"paidBill": "Cuenta pagada",
					"payers": "Pagadores",
					"paymentMethod": "Método de pago",
					"payments": "Pagos",
					"phone": "Teléfono",
					"products": "Productos",
					"purchase": "Compra",
					"recharge": "Recarga",
					"refunded": "Reembolsado",
					"service": "Servicio",
					"shared": "Compartido",
					"total": "Total",
					"totalProducts": "Total ({{count}} Productos)",
					"unavailable": "No disponible",
					"used": "Usado",
					"value": "Valor",
					"zigcode": "Zigcode"
				},
				"sendByEmail": {
					"datetime": "Fecha/Hora",
					"email": "Email",
					"invoices": "Facturas",
					"nfce": "Consumo (NFC-e)",
					"nfse": "Servicio (NFS-e)",
					"sat": "Consumo (SAT)",
					"sendEmail": "Enviar email",
					"sendInvoucesByEmail": "Enviar facturas por email",
					"type": "Tipo"
				},
				"sheet": {
					"actions": {
						"columns": {
							"method": "Tipo",
							"value": "Valor"
						},
						"title": "Opciones"
					},
					"consumption": {
						"columns": {
							"count": "Cantidad",
							"name": "Nombre",
							"value": "Valor"
						},
						"title": "Consumo"
					},
					"fileName": "consolidated-history",
					"payments": {
						"columns": {
							"method": "Tipo",
							"value": "Valor"
						},
						"title": "Pagos"
					},
					"recharges": {
						"columns": {
							"method": "Método",
							"value": "Valor"
						},
						"title": "Recargas"
					},
					"summary": {
						"bonusReceveid": "Bonus Recibido",
						"columns": {
							"method": "Tipo",
							"value": "Valor"
						},
						"entrances": "Entradas",
						"minimumConsumptionUsed": "Consumo utilizado",
						"notSyncRecharges": "Recargas no sincronizadas",
						"notUsedMinimumConsumption": "Consumo no utilizado",
						"notUsedRecharges": "Recargas no utilizadas",
						"openedBill": "Cuentas abiertas",
						"payments": "Pagos",
						"paymentsInOtherEvents": "Pagos en otros eventos",
						"products": "Productos",
						"rechargeBalance": "Saldo de recarga",
						"rechargeDevolutions": "Devolución de recarga",
						"recharges": "Recargas",
						"rechargesFromOtherEvents": "Recargas de otros eventos",
						"service": "Servicio",
						"title": "Resumen",
						"totalConsumption": "Consumo total",
						"bonusPayments": "Pago con bonus restante",
						"marketPlaceDiscount": "Descuento del delivery"
					},
					"transactionalHistory": {
						"filter": "Filtrar por",
						"filterPlaceholder": "Introduzca o seleccione los tipos transaccionales",
						"columns": {
							"transaction": "transacción",
							"seller": "vendedor",
							"value": "valor",
							"id": "id",
							"time": "hora de la transacción",
							"sync": "sincronización",
							"zigCode": "zigTag",
							"bonusCategoryName": "categoría de bonus"
						}
					},
					"consumptionHistory": {
						"title": "Historial de Consumo",
						"consumption": "Consumo",
						"servicePaidOnEvent": "Servicio Pagado en el Evento",
						"amountConsumption": "Consumo Total",
						"columns": {
							"date": "Fecha",
							"type": "Tipo",
							"item": "Artículo",
							"qtd": "Cant",
							"value": "Valor",
							"discountValue": "Descuento"
						}
					},
					"withoutInfo": "No hay información para mostrar",
					"noCard": "Sin tarjeta"
				},
				"tabs": {
					"bonusAndDiscounts": "Bonus y Descuentos",
					"debtorsReport": "Cuentas abiertas",
					"ticketsByUserReport": "Control de fichas"
				},
				"transactionalHistory": {
					"acquirerModal": {
						"acquirer": "Pasarela",
						"cardHolderName": "Nombre del titular de la tarjeta",
						"cardHolderNumber": "Tarjeta",
						"notKnown": "Desconocido",
						"paidAmount": "Valor de transacción",
						"transactionType": "Tipo de transacción",
						"unknown": "Desconocido",
						"urlLabel": "url"
					},
					"employee": "Vendedor",
					"event": "Evento",
					"export": "Exportar a Excel",
					"formatters": {
						"appPrePayment": "Pago adelantado via app",
						"attach": "Registro de la tarjeta",
						"attachToReserve": "Incorporar al paquete",
						"bonus": "Bonus",
						"changePostLimit": "Limitar cambio",
						"consumeRecharge": "Devolución de recarga",
						"consumptionObligation": "Consumo mínimo",
						"detachAndRefundActivation": "Devolución de tarjeta",
						"discount": "Descuento",
						"entranceTransaction": "Entrada",
						"minimumConsumption": "Consumo",
						"postPayment": "Pago",
						"productTransaction": "Compra",
						"promotion": "Promoción ganada",
						"recharge": "Recargar",
						"refundRecharge": " Chargeback sobre recarga",
						"refundTransaction": "Devolución",
						"sharedTransaction": "Pago compartido",
						"tipRemoval": "Servicio eliminado",
						"zigCardPixRefund": "Reembolso Pix",
						"transferConsumptionObligation": "Transferir obligación de consumo",
						"singleProductReturn": "Devolución de producto",
						"refundPostPayment": "Reembolso de pago"
					},
					"value": "Valor",
					"id": "ID",
					"hour": "Hora",
					"label": "Historial de transacciones",
					"loading": "Cargando...",
					"paymentTable": {
						"acquirer": "Pasarela",
						"cpf": "DNI",
						"method": "Método",
						"name": "Pagadores",
						"value": "Valor"
					},
					"productTable": {
						"name": "Producto",
						"value": "Precio",
						"count": "Qty.",
						"discountValue": "Descuento",
						"total": "TOTAL",
						"totalValue": "Valor final",
						"details": "Detalles",
						"transferFrom": "Transferido desde",
						"transferTo": "Transferido a",
						"item": "Ítem",
						"section": "Sección"
					},
					"refundTable": {
						"count": "Qty.",
						"name": "Producto"
					},
					"service": "Servicio",
					"marketPlaceDiscount": "Descuento del delivery",
					"toolTipMarketPlaceDiscount": "Descuento del delivery (ifood, rappi, etc.). Descuento en el valor total del pedido.",
					"sheet": {
						"date": "Fecha",
						"employee": "Vendedor",
						"cardNumber": "Número de tarjeta",
						"fileName": "transactional-history-of-",
						"hour": "Hora",
						"id": "ID",
						"in": "-en-",
						"operation": "Operación",
						"title": "Historia de transacciones de {{user}} durante {{event}}",
						"value": "Valor",
						"bonusCategoryName": "Categoría de bonus"
					},
					"unknown": "Desconocido"
				}
			},
			"errorCountIssuedInvoice": "Se encontró un tipo de error al emitir notas",
			"errorCountIssuedInvoices": "Se encontraron tipos de error al emitir notas",
			"fileTitle": "Clientes en el evento {{eventName}} {{eventDate}}",
			"filename": "customers_at_event_{{eventName}}_{{eventDate}}",
			"issueAllInvoicesButton": "Emitir todas las notas",
			"issueLoading": "Emisión de notas...",
			"issuedInvoice": "La nota se emitió correctamente",
			"issuedInvoices": "Las notas se emitieron con éxito",
			"onlyClientsCheckbox": "Clientes con notas no emitidas",
			"period": "Periodo",
			"searchPlaceholder": "Buscar por nombre, DNI o teléfono",
			"table": {
				"appTransactionsValue": "Pagado via app",
				"bonusTransactionsValue": "Pagado con bonus",
				"checkInTime": "Hora de entrada",
				"checkOutTime": "Hora de salida",
				"document": "DNI",
				"housePostPaidTransactionsValue": "Postpaid En casa",
				"housePrePaidTransactionsValue": "Prepaid En casa",
				"name": "Nombre",
				"noDataText": "No hay datos para mostrar.",
				"phone": "Teléfono",
				"total": "Total"
			},
			"thisEventTitle": "en este evento",
			"title": "Clientes",
			"until": "Hasta"
		},
		"conference": {
			"title": "Conferencia de Evento",
			"eventOpen": "Evento abierto",
			"closeEventToConference": "Debes cerrar el evento para realizar la conferencia",
			"titleTypeOfConference": {
				"resumed": "Tabla de resumen",
				"integratedIncome": "Tarifas de aplicaciones integradas y máquinas (crédito/débito)",
				"notIntegratedIncome": "Tarifas de máquinas POS no integradas (crédito/débito)",
				"zigFees": "Tarifas Zig",
				"securityDeposit": "Depósito de seguridad",
				"otherCharges": "Otros cargos",
				"rechargeRefund": "Reembolso de recarga"
			},
			"columnsTable": {
				"name": "Nombre",
				"grossValue": "Valor Bruto",
				"tax": "Impuesto",
				"taxReceivedOrPayable": "Zig por Cobrar / Pagar",
				"receiptForecast": "Previsión de recepción"
			},
			"conference": "Conferencia",
			"processConference": "Procesar conferencia"
		},
		"entranceBilling": {
			"tabs": {
				"boxOfficeBilling": {
					"filename": "ticket_billing",
					"label": "Facturación de tickets",
					"percentage": "porcentaje",
					"quantity": "cantidad",
					"revenue": "ingresos",
					"value": "valor"
				},
				"entranceReport": {
					"columns": {
						"count": "Cantidad",
						"discountValue": "Descuento",
						"entrance": "Entrada",
						"name": "Nombre",
						"subtotal": "Subtotal",
						"totalValue": "Valor total",
						"unitValue": "Valor unitario"
					},
					"filename": "tickets-sold-by-employees",
					"label": "Entradas vendidas por los empleados",
					"sheet": {
						"count": "Cantidad",
						"discountValue": "Descuento",
						"fileName": "entrada",
						"name": "Nombre",
						"subtotal": "Subtotal",
						"title": "Entrada",
						"totalValue": "Valor total",
						"unitValue": "Valor unitario"
					},
					"total": "Total",
					"totalCategory": "Total ({{category}})"
				},
				"pageTabs": {
					"boxOffice": "Ingresos",
					"soldEntrances": "Entradas Vendidas",
					"employeeReport": "Entradas por Empleado"
				},
				"soldEntrances": {
					"clientsReport": {
						"title": "Listado de Clientes por Entrada Vendida",
						"filterLabel": "Filtrar por Entrada Vendida",
						"filterPlaceholder": "Agregar filtros por entrada",
						"clients": "Clientes",
						"entranceValue": "Valor de la Entrada",
						"consumption": "Consumo",
						"total": "Total",
						"name": "Nombre",
						"document": "Documento",
						"entrance": "Entrada",
						"checkin": "Check-in",
						"checkout": "Check-out",
						"fileName": "clientes-por-entrada-vendida_{{date}}"
					},
					"columns": {
						"averageValue": "Precio medio",
						"count": "Unidades vendidas",
						"name": "Nombre",
						"totalValue": "Total"
					},
					"filter": "Filtrar por hora",
					"label": "Total de entradas vendidas",
					"sheet": {
						"average": "Valor medio",
						"count": "Cantidad",
						"fileName": "tickets_sold",
						"name": "Nombre",
						"title": "Entradas vendidas",
						"totalValue": "Precio"
					},
					"since": "desde",
					"tabs": {
						"total": "Total",
						"clients": "Clientes por Entrada"
					},
					"total": "Recibo total",
					"until": "hasta"
				}
			}
		},
		"eventReports": {
			"afterClosingEvent": {
				"columns": {
					"customerName": "Nombre de usuario",
					"date": "Fecha/hora de sincronización",
					"employee": "Empleado",
					"origin": "origen",
					"transactionType": "Tipo de transacción",
					"value": "valor"
				},
				"description": "Informe con acciones o transacciones después del cierre del evento.",
				"filterOriginLabel": "Visualizar",
				"filterTransactionLabel": "Filtrar por tipo de transacción",
				"historyMachineAfterClosingLabel": "Historial después del cierre",
				"historyMachineLabel": "Máquina de historial",
				"offlineActionLabel": "Después del cierre",
				"optionAll": "Todas las transacciones",
				"optionHistoryMachine": "Historial de la máquina de transacciones",
				"optionHistoryMachineAfterClosing": "Historial de transacciones de la máquina después del cierre del evento",
				"optionOfflineAction": "Transacciones sincronizadas después del cierre del evento",
				"searchLabel": "Buscar por nombre de empleado",
				"searchPlaceHolder": "Introduzca el nombre del empleado",
				"title": "Acciones sincronizadas después del evento"
			},
			"cashierClosings": {
				"all": "Todas",
				"balanceTitle": "Ingresos por cajero",
				"balanceTitleDay": "Ingresos por cajero en el día {{day}}",
				"card": {
					"bleeding": "Retirada",
					"cardDevolution": "Devoluciones de tarjetas",
					"productDevolution": "Devoluciones de producto",
					"cash": "Efectivo",
					"casher_one": "{{numberOfCashiers}} Cajero",
					"cashier_other": "{{numberOfCashiers}} Cajeros",
					"changeFund": "Movimiento del cambio",
					"closed": "Cerrado",
					"difference": "Diferencia",
					"modality": "Modalidad",
					"noFlag": "No Flag",
					"notClosed_one": "({{numberOfOpenCashiers}} no cerrado)",
					"notClosed_other": "({{numberOfOpenCashiers}} no cerrado)",
					"open": "Abrir",
					"received": "Facturado",
					"rechargeDevolutions": "Recarga de devoluciones",
					"total": "TOTAL",
					"xlsx": {
						"cashier": "Cajero",
						"closed": "Cerrado",
						"closingCashier": "Cierre por cajero",
						"closingResume": "Resumen de cierre",
						"difference": "Diferencia",
						"filename": "closing-by-cashier-in-place",
						"filenameEvent": "closing-by-cashier-{{eventDate}}",
						"modality": "Modalidad",
						"received": "Facturado"
					}
				},
				"cashier": "Cajero",
				"filenameBalance": "income_per_cashier",
				"header": {
					"addBleed": "Añadir retirada",
					"addChange": "Añadir modificación del cambio",
					"addObs": "Agregar comentario",
					"cashierHistory": "Ver el historial del cajero",
					"closeCashier": "¿Está seguro de que desea cerrar el {{cashierName}} cajero?",
					"closeCashierButton": "Cerrar cajero",
					"historyTitle": "Historial del cajero - {{cashierName}}",
					"obs": "Comentario",
					"reopenCashier": "¿Está seguro de que desea volver a abrir el cajero??",
					"reopenCashierButton": "Volver a abrir el cajero",
					"transactionalHistory": "Ver historial de transacciones"
				},
				"info": {
					"addNewModality": "Añadir nueva modalidad",
					"billed": "Facturado",
					"bleeding": "Retirar",
					"bleeds": "Retiradas",
					"cancel": "Cancelar cambios",
					"cardDevolution": "Devolución de tarjetas",
					"cashierNotClosed": "Cajero no cerrado",
					"cashierReceipt": "Ingresos por cajero",
					"cashier_one": "cajero",
					"cashier_other": "cajero",
					"changeFund": "Cambiar fondo",
					"changes": "Cambios",
					"closeCashier": "Cerrar cajero",
					"closed": "Cerrado",
					"closingCashier": "Cierre de cajero",
					"createBleed": "Abrir retirada",
					"createChange": "Agregar fondo de cambio",
					"devolutions": "Devuelto",
					"modality": "Modalidad",
					"negative": "Diferencia",
					"notClosed": "no cerrado",
					"rechargeDevolutions": "Recarga de devoluciones",
					"save": "Guardar cierre",
					"searchCashier": "Buscar cajero por nombre",
					"totalBilled": "Total facturado",
					"totalClosed": "Total cerrado"
				},
				"modal": {
					"addFlag": "Add flag",
					"cashierPosts": "Transacciones de pospago",
					"cashierRecharges": "Recambios",
					"cashiers": "Cajero",
					"changeFund": "Cambiar fondo",
					"column": {
						"author": "Empleado",
						"client": "Cliente",
						"clients": "Cliente(s)",
						"cardNumber": "ZigTag",
						"date": "Fecha",
						"method": "Método",
						"obs": "Observación",
						"payments": "Pagos",
						"serialNumber": "Número serial (SN)",
						"total": "Total",
						"valueComsumed": "Valor consumido",
						"valueRecharged": "Valor recargado"
					},
					"history": "Historial",
					"historyTitle": "Historia de {{name}}",
					"refundPayment": "Reembolso de pago",
					"saveValues": "Guardar valores",
					"value": "Valor"
				},
				"valueGreaterThanZero": "El valor debe ser mayor que 0",
				"value": "Valor",
				"noCard": "Sin tarjeta",
				"noCashierSelected": "No hay cajero seleccionado",
				"paymentMethod": {
					"ame": "Ame",
					"anticipated": "Anticipado",
					"bonus": "Bonus",
					"cash": "Efectivo",
					"credit": "Crédito",
					"dashboard": "Dashboard",
					"debit": "Débito",
					"deliveryOnline": "Delivery Online",
					"devolution": "Devoluciones",
					"foodVoucher": "Vale de Alimentación",
					"ifood": "Ifood",
					"installment": "Pago a plazo",
					"pix": "Pix",
					"postEvent": "Pagado después del evento",
					"rappi": "Rappi",
					"subtotal": "Subtotal",
					"total": "Total",
					"uber": "Uber",
					"voucher": "Voucher",
					"zigCredit": "Credit Zig",
					"zigDebit": "Zig Debit",
					"online": "Online",
					"mbway": "MBWay"
				},
				"postPaid": "Transacciones de pospago",
				"recharges": "Recambios",
				"total": "Total",
				"transactionsTitle": "Historia de {{name}}"
			},
			"debtorsReport": {
				"modal": {
					"addPayment": "Añadir pago",
					"bonus": "Pagar con bono",
					"cash": "Efectivo",
					"column": {
						"bonus": "Bonus",
						"value": "Valor"
					},
					"confirm": "Confirmar",
					"creditCard": "Tarjeta de crédito",
					"debitCard": "Tarjeta de débito",
					"email": "Email",
					"emailError": "Email inválido",
					"emailPlaceholder": "Email del cliente",
					"eventScope": "evento",
					"fieldRequired": "Campo obligatorio",
					"multiplePaymentConfirm_part1": "Este pago ",
					"multiplePaymentConfirm_part2": "pagará {{value}}",
					"multiplePaymentConfirm_part3": "del cliente en {{scope}}, ¿Estás seguro de que quieres hacer esto?",
					"multiplePaymentError": "¡Atención! Agregar un método de pago",
					"no": "No",
					"observation": "Comentario",
					"observationPlaceholder": "Añadir comentario",
					"openConsumption": "Consumo abierto",
					"openValues": "Valores abiertos",
					"pay": "Pagar",
					"paymentConfirm_part1": "Este pago",
					"paymentConfirm_part2": "pagará TODA la deuda del cliente",
					"paymentConfirm_part3": "en {{scope}}, ¿Estás seguro de que quieres hacer esto?",
					"paymentConsumption": "Pagar en consumo",
					"paymentMethod": "Forma de pago",
					"paymentMethodError": "Seleccione un método de pago",
					"paymentService": "Pago en servicio",
					"pixCharge": "Facturación a través de PIX",
					"pixValue": "Valor de pix",
					"placeScope": "lugar",
					"postEvent": "Marcar como pagado",
					"reason": "Justificación",
					"reasonPlaceholder": "Añadir justificación de bonus",
					"select": "Escoger",
					"sendCharge": "Enviar cargo",
					"service": "Servicio ({{tip}}%)",
					"submitError": "Solo es posible pagar de más hasta el 25% del monto total pendiente.",
					"total": "Total",
					"totalDebit": "Total pendiente",
					"voucher": "Voucher",
					"yes": "Sí",
					"discharge": "Dar de baja"
				},
				"title": "Abrir cuentas",
				"alertTitleOpenBill": "No es posible enviar cobros en el informe del evento",
				"alertMessageOpenBill": "Para enviar cobros, acceda al menú [Ubicaciones] > elija la ubicación > menú [Informes Financieros] > pestaña 'Cuentas Pendientes' y utilice el enlace en la columna 'Cobrar'."
			},
			"individualLimitPost": {
				"columns": {
					"client": "Cliente",
					"date": "Fecha",
					"employeeName": "Empleado",
					"emptyText": "No hay datos para mostrar.",
					"limit": "Aumento del límite",
					"newLimite": "Nuevo límite",
					"username": "Usuario"
				},
				"filename": "individual_pos_limit_change_report",
				"searchPlaceholder": "Buscar por usuario, id o nombre",
				"title": "Información del cliente",
				"titleTab": "Cambio de límite personal"
			},
			"minimumConsumption": {
				"title": "Pronto Consumo"
			},
			"openedBillPayment": {
				"columns": {
					"client": "Cliente",
					"employeeName": "Pagado por",
					"method": "Método",
					"openedEventDate": "Fecha de apertura de la cuenta",
					"tipValue": "Valor de propina",
					"value": "Valor",
					"documento": "Documento"
				},
				"filename": "report_of_payments_of_accounts_in_open_in_event",
				"title": "Abrir pagos de cuenta"
			},
			"rappiDiscounts": {
				"columns": {
					"date": "Fecha",
					"employee": "Empleado que aplicó el descuento",
					"products": "Productos",
					"value": "Valor del descuento"
				},
				"filename": "rappi_discount_report",
				"rappiDiscounts": "DRappi Discounts",
				"title": "Rappi Discounts"
			},
			"rechargeConsumption": {
				"columns": {
					"ame": "Ame",
					"anticipated": "Anticipado",
					"author": "Cajero",
					"cash": "Efectivo",
					"client": "Cliente",
					"credit": "Crédito",
					"dashboard": "Dashboard",
					"debit": "Débito",
					"deliveryOnline": "Online Delivery",
					"ifood": "Ifood",
					"method": "Método",
					"pix": "PIX",
					"rappi": "Rappi",
					"total": "Total",
					"uber": "Uber",
					"value": "Valor",
					"voucher": "Voucher",
					"integratedFoodVoucher": "Vale de comida",
					"zigPosCreditInInstallments": "Crédito a plazos"
				},
				"detailDialog": "Ver recarga devuelta por el cajero",
				"filename": "recharge-devolution",
				"rechargesRefundedBy": "Recargas devueltas por {{author}}",
				"title": "Devolución de recarga"
			},
			"refunded": {
				"columns": {
					"canceled": "Cancelado",
					"category": "Categoría",
					"clients": "Clientes",
					"count": "Cantidad",
					"date": "Fecha",
					"moreRefundedBuyer_other": "y más {{buyers}} personas",
					"moreRefundedBuyer_one": "y más {{buyers}} persona",
					"name": "Nombre del producto",
					"refundObs": "Comentarios",
					"reason": "Razón",
					"refunded": "Reembolsado",
					"refundedBy": "Reembolsado por",
					"soldBy": "Vendido por",
					"totalCount": "Importe total",
					"totalRefunded": "Total ({{total}} devuelto)",
					"totalValue": "Valor total",
					"type": "Tipo",
					"value": "Valor",
					"operationType": "Operación"
				},
				"filename": "refunded-products",
				"title": "Productos reembolsados/cancelados"
			},
			"resumeReport": {
				"fileName": "billing-{{eventName}}",
				"finished": {
					"end": "Cerrado: {{end}}h",
					"not": "El evento no ha cerrado"
				},
				"reportIn": "Facturación del evento '{{eventName}}'",
				"title": "Reanudar"
			},
			"servicesRemoval": {
				"clientInfo": "Información del cliente",
				"columns": {
					"date": "Fecha",
					"name": "Cliente",
					"reason": "Razón",
					"total": "Total eliminado",
					"value": "Valor",
					"employee": "Funcionário"
				},
				"goTo": "go to",
				"title": "Eliminación de servicios por parte del cajero",
				"titlePrint": "Servicios eliminados"
			},
			"tabs": {
				"storageV2": {
					"tabs": {
						"products": {
							"transferDrawer": {
								"title": "Transferir producto del inventario {{productName}}",
								"form": {
									"label": {
										"product": "Producto",
										"fromStorage": "Retirando productos del inventario",
										"toStorage": "Transfiriendo productos al inventario",
										"quantity": "Cantidad que desea transferir"
									},
									"placeholder": {
										"toStorage": "Seleccione el inventario"
									},
									"hint": {
										"maxQuantity": "Máximo disponible: {{maxQuantity}}"
									},
									"sectionTitle": {
										"chooseDestination": "Elija el inventario de destino"
									},
									"validation": {
										"maxStorageCountIs": "La cantidad máxima en inventario es {{productMaxCountString}}",
										"missingField": "Campo obligatorio",
										"invalidQuantity": "Cantidad inválida"
									}
								},
								"actions": {
									"cancel": "Cancelar",
									"submit": "Concluir transferencia"
								},
								"notifications": {
									"success": "Transferencia completada con éxito."
								}
							},
							"removeProductFromStorageDialog": {
								"title": "Eliminar producto",
								"warningMessageSingle": "¿Está seguro de que desea eliminar el producto {{productName}} del inventario?",
								"warningMessageMultiple": "¿Está seguro de que desea eliminar los {{count}} productos del inventario?",
								"warningMessageStrong": " Esta acción no se puede deshacer",
								"submit": "Eliminar producto",
								"notifications": {
									"success": "Producto eliminado del inventario con éxito."
								}
							}
						}
					}
				},
				"afterClosingEvent": "Acciones sincronizadas después del evento",
				"bonusByProduct": "Bonus por producto",
				"cashierClosings": "Cierres de cajeros",
				"consumptionObligation": "Consumo mínimo",
				"debtors": "Abrir cuentas",
				"devolution": "Devolución de tarjetas por box",
				"discounts": "Descuentos de cuenta",
				"individualLimitPost": "Cambio del límite de puestos individuales",
				"minimumConsumption": "Pronto consumo",
				"openSales": "Ventas abiertas",
				"openedBillPayment": "Abrir pagos de cuenta",
				"openedBillReports": {
					"stillOpenInPeriod": "Aún abiertas en el período",
					"stillOpenInPeriodTooltip": "Se refiere al valor de cuentas abiertas en el período seleccionado",
					"linksGenerated": "Enlaces generados",
					"paidInPeriod": "Pagos de cuentas abiertas resueltos en el período",
					"tabs": {
						"debtors": "Cuentas abiertas",
						"payments": "Pagos de cuentas abiertas"
					}
				},
				"promotion": "Promociones utilizadas",
				"rappiDiscounts": "Rappi Discounts",
				"rechargeConsumption": "Devolución de recargas",
				"refunded": "Productos reembolsados",
				"refundedRecharges": "Recargas reembolsadas",
				"resume": "Reanudar",
				"servicesRemoval": "Servicios eliminados",
				"userBonus": "Bonus",
				"forciblySynchronizedBalances": "Saldos sincronizados a la fuerza",
				"tipReport": "Informe de Propinas",
				"transactionTransferReport": "Transferencias de facturas"
			},
			"forciblySynchronizedBalance": {
				"title": "Saldos sincronizados a la fuerza",
				"table": {
					"columns": {
						"date": "Fecha y hora",
						"user": "Cliente",
						"employee": "Empleado",
						"reason": "Justificación",
						"balance": "Saldo sincronizado"
					}
				},
				"successfulExportMsg": "¡Hoja de cálculo exportada con éxito!"
			}
		},
		"financialReport": {
			"fileName": "billing-{{event}}",
			"finished": {
				"end": "Cerrado: {{end}}",
				"not": "El evento no ha cerrado"
			},
			"label": "Reanudar",
			"reportIn": "Facturación del evento '{{event}}'",
			"tabs": {
				"bonusReport": {
					"title": "Bonificación",
					"description": "Vea todos los informes de concesión y uso de bonificaciones",
					"filenameBonus": "bonificacion-concedida",
					"filenameAnticipated": "consumo-anticipado",
					"filenameConsumption": "Consumo",
					"select": "Seleccione una categoría",
					"selectNotFound": "Categoría no encontrada",
					"filenameComsumption": "consumo",
					"total": "Total de {{category}}",
					"tabs": {
						"given": "Bonificación Concedida",
						"used": "Bonificación Utilizada"
					},
					"columns": {
						"client": "Cliente",
						"category": "Categoría",
						"date": "Fecha",
						"reason": "Razón",
						"receivedValue": "Recibido",
						"spentValue": "Gastado en el evento",
						"spentValueInOtherEvents": "Gastado en otros eventos",
						"givenBy": "Dada por",
						"total": "Total"
					}
				}
			}
		},
		"multivendor": {
			"closings": {
				"columns": {
					"eventDate": "Fecha del evento",
					"fixedFee": "Tarifa de alquiler fija",
					"generalFeeValue": "Tarifa variable general",
					"generalPercentageFee": "Comisión variable en la facturación",
					"otherProductsFeeValue": "Tarifa variable en productos especiales",
					"payDate": "Fecha de pago",
					"totalSoldValue": "Facturación total",
					"vendorName": "Vendedor",
					"vendorValueToReceive": "Valor a recibir"
				},
				"emptyText": "No hay datos para mostrar.",
				"filename": "closing-by-vendor",
				"title": "Cierre por proveedor"
			},
			"productsSold": {
				"title": "Productos vendidos por proveedor"
			},
			"revenues": {
				"columns": {
					"name": "Vendedor",
					"rent": "Alquilar",
					"revenue": "Receta",
					"subtotal": "Total parcial",
					"total": "Total",
					"totalSoldValue": "Productos vendidos",
					"totalTipValue": "Servicio"
				},
				"description": "Informe de relación de facturación y cada proveedor registrado como parte del sitio.",
				"filename": "billing_by_vendor",
				"title": "Facturación por proveedor"
			}
		},
		"panel": {
			"canceled": "Canceledo",
			"closeEvent": {
				"emptyName": "El nombre del evento está vacío",
				"eventNameMessage": "Introduzca el nombre del evento para confirmar el cierre",
				"finishedActivityDevices": "Hay {{finishedActivityDevices}} TPV's con operaciones abiertas!",
				"incorectName": "El nombre del evento es incorrecto",
				"message": "¿Está seguro de que desea cerrar el evento? Esto desactivará a todos los usuarios y cerrará el informe, el inventario y los cajeros.."
			},
			"closeEventButton": "Cerrar evento",
			"deleteEvent": {
				"confirm": "¿Está seguro de que desea eliminar el evento? Esta será una acción permanente"
			},
			"eventNotOpen": "Este evento aún no se ha inaugurado",
			"eventStatus": "Estado del evento",
			"finished": "Closed",
			"finishedActivityText": "{{activeDevices}} TPV con operación abierta",
			"goTo": "go to",
			"importConsumption": {
				"balanceType": "Tipo de saldo",
				"bonus": "Bonus",
				"columns": {
					"document": "DNI",
					"email": "E-mail",
					"gender": "Género",
					"isForeign": "¿Es extranjero?",
					"name": "Nombre",
					"phone": "Teléfono",
					"reason": "Razón",
					"value": "Valor"
				},
				"confirm": "Confirmar",
				"consumption": "Consumo",
				"consumptionErrors": "Consumiciones que fallaron",
				"consumptionType": "Tipo de consumición",
				"document": "DNI",
				"import": "Importar consumiciones",
				"minimumConsumption": "Consumo anticipado",
				"normal": "Normal",
				"reason": "Razón",
				"recharge": "Recargar",
				"spreadsheet": "Spreadsheet",
				"successNotification": "Consumición importada!",
				"title": "Importar consumición",
				"user": "Usuario",
				"warningNotification": "No se han enviado datos. Algunas consumaciones fallaron"
			},
			"importConsumptionCardsGroup": {
				"title": "Grupo de cartas",
				"fields": {
					"group": {
						"label": "Nombre del grupo de tarjetas",
						"required": "Seleccione un grupo de tarjetas"
					},
					"balanceType": {
						"label": "Tipo de saldo",
						"required": "El monto del saldo debe ser mayor que cero"
					},
					"balance": {
						"label": "Valor del saldo"
					}
				}
			},
			"importConsumptionZigCode": {
				"title": "ZigCode",
				"fileName": "Hoja de trabajo de consumación",
				"rechargeSuccess": "¡Recargado con éxito!",
				"balanceType": "Tipo de saldo",
				"columns": {
					"reason": "Razón",
					"value": "Valor",
					"zigCode": "ZigCode"
				}
			},
			"importConsumptionUser": {
				"bonus": "Bonus",
				"document": "Documento",
				"documentError": "Se requiere documento",
				"documentType": "Tipo de documento",
				"minimumConsumption": "Consumo mínimo",
				"paymentMethod": "Forma de pago",
				"paymentMethodError": "Se requiere método de pago",
				"reason": "Razón",
				"recharge": "Recargar",
				"submitRecharge": "Recargar ",
				"value": "Valor de recarga",
				"valueError": "Se requiere un valor de recarga",
				"saveToDigitalCardQuestion": "¿Desea guardar la recarga en la tarjeta digital del cliente, si tiene una?",
				"saveToDigitalCardQuestionPlural": "¿Desea guardar las recargas en las tarjetas digitales de los clientes, si las tienen?"
			},
			"notOpened": "No abierto",
			"openedBy": "Abierto por",
			"open": "Abrir",
			"openEvent": "Evento abierto",
			"publicCard": {
				"allInsideText": "siguen disfrutando",
				"allOutsideText": "ya se ha ido",
				"capacity": "Capacidad",
				"genderCard": {
					"averageTicket": "Ticket medio",
					"female": "Mujeres",
					"invoice": "Facturado",
					"male": "Hombres",
					"other": "Otros",
					"realTicket": "Ticket real",
					"zeroTicket": "Zero Ticket"
				},
				"newPublicText": "Nuevos clientes",
				"oldPublicText": "Volvió",
				"people": "persona",
				"title": "Público",
				"totalPublic": "{{totalPublic}} estuvieron en el evento"
			},
			"removeEventButton": "Eliminar evento",
			"topClientsCard": {
				"clientInfo": "Información del cliente",
				"clients": "Clientes",
				"count": "Consumo",
				"title": "Clientes que más consumen"
			},
			"topProductsPriceCard": {
				"allProductsSold": "Todos los productos vendidos",
				"altNavlink": "Link al reporte de todos los productos vendidos",
				"consumption": "Consumo",
				"noData": "Sin datos",
				"other": "Otros",
				"products": "Productos",
				"quantity": "Cantidad",
				"title": "Productos por ventas",
				"unavailable": "No disponible"
			},
			"totalOpenedTable": "Total de mesa abierta",
			"editEvent": {
				"title": "Editar evento",
				"confirm": "Confirmar",
				"passTemplate": "ID del modelo del pase"
			},
			"totalOpenedTables": "Total de mesas abiertas",
			"totalTables": "Total de mesas",
			"zigMesaOperationMode": {
				"message": "Estado del servidor en el POS",
				"online": "Online",
				"local": "Local"
			},
			"operationCard": {
				"title": "Operación Zig Mesa",
				"peopleSingle": "Persona",
				"peoplePlural": "Personas",
				"tableSingle": "Mesa",
				"tablePlural": "Mesas",
				"time": "Tiempo"
			},
			"totalReceiptCard": {
				"averageTicket": "Ticket medio",
				"column": {
					"adjustedReceipt": "Ingresos ajustados",
					"bar": "Bar",
					"entrance": "Entrada",
					"entranceConsumptions": "Consumo de entrada",
					"extraConsumptions": "Consumo extra",
					"invoicing": "Facturación",
					"opened": "Abrir cuentas",
					"rechargeReturned": "Recargas devueltas",
					"refundedPostPayments": "Reversión de pago",
					"tableRow": {
						"ame": "Ame",
						"anticipated": "Anticipado",
						"app": "App",
						"cash": "Efectivo",
						"credit": "Crédito",
						"debit": "Débito",
						"deliveryOnline": "Delivery Online",
						"ifood": "Ifood",
						"pix": "Pix",
						"postEvent": "Pagado después del evento",
						"rappi": "Rappi Pay",
						"uber": "Uber",
						"voucher": "Voucher",
						"integratedFoodVoucher": "Vale de Alimentación",
						"mbway": "Mbway",
						"online": "Online"
					},
					"title": "Modo de pago",
					"total": "Total",
					"value": "Valor"
				},
				"emptyContent": "No hay nada que mostrar aquí",
				"errorContent": "Error!",
				"notIdealStateMessage": "Esta información solo está disponible para eventos de 08/01/2017",
				"realTicket": "Real Ticket",
				"receipt": "Recibo",
				"operationTable": {
					"title": "Operación",
					"operationMode": "Modo de operación",
					"zigTable": "Zig Mesa",
					"zigCard": "Zig Card",
					"zigDelivery": "Zig Delivery",
					"total": "Total",
					"invoicing": "Facturación"
				},
				"timelineCard": {
					"consumption": "Consumo",
					"period": "Periodo",
					"recharge": "Recambios",
					"zigCardConsumption": "Consumo Zig Card",
					"tableConsumption": "Consumo de mesa",
					"tooltipMessage": "{{titleMap}} en el período de {{start}} al{{end}}",
					"value": "Valor consumido"
				},
				"title": "Financiero",
				"zeroTicket": "Zero Ticket"
			},
			"vendorsResumeCard": {
				"name": "Proveedores",
				"title": "Ventas por proveedores",
				"totalSold": "Total vendido"
			}
		},
		"pos": {
			"columns": {
				"fingerPrint": "CÓDIGO",
				"product": "PRODUCTO",
				"version": "VERSIÓN",
				"employee": "EMPLEADO",
				"activacion": "ACTIVACIÓN",
				"lastUpdate": "ÚLTIMA ACTUALIZACIÓN",
				"cleanedDataStatus": "¿LIMPIÓ??",
				"hasFinishedActivity": {
					"finished": "CERRADO",
					"label": "Operación",
					"open": "Abrir"
				},
				"devicePlatform": "MODELO",
				"status": "STATUS",
				"date": "FECHA"
			},
			"deviceConfigColumn": {
				"bluetooth": "Bluetooth",
				"bluetoothMachine": "Máquina Bluetooth",
				"connected": "Conectado",
				"disconnect": "Sin conexión",
				"mobileData": "Datos móviles",
				"nfc": "NFC",
				"noData": "no data",
				"off": "off",
				"on": "on",
				"tryingToConnect": "Intentando conectarse a la máquina bluetooth",
				"wifi": "Wifi"
			},
			"editConfig": {
				"bluetooth": "Bluetooth",
				"configs": {
					"checkbox": "Intente emparejar la máquina bluetooth",
					"label": "Opciones"
				},
				"confirmMessage": "¿Está seguro de que desea guardar los cambios? Tanto el wifi como los datos móviles del dispositivo (s) están deshabilitados, por lo que no será posible ver la información actualizada del dispositivo.",
				"errorMessage": "Una de estas preferencias 'Habilitar venta' y 'Habilitar venta grupal' debe estar activa",
				"label": "Editar configuración",
				"noName": "Preferencia sin nombre",
				"preferences": "Preferencias",
				"title": "Modificar TPVs ({{count}})",
				"wifi": "Wifi"
			},
			"error": "Esta operación sólo está permitida cuando no hay ningún TDV seleccionado",
			"humanizedPreferencies": {
				"dettachOnCheckout": "Separar automáticamente al finalizar la compra",
				"hideDettachOption": "Hide detach",
				"hidePaymentModeVoucher": "Ocultar el modo de pago Voucher",
				"isGroupedSellEnabled": "Habilitar la venta en grupo",
				"isKeyboardOpenEnabled": "El teclado ya está abierto",
				"isNormalSellEnabled": "Habilitar venta",
				"isNumericKeyboardInObsEnabled": "Observación con teclado numérico",
				"isSearchByCodeEnabled": "Búsqueda numérica",
				"isSellWithoutCardEnabled": "Habilitar la venta sin tarjeta",
				"isStockTransfEnabled": "Transferir stock",
				"isStorageTransferPrinterLanActive": "Habilitar impresora de transferencia de inventario LAN",
				"printTwoTickets": "Imprime dos tickets de venta",
				"printViaBtForWaiter": "Mostrar botón para imprimir pedidos pendientes de empleados",
				"registerWithoutCard": "Regístrese sin tarjeta",
				"removeCreditDebitPaymentOption": "Eliminar opción de débito y crédito"
			},
			"info": "Es necesario que el TDV esté conectado a internet para sincronizar los ajustes.",
			"noName": "Sin nombre",
			"open": "{{active}} de {{total}} TPVs abiertos",
			"searchPlaceholder": "Buscar dispositivo o empleado",
			"settings": "Ajustes",
			"title": "Dispositivos: TPVs y Totems del Evento"
		},
		"sellChip": {
			"addCollaborator": "Agregar colaborador",
			"chipsFound": "{{num}} Chips encontrados",
			"columns": {
				"actionButton": "Chip de reembolso",
				"clients": "Clientes",
				"date": "Fecha",
				"employee": "Empleado",
				"products": "Productos",
				"refunded": "Reembolsado",
				"value": "Valor"
			},
			"modal": {
				"okText": "Reembolso",
				"product": "Producto",
				"products": "Productos",
				"reason": "Razón",
				"reasonError": "Este campo no puede estar vacío",
				"reasonPlaceholder": "Introduce el motivo del reembolso",
				"reasonRequired": "Razón requerida.",
				"returnToStorage": "Devolver el producto al almacén",
				"shouldReturnToStorage": "¿Debería volver al almacenamiento?",
				"title": "Reembolsa el chip {{client}}"
			},
			"noChipsFound": "No se han encontrado chips",
			"oneChipFound": "Un chip encontrado",
			"placeholder_one": "Seleccione el colaborador",
			"placeholder_other": "Seleccionar colaboradores",
			"searchPlaceholder": "Búsqueda por cliente o producto",
			"title": "Chips vendidos en el evento"
		},
		"operationReports": {
			"tabs": {
				"orangeScreenReport": "Informe de Pantalla Naranja",
				"allEventActionsReport": "Acciones del Evento",
				"totemActionsReport": "Acciones en el Totem"
			},
			"orangeScreenReport": {
				"title": "Informe de Pantalla Naranja",
				"subtitle": "Lista con todos los incidentes en el período del evento.",
				"filters": {
					"employee": {
						"label": "Nombre del empleado",
						"placeholder": "Ingrese el nombre del empleado"
					},
					"deviceFingerprint": {
						"label": "ID del PDV",
						"placeholder": "Ingrese el ID del PDV"
					}
				},
				"columns": {
					"date": "Fecha/hora del incidente",
					"employee": "Empleado",
					"deviceId": "ID de PDV",
					"zigDeviceUid": "ID de Tarjeta"
				},
				"filename": "informe-de-pantalla-naranja"
			},
			"allEventActionsReport": {
				"title": "Acciones del Evento",
				"description": "Lista de todas las acciones durante el evento.",
				"filters": {
					"employee": {
						"label": "Nombre del operador",
						"placeholder": "Ingrese o seleccione el operador"
					},
					"transaction": {
						"label": "Tipo de transacción",
						"placeholder": "Ingrese o seleccione el tipo"
					}
				},
				"columns": {
					"id": "Id",
					"date": "Fecha y hora",
					"transactionType": "Tipo de transacción",
					"employee": "Operador",
					"user": "Cliente",
					"paymentMethod": "Forma de pago",
					"products": {
						"title": "Productos",
						"name": "Nombre del producto",
						"count": "Cantidad",
						"value": "Valor"
					},
					"value": "Valor"
				},
				"filename": "informe-acciones-del-evento",
				"paymentMethodWithCashless": {
					"ZigPosCredit": "ZigPos Crédito",
					"ZigPosCreditInInstallments": "ZigPos Crédito en Cuotas",
					"ZigPosDebit": "ZigPos Débito",
					"CreditCard": "Tarjeta de Crédito",
					"DebitCard": "Tarjeta de Débito",
					"Cash": "Efectivo",
					"App": "App",
					"Voucher": "Vale",
					"Anticipated": "Anticipado",
					"Pix": "Pix",
					"Cashless": "Sin Efectivo",
					"IntegratedFoodVoucher": "Vale de Comida Integrado",
					"MBWay": "MBWay",
					"Bonus": "Bonus",
					"MinimumConsumption": "Consumo Mínimo",
					"Ifood": "Ifood",
					"DigitalCashless": "Cashless Digital"
				},
				"openingInfoModal": "Datos de apertura del evento",
				"opening": "Apertura",
				"by": "Por",
				"openingTime": "Hora de apertura",
				"openingBy": "Abrir evento por"
			},
			"totemActionsReport": {
				"title": "Totem Acciones",
				"description": "Lista de todas las acciones durante el evento.",
				"filters": {
					"totem": {
						"label": "Totem",
						"placeholder": "Ingrese o seleccione el totem"
					},
					"transaction": {
						"label": "Tipo de transacción",
						"placeholder": "Ingrese o seleccione el tipo"
					},
					"search": {
						"label": "Buscar",
						"placeholder": "Buscar por ID"
					}
				},
				"columns": {
					"date": "FECHA Y HORA",
					"transactionType": "TIPO DE TRANSACCIÓN",
					"totem": "TOTEM",
					"user": "CLIENTE",
					"value": "VALOR",
					"paymentMethod": "FORMA DE PAGO"
				},
				"filename": "informe-acciones-del-totem"
			}
		},
		"zigTags": {
			"block": {
				"success": "TAG bloqueado con éxito"
			},
			"empty": {
				"title": "Busca un ZIG TAG para administrarla"
			},
			"form": {
				"errors": {
					"zigTagRequired": "Escriba el número de TAG que desea buscar"
				},
				"label": "Buscar Zig TAG",
				"placeholder": "Escribe el número del TAG",
				"searchBtn": "Buscar"
			},
			"table": {
				"actions": {
					"blockTag": "Bloquear Tag"
				},
				"columns": {
					"actions": "Actions",
					"isBlocked": "Está bloqueado?",
					"userDocument": "Documento de usuario",
					"userName": "Usuario",
					"zigCode": "Zig Código"
				}
			},
			"title": "Gestionar Zig Tags"
		},
		"tableReports": {
			"tabs": {
				"performanceTableReport": {
					"tabName": "Rendimiento de las mesas",
					"label": "Informes de mesas",
					"title": "Rastrea el rendimiento de las mesas y optimiza la gestión de tu restaurante.",
					"averageTime": "tiempo promedio",
					"filters": {
						"table": "Todas las mesas",
						"periodOptions": {
							"sevenDays": "7 días",
							"fifteenDays": "15 días",
							"thirtyDays": "30 días",
							"sixtyDays": "60 días"
						},
						"allTables": "Todas las mesas"
					},
					"more": "más",
					"less": "menos",
					"tableNumber": "Número de mesa",
					"qtdTimes": "veces",
					"eventPercentage": "{{comparison}} que el último evento",
					"companiePercentage": "{{comparison}} que en los últimos {{days}} días",
					"served": "atendidas",
					"cards": {
						"totalBilling": "Facturación total",
						"peopleServed": "Personas atendidas",
						"averageTicketPerTable": "Ticket promedio por mesa",
						"averageTicketPerPerson": "Ticket promedio por persona",
						"bestPerformanceByWaiter": "Mejor desempeño por mesero",
						"mostSoldProduct": "Producto más vendido",
						"averageSpins": "Promedio de giros",
						"AverageLengthOfStay": "Promedio de permanencia",
						"tableCombinations": "Combinaciones de mesas",
						"nextPage": "Siguiente",
						"previousPage": "Anterior",
						"totalSales": "Total en ventas",
						"averageTicket": "Ticket promedio",
						"attendances": "Atenciones"
					},
					"table": {
						"title": "Consumo de mesas",
						"columns": {
							"tableName": "MESA",
							"employeeName": "MESERO",
							"numberOfSeats": "PERSONAS",
							"checkoutBy": "CERRADO POR",
							"openedAt": "APERTURA",
							"permanence": "TIEMPO DE PERMANENCIA",
							"tip": "SERVICIO",
							"productsValue": "PRODUCTOS",
							"closedAt": "CERRADO",
							"discount": "DESCUENTOS",
							"refundValue": "REEMBOLSOS",
							"totalValue": "TOTAL",
							"products": {
								"imageUrl": "FOTO",
								"sku": "SKU",
								"name": "NOMBRE DEL PRODUCTO",
								"quantity": "CANTIDAD",
								"unitPrice": "PRECIO UNITARIO",
								"subTotal": "SUBTOTAL",
								"discount": "DESCUENTOS",
								"total": "PRECIO TOTAL"
							}
						}
					}
				},
				"general": {
					"label": "Informe general",
					"eventDate": "Fecha del evento",
					"filters": {
						"table": "Mesa",
						"employeeName": "Empleado",
						"payment": "Pago",
						"tablePlaceholder": "Seleccione una mesa",
						"employeeNamePlaceholder": "Todos",
						"status": "Status",
						"paymentPlaceholder": "Todos",
						"dateOrPeriod": "Dato o periodo"
					},
					"resume": {
						"people": "Personas",
						"totalRevenue": "Ingresos totales",
						"openTables": "Mesas en uso",
						"tablesUsed": "Mesas utilizadas",
						"chargeback": "Revertidos",
						"averageTicket": "Ticket medio",
						"averageLengthStay": "Tiempo promedio de estancia",
						"hours": "horas y",
						"minutes": "minutos"
					},
					"table": {
						"title": "Consumo de mesas",
						"allPayments": "Ver todos los pagos",
						"columns": {
							"tableName": "MESA",
							"employeeName": "EMPLEADO",
							"numberOfSeats": "PERSONAS",
							"permanence": "PERMANENCIA",
							"openedAt": "APERTURA",
							"closedAt": "CIERRE",
							"discount": "DESCUENTOS",
							"refundValue": "REVERTIR",
							"totalValue": "TOTAL",
							"icon": "CUENTA",
							"buyers": {
								"name": "NOMBRE",
								"document": "DNI",
								"paymentType": "TIPO DE PAGO",
								"total": "TOTAL"
							}
						}
					},
					"paymentTypes": {
						"CreditCard": "Tarjeta de crédito",
						"DebitCard": "Tarjeta de débito",
						"Pix": "Pix",
						"Cash": "Efectivo"
					}
				},
				"totalProductsSold": {
					"label": "Total de productos vendidos"
				},
				"totalByClient": {
					"label": "Total por cliente",
					"title": "Total de ventas por cliente",
					"table": {
						"title": "Consumo de mesas",
						"columns": {
							"name": "NOMBRE",
							"document": "DNI",
							"openedAt": "APERTURA",
							"closedAt": "CIERRE",
							"payment": "PAGO",
							"serviceValue": "VALOR DEL SERVICIO",
							"discount": "DESCUENTOS",
							"refundValue": "REVERTIR",
							"totalValue": "TOTAL",
							"products": {
								"imageUrl": "IMAGEN",
								"sku": "SKU",
								"name": "NOMBRE DEL PRODUCTO",
								"tableName": "MESA",
								"payment": "PAGO",
								"quantity": "CANTIDAD",
								"unitValue": "VALOR UNITARIO",
								"totalValue": "VALOR TOTAL"
							}
						}
					}
				},
				"productsByTable": {
					"label": "Salida de productos en mesa"
				},
				"tableProductsSold": {
					"mainTitle": "Rendimiento de la mesa",
					"mainSubtitle": "Acompaña el descanso de las mesas y potencializa la gestión de tu restaurante.",
					"label": "Salida de productos en mesa",
					"title": "Salida de productos en mesa",
					"tabName": "Rendimiento de la mesa",
					"filters": {
						"table": "Mesa",
						"employeeName": "Empleado",
						"payment": "Pago",
						"product": "Producto",
						"tablePlaceholder": "Seleccione una mesa",
						"employeeNamePlaceholder": "Todos",
						"status": "Status",
						"paymentPlaceholder": "Todos",
						"productPlaceholder": "Todos"
					},
					"table": {
						"title": "Consumo de mesas",
						"columns": {
							"tableName": "MESA",
							"employeeName": "EMPLEADO",
							"numberOfSeats": "PERSONAS",
							"permanence": "PERMANENCIA",
							"openedAt": "APERTURA",
							"closedAt": "CIERRE",
							"discount": "DESCUENTOS",
							"refundValue": "REVERTIR",
							"totalValue": "TOTAL",
							"products": {
								"imageUrl": "IMAGEN",
								"sku": "SKU",
								"name": "NOMBRE DEL PRODUCTO",
								"quantity": "CANTIDAD",
								"unitPrice": "VALOR UNITARIO",
								"subTotal": "SUBTOTAL",
								"discount": "DESCUENTOS",
								"total": "VALOR TOTAL"
							}
						}
					}
				}
			}
		}
	},
	"shared": {
		"fiscalReportDateFilterHint": "Este filtro utiliza la fecha de la transacción, no la fecha de emisión de la factura",
		"fiscalReportDateFilterRechargeHint": "Este filtro utiliza la fecha de la recarga, no la fecha de emisión de la factura",
		"yes": "Sí",
		"no": "No"
	},
	"globalKeys": {
		"important": "Importante",
		"add": "Agregar",
		"all": "Todo",
		"and": "y",
		"attention": "Atención",
		"by": "por",
		"filter": "Filtrar",
		"cancel": "Cancelar",
		"close": "Cerrar",
		"code": "Código",
		"comingSoon": "Próximamente",
		"pending": "Pendiente",
		"conclude": "Terminar",
		"confirm": "Confirmar",
		"continue": "Continuar",
		"cpf": "DNI",
		"create": "crear",
		"currencies": {
			"dollar": "Dólar",
			"euro": "Euro",
			"mexPeso": "Peso mexicano",
			"real": "Real"
		},
		"day": "Día",
		"days": "Días",
		"month": "Mes",
		"category": "Categoría",
		"daysOfTheWeek": {
			"fri": "Vie",
			"friday": "Viernes",
			"mon": "Lun",
			"monday": "Lunes",
			"sat": "Sáb",
			"saturday": "Sábado",
			"sun": "Dom",
			"sunday": "Domingo",
			"thu": "Jue",
			"thursday": "Jueves",
			"tue": "Mar",
			"tuesday": "Martes",
			"wed": "Mié",
			"wednesday": "Miércoles"
		},
		"daysOfTheWeekComplete": {
			"friday": "Viernes",
			"holidays": "Vacaciones",
			"monday": "Lunes",
			"saturday": "Sábado",
			"sunday": "Domingo",
			"thursday": "Jueves",
			"tuesday": "Martes",
			"wednesday": "Miércoles"
		},
		"daysOfTheWeekSmall": {
			"fri": "Vie",
			"hol": "hol",
			"mon": "Lun",
			"sat": "Sáb",
			"sun": "Dom",
			"thu": "Jue",
			"tue": "Mar",
			"wed": "Mié"
		},
		"typeDate": {
			"Day": "Día",
			"Week": "Semana",
			"Month": "Mes",
			"Year": "Año"
		},
		"typeDatePlural": {
			"Days": "Días",
			"Weeks": "Semanas",
			"Months": "Meses",
			"Years": "Años"
		},
		"delete": "Borrar",
		"disable": "Desactivar",
		"disabled": "Desactivado",
		"download": "Descargar",
		"duplicate": "Duplicar",
		"edit": "Editar",
		"erase": "Borrar",
		"error": "Error",
		"exclude": "Borrar",
		"export": "Exportar tabela",
		"exportExcel": "Exportar en Excel",
		"exportPdf": "Exportar en PDF",
		"false": "Falso",
		"falseCaps": "FALSO",
		"finished": "Terminado",
		"from": "De",
		"gender": {
			"female": "Mujer",
			"male": "Hombre",
			"others": "Other"
		},
		"goBack": "Volver",
		"goFoward": "Adelante",
		"grams": "Gramos",
		"import": "Importar",
		"invalid": "No válido",
		"issue": "Emitir",
		"kilos": "Kilos",
		"leave": "Salir",
		"liter": "Litro",
		"loading": "Cargando",
		"message": "Mensaje",
		"messages": "Mensajes",
		"months": {
			"april": "Abril",
			"august": "Agosto",
			"december": "Diciembre",
			"february": "Febrero",
			"january": "Enero",
			"july": "Julio",
			"june": "Junio",
			"march": "Marzo",
			"may": "Mayo",
			"november": "Noviembre",
			"october": "Octubre",
			"september": "Septiembre"
		},
		"more": "más",
		"name": "Nombre",
		"new": "Nuevo",
		"newRole": "Nueva posición",
		"next": "Próximo",
		"no": "No",
		"noCaps": "NO",
		"notTested": "No probado",
		"order": "Orden",
		"period": "Período",
		"phone": "Teléfono",
		"phoneInternational": "Teléfono (solo internacional)",
		"preview": "Vista previa",
		"previous": "Anterior",
		"print": "Impresión",
		"printReport": "Imprimir reporte",
		"reload": "Recargar",
		"remove": "Eliminar",
		"restore": "Restaurar",
		"request": "Pedir",
		"requiredField": "Campo obligatorio",
		"save": "Guardar",
		"search": "Buscar",
		"seeAttachments": "Ver adjuntos",
		"seeLess": "Ver menos",
		"seeMore": "Ver más",
		"select": "Seleccionar",
		"selected": "Seleccionado",
		"selectedPlural": "Seleccionados",
		"send": "Enviar",
		"sendMessageNow": "Enviar mensaje ahora",
		"shortMonths": {
			"apr": "Abr",
			"aug": "Ago",
			"dec": "Dec",
			"feb": "Feb",
			"jan": "Ene",
			"jul": "Jul",
			"jun": "Jun",
			"mar": "Mar",
			"may": "May",
			"nov": "Nov",
			"oct": "Oct",
			"sep": "Sep"
		},
		"tested": "Probado",
		"to": "Para",
		"toSelect": "Escoger",
		"today": "Hoy",
		"tomorrow": "Mañana",
		"transfer": "Transferencia",
		"true": "Verdadero",
		"truthCaps": "VERDADERO",
		"tryAgain": "Vuelve a intentarlo",
		"typeHere": "Escribe aquí",
		"unknown": "Anónimo",
		"uid": "Zig Code",
		"upload": "Subir",
		"value": "Valor",
		"withoutPermission": "No tienes los permisos",
		"withoutPermissionToViewPage": "No se permite ver la pagina",
		"yes": "Sí",
		"yesCaps": "SÍ",
		"yesterday": "Ayer",
		"update": "Actualizar",
		"enable": "Activar",
		"enabled": "Activado",
		"dataSavedSuccess": "Datos guardados exitosamente",
		"backToMainPage": "Volver a la página principal",
		"somethingWentWrong": "Ups... Algo no salió como estaba planeado",
		"savingData": "Guardando datos",
		"subtotal": "Total parcial",
		"total": "Total",
		"type": "Tipo",
		"emptyText": "No hay datos para mostrar.",
		"of": "de",
		"noneOfTheOptions": "Ninguna de las opciones",
		"transaction": "Transacción",
		"page": "página",
		"paginationTotal": "{{start}}-{{end}} de {{total}}",
		"recharge": "Recarga",
		"date": "Fecha",
		"since": "Desde",
		"until": "Hasta"
	},
	"nav": {
		"header": {
			"event": "Evento",
			"logout": "Cerrar sesión",
			"org": "Organización",
			"place": "Lugar",
			"language": "Idioma"
		},
		"navbar": {
			"default": {
				"logout": "Cerrar sesión",
				"changeLanguage": "Cambiar idioma",
				"changeSystemLanguage": "Cambiar el idioma del sistema"
			},
			"selectLanguageModal": {
				"selectLanguage": "Seleccione el idioma",
				"cancel": "Cancelar",
				"confirm": "Confirmar"
			},
			"event": {
				"barReports": "Bar Reports",
				"salesReport": "Informes de ventas",
				"bookings": "Reservas",
				"clients": "Información del cliente",
				"conference": "Conferencia de Evento",
				"financialReport": "Informes financieros",
				"guestList": "Listas de invitados",
				"multivendor": "Multi-vendor",
				"panel": "Panel",
				"businessIntelligence": "Panel general",
				"eventPanel": "Panel de eventos",
				"reports": "Informes",
				"customers": "Clientes",
				"devices": "Dispositivos",
				"sellChip": "Ventas sin tarjeta",
				"ticketsReport": "Informes de tickets",
				"zigTag": "Zig Tag",
				"operationReport": "Informe de Operación",
				"hawkersReport": "Informe de ambulantes",
				"rechargeManagement": "Gestión del saldo",
				"tableReports": "Informes de mesas"
			},
			"org": {
				"panel": "Lugares",
				"employee": "Acceso al equipo",
				"crm": "CRM",
				"categories": "Categorías",
				"reports": "Informes",
				"recharge": "Recarga",
				"stock": "Stock",
				"giftback": "Giftback",
				"fiscal": "Fiscal",
				"taxRegistration": "Registro Fiscal",
				"internalSalesCampaign": "Campaña de ventas interna.",
				"productRegistration": "Registro de producto",
				"advancedBI": "BI avanzado",
				"customersList": "Lista de Clientes",
				"stockInventory": "Stock",
				"stockInventoryV1": "Registro de base de producto",
				"taxData": "Datos fiscales",
				"fiscalSettings": "Datos fiscales",
				"financialReport": "Reportes",
				"satisfactionSurvey": "Encuesta de satisfacción",
				"customers": "Área de Clientes",
				"sendingMessages": "Enviar mensajes",
				"loyalty": "Programas de fidelización",
				"communication": "Campañas de Comunicación",
				"chartOfAccounts": "Plan de cuentas",
				"fiscalBoard": "Junta Fiscal",
				"vendors": "Proveedores",
				"team": "Equipo"
			},
			"place": {
				"audits": "Auditorías",
				"barReports": "Bar Reports",
				"salesReport": "Informes de ventas",
				"prechargeReports": "Precarga por hoja de cálculo",
				"businessInteligence": "Business Intelligence",
				"pdvTeam": "Operadores de PDV",
				"productAndMenu": "Productos y Menús",
				"cashFlow": "Financiero",
				"clients": "Clientes",
				"contracts": "Contratos",
				"tagGroups": "Grupos de Etiquetas",
				"delivery": "Delivery",
				"deliveryOrders": "Pedidos",
				"deliveryReport": "Informes",
				"deliveryMenus": "Menús",
				"deliverySettings": "Configuración",
				"events": "Eventos",
				"extract": "Extracto",
				"financialReport": "Informes financieros",
				"guestList": "Lista de invitados",
				"invoices": "Facturas",
				"transferReport": "Informe de transferencia",
				"multivendor": "Multi-vendor",
				"passwordCard": "Tarjeta de contraseña",
				"pos": "Ventas POS",
				"precharge": "Sitios de precarga",
				"products": "Productos",
				"menu": "Menú",
				"bars": "Bares y Sectores",
				"opened": "Abierto",
				"closed": "Cerrado",
				"crm": "CRM",
				"reports": "Informes",
				"preChargeLabel": "Pre-carga",
				"inventoryControl": "Control de inventario",
				"receptive": "Receptivo",
				"promotions": "Promociones y descuentos",
				"settings": "Configuración",
				"storage": "Almacenamiento",
				"storageReports": "Informes de Stock",
				"tickets": "Tickets",
				"ticketsReport": "Informes de tickets",
				"whatsup": "What's Up?",
				"zigAccount": "Cuenta Zig",
				"rechargeManagement": "Gestión del saldo",
				"tableReports": "Informes de mesas",
				"generalConfig": "Configuración General",
				"operationReport": "Informe de operación",
				"config": "Configuraciones",
				"kds": "Gestor de pedidos (KDS)",
				"kdsConfig": "Administrar KDS",
				"kdsReport": "Informe"
			}
		}
	},
	"noAuth": {
		"expiredSession": {
			"cardTitle": "Por su seguridad, su sesión ha caducado.",
			"loginButtonLabel": "Volver a iniciar sesión"
		},
		"login": {
			"dashboard": "Dashboard"
		},
		"errors": {
			"required": "Campo obligatorio",
			"passwordMustBeSame": "Las contraseñas deben ser iguales",
			"minLength": "La contraseña debe tener al menos {{count}} caracteres"
		},
		"actions": {
			"send": "Enviar"
		},
		"confirmMessages": {
			"passwordUpdated": "Contraseña actualizada con éxito"
		},
		"labels": {
			"password": "Contraseña",
			"confirmPassword": "Confirmación de contraseña"
		},
		"recoveryPassword": "Recuperación de contraseña"
	},
	"org": {
		"employees": {
			"tabs": {
				"employees": {
					"addEmployeeZigtagError": "Error al agregar colaborador con Zigtag",
					"addModal": "Agregar empleado",
					"checkAll": "Seleccionar empleado ({{counter}})",
					"columns": {
						"bar": {
							"label": "Bar",
							"none": "No hay barra seleccionada"
						},
						"custom": "Costum",
						"name": "Empleado",
						"places": {
							"label": "Lugares",
							"none": "No hay lugar seleccionado"
						},
						"role": "Puesto de trabajo",
						"username": "Iniciar sesión",
						"zigtag": "ZigTag"
					},
					"createEmployee": {
						"barsSelect": {
							"bars": "Bars",
							"menu": "Menu",
							"print": "Impresión"
						},
						"fakeBarBlocklistPermission": "Restringir la vista de los productos del menú",
						"menuVisualization": {
							"label": "Tipos",
							"placeholder": "Seleccione el tipo de visualización del menú",
							"title": "Visualización del menú",
							"type": {
								"grid": "Predeterminado",
								"list": "Sin foto",
								"smallGrid": "Foto pequeña"
							}
						},
						"noSelectedPlace": "Seleccione un lugar para habilitar este permiso",
						"onlyOneSelect": "Para habilitar este permiso, seleccione solo una ubicación",
						"validation": {
							"initialValueSmaller": "El valor inicial debe ser menor que el final",
							"login": "Introduzca un nombre de usuario válido",
							"name": "Introduce un nombre válido",
							"negative": "Los valores no pueden ser negativos",
							"password": "Introduce una contraseña válida",
							"role": "Seleccionar un rol",
							"same": "Los valores rellenados son los mismos",
							"selectedPlaces": "At least one location is required",
							"twoValues": "Ambos valores deben ser completados"
						}
					},
					"deleteModal": {
						"content": "¡Atención! Los empleados serán desactivados permanentemente.",
						"title": "¿Desea desactivar {{count}} empleado(s)?"
					},
					"deleteWarning": "¡Vaya! Se ha producido un problema, inténtelo de nuevo",
					"edit": {
						"data": {
							"employeeNumber": {
								"end": "Hasta",
								"label": "Agregar más de un empleado",
								"start": "En",
								"tooltip": "Solo para más de un empleado dentro del mismo puesto"
							},
							"label": "Datos de los empleados",
							"login": "Iniciar sesión",
							"name": "Nombre del empleado",
							"password": "Contraseña",
							"photo": "Foto",
							"zigCard": "Zig Card"
						},
						"extra": {
							"fichasAmount": {
								"label": "Número de formas registradas",
								"placeholder": "Cantidad de formas"
							},
							"label": "Información adicional",
							"type": "Tipo de colaborador"
						},
						"label": "Editar empleado",
						"places": {
							"label": "Lugares",
							"selectedBar": {
								"label": "Bares",
								"placeholder": "None"
							},
							"selectedPlace": "Lugares",
							"mainBar": "Bar principal / punto de venta"
						},
						"role": {
							"employeeRole": {
								"custom": "Personalizar",
								"label": "Oficina",
								"none": "Ninguno",
								"placeholder": "Elegir un puesto de trabajo"
							},
							"label": "Roles de trabajo y permisos",
							"permissions": "Permisos"
						},
						"seeProducts": {
							"blockedBar": {
								"label": "Cerrar barras",
								"placeholder": "Ninguno"
							},
							"label": "Ver productos de bar"
						}
					},
					"editButton": "Editar empleado",
					"exportButton": "Exportar empleados",
					"deleteButton": "Eliminar empleados",
					"editMultiple": {
						"bar": "Bares",
						"confirm": "¿Desea modificar los siguientes colaboradores?",
						"fichasAmount": "Número de formas registradas",
						"info": "Los campos sin rellenar mantendrán sus valores iniciales",
						"label": "Editar empleado ({{count}})",
						"none": "Ninguno",
						"number": "Número desde",
						"places": "Lugares",
						"rename": "Editar nombre",
						"role": "Cambiar el rol del trabajo",
						"mainBar": "Bar principal"
					},
					"employeeDelete": {
						"customized": "Posición personalizada",
						"text": "¿Realmente quieres eliminar {{name}} ({{role}})'? Esta acción no se puede deshacer"
					},
					"filter": "Filtrar por lugares",
					"importModal": {
						"buttonText": "Elija un worksheet",
						"columns": {
							"fichasAmount": "Número de formas en tokens",
							"name": "Nombre",
							"password": "Contraseña",
							"username": "Nombre de usuario",
							"zigTag": "ZigTag"
						},
						"custom": "Personalizar",
						"errorNotification": "No worksheet seleccionada",
						"label": "Importar empoleado",
						"passwordRequirements": "Los empleados con el permiso \"Acceso al dashboard\" deben seguir las siguientes reglas para la contraseña: mínimo de 6 caracteres, al menos una letra.",
						"permissions": "Permisos",
						"places": "Lugares y Bares",
						"requiredField": "Este campo es obligatorio",
						"role": "Oficina",
						"selectPlace": "Se debe seleccionar al menos una ubicación",
						"sheetFileName": "Empleado"
					},
					"multipleEmployeeModalError": {
						"success": "Creado con éxito",
						"successMessage": "Se han creado {{logins}} empleados de inicio de sesión",
						"error": "Fallido",
						"errorMessage": "No se pueden crear empleados que inicien sesión {{logins}}. nombre de usuario ya existe"
					},
					"importSuccess": "Empleados importados correctamente",
					"label": "Equipo",
					"search": "Buscar",
					"uncheckAll": "Anule la selección de todos los empleados ({{counter}})"
				},
				"roles": {
					"columns": {
						"employees": "Número de empleados",
						"none": "Ninguno",
						"options": "Opciones",
						"role": "Puestos de trabajo"
					},
					"create": "Crear rol de trabajo",
					"edit": "Editar rol de trabajo",
					"isNameInvalid": "Los campos no se rellenaron correctamente",
					"label": "Puestos de trabajo",
					"modal": {
						"importPermissions": {
							"label": "Importar permisos",
							"placeholder": "Ex: box"
						},
						"permissions": "Permisos",
						"placesBar": {
							"bar": "Bar",
							"blocked": "Cerrar barras",
							"chooseBar": "Elige un bar",
							"chooseLocal": "Elige un lugar",
							"chooseMinimum": "Elige al menos un bar",
							"none": "Ninguno",
							"place": "Lugares"
						},
						"roleName": {
							"error": "Nombre no válido",
							"label": "Nombre del puesto de trabajo",
							"placeholder": "Ex: Waiter"
						}
					},
					"removeRole": "¿Está seguro de que desea eliminar el rol de trabajo?",
					"roleError": "No se encontró el puesto de trabajo, inténtelo de nuevo",
					"search": "Buscar por puesto de trabajo"
				}
			}
		},
		"clients": {
			"applyFilter": "Aplicar filtros",
			"cancel": "Cancelar",
			"place": "Lugar",
			"clearFilter": "Borrar todos los campos",
			"daysOfTheWeek": {
				"friday": "Viernes",
				"monday": "Segundo",
				"saturday": "Sábado",
				"sunday": "Domingo",
				"thursday": "Quinto",
				"tuesday": "Martes",
				"wednesday": "Cuarto"
			},
			"documentTypePlaceHolder": "Seleccionar tipo de documento de cliente",
			"filter": {
				"addProduct": "Añadir otro producto",
				"consumptionVolume": "Consumo mínimo",
				"daysOfTheWeek": "Días de la semana",
				"daysOfTheWeekPlaceholder": "Seleccione los días de la semana",
				"gender": "Género",
				"genderPlaceholder": "Seleccionar el género",
				"noProducts": "No se encontraron productos",
				"notUsedRecharges": "Saldo mínimo de recarga no utilizado",
				"period": "Período",
				"periodFrequency": "Frecuencia",
				"firstTime": "1ª vez",
				"frequencyPlaceholder": "Elegir frecuencia del cliente",
				"product": "Producto",
				"productsConsumed": "productos consumidos",
				"quantity": "La cantidad",
				"removeProduct": "Eliminar producto",
				"selectProduct": "Elige un producto",
				"yearPlaceholder": "aaaa",
				"birthdateRange": "Período de Cumpleaños",
				"birthdateYear": "Año de Cumpleaños",
				"products": "Productos",
				"productsPlaceholder": "Seleccione los productos",
				"errors": {
					"type": "Datos inválidos",
					"birthdate": {
						"year": "Inserte un año entre 1900 y el año actual"
					}
				}
			},
			"filterTitle": "Filtros avanzados",
			"filterByProductTitle": "Filtrar por producto",
			"gender": {
				"female": "Mujer",
				"male": "Hombre",
				"others": "Otros"
			},
			"productError": "La cantidad de {{producto}} debe ser mayor que cero",
			"search": "Buscar",
			"searchTitle": "Tipo de búsqueda",
			"searchPlaceholder": "Insertar documento del cliente",
			"searchClientByName": "Insertar nombre del cliente",
			"table": {
				"birthDate": "Fecha de cumpleaños",
				"consumption": "Consumado",
				"countClients_one": "Cliente encontrado",
				"countClients_other": "Clientes encontrados",
				"countTicketClients": "Ticket promedio por cliente",
				"cpf": "CPF",
				"email": "Correo electrónico",
				"emptyText": "No hay información para mostrar",
				"firstTimeAtPlace": "Primera vez",
				"hasApp": "Aplicación activa",
				"infoLabel": "Seleccione un cliente para ver los detalles.",
				"lastTimeAtPlace": "Última visita",
				"moreResults": "Cargar más resultados",
				"moreThan": "mas de",
				"name": "Cliente",
				"phone": "Teléfono",
				"presences": "Presencia",
				"remaningValueOnPlace": "saldo disponible",
				"uninformed": "No informado"
			},
			"titleWithPlace": "Lista de clientes"
		},
		"fiscal": {
			"fiscalData": "Datos fiscales",
			"validations": {
				"number": "Sólo números"
			}
		},
		"fiscalBoard": {
			"addPlace": "Añadir lugar",
			"column": {
				"date": "Fecha",
				"errorType": "Tipo de error",
				"total": "Total emitible",
				"type": "Tipo",
				"value": "Valor"
			},
			"fiscalProfile": "Emisión por perfil fiscal",
			"issuingErrors": "Emisión de errores",
			"nfce": "NFC-e",
			"nfceIssued": "NFC-e issued",
			"nfse": "NFS-e",
			"nfseIssued": "NFS-e issued",
			"selectMonth": "Seleccione un mes",
			"selectPlace": "Seleccione un lugar"
		},
		"fiscalData": {
			"components": {
				"drawers": {
					"drawerProfile": {
						"excludeTaxProfile": "Excluir perfil",
						"infoDataCompany": {
							"CNPJ": "CIF",
							"cityCode": "Código postal",
							"corporateReason": "Razón corporativa",
							"fantasyName": "Nombre Empresa",
							"municipalRegistration": "Municipal registration",
							"stateRegistration": "State registration",
							"taxRegime": "Tax regime"
						},
						"infoDataIvaVendus": {
							"apikey": "API key",
							"cashierIds": "IDs cajeros",
							"country": "País",
							"payments": {
								"cash": "Efectivo",
								"credit": "Crédito",
								"debit": "Débito",
								"mbway": "Mbway",
								"others": "Otros",
								"paymentMethodId": "Forma de pago"
							}
						},
						"infoDataNfce": {
							"certificate": "Certificado",
							"certificatePassword": "Contraseña del certificado",
							"cscNfceHomologation": "CSC NFC-e homologación",
							"cscNfceProduction": "CSC NFC-e producción",
							"expirationDate": "Fecha de caducidad",
							"idNfceHomologation": "ID NFC-e homologación",
							"idNfceProduction": "Id NFC-e producción"
						},
						"infoDataSat": {
							"serialNumberSat": "Número de serie SAT"
						},
						"infoDataTax": {
							"mode": "Tax mode"
						},
						"infoManifestation": {
							"manifestation": "Manifestación"
						},
						"infoNationalService": {
							"nationalService": "Serviço Nacional"
						},
						"infosGeneralData": {
							"email": "Email",
							"phone": "Teléfono"
						},
						"infosGeneralDataFiscalModeBR": {
							"cep": "Código postal",
							"county": "Ciudad",
							"neighborhood": "Barrio",
							"number": "Número",
							"publicPlace": "Calle",
							"state": "Comunidad Autónoma"
						},
						"infosTipConfig": {
							"taxGroup": "Grupo fiscal",
							"registered": "Registrado"
						},
						"titles": {
							"companyData": "Datos de la empresa",
							"generalData": "Datos generales",
							"taxData": "Datos fiscales",
							"tipConfig": "Configuración de la punta"
						}
					},
					"editData": "Editar información",
					"viewlinkedplaces": "Ver lugares enlazados",
					"drawerCouvert": {
						"code": "SKU",
						"couvertGeneralData": "Datos generales de couvert",
						"taxGroup": "Grupo fiscal",
						"taxProfile": "Perfil fiscal"
					},
					"drawerGroup": {
						"excludeTaxGroup": "Excluir grupo",
						"titles": {
							"generalData": "Datos generales",
							"vat": "IVA",
							"service": "Servicio"
						},
						"fiscalProductGroupType": {
							"vat": "Impuesto sobre el Valor Agregado (IVA)",
							"vatFactura": "Impuesto sobre el Valor Agregado (IVA) - Mexico",
							"vatSpain": "IVA (España)",
							"service": "Servicio",
							"serviceNational": "Servicio Nacional",
							"invoice": "Factura"
						},
						"fields": {
							"taxRate": {
								"label": "Tasa de impuesto (%)"
							},
							"code": {
								"label": "SKU"
							},
							"productType": {
								"label": "Tipo de producto"
							},
							"taxExemption": {
								"label": "Exención de impuestos"
							},
							"taxType": {
								"label": "Tipo de impuesto"
							}
						}
					}
				},
				"infoCard": {
					"seeDatails": "Ver detalles"
				},
				"modalPlaces": {
					"message": "Utilice la tabla siguiente para activar y desactivar el {{ groupOrProfile }} fiscal en su organización",
					"group": "Grupo",
					"profile": "Perfil",
					"title": "Lugares vinculados al {{ groupOrProfile }} fiscal: {{ name }}",
					"searchPlace": "Buscar place",
					"placesAt": "Lugares en"
				},
				"modalDelete": {
					"messageProfile": "Al confirmar la acción, eliminarás permanentemente el perfil fiscal {{ profile }}. ¿Deseas continuar?",
					"messageGroup": "Al confirmar la acción, eliminarás permanentemente el grupo fiscal {{ group }}. ¿Deseas continuar?",
					"profileDeletedSuccess": "¡Perfil fiscal eliminado exitosamente!",
					"groupDeletedSuccess": "¡Grupo fiscal eliminado exitosamente!"
				}
			},
			"taxTabs": {
				"tabTaxCouvert": {
					"emptyTaxCouvertMessage": "No hay datos fiscales de couvert para mostrar",
					"infosTaxCouvert": {
						"cest": "CEST",
						"cfop": "CFOP",
						"code": "SKU",
						"group": "Group",
						"ncm": "NCM",
						"profile": "Profile"
					},
					"searchPlaceholder": "Buscar datos fiscales de couvert"
				},
				"tabTaxGroups": {
					"addNewTaxGroup": "Agregar nuevo grupo",
					"emptyTaxGroupsMessage": "No existen grupos fiscales de producto para mostrar",
					"infosTaxGroup": {
						"aliquot": "Alícuota",
						"cfop": "CFOP",
						"tax": "Impuesto",
						"type": "Tipo"
					},
					"searchPlaceholder": "Buscar grupos fiscales de producto",
					"typeLabel": {
						"invoice": "Factura",
						"service": "Servicio",
						"serviceNational": "Servicio nacional",
						"vat": "IVA (Portugal)",
						"vatFactura": "IVA (México)",
						"vatSpain": "IVA (España)"
					}
				},
				"tabTaxProfiles": {
					"addNewTaxProfile": "Agregar nuevo perfil",
					"emptyTaxProfilesMessage": "No hay perfiles fiscales para mostrar",
					"infosTaxProfile": {
						"cnpj": "CIF",
						"corporateName": "Razón social",
						"fantasyName": "Nombre Empresa",
						"stateRegistration": "Registro estatal",
						"taxRegime": "Tax regime",
						"phone": "Teléfono",
						"email": "E-mail"
					},
					"optionsTaxation": {
						"normalRegime": "Normal regime",
						"simpleNational": "Simple national",
						"simpleNationalExcess": "Simple national excess"
					},
					"searchPlaceholder": "Search tax profile"
				}
			},
			"titlePage": "Tax data",
			"titlesTabs": {
				"taxCouvert": "Couvert Tax Data",
				"taxGroups": "Product Tax Groups",
				"taxProfiles": "Tax profiles",
				"minimumConsummation": "Consumo mínimo",
				"recharge": "Recarga"
			}
		},
		"fiscalCouvertForm": {
			"editOfPlace": "Editar couvert fiscal de {{ placeName }}",
			"fields": {
				"code": {
					"label": "SKU",
					"placeholder": "Ingrese el SKU"
				},
				"NCM": {
					"label": "NCM",
					"placeholder": "Ingrese el NCM"
				},
				"CEST": {
					"label": "CEST",
					"placeholder": "Ingrese el CEST"
				},
				"taxProfile": {
					"label": "Perfil fiscal"
				},
				"taxGroup": {
					"label": "Grupo fiscal"
				}
			}
		},
		"fiscalGroupForm": {
			"navigateBackGroupLabel": "Volver a los grupos fiscales",
			"navigateBackCouvertLabel": "Volver a los grupos fiscales",
			"titleSteps": {
				"vat": "Impuesto sobre el Valor Agregado",
				"service": "Servicio",
				"serviceNational": "Servicio Nacional",
				"general": "Datos generales"
			},
			"steps": {
				"general": {
					"fields": {
						"name": {
							"label": "Nombre",
							"placeholder": "Nombre del grupo"
						},
						"type": {
							"label": "Tipo"
						}
					},
					"types": {
						"invoice": "Factura",
						"vat": "IVA Portugal",
						"vatFactura": "IVA Mexico",
						"vatSpain": "IVA España",
						"service": "Servicio"
					}
				},
				"vat": {
					"fields": {
						"taxRate": {
							"label": "Tasa de impuesto (%)"
						},
						"code": {
							"label": "SKU",
							"placeholder": "Seleccionar SKU"
						},
						"productType": {
							"label": "Tipo de producto",
							"placeholder": "Seleccionar tipo de producto"
						},
						"taxExemption": {
							"label": "Exención de impuestos",
							"placeholder": "Seleccionar exención de impuestos"
						},
						"taxType": {
							"label": "Tipo de impuesto",
							"placeholder": "Seleccionar tipo de impuesto"
						},
						"region": {
							"label": "Región",
							"placeholder": "Seleccione la región"
						}
					},
					"vatVendusTaxExemptionOptions": {
						"M01": "Artículo 16.º, n.º 6 del CIVA o similar",
						"M02": "Artículo 6.º del decreto-Lei n.º 198/90, de 19 de Junio",
						"M03": "Exigibilidad de caja",
						"M04": "Artículo 13.º del CIVA o similar",
						"M05": "Artículo 14.º del CIVA o similar",
						"M06": "Artículo 15.º del CIVA o similar",
						"M07": "Artículo 9.º del CIVA o similar",
						"M08": "IVA (autoliquidación)",
						"M09": "IVA (no otorga derecho a deducción)",
						"M10": "IVA (régimen de exención: artículo 53.º del CIVA)",
						"M11": "Régimen particular del tabaco",
						"M12": "Régimen de margen de beneficio de agencias de viajes",
						"M13": "Régimen de margen de beneficio de bienes de segunda mano",
						"M14": "Régimen de margen de beneficio de objetos de arte",
						"M15": "Régimen de margen de beneficio de objetos de colección y antigüedades",
						"M16": "Artículo 14.º del RITI o similar",
						"M99": "No sujeto; no gravado o similar"
					},
					"vatVendusProductTypeOptions": {
						"P": "Producto",
						"S": "Servicio",
						"O": "Otro (fletes, anticipos, etc.)",
						"I": "Impuesto (excepto IVA e IS) o Carga Parafiscal",
						"E": "Impuesto especial sobre el consumo (IABA, ISP e IT)"
					},
					"vatVendusCodeOptions": {
						"INT": "Tipo impositivo intermedio",
						"ISE": "Exento",
						"NOR": "Tipo impositivo normal",
						"RED": "Tipo impositivo reducido",
						"RED2": "Tarifa súper reducida",
						"OUT": "Tarifa excepcional",
						"OUT2": "Tarifa excepcional 2"
					}
				}
			}
		},
		"fiscalProfileForm": {
			"components": {
				"infoBanner": {
					"tipError": {
						"title": "No pudimos completar el registro.",
						"description": "Revise los campos completados o inténtelo de nuevo en unos minutos."
					}
				}
			},
			"steps": {
				"company": {
					"fields": {
						"CNPJ": {
							"label": "CIF",
							"placeholder": "Añadir CIF"
						},
						"cityCode": {
							"label": "Código de la ciudad",
							"placeholder": "Insertar código de ciudad"
						},
						"corporateReason": {
							"label": "Razón corporativa",
							"placeholder": "Insertar motivo corporativo"
						},
						"fantasyName": {
							"label": "Nombre de fantasía",
							"placeholder": "Insertar nombre de fantasía"
						},
						"municipalRegistration": {
							"label": "Registro municipal",
							"placeholder": "Insertar registro municipal"
						},
						"stateRegistration": {
							"label": "Registro estatal",
							"placeholder": "Insertar registro estatal"
						},
						"taxRegime": {
							"label": "Régimen fiscal",
							"placeholder": "Seleccionar régimen fiscal"
						}
					},
					"optionsTaxation": {
						"normalRegime": "Régimen normal",
						"simpleNational": "Simple nacional",
						"simpleNationalExcess": "Simple national excess"
					}
				},
				"fiscal": {
					"fieldsIvaFactura": {
						"apikey": {
							"label": "Clave de la API",
							"placeholder": "Insertar clave de la API"
						},
						"secretkey": {
							"label": "Clave Secreta de la API",
							"placeholder": "Insertar clave secreta de la API"
						},
						"fiscalProductGroup": {
							"label": "Grupo fiscal del producto",
							"placeholder": "Elegir grupo fiscal del producto"
						},
						"autoInvoicingURL": {
							"label": "URL de autofacturación",
							"placeholder": "Insertar URL de autofacturación"
						},
						"issuerDocument": {
							"label": "RFC del emisor",
							"placeholder": "Insertar RFC del emisor"
						},
						"expiration": {
							"label": "Fecha de expiración",
							"placeholder": "Elegir una opción para la fecha de expiración",
							"expirationDaysLabel": "Días después de la fecha de la transacción",
							"expirationDaysPlaceholder": "Elegir días después de la fecha de la transacción",
							"expirationDaysHint": "Al establecer un plazo que exceda el mes de creación de la transacción, la fecha de vencimiento será el último día del mes.",
							"lastMonthDay": "En el último día del mes",
							"daysAfterTransaction": "Días después de la fecha de la transacción"
						}
					},
					"fieldsIvaVendus": {
						"apikey": {
							"label": "Clave API",
							"placeholder": "Insertar clave de API"
						},
						"cashierIds": {
							"label": "Identificaciones de cajero",
							"placeholder": "Insertar identificadores de cajero"
						},
						"country": {
							"label": "País",
							"placeholder": "Seleccionar país",
							"options": {
								"PT": "PT - Portugal",
								"ES": "ES - España"
							}
						},
						"paymentMethodIds": {
							"labelCash": "Efectivo",
							"labelCredit": "Crédito",
							"labelDebit": "Débito",
							"labelMbway": "Mbway",
							"labelOthers": "Otros",
							"labelPayment": "ID de método de pago:",
							"placeholderPaymentId": "Insertar ID"
						}
					},
					"fieldsNfce": {
						"certificate": {
							"label": "Certificado"
						},
						"certificatePassword": {
							"label": "Contraseña del certificado",
							"placeholder": "Insertar contraseña de certificado"
						},
						"cscNfceHomologation": {
							"label": "CSC NFC-e homologation",
							"placeholder": "Insert CSC NFC-e homologation"
						},
						"cscNfceProduction": {
							"label": "CSC NFC-e production",
							"placeholder": "Insert CSC NFC-e production"
						},
						"expirationDate": {
							"label": "Fecha de caducidad",
							"placeholder": "00/00/0000"
						},
						"idNfceHomologation": {
							"label": "ID NFC-e homologation",
							"placeholder": "Insert ID NFC-e homologation"
						},
						"idNfceProduction": {
							"label": "Id NFC-e production",
							"placeholder": "Insert ID NFC-e production"
						}
					},
					"fieldsSat": {
						"serialNumberSat": {
							"label": "Número de serie SAT",
							"placeholder": "Ingrese la contraseña de serie"
						}
					},
					"optionsTaxation": {
						"SimpleNationalExcess": "Exceso nacional simple",
						"normalRegime": "Régimen normal",
						"simpleNational": "Simple nacional"
					}
				},
				"general": {
					"fieldsAddress": {
						"cep": {
							"label": "CP",
							"placeholder": "00000"
						},
						"complement": {
							"label": "Complemento",
							"placeholder": "Insertar complemento"
						},
						"county": {
							"label": "Comunidad Autonoma",
							"placeholder": "Insertar Comunidad autonoma"
						},
						"neighborhood": {
							"label": "Barrio",
							"placeholder": "Insertar vecindario"
						},
						"number": {
							"label": "Número",
							"placeholder": "Insertar número"
						},
						"publicplace": {
							"label": "Lugar público",
							"placeholder": "Insertar lugar público"
						},
						"uf": {
							"label": "UF",
							"placeholder": "Seleccionar estado"
						}
					},
					"fieldsGeneral": {
						"email": {
							"label": "Email",
							"placeholder": "Insertar correo electrónico"
						},
						"fiscalMode": {
							"label": "Modo de impuestos",
							"placeholder": "Seleccionar modo de impuestos"
						},
						"enableManifestation": {
							"label": "Habilitar búsqueda de NF emitidos para este CNPJ para importar al stock"
						},
						"name": {
							"label": "Nombre",
							"placeholder": "Nombre del perfil"
						},
						"phone": {
							"label": "Teléfono",
							"placeholder": "Insertar teléfono",
							"error": "Número de teléfono no válido: debe contener de 10 a 11 dígitos con prefijo",
							"errorIvaVendus": "Número de teléfono no válido: debe contener 9 dígitos",
							"errorIvaFactura": "Número de teléfono no válido: debe contener 9 a 12 dígitos"
						}
					},
					"optionsFiscalMode": {
						"ivaFactura": "IVA - Factura",
						"ivaVendus": "IVA",
						"nfce": "NFC-e",
						"sat": "SAT"
					},
					"optionsEnableManifestation": {
						"allow": "Sí, permitir la búsqueda de facturas emitidas para este CNPJ",
						"notAllow": "no permitir la búsqueda de facturas"
					}
				},
				"service": {
					"descriptionInfoWarning": "Los siguientes campos son obligatorios para emitir facturas. Y si no se modifican, las facturas se emitirán con el estándar fiscal de Zig..",
					"insertCestManual": "Add manual CEST?",
					"labelFields": {
						"CEST": "CEST",
						"NCM": "NCM",
						"code": "Code",
						"name": "Name",
						"taxGroup": "Tax group",
						"taxProfile": "Tax profile"
					},
					"messageErrorNotReturnCest": "Could not return CEST to informed NCM",
					"messageErrorNotReturnTaxGroups": "Unable to return tax groups",
					"placeholderFields": {
						"CEST": "Insert CEST",
						"NCM": "Insert NCM",
						"code": "Service code",
						"name": "Insert name",
						"selectCEST": "Select CEST",
						"taxGroup": "Select Tax group",
						"taxProfile": "Tax profile"
					},
					"titleInfoWarning": "Data required for issuance"
				}
			},
			"titleSteps": {
				"company": "Company data",
				"fiscal": "Tax data",
				"general": "General data",
				"tip": "Configuración de propina"
			},
			"navigateBackLabel": "Volver a los perfiles fiscales"
		},
		"giftback": {
			"giftbacks": {
				"title": "Campañas de giftback",
				"description": "Crea y gestiona tus campañas de giftback.",
				"createGiftback": "Crear giftback",
				"searchPlaceholder": "Buscar por nombre de campaña",
				"deleteConfirm": "¿Estás seguro de querer eliminar el giftback?",
				"deleteGiftback": "Eliminar giftback",
				"steps": {
					"general": {
						"title": "Configuración general"
					},
					"resume": {
						"title": "Resumen"
					}
				},
				"emptyState": {
					"title": "No encontramos lo que buscas",
					"description": "Intenta seleccionar una nueva ubicación o período, o inténtalo de nuevo más tarde."
				},
				"buttonsTitle": {
					"createAndActivateLater": "Crear y activar después",
					"createAndActivateNow": "Crear y activar giftback",
					"saveChanges": "Guardar cambios"
				},
				"feedbackerros": {
					"selectAtLeastOnePlace": "Seleccione al menos un local",
					"maxCharactersName": "Máximo de 50 caracteres"
				},
				"form": {
					"active": "Activar giftback",
					"name": "Nombre de la campaña",
					"namePlaceHolder": "Ingrese el nombre de la campaña",
					"minimumConsumptionLabel": "Valor mínimo del consumo",
					"minimumConsumptionTooltip": "Valor que el cliente debe consumir para convertir en giftback.",
					"percentageLabel": "Porcentaje",
					"percentageTooltip": "Cuánto del valor consumido por el cliente se regalará al mismo.",
					"expiresInLabel": "Plazo para expirar el giftback",
					"expiresInTooltip": "Número máximo de días que el cliente debe utilizar el giftback.",
					"expiresInPlaceholder": "Seleccione el plazo para expirar el giftback",
					"expiresAtLabel": "Período de redención",
					"expiresAtTooltip": "Tiempo que el cliente tendrá para disfrutar del giftback.",
					"expiresAtPlaceholder": "Seleccione el período de validez del giftback",
					"placeLabel": "Locales participantes",
					"removeGiftback": "Eliminar giftback",
					"selectAll": "seleccionar todo",
					"day": "día",
					"days": "días",
					"week": "semana",
					"noValidity": "Sin validez",
					"selectAllPlacesDescription": "Seleccione los locales donde el giftback estará disponible.",
					"shouldConsiderEntranceLabel": "Incluir entradas no cálculo del Giftback"
				},
				"tabs": {
					"addNewGiftback": "Añadir nuevo giftback"
				}
			},
			"giftbackReport": {
				"selectGiftbackLabel": "Campaña",
				"selectGiftbackPlaceholder": "Seleccione la(s) campaña(s)",
				"table": {
					"createdAt": "Creado en",
					"giftback": "Campaña",
					"messagesSent": "SMS enviados",
					"place": "Lugares",
					"rescues": "Rescates",
					"totalValue": "{{ currencySymbol }} total en ventas",
					"giftbackSent": "Total de giftbacks",
					"giftbackValue": "{{ currencySymbol }} giftback canjeado",
					"conversionRate": "Tasa de conversión"
				},
				"title": "Informe de rescates",
				"totalizers": {
					"quantity": "Campañas creadas",
					"totalRescues": "Total de rescates",
					"totalSales": "Ventas totales mediante giftback",
					"totalSms": "Total de SMS creados"
				}
			},
			"giftbackPowerBi": {
				"title": "Informe de Giftback"
			}
		},
		"giftCard": {
			"tabs": {
				"campaigns": "Campañas",
				"metabase": "Desempeño"
			},
			"pageTitleList": "Gift Card",
			"pageSubtitle": "Configure su tarjeta de regalo para campañas.",
			"modalTitle": "Gift Cards",
			"modalDescription": "Campaña creada con éxito. Ahora puedes exportar el archivo para canjear los cupones.",
			"manageGiftCardModal": {
				"title": {
					"active": "Activar campaña",
					"inactive": "Desactivar campaña"
				},
				"description": {
					"active": "Activando campaña ({{campaign}}), ¿continuar?",
					"inactive": "Desactivando campaña ({{campaign}}), ¿continuar?"
				}
			},
			"fields": {
				"campaignName": "Nombre de la campaña",
				"campaignPlaces": "Lugar",
				"campaignCreatedAt": "Fecha de creación",
				"numberOfGifts": "Número de cupones",
				"giftCardValue": "Valor unitario",
				"giftCardExpirationDate": "Fecha de expiración",
				"giftCardRedeemed": "rescatado",
				"validation": {
					"campaignNameAlreadyExists": "Este nombre de campaña ya existe"
				}
			},
			"form": {
				"validations": {
					"required": "Campo obligatorio"
				},
				"messages": {
					"successInCreating": "Campaña creada con éxito",
					"failedToCreate": "Error al crear la campaña",
					"successInCreatingSubtitle": "Acceda a todos los códigos de la campaña descargando la hoja de cálculo a continuación:",
					"campaignEdited": "Campaña actualizada",
					"campaignEditedFailure": "Error al actualizar la campaña"
				}
			},
			"actions": {
				"label": "Acciones",
				"exportCupons": "Exportar cupones",
				"track": "Rastrear",
				"createCampaign": "Crear campaña",
				"inactivate": "Desactivar",
				"activate": "Activar"
			},
			"status": {
				"label": "Estado",
				"active": "Activa",
				"inactive": "Inactiva",
				"expired": "Venció"
			},
			"excel": {
				"title": "Tarjetas de regalo",
				"filename": "tarjetas-de-regalo",
				"columns": {
					"giftCardcodes": "Códigos",
					"giftCardValue": "Valor unitario"
				}
			}
		},
		"helpers": {
			"humanize": {
				"paymentMethod": {
					"ame": "Ame",
					"anticipated": "Anticipado",
					"app": "App",
					"automaticDebit": "Automatic Debit",
					"bankTransfer": "Bank transfer",
					"bleedings": "Sangria",
					"boleto": "Bank slip",
					"bonus": "Bonus",
					"cash": "Cash",
					"check": "Check",
					"consumptionFromBar": "Early consummation",
					"creditCard": "Credit card",
					"dashboard": "Dashboard",
					"debitCard": "Debit card",
					"deliveryOnline": "Delivery Online",
					"ifood": "Ifood",
					"other": "Other",
					"pix": "Pix",
					"postEvent": "Post event",
					"promissory": "Promissory note",
					"rappi": "Rappi",
					"uber": "Uber",
					"voucher": "Voucher",
					"zigCredit": "Zig Credit",
					"zigDebit": "Zig Debit",
					"zigPosCredit": "Zig post credit",
					"zigPosDebit": "Zig post debit",
					"zigPosCreditInInstallments": "Crédito en cuotas",
					"integratedFoodVoucher": "Vale de Alimentación"
				}
			},
			"string": {
				"grams": "Gramos",
				"kilogram": "Kilogramos",
				"liter": "Litros",
				"lowercase": {
					"grams": "gramos",
					"kilogram": "kilogramos",
					"liter": "litros",
					"milliliter": "mililitros",
					"unit": "unidad"
				},
				"milliliter": "Mililitros",
				"unit": "Unidad"
			}
		},
		"loyalty": {
			"commingSoon": {
				"cards": {
					"paper": {
						"description": "Sus clientes pueden monitorear y canjear sus puntos ganados a través de la Zig.app.",
						"title": "Dile adiós al papel."
					},
					"retainCustomers": {
						"description": "Elija ubicaciones participantes, recompensas, puntos e involucre a sus clientes.",
						"title": "Retener clientes"
					},
					"trackResults": {
						"description": "Puede supervisar el rendimiento de sus programas de fidelización.",
						"title": "Seguimiento de los resultados"
					}
				},
				"description": "Puede elegir entre varias formas para que sus clientes ganen puntos y las recompensas que recibirán. Aumentar la retención de clientes incentivándolos a visitar ubicaciones o comprar un producto a cambio de puntos, entre otras opciones disponibles en el módulo de lealtad",
				"subtitle": "Mejore sus resultados y la experiencia de sus clientes con los programas de fidelización."
			},
			"title": "Fidelización de clientes",
			"tabs": {
				"programs": {
					"createSteps": {
						"points": {
							"pointRules": {
								"npsAnswer": {
									"mainTitle": "Respuesta NPS",
									"description": "Defina la cantidad de puntos que ganarán los clientes al completar la encuesta de satisfacción",
									"detailTitle": "Cantidad de puntos por respuesta a la encuesta de satisfacción"
								}
							},
							"npsAnswerPoints": {
								"inputLabel": "Puntos",
								"inputPlaceholder": "Ingrese los puntos por respuesta NPS",
								"continueButtonText": "Añadir puntos"
							}
						}
					}
				}
			}
		},
		"productFeatureTemplates": {
			"activeTab": "producto-caracteristicas-plantillas",
			"form": {
				"addProduct": {
					"fields": "Rellene al menos un campo",
					"isRequired": "This field is required",
					"wrongFields": {
						"field": "campo",
						"from": "De",
						"label": "Rellene todos los datos",
						"of": "de"
					}
				},
				"createModel": "Crear modelo",
				"editModel": "Editar modelo",
				"isRequired": "Este campo es necesario",
				"templateFieldsContainer": {
					"add": "Añadir campo",
					"field": "campo {{number}}",
					"isRequired": "¿Es obligatorio el campo {{number}}??",
					"label": "Campos de modelo",
					"name": {
						"label": "Nombre de campo {{number}}",
						"placeholder": "Introduzca el nombre del campo {{number}}"
					},
					"remove": "Eliminar campo",
					"type": {
						"bool": "Verdadero/Falso",
						"enum": "Opciones",
						"label": "Tipo de campo {{number}}",
						"number": "Número",
						"placeholder": "Seleccionar tipo de campo",
						"text": "Texto"
					},
					"value": {
						"label": "Opciones para el campo {{number}}",
						"placeholder": "Valor {{count}} del campo {{number}}"
					}
				},
				"templateName": {
					"label": "Nombre del modelo",
					"placeholder": "Introduzca el nombre de la plantilla"
				},
				"templateObservation": {
					"label": "Nota",
					"placeholder": "Introduzca alguna observación (optional)"
				}
			},
			"header": {
				"add": "Agregar plantilla"
			},
			"modal": {
				"add": "Añadir",
				"edit": "Edit",
				"title": "product functionality model"
			},
			"templateList": {
				"actions": {
					"edit": "Editar plantilla",
					"remove": "Eliminar plantilla",
					"title": "¿Realmente quieres eliminar la plantilla? Toda la funcionalidad que lo use también se deshabilitará.."
				},
				"status": {
					"title": "¿Realmente quieres desactivar la plantilla? Toda la funcionalidad que lo use también se deshabilitará."
				}
			},
			"title": "Plantillas de funcionalidad del producto",
			"tooltip": "Crea plantillas con campos personalizados para tu producto"
		},
		"communication": {
			"actions": {
				"campaignCategoryModal": {
					"placeholder": "Seleccione una campaña",
					"successMessage": "Campaña vinculada al mensaje",
					"text": "Seleccionar campaña",
					"textButtonConfirm": "Confirmar selección",
					"title": "Envío de enlaces a la campaña",
					"tooltipMessage": "OPCIONAL: Vincule este envío a una campaña para facilitar el análisis del rendimiento de varios envíos juntos."
				},
				"cancelModal": {
					"at": "at",
					"cancel": "Cancelar envio",
					"clients": "Clientes del dia",
					"close": "Cerrar",
					"confirm": "Cuando cancele el envío, su saldo volverá a su cuenta en unas pocas horas",
					"text": "Do you want to cancel sending the scheduled message for "
				},
				"list": {
					"canceled": "Ver informe de mensajes",
					"schedule": {
						"cancelShipping": "Cancelar envío",
						"editAddressees": "Editar destinatarios",
						"editMessage": "Editar el contenido del mensaje",
						"hitchCampaign": "Envío de enlaces a la campaña"
					},
					"sent": "Ver informe de envío"
				}
			},
			"at": "at",
			"columns": {
				"campaign": "Campaña",
				"channel": "Canal",
				"date": "Fecha y hora",
				"impactedCustomers": "Clientes afectados",
				"message": "Mensaje",
				"place": "Lugar",
				"status": "Estado"
			},
			"export": "Exportar a Excel",
			"label": "Mensajes enviados",
			"message": {
				"columnsTableClients": {
					"attendance": "Visitas",
					"cpf": "DNI",
					"name": "Nombre del cliente",
					"ticket": "Ticket medio"
				},
				"crudMessage": {
					"campaignModal": {
						"confirmButton": "Crear campaña",
						"placeholder": "Introduzca el nombre de la campaña",
						"title": "Nombre de la campaña",
						"tooltipMessage": "OPCIONAL: Vincule este envío a una campaña para facilitar el análisis del rendimiento de varios envíos juntos."
					},
					"campaignSelect": {
						"createOrSearch": "Buscar por campaña o crear una nueva",
						"placeholder": "Seleccionar campaña",
						"text": "OPCIONAL: Vincule este envío a una campaña para facilitar el análisis del rendimiento de varios envíos juntos.",
						"title": "Campaña"
					},
					"campaignsDetail": {
						"canceled": "Cancelado",
						"canceledMessage": "El mensaje que se suponía que debía enviarse el {{day}} fue cancelado",
						"client": "cliente",
						"clients": "clientes",
						"columns": {
							"clientName": "Nombre del cliente",
							"cpf": "DNI",
							"gender": "Genero",
							"phone": "Teléfono",
							"status": "Estado"
						},
						"genders": {
							"female": "Mujer",
							"male": "Hombre",
							"other": "Otro",
							"uninformed": "No informado"
						},
						"programmedMessage": "Tu mensaje fue programado el {{day}} para ser enviado el {{date}}",
						"sent": "Enviado",
						"sentInDay": "Enviado el día {{day}} para"
					},
					"content": "Contenido del mensaje",
					"create": {
						"client": "persona",
						"clients": "personas",
						"mes": "Haga clic aquí para ver sugerencias sobre el contenido",
						"subtitle": {
							"sms": "Introduzca el contenido que se enviará a la lista de clientes seleccionada. Tu mensaje impactará",
							"whatsapp": "Seleccione una plantilla basada en lo que desea comunicar y, a continuación, cambie sus parámetros."
						},
						"subtitleTemplateList": "Seleccione una plantilla basada en lo que desea comunicar y luego cambie sus parámetros.",
						"title": "Nuevo mensaje"
					},
					"day": "Día",
					"edit": {
						"subtitle": "Reescribir el contenido del mensaje o cambiar la programación de envío.",
						"title": "Editar mensaje programado"
					},
					"errors": {
						"campaign": "No se puede crear la campaña.",
						"editMessage": {
							"sendNow": "Datos actualizados. El mensaje se enviará en breve.",
							"success": "Datos actualizados."
						},
						"place": "No se pudo identificar el lugar",
						"smsCost": "El costo de SMS debe configurarse"
					},
					"footer": {
						"reprogram": "Reprogramar envio de SMS",
						"scheduleShipping": "Programar envío de SMS",
						"send": "Enviar SMS ahora"
					},
					"hour": "Hora",
					"modalMessage": {
						"addBalance": "Agregar saldo",
						"messageScheduled": {
							"at": "at",
							"cancelOrEdit": "Si desea cancelar la suscripción o cambiar el contenido, vuelva a la lista de mensajes y edite la información de envío.",
							"client": "cliente",
							"clients": "clientes",
							"clientsCount": "Su mensaje será enviado a ",
							"day": "dia",
							"of": "de"
						},
						"messageSent": {
							"client": "cliente",
							"clients": "clientes",
							"clientsCount": "Su mensaje fue enviado a ",
							"of": "de"
						},
						"messageTips": {
							"tipFour": "¿Lanzamiento de un nuevo producto? Filtra a tus mejores clientes y envía toda la información de tus productos.",
							"tipThree": "¿Va a haber una promoción interesante? Filtrar el grupo de clientes que tienen derecho a la promoción y enviar SMS dirigidos.",
							"tipTwo": "Puede incluir enlaces importantes para sus clientes. Los enlaces a su página de destino o boleto de evento facilitan al cliente el acceso a la información y la compra de tickets",
							"tips": "Consejos de lo que puedes hacer",
							"typeOne": "¡Un mensaje bien escrito impacta a sus clientes de una manera única! Como tienes {{characters}} characters, Idealmente, su mensaje es preciso, claro y directo"
						},
						"notBalance": "No tienes saldo suficiente para enviar SMS al grupo seleccionado. ¿Desea agregar el saldo restante??",
						"title": {
							"messageScheduled": "Mensaje programado",
							"messageSent": "Message sent",
							"messageTips": "Message Tips"
						}
					},
					"program": "Programar envío",
					"resumeCard": {
						"amountMessageNotReceived": {
							"error": {
								"sms": "SMS no recibidos por error",
								"whatsapp": "Mensajes no recibidos por error"
							},
							"notRecieved": {
								"sms": "SMS no recibidos",
								"whatsapp": "Mensajes no recibidos"
							},
							"optout": {
								"sms": "SMS no recibidos por optout",
								"whatsapp": "Mensajes no recibidos por Optout"
							}
						},
						"amountMessageReceived": {
							"sms": "SMS recibidos",
							"whatsapp": "Mensajes recibidos"
						},
						"amountMessageSent": "Total de contenedores",
						"footerText": {
							"addedValue": "El valor de {{value}} se añadirá al pago mensual de Zig.",
							"charactersLimit": "El número de caracteres ha superado el límite. El costo del SMS ha cambiado y el valor de {{value}} se agregará al pago mensual de Zig..",
							"noExtraCost": "Como no hubo cambios en la cantidad de la lista de destinatarios, no habrá ningún costo adicional.",
							"smsBalanceAddedValue": "El valor adicional de {{value}} se añadirá al pago mensual de Zig.",
							"smsBalanceSubtractedValue": "El valor de {{value}} se deducirá del pago mensual de Zig.",
							"summarizes": "Los mensajes para excluir a los clientes no se cobrarán."
						},
						"messageCost": "Gastos de envío",
						"messageInProcess": {
							"sms": "SMS en proceso",
							"whatsapp": "Mensaje en proceso"
						},
						"postShipmentBalance": "Saldo posterior al envío",
						"rescheduledShippingCost": "Costo de envío reprogramado",
						"resume": "Resumen de la presentación",
						"sms": "SMS"
					},
					"sendNow": "Enviar ahora",
					"success": {
						"createTemplate": "Nueva plantilla solicitada"
					},
					"summarizes": "Datos de envío",
					"textArea": {
						"at": "at",
						"character": "caractere restante",
						"characters": "caracteres restantes",
						"content": "Contenido del mensaje",
						"copy": "Copiar contenido del mensaje",
						"footer": "Tip: Para añadir variables y poder cambiarlas en el futuro, escriba [VARIABLE] entre corchetes.",
						"placeholder": "Escribir el contenido del mensaje para el grupo seleccionado...",
						"successCopy": "Mensaje copiado al portapapeles"
					}
				},
				"emptyWhatsappList": "Ninguna ubicación en la organización tiene números registrados en WhatsApp. Contacta con el equipo de atención al cliente de Zig y solicita el registro de un número para poder enviar mensajes vía WhatsApp a tus clientes.",
				"footer": {
					"confirmWithSaveGroup": "Guardar grupo y seguir adelante",
					"confirmWithoutSaveGroup": "Reenviar sin guardar grupo",
					"forward": "Adelante",
					"save": "Guardar el mensaje de cambio y edición"
				},
				"header": {
					"isCreate": {
						"subtitle": "Seleccione una casa de su organización para enumerar el grupo de clientes destinatarios.",
						"title": "Nuevo mensaje"
					},
					"isEdit": {
						"subtitle": "Cambie la casilla para seleccionar otro grupo de destinatarios",
						"title": "Editar mensaje programado"
					}
				},
				"import": "Importar hojas de excel",
				"infos": {
					"agree": "Understood",
					"text": "Al importar la lista de contactos del cliente, con el fin de enviar SMS, confirma que ha aceptado la recepción de mensajes, según la Ley General de Protección de Datos (LGPD).",
					"title": "Responsabilidad de la información del cliente"
				},
				"modalImportClients": {
					"add": "Agregar clientes",
					"addedClient": "Cliente añadido",
					"addedClients": "Clientes añadidos",
					"clients": "Clientes",
					"cpf": "DNI",
					"downloadSheet": "Descargar hoja de muestra",
					"emptyMessage": {
						"description": "Agregue clientes por CPF o importando una lista de CPF de la hoja de cálculo de ejemplo.",
						"title": "No se agregaron clientes"
					},
					"feedback": {
						"default": "Se ha producido un error al importar la hoja",
						"download": "Descargar",
						"emptyHeaderCell": "Columnas a las que les falta el nombre",
						"emptySheet": "Esta hoja está vacía",
						"errorMessage": "Hoja de trabajo no válida, descárguela nuevamente y realice los cambios necesarios.",
						"sheetPoorlyFormatted": "Formatear hoja de cálculo para fuente Calibri, tamaño 11, eliminar espacios, saltos de línea innecesarios y negrita",
						"unidentifiedColum": "Error en los nombres de columna",
						"verifyBaseSheet": ", Comprueba la plantilla de hoja de cálculo de muestra o utilízala como hoja de cálculo base."
					},
					"import": "Importar clientes",
					"importSheet": "Hoja de importación",
					"invalidClientList": "Lista de clientes (invalid)",
					"name": "Nombre",
					"phone": "Teléfono"
				},
				"modalMyModels": {
					"columns": {
						"model": "Modelo",
						"status": "Estado"
					},
					"emptyState": {
						"text": "Solicita una nueva plantilla para enviar mensajes de WhatsApp a tus clientes",
						"title": "No hay plantilla registrada"
					},
					"requestNewModel": "Solicitar nuevo modelo",
					"status": {
						"approved": "Aprobado",
						"pending": "Pendiente",
						"received": "Recibido",
						"rejected": "Rechazado"
					},
					"title": "Mis modelos"
				},
				"modalSaveGroup": {
					"filtersList": "Filtros aplicados",
					"groupName": {
						"placeholder": "Seleccione un nombre para el nuevo grupo de clientes",
						"title": "Nombre del grupo"
					},
					"text": "Guarde los filtros aplicados para crear un grupo de clientes y facilitar el envío de SMS en el futuro.",
					"title": "Guardar grupo"
				},
				"myModels": "Mis modelos",
				"places": "Casas",
				"sheet": {
					"columns": {
						"cpf": "DNI",
						"name": "Nombre",
						"phone": "Telefono"
					},
					"title": "Lista de clientes (ejemplo)"
				}
			},
			"modalChannel": {
				"channel": {
					"email": {
						"description": "Seleccione una casa, filtre clientes y envíe correos electrónicos personalizados",
						"title": "Email"
					},
					"sms": {
						"description": "Seleccione una casa, filtre clientes y envíe mensajes de texto estándar",
						"título": "SMS"
					},
					"whatsapp": {
						"description": "Seleccione una casa, filtre clientes y envíe mensajes de WhatsApp",
						"title": "Whatsapp"
					}
				},
				"tags": {
					"comingSoon": "Próximamente",
					"new": "New"
				},
				"title": "Canal"
			},
			"new": "Nuevo mensaje",
			"packages": {
				"header": {
					"subtitle": "Añade saldo para enviar mensajes a tus clientes",
					"title": "Añadir saldo"
				},
				"modalPackage": {
					"addBalance": "y añadir {{amount}} saldo sms?",
					"footer": {
						"sellPackage": "Comprar paquete SMS"
					},
					"for": "por",
					"label": "¿Quieres comprar el Paquete?",
					"title": "Comprar paqueteComprar paquete"
				},
				"packageCard": {
					"forSMS": "by SMS",
					"sell": "Comprar paquete",
					"sms": "SMS",
					"tagLabel": "Tag Label"
				},
				"title": "Paquetes",
				"xlsx": {
					"date": "Fecha y hora",
					"filename": "Campañas SMS",
					"impactedCustomers": "Clientes afectados",
					"message": "Message",
					"place": "Place",
					"status": "Status",
					"title": "SMS Campaign History"
				}
			},
			"permissionDenied": "No se permite ninguna ubicación para administrar los mensajes de WhatsApp",
			"status": {
				"canceled": "cancelado",
				"delivered": "entregado",
				"error": "error",
				"notSent": "no enviado",
				"optout": "optar por no participar",
				"scheduled": "Programado",
				"sending": "envío",
				"sent": "enviado"
			},
			"title": "Mensajes",
			"warningCard": {
				"label": "El valor de {{value}} se agregará al pago mensual de Zig.",
				"title": "Pago"
			},
			"whatsapp": {
				"actionButtons": {
					"actionButton": "Acciones",
					"addButton": "Agregar otro botón",
					"formatValidation": {
						"phoneNumber": "Número de teléfono no válido",
						"url": "Enlace a un sitio web no válido"
					},
					"noneButton": "Ninguno",
					"optionsAction": {
						"label": {
							"accessWebsite": "Acceder al sitio web",
							"buttonText": "Texto del botón",
							"country": "País",
							"makeCall": "Hacer una llamada",
							"phoneNumber": "Número de teléfono",
							"typeAction": "Tipo de acción",
							"websiteLink": "Enlace al sitio web"
						},
						"placeholder": {
							"accessWebsite": "Acceda a nuestro sitio",
							"callNow": "Llama ahora",
							"enterNumber": "Introduzca el número aquí",
							"insertLink": "Inserte el enlace aquí"
						},
						"observation": {
							"name": "Observación",
							"description": "Observation"
						}
					},
					"quickResponseAction": {
						"placeholderQuickResponse": "Ingrese la respuesta rápida aquí",
						"title": "Respuesta rápida {{numbering}}"
					},
					"quickResponseButton": "Quick response",
					"subTitle": "Estos son botones que aparecen como opciones en las que se puede hacer clic justo después de su mensaje",
					"title": "Opcional - Botones",
					"validationFields": {
						"requiredField": "Campo obligatorio {{field}}"
					}
				},
				"contentControlModal": {
					"alcoholicBeverages": "Bebidas alcohólicas",
					"confirmation": {
						"label": "Confirmo que he leído las políticas de WhatsApp Business y estoy al tanto de lo que se puede divulgar.",
						"paragraph": "Facebook tiene políticas sobre el tipo de contenido publicado por WhatsApp. ¿Confirma que ha leído el",
						"underlined": "y son conscientes de lo que puede y no puede ser revelado por la plataforma?"
					},
					"paragraph1": {
						"text": "Whatsapp y Facebook tienen políticas de uso claras. Todo el contenido de comunicación que pasa a través de la plataforma debe ser revisado y aprobado para garantizar que no viole las políticas de Whatsapp. Los siguientes son algunos usos prohibidos tomados de la propia documentación.",
						"textLink": "WhatsApp Business Policy. To read the full documentation, click here."
					},
					"paragraph2": {
						"text": "Teniendo en cuenta el contexto en el que opera ZigPay, debemos dejar en claro algunas de las políticas contenidas en la documentación de política comercial de Whatsapp que probablemente interfieran con lo que puede divulgar en la plataforma. Hemos enumerado algunos a continuación, pero es muy importante que lea el",
						"textLink": "Documentación completa de la política comercial."
					},
					"paragraph3": {
						"exampleBold": "Ejemplos:",
						"politicsBold": "Política:",
						"text": "Las empresas no pueden vender o promover la venta de bebidas alcohólicas"
					},
					"paragraph4": {
						"areAllowedBold": "Están permitidos:",
						"text": "Divulgaciones sobre libros o DVDs sobre bebidas alcohólicas. O artículos relacionados con el alcohol, como vasos, refrescos y soportes para botellas de vino."
					},
					"paragraph5": {
						"areNotAllowedBold": "No permitido:",
						"text": "Divulgaciones sobre bebidas alcohólicas o kits para la producción de bebidas alcohólicas"
					},
					"title": "Control de contenido"
				},
				"newTemplatePage": {
					"footer": {
						"newModelButton": "Solicitar nuevo modelo",
						"title": "Vista previa del mensaje"
					},
					"glossary": {
						"client": {
							"description": "Nombre del cliente",
							"name": "Nombre del cliente"
						},
						"date": {
							"description": "Día de la semana o fecha específica",
							"name": "Punto"
						},
						"description": "Para reutilizar esta plantilla, escriba el código siguiente entre corchetes como en el ejemplo: “[date]”",
						"discount": {
							"description": "Valor porcentual de descuento",
							"name": "Porcentaje de descuento"
						},
						"originalProductPrice": {
							"description": "Precio original del producto específico",
							"name": "Precio del producto"
						},
						"productName": {
							"description": "Nombre del producto",
							"name": "Nombre específico del producto"
						},
						"productPromotionalPrice": {
							"description": "Precio promocional específico del producto",
							"name": "Precio promocional del producto"
						},
						"title": "Glosario de variables"
					},
					"glossaryVariables": {
						"client": "cliente",
						"date": "fecha",
						"discount": "discuento",
						"productName": "nombre del producto",
						"productOriginalPrice": "producto-original-precio",
						"productPromotionalPrice": "producto-promocional-precio",
						"observation": "observaciones"
					},
					"header": {
						"subtitle": {
							"link": "Recuerda seguir siempre las pautas de contenido de WhatsApp",
							"text": "La solicitud de la nueva plantilla puede tardar unos días. Escriba a continuación lo que desea incluir en su nueva plantilla."
						},
						"title": "Solicitar nuevo modelo para"
					},
					"imageLabel": "Imagen",
					"imageTooltipMessage": "Adjunta una imagen para cargarla en tu plantilla",
					"invalideVariableMessage": "Debe utilizar una de las variables del glosario",
					"messageErrorUpload": "El archivo adjunto debe ser de tipo de imagen.",
					"modelTitle": "Título del modelo",
					"modelTitlePlaceholder": "Introduzca el título",
					"modelTitleTooltipMessage": "Introduce un título para tu plantilla",
					"removeFileButtonLabel": "Haga clic aquí para adjuntar una imagen",
					"textareaLabel": "Contenido del mensaje",
					"textareaPlaceholder": "Escribe el contenido de la plantilla aquí. Consejo: para agregar variables y poder cambiarlas en el futuro, siga el glosario al lado.",
					"textareaTooltipMessage": "Escribe el contenido de la plantilla que te gustaría crear",
					"warning": {
						"description": "WhatsApp puede tardar hasta 3 días en autorizar el nuevo modelo. Durante este período puede enviar otros mensajes de los otros modelos en el área anterior.",
						"responseDeadline": "Fecha límite de respuesta"
					}
				},
				"section": {
					"emptyTemplateState": {
						"text": "Solicita una nueva plantilla para enviar mensajes de WhatsApp a tus clientes",
						"title": "No hay plantilla registrada"
					},
					"footer": {
						"btnRequestNewModel": "Solicitar nuevo modelo",
						"btnUnderstandWhy": "Comprende por qué solo puedes enviar mensajes de WhatsApp desde plantillas"
					},
					"form": {
						"checkboxLabel": "Usar el nombre del cliente del banco",
						"previewTitle": "Vista previa del mensaje",
						"title": "Establecer parámetros de mensaje"
					},
					"header": {
						"editTitle": "Editar mensaje de WhatsApp",
						"goBack": "Regrese y seleccione otro modelo",
						"model": "Modelo"
					},
					"tags": {
						"approvedModel": "Modelo aprobado",
						"modelInValidation": "Modelo en validación",
						"modelRecieved": "Modelo recibido por Whatsapp",
						"modelRefused": "Modelo no aprobado por Whatsapp"
					},
					"understandWhyModal": {
						"text": "Whatsapp y Facebook tienen políticas de uso claras. Todo el contenido de comunicación que pasa a través de la plataforma debe ser revisado y aprobado para garantizar que no viole las políticas de Whatsapp. Para asegurarse de que no se infrinjan sus políticas, solo podrá iniciar conversaciones con esta plantilla de mensaje. Dado que Facebook tiene derecho a revisar y rechazar las plantillas de mensajes en cualquier momento..",
						"title": "Entiende por qué solo puedes enviar mensajes de WhatsApp desde plantillas",
						"understandButton": "Entendido"
					}
				}
			}
		},
		"products": {
			"emptyList": "No se han encontrado productos",
			"functions": {
				"modal": {
					"sheet": {
						"columns": {
							"category": "Categoría",
							"fiscalCode": "SKU",
							"fiscalNcm": "Fiscal - NCM",
							"hasAlcohol": "¿Contiene alcohol??",
							"id": "Product Id",
							"name": "Nombre",
							"type": "Tipo de producto"
						},
						"inventory": "Inventario"
					}
				}
			},
			"tabs": {
				"categories": {
					"add": "Añadir categoría",
					"addProduct": "Añadir producto en{{category}}",
					"addSubcategory": "Agregar subcategoría en{{category}}",
					"categoryModal": {
						"create": "Crear categoría",
						"createSubcategory": "Crear subcategoría",
						"edit": "Editar categoría",
						"inputs": {
							"image": "Imagen",
							"name": {
								"label": "Nombre",
								"placeholder": "Introduzca un nombre para la categoría"
							},
							"description": {
								"label": "Descripción",
								"placeholder": "Describa la categoría"
							},
							"prefix": "Nivel",
							"priorityLevel": {
								"errorMessage": "Introduzca un nivel de prioridad válido (ex: 1, 2, 3...)",
								"label": "Nivel de prioridad"
							},
							"chartAccount": {
								"label": "Plan de Cuentas",
								"placeholder": "Seleccionar el plan de cuentas"
							},
							"printOrder": {
								"label": "Fase de categoría",
								"placeholder": "Ingrese la fase de categoría"
							},
							"errors": {
								"requiredName": "Nombre es requerido",
								"requiredPriority": "Nivel de prioridad es requerido",
								"invalidPriority": "Nivel de prioridad inválido",
								"requiredPrintOrder": "Fase de categoría es requerida",
								"invalidPrintOrder": "Fase de categoría inválida"
							}
						}
					},
					"columns": {
						"actions": "Acciones",
						"combo": "Combo",
						"product": "Producto",
						"systemProduct": "Producto de Sistema"
					},
					"deleteCategory": "¿Quieres eliminar la categoría? Esta operación no se puede deshacer.",
					"deleteProduct": "¿Desea eliminar este producto? Esta operación no se puede deshacer.",
					"label": "Categorías",
					"priorityLevel": "Nivel de prioridad {{level}}",
					"productModal": {
						"create": "Crear producto",
						"edit": "Editar producto",
						"inputs": {
							"hasAlcohol": "Contiene alcohol",
							"image": "Imagen",
							"name": {
								"emptyError": "Nombre del producto no rellenado",
								"label": "Nombre y apellidos",
								"noCategory": "Nombre de la categoría no rellenado",
								"noPriority": "Nivel de prioridad no válido",
								"noStringError": "Use only valid characters"
							},
							"type": {
								"error": "Seleccione un tipo de producto",
								"label": "Tipo de producto",
								"placeholder": "Select a product type"
							}
						}
					},
					"search": {
						"label": "Search",
						"placeholder": "Categoría, subcategoría o producto"
					},
					"subcategories": "Subcategorías",
					"subcategory": "Subcategoría",
					"description": "Descripción",
					"chartAccount": "Plan de Cuentas",
					"products": "Productos"
				},
				"generalStock": "Stock general",
				"productsTab": {
					"addEditProductModal": {
						"add": "Añadir producto",
						"edit": "Editar producto",
						"form": {
							"category": {
								"error": "Elegir o crear una categoría",
								"info": "Crearás una nueva categoría",
								"label": "Categoría",
								"placeholder": "Seleccionar o crear una categoría"
							},
							"code": {
								"label": "SKU",
								"placeholder": "Introduzca un SKU",
								"tooltip": "Si no se rellena, el código se generará automáticamente"
							},
							"error": "Este campo es obligatorio",
							"hasAlcohol": "Contiene alcohol?",
							"name": {
								"error": "Usar sólo caracteres válidos",
								"label": "Nombre del producto",
								"placeholder": "Introduzca un nombre para el producto"
							},
							"ncm": {
								"error": "NCM debe tener 8 dígitos",
								"label": "NCM",
								"placeholder": "Introduzca un NCM"
							},
							"photo": "Imagen",
							"type": {
								"label": "Tipo",
								"placeholder": "Seleccione un tipo de producto"
							}
						},
						"unavailable": "Indisponible",
						"undefined": "Indefinido",
						"update": "Actualizar producto"
					},
					"description": "Relación de productos registrados en la organización y su información básica.",
					"exportProducts": {
						"columns": {
							"category": "Categoría",
							"description": "Descripción",
							"fiscalCode": "SKU",
							"fiscalNcm": "NCM",
							"hasAlcohol": "¿Contiene alcohol??",
							"id": "Id del producto",
							"systemProduct": "Producto de sistema",
							"places": "Lugares",
							"title": "Nombre",
							"type": "Tipo"
						},
						"products": "Productos",
						"warningNotification": "Productos no modificados"
					},
					"header": {
						"add": "Añadir producto",
						"addPlaces": "Editar lugares",
						"counter": "{{amount}} Productos",
						"deleteProduct": "Eliminar (1) producto",
						"deleteMultipleProducts": "Eliminar ({{products}}) productos",
						"editPlaces": "Editar lugares",
						"export": "Productos de exportación",
						"inventory": "Cambiar inventario",
						"search": "Buscar"
					},
					"inventoryUpdate": {
						"columns": {
							"category": "Categoría",
							"fiscalCode": "SKU",
							"fiscalNcm": "Fiscal - Ncm",
							"hasAlcohol": "¿Contiene alcohol??",
							"id": "Pproduct id",
							"name": "Name",
							"type": "Product type"
						},
						"download": "Descargar hoja de cálculo",
						"import": "Importar hoja de cálculo",
						"label": "Cambiar inventario"
					},
					"label": "Registro de base de producto",
					"modalDelete": {
						"title": "Eliminar producto",
						"description": "Al confirmar la acción, eliminas permanentemente el producto. ¿Quieres continuar?"
					},
					"modalDeleteMultipleProducts": {
						"title": "Eliminar productos",
						"description": "Al eliminar productos seleccionados, se eliminarán de todas las ubicaciones y no será posible revertir esta acción.",
						"confirm": "¿Quieres eliminarlo de todos modos?"
					},
					"link": "Enlace",
					"links": "Enlaces",
					"productPlacesModal": {
						"title": "Enlaces de Producto",
						"description": "Lista de ubicaciones donde está presente el producto",
						"seePlace": "Ver lugar"
					},
					"productForm": {
						"alcoholLabel": "¿Contiene Alcohol?",
						"categoryLabel": "Categoría",
						"categoryPlaceholder": "Ingrese la categoría del producto",
						"createProduct": "Crear Producto",
						"editProduct": "Editar Producto",
						"fiscalCodelabel": "SKU",
						"fiscalCodePlacehodler": "Ingrese el código SKU del producto",
						"ncmLabel": "NCM",
						"ncmPlaceholder": "Ingrese el código NCM del producto",
						"photolabel": "Foto",
						"productNameLabel": "Nombre del Producto",
						"productNamePlaceholder": "Ingrese el nombre del producto",
						"placesLabel": "Ubicaciones",
						"placesPlaceholder": "Seleccione las ubicaciones del producto",
						"price": "Precio",
						"priceTooltip": "Cambiar el precio en este campo altera el precio del producto para todos los lugares vinculados",
						"editPrice": "Cambiar el precio",
						"saveProduct": "Guardar Producto",
						"saveEditProduct": "Guardar Cambios",
						"confirmProductPrice": {
							"goBack": "Volver a la edición",
							"confirm": "Confirmar cambio",
							"title": "Confirmar ajuste",
							"description": {
								"title": "¿Desea confirmar el cambio de precio?",
								"subtitle": "Los lugares vinculados tendrán el nuevo valor de <b>{{productValue}}</b> para el producto <b>{{productName}}</b>."
							}
						}
					},
					"removeProduct": {
						"label": "Eliminar producto",
						"title": "¿Realmente quieres eliminar el producto??"
					},
					"rows": {
						"noProducts": "No hay productos",
						"places": "Lugares",
						"products": "Productos",
						"type": "Tipo",
						"fiscalCode": "SKU"
					},
					"selectPlaces": {
						"label": "Seleccionar lugares",
						"search": "Buscar lugares"
					},
					"types": {
						"product": "Producto",
						"supply": "Suministro"
					}
				}
			}
		},
		"clientArea": {
			"title": "Hub de Datos",
			"places": "Lugares",
			"org": "Organización",
			"searchPanel": "Nombre del panel",
			"noPanels": "Sin paneles disponibles.",
			"noPanelsForFilter": "Sin paneles correspondientes a los filtros.",
			"autoRefresh": "Actualización automática.",
			"fullScreen": "Pantalla completa",
			"autoUpdatesOn": "Actualizaciones automáticas activadas",
			"autoUpdatesOff": "Actualizaciones automáticas desactivadas",
			"rotateDevice": "Por favor gira tu dispositivo",
			"otherPanels": "Otros",
			"subtitle": "Obtén acceso centralizado a los paneles de datos esenciales. Aquí encontrarás información actualizada para el análisis y la toma de decisiones, todo en un solo lugar.",
			"panelSelector": {
				"title": "Agregar paneles a la visualización"
			}
		},
		"reports": {
			"addPlacesPlaceholder": "Seleccionar lugar(s)",
			"addPlacesTitle": "Agregar lugares al informe",
			"all": "Todo",
			"downloadExcel": {
				"columns": {
					"date": "Date",
					"inboundService": "Servicio entrante",
					"place": "Lugar",
					"service": "Servicio",
					"totalBilling": "Facturación total"
				},
				"fileName": "Facturación-{{orgName}}",
				"title": "Informe {{orgName}}"
			},
			"emptyComponent": "No hay datos para mostrar el informe",
			"emptyPlaces": "Agregar al menos un lugar para ver el informe",
			"header": {
				"day": "Día",
				"entrance": "Couvert/Entrada",
				"people": "Gente",
				"period": "Periodo",
				"products": "Productos",
				"revenue": "Ingresos",
				"service": "Servicio",
				"ticket": "Ticket medio"
			},
			"products": {
				"currentPeriod": "en {{currPeriod}}",
				"dayFilter": "Seleccione el día",
				"empty": "No hay datos para mostrar el informe",
				"nextPeriod": "{{currPeriod}} to {{nextPeriod}}",
				"period": "Periodo: ({{since}} to {{until}})",
				"periodTitle": "Periodo",
				"productConsumptionTab": "Productos por hora",
				"productsSold": {
					"table": {
						"count": "CANTIDAD",
						"productName": "NOMBRE DEL PRODUCTO",
						"place": "LOCAL",
						"sku": "SKU",
						"total": "Total",
						"totalPlaceValue": "TOTAL LOCAL",
						"totalValue": "VALOR TOTAL",
						"unitValue": "VALOR UNITARIO"
					},
					"totalizers": {
						"totalCount": "Cantidad total de productos",
						"totalSold": "Facturación total del período"
					}
				},
				"productSoldTab": "Productos vendidos por local",
				"title": "Ventas totales por tiempo",
				"totalConsumedAt": "Total consumido en {{value}}",
				"totalConsumedPeriod": "Total consumido desde {{since}} to {{until}}:"
			},
			"revenue": {
				"methodChart": {
					"adjustedMoney": "Dinero ajustado: {{value}}",
					"rechargeDevolutions": "Recargas devueltas: {{value}}"
				},
				"paymentMethod": "Métodos de pago",
				"periodChart": {
					"duringPeriodSubtitle": "Durante el período",
					"perLocalTitle": "Ingresos totales por lugar"
				},
				"revenueChart": {
					"entranceService": "Servicio de entrada: {{entrance}}"
				},
				"title": "Ingresos totales"
			},
			"services": {
				"subtitle": "Por lugar en porcentaje",
				"title": "Servicio total"
			},
			"tooltip": "No incluye cuentas abiertas"
		},
		"internalSalesCampaign": {
			"title": "Campañas internas",
			"subtitle": "Cree campañas internas, siga el progreso y administre el pago de bonificaciones.",
			"tabs": {
				"campaign": "Campañas",
				"bonusManagement": "Gestión de bonificación"
			},
			"campaignDetails": {
				"back": "Volver",
				"summary": "Resumen",
				"position": "Posición",
				"points": "Puntos",
				"downloadExcel": "Descargar Excel",
				"resultsPerPage": "Resultados por página",
				"operator": "OPERADOR (USER)",
				"ranking": "Clasificación de operadores"
			},
			"bonusManagement": {
				"filters": {
					"campaignName": "Filtrar por nombre de campaña",
					"campaignStatus": "Filtrar por estado",
					"operatorName": "Filtrar por nombre de operador",
					"pending": "Pendiente",
					"done": "Efectuado"
				},
				"paymentType": {
					"bonus": "Bono",
					"dayOff": "Día libre",
					"employeeOfTheMonth": "Colaborador del mes",
					"money": "Dinero",
					"pix": "Pix"
				},
				"table": {
					"status": "ESTADO",
					"campaignName": "CAMPANHA",
					"operator": "OPERADOR",
					"bonusType": "TIPO DE BONO",
					"value": "VALOR",
					"retrievedAt": "EFETUADO EM",
					"retrievedBy": "RESPONSABLE",
					"confirmBonus": "Confirmar bono"
				}
			},
			"messages": {
				"errorMsg": "Error al cerrar la campaña",
				"errorDescriptionError": "Por favor, intente nuevamente más tarde o comuníquese con el soporte.",
				"successMsg": "¡Éxito!",
				"successDescription": "¡Se ha creado una campaña!",
				"warnMsg": "Cerrar campaña",
				"warnDescription": "Esta campaña finalizará antes del período establecido. Si la campaña ya ha comenzado, esto podría afectar directamente la meta de los colaboradores y las ventas. ¿Desea continuar?",
				"closeCampaignMsg": "Sí, cerrar campaña",
				"close": "Cerrar",
				"editcampaign": "Editar campaña",
				"duplicateCampaign": "Duplicar campaña",
				"closeCampaignBtn": "Cerrar campaña"
			},
			"modal": {
				"confirmationTitle": "Su campaña no fue creada",
				"continuebtn": "No, continuar configuración",
				"exitBtn": "Sí, salir sin guardar",
				"content": "Al salir, la configuración de la campaña se perderá y esta acción no podrá deshacerse. ¿Desea continuar?"
			},
			"steps": {
				"generalSettings": "Configuraciones generales",
				"generalSettingsDetails": "Configure los detalles de su campaña.",
				"salesTarget": "Meta de ventas",
				"bonus": "Bonificación",
				"cancel": "Cancelar",
				"summary": "Resumen",
				"allSettings": "Todas las configuraciones",
				"back": "Volver",
				"next": "Siguiente",
				"finish": "Finalizar",
				"campaignLocale": "Ubicación de la campaña",
				"campaignLocalePlaceholder": "Seleccione una o más ubicaciones para esta campaña",
				"campaignName": "Nombre de la campaña",
				"winnerQuantity": "Cantidad de ganadores",
				"winnerQuantityPlaceholder": "Seleccione la cantidad de ganadores",
				"onlyFirstPlace": "Apenas el 1er lugar en el ranking general",
				"onlyFirstAndSecondPlace": "Apenas el 1er y 2do lugar en el ranking general",
				"top3": "Apenas el top 3 en el ranking general",
				"charCount": "Número máximo de caracteres: 20",
				"campaignNamePlaceholder": "Ingrese el nombre de la campaña",
				"sponsor": "Patrocinador (opcional)",
				"sponsorPlaceholder": "Ingrese el nombre del patrocinador",
				"salesTargetDescription": "Elija el tipo de meta en la que se enfocará su campaña.",
				"campaign": "Campaña",
				"withBonusExtra": "El {{position}} lugar en el ranking general ganará el bono extra de",
				"withBonus": "El {{position}} lugar en el ranking general ganará el bono de",
				"selectWinners": "Seleccione el(los) ganador(es) y configure el valor:",
				"allOperators": "Todos los operadores que alcanzarán la meta recibirán el bono de",
				"prizeByRanking": "Premiar por ranking",
				"addPositionToRanking": "Agregar posición al ranking",
				"campaignSubtitle": "Configure los detalles de su campaña.",
				"dateInfo": "Atención: La campaña solo se podrá editar hasta 30 minutos antes de la hora programada para iniciar.",
				"startDate": "Fecha de inicio",
				"startTime": "Hora de inicio",
				"endDate": "Fecha de finalización",
				"endTime": "Hora de finalización",
				"types": {
					"soldProducts": "Por producto",
					"soldProductsPlaceholder": "Elija un producto",
					"metaType": "Tipo de meta",
					"metaTypeTooltip": "La meta es el objetivo de la campaña y sirve para medir el rendimiento de los colaboradores. Puede ser definida por: cantidad de productos vendidos, número de atenciones o valor total en ventas.",
					"selectTypeGoal": "Seleccione el tipo de meta",
					"soldProductsDescription": "Defina un producto estratégico como meta para su campaña.",
					"productsQuantity": "Meta de ventas (cant.)",
					"selectProducts": "Seleccione el producto",
					"salesTotal": "Por valor total en ventas",
					"salesTotalDescription": "Defina un valor total en ventas como meta para su campaña.",
					"salesTotalGoal": "Meta de ventas (MXN$)",
					"attendance": "Por atención",
					"attendanceGoal": "Cantidad",
					"attendanceDescription": "Defina una cantidad de atenciones (de personas o mesas) como meta para su campaña."
				},
				"bonusContent": {
					"title": "Bonificación",
					"subtitle": "Seleccione y configure el tipo de bonificación a otorgar al colaborador.",
					"moneyTitle": "Bono en efectivo",
					"moneySubtitle": "Bono con pago en efectivo o vía transferencia electrónica.",
					"bonusTitle": "Cashless Zig",
					"bonusSubtitle": "Bono disponible en el CPF o en la tarjeta de consumo Cashless Zig del(los) colaborador(es).",
					"featuredContribuitorTitle": "Colaborador destacado",
					"featuredContribuitorSubtitle": "Esta bonificación es un reconocimiento al mérito. La aplicación será definida por el gestor.",
					"slackTitle": "Día libre extra",
					"slackSubtitle": "Este bono concede un día libre extra, además del regular. La aplicación será definida por el gestor.",
					"winnersQuantity": "Cant. de ganadores",
					"firstPlaceBonus": "Bono 1er lugar",
					"scondPlaceBonus": "Bono 2do lugar",
					"thirdPlaceBonus": "Bono 3er lugar"
				},
				"resume": {
					"title": "Resumen",
					"subtitle": "Revise el resumen de la configuración de la campaña.",
					"warning": "Atención: Después de la creación de la campaña, solo podrá editarse hasta 30 minutos antes del horario programado para iniciar.",
					"geralSettings": "Configuraciones generales",
					"campaignLocale": "Ubicación de la campaña",
					"campaignName": "Nombre de la campaña",
					"sponsor": "Patrocinador",
					"schedule": "Programación",
					"initialDate": "Fecha de inicio de la campaña",
					"endDate": "Fecha de finalización de la campaña",
					"goal": "Meta de ventas",
					"type": "Tipo",
					"goalSell": "Meta de ventas (cant.)",
					"product": "Producto",
					"bonus": "Bonificación",
					"bonusType": "Tipo de bonificación",
					"winnerQuantity": "Cant. de ganadores",
					"allOperators": "Todos los operadores que alcanzarán la meta recibirán el bono de"
				}
			},
			"newCampaign": "Crear campaña",
			"campaign": {
				"cards": {
					"active": "Campañas activas",
					"campaignsProgramed": "Campañas programadas",
					"campaignsConcluded": "Campañas concluidas",
					"totalProductsSold": "Total en ventas",
					"onSale": "Campañas en curso"
				},
				"filters": {
					"campaignName": "Filtrar por nombre de campaña",
					"campaignStatus": "Filtrar por estado",
					"operatorName": "Filtrar por nombre de operador"
				},
				"table": {
					"noContent": "No se encontraron campañas",
					"checkFilters": "Cree una campaña o verifique los filtros.",
					"status": "ESTADO",
					"campaignName": "CAMPAÑA",
					"start": "INICIO",
					"end": "FIN",
					"metaType": "TIPO DE META",
					"productsSell": "PRODUCTOS VENDIDOS",
					"services": "ATENCIONES",
					"totalValue": "VALOR TOTAL",
					"edit": "Editar campaña",
					"duplicate": "Duplicar campaña",
					"finish": "Cerrar campaña"
				},
				"tags": {
					"active": "Activa",
					"finished": "Finalizada",
					"scheduled": "Programada",
					"onSale": "En curso"
				}
			}
		},
		"satisfactionSurvey": {
			"smsReport": {
				"filterByPlace": "Filtrar por lugar",
				"filterByDate": "Fecha del evento",
				"columns": {
					"date": "Fecha del evento",
					"smsSentCount": "Sms enviados",
					"npsAnswersCount": "Respuestas",
					"conversion": "Tasa de conversión de SMS"
				},
				"totalizers": {
					"smsSents": "Sms enviados",
					"npsFormAnswers": "Total de respuestas",
					"checkins": "Tasa de conversión total"
				}
			},
			"customModal": {
				"successNotification": "Enlace de encuesta copiado"
			},
			"formatQuestionType": {
				"cleaness": "Limpieza",
				"mixes": "Variedad de menú",
				"music": "Musica",
				"nps": "NPS",
				"price": "Precio",
				"product": "Producto",
				"service": "Servicio / Servicio al cliente",
				"paymentExperience": "Experiencia de pago"
			},
			"periodData": {
				"custom": "Período personalizado",
				"ninety": "Últimos 90 días",
				"period": "Periodo",
				"placeholder": "Seleccionar período",
				"rangeFormat": "{{sinceDay}} de {{sinceMonth}} a {{untilDay}} de {{untilMonth}}",
				"sixty": "Últimos 60 días",
				"thirty": "Últimos 30 días"
			},
			"results": {
				"columns": {
					"averageTicket": "Ticket medio",
					"birthDate": "Fecha de nacimiento",
					"client": "Cliente",
					"comment": "Comentario",
					"date": "Fecha",
					"document": "Documento",
					"phone": "Teléfono",
					"ratingDate": "Fecha de clasificación"
				},
				"customerAnswer_one": "{{totCustomers}} El cliente respondió a la encuesta de satisfacción",
				"customerAnswer_other": "{{totCustomers}} Los clientes respondieron a la encuesta de satisfacción",
				"drawer": {
					"answerNps": "Del 1 al 10, la posibilidad de que este cliente recomiende {{name}} a amigos y familiares es",
					"assessment": "Evaluación",
					"consumedProducts": "Productos consumidos",
					"date": "Fecha",
					"event": "Evento",
					"stars_one": "{{value}} Estrella",
					"stars_other": "{{value}} Estrellas",
					"title": "Detalles de la experiencia",
					"client": "Cliente",
					"cpf": "CPF",
					"phone": "Teléfono",
					"birthDate": "Fecha de nacimiento"
				},
				"emptyStateDescription": "Este lugar no está habilitado para recibir respuestas de encuestas de satisfacción. Póngase en contacto con el equipo de Zig para que pueda activar este servicio.",
				"emptyStateTitle": "Lugar no habilitado",
				"searchClientPlaceholder": "Buscar por nombre o número de documento",
				"export": "Exportar a Excel",
				"fileTitle": "Historial de clasificación de eventos",
				"filename": "nps-reviews",
				"filterPlaceholder": "Filtrar por lugar",
				"lastDays_one": "en el último {{days}} day",
				"lastDays_other": "En el último {{days}} days",
				"popover": {
					"answer_one": "{{totalAnswers}} Clasificación",
					"answer_other": "{{totalAnswers}} clasificaciones",
					"client_one": "{{count}} cliente",
					"client_other": "{{count}} clientes",
					"opinion_one": "{{count}} revisión",
					"opinion_other": "{{count}} Comentarios"
				},
				"resultsEvent": "Resultado de la búsqueda por evento"
			},
			"searchSettings": {
				"cancelButton": "Cancelar cambios",
				"description": "Elija qué parámetros desea que sus clientes evalúen en casa.",
				"emptyState": {
					"description": "No se encontró ningún lugar habilitado para configurar la encuesta de satisfacción. Póngase en contacto con el equipo de Zig para que pueda activar este servicio.",
					"title": "No place enabled"
				},
				"new": "New",
				"saveButton": "Guardar cambios",
				"successNotification": "Se ha actualizado la configuración de búsqueda",
				"title": "Configuración de la encuesta",
				"shouldSendSmsOnCheckout": "Envíe automáticamente SMS NPS a todos los clientes después del checkout"
			},
			"shareSettings": {
				"content": "Es muy importante que se definan los medios de activación del cliente para que pueda obtener comentarios justos de su organización..",
				"modal": {
					"downloadAllQRCode": "Descargar todos los QRCodes",
					"link": "Copiar enlace",
					"linkDescription": "Haga clic para copiar el enlace de la encuesta",
					"qrCode": "Descargar QRCode",
					"qrCodeDescription": "Haga clic aquí para abrir QRCode",
					"rowModal": {
						"link": "No hay lugares habilitados. Para generar un enlace a una encuesta de satisfacción, simplemente actívelo en la pestaña \"Configuración de la encuesta\"",
						"qrCode": "No hay lugares habilitados. Para descargar el QRCode de esta encuesta, simplemente actívelo en la pestaña \"Configuración de la encuesta\""
					}
				},
				"qrCodeSection": {
					"description": "Haga clic en el botón de abajo para descargar e imprimir el código QR que llevará a su cliente al enlace de la encuesta de satisfacción.",
					"downloadButton": "Descargar código QR",
					"title": "QR Code on table / lounge"
				},
				"smsSection": {
					"copyButton": "Copy survey link",
					"description": "Copie el siguiente enlace y envíe un mensaje a la lista de clientes seleccionados por usted. Simplemente vaya a la sección de mensajes en el área de cliente.",
					"title": "Manual SMS",
					"cancelUpdates": "Cancelar cambios",
					"saveUpdates": "Guardar cambios",
					"dailyLimit": {
						"label": "Límite diario de SMS",
						"tooltip": "El costo por SMS enviado está especificado en su contrato.",
						"description": "Este será el límite para los envíos automáticos del enlace."
					}
				},
				"title": "Configuración de uso compartido"
			},
			"tabs": {
				"newPlaceAvailable": "Nueva ubicación disponible",
				"results": "Resultados",
				"searchSettings": "Configuración de la encuesta",
				"shareSettings": "Configuración y uso compartido",
				"smsReport": "Informe de inversión"
			},
			"title": "Encuesta de satisfacción"
		},
		"chartOfAccounts": {
			"titlePage": "Plan de Cuentas",
			"tableTitle": {
				"revenues": "Ingresos",
				"costs": "Costos",
				"expenses": "Gastos"
			},
			"tableRows": {
				"minimizeAll": "Minimizar",
				"expandAll": "Expandir"
			},
			"expandLevels": "Expandir niveles",
			"categoryFixedInfo": "Esta categoría recibe entradas automáticas del sistema y no se puede editar",
			"viewCode": "Ver código del plan de cuentas",
			"usageInfo": "El Plan de Cuentas Financieras es la lista de categorías de ingresos y gastos de una empresa. Al ser una forma de clasificar las transacciones financieras, ayuda a organizar y comprender mejor la situación financiera al observar ingresos y gastos.",
			"titleModal": {
				"edit": "Renombrar cuenta",
				"create": "Agregar cuenta",
				"exclude": "Eliminar plan de cuentas",
				"warning": "Este plan de cuentas tiene vínculos"
			},
			"modalExcludeChart": {
				"warningContent": "Este plan de cuentas <strong>no se puede eliminar</strong> ya que hay transacciones vinculadas a él.",
				"excludeContent": "Al confirmar la acción, eliminará permanentemente el plan de cuentas de \"{{name}}\". ¿Desea continuar?",
				"buttonExclude": "Sí, quiero eliminar el plan"
			},
			"typeChartCredit": "Credit",
			"typeChartDebit": "Debit"
		},
		"teamAndRoles": {
			"employeesRole": {
				"table": {
					"roleName": "Nombre del rol",
					"access": "Acceso",
					"collaboratorsQuantity": "Número de colaboradores en el rol",
					"none": "Ninguno"
				},
				"masterOperationPDVAndDashboard": "Maestro - Operación (POS) y Tablero",
				"operationPDV": "Operación (POS)",
				"dashboard": "Panel",
				"rolePermissionWarning": "Después de separar a los empleados en dash y pdv, ya no es posible crear o utilizar puestos con permisos de ambos tipos",
				"roleNeedsASlug": "El rol necesita un slug",
				"collaborators": "Colaboradores",
				"collaborator": "Colaborador",
				"editRole": "editar trabajo",
				"deleteRole": "eliminar trabajo",
				"newRole": "Nuevo cargo",
				"deleteRoleModal": {
					"title": "¿Deseas eliminar el rol?",
					"describe": "Al eliminar un rol, todos los colaboradores vinculados a él perderán la vinculación."
				},
				"header": {
					"roles": "Cargos",
					"describe": "Agrega, edita y elimina cargos para ser utilizados en el panel de control o en el punto de venta (POS)",
					"searchRole": "Buscar cargo",
					"searchRolePlaceholder": "Buscar por nombre de cargo",
					"closeSearch": "Cerrar búsqueda",
					"alertMessage": "Después de separar a los empleados en dash y pdv, ya no es posible crear o utilizar puestos con permisos de ambos tipos"
				},
				"roleModal": {
					"PDVRole": "Operación",
					"PDVDescription": "Cargo para colaboradores con permiso de acceso a <b>POS</b>",
					"PDVFooterText": "Crear cargo POS",
					"enterpriseRole": "Gerente",
					"enterpriseDescription": "Cargo para colaboradores con permiso de acceso al <b>Dashboard</b>",
					"enterpriseFooterText": "Crear cargo de Dashboard",
					"newManagerRole": "Nuevo cargo gerente",
					"newOperationRole": "Nuevo cargo de operación",
					"operationPermission": "Permisos de PDV",
					"managerPermission": "Permisos de gerente",
					"enterprisePermission": "Permisos de Dashboard",
					"paymentPermission": "Permisos de método de pago"
				},
				"form": {
					"roleNameDescription": "Selecciona el tipo de cargo que deseas crear",
					"roleNameRequired": "Se requiere el nombre del cargo",
					"roleName": "Nombre del cargo",
					"roleNamePlaceholder": "Ingresa el nombre del nuevo cargo",
					"roleNameError": "Nombre del cargo inválido",
					"importExistingRolePermissions": "(Opcional) Importar permisos de cargo existente",
					"selectExistingRole": "Selecciona un cargo existente",
					"roleType": "Tipo de cargo",
					"operational": "POS",
					"managerial": "Panel",
					"master": "Master",
					"saveEditions": "Guardar cambios",
					"createNewRole": "Crear nuevo cargo",
					"discardChanges": "Descartar cambios",
					"discardCreation": "Descartar creación"
				}
			}
		},
		"vendors": {
			"title": "Vendedores",
			"searchNamePlaceholder": "Buscar por nombre/iniciar sesión del vendedor",
			"header": {
				"create": "Crear vendedor"
			},
			"list": {
				"vendors": "Proveedores",
				"rent": "Ubicación",
				"revenuePercentageFee": "ganancia%",
				"tipPercentageFee": "Frais de servicio",
				"places": "Lugares",
				"fiscalProfile": "Perfil fiscal",
				"login": "Acceso",
				"paymentDaysOffset": "Tiempos de traslado",
				"actions": {
					"editVendor": "Editar proveedor",
					"deleteVendor": "Eliminar proveedor"
				},
				"place": "Ubicación",
				"bars": "Barras"
			},
			"modal": {
				"close": "Cerrar",
				"prevStep": "Etapa précédente",
				"nextStep": "Prochaine étape",
				"steps": {
					"dataCollection": "Datos del proveedor",
					"barSelection": "Datos de lugares y bares",
					"feesCalculation": "Perfil de tarifas y impuestos",
					"guidance": "Guía"
				},
				"delete": {
					"title": "Eliminar proveedor",
					"description": "¿Está seguro de que desea eliminar permanentemente a este proveedor?",
					"buttonConfirm": "Confirmar"
				},
				"mode": {
					"create": "Crear nuevo vendedor",
					"update": "Modificar vendedor",
					"updateDataCollection": "Modificar datos del vendor",
					"updateLinkingBarsAndLocations": "Editar ubicaciones y bares",
					"updateFeesTaxProfile": "Editar tarifas y perfil de impuestos"
				},
				"submit": {
					"create": "Crear vendedor",
					"update": "Guardar"
				},
				"form": {
					"required": "Campo requerido",
					"nonnegative": "El valor debe ser mayor o igual a cero.",
					"name": {
						"label": "Nombre",
						"validation": "El nombre no puede estar vacío",
						"placeholder": "Ingrese el nombre del vendedor",
						"nonempty": "El nombre no puede estar vacío"
					},
					"login": {
						"label": "Identificador de inicio de sesión",
						"validation": "El identificador de inicio de sesión no puede estar vacío",
						"placeholder": "Ingrese el identificador de inicio de sesión del vendedor",
						"nonempty": "El identificador de inicio de sesión no puede estar vacío",
						"emailRegexValidation": "El identificador de inicio de sesión no debe ser un correo electrónico",
						"charactersRegexValidation": "El identificador de inicio de sesión no debe contener letras mayúsculas ni caracteres especiales"
					},
					"password": {
						"label": "Contraseña",
						"validation": "La contraseña no puede estar vacía",
						"placeholder": "Ingrese la contraseña del vendedor",
						"required": "Contraseña requerida",
						"nonempty": "La contraseña no puede estar vacía"
					},
					"places": {
						"label": "Ubicaciones",
						"validation": "Seleccione al menos una ubicación",
						"placeholder": "Seleccione las ubicaciones donde el vendedor estará activo",
						"selectAll": "Seleccionar todo"
					},
					"bars": {
						"label": "Bares",
						"validation": "Seleccione al menos un bar",
						"placeholder": "Seleccione los bares del vendedor",
						"noBars": "Ningún bar seleccionado"
					},
					"dailyRentalFeeValue": {
						"label": "Tarifa fija por evento"
					},
					"revenuePercentageFee": {
						"label": "Tarifa de porcentaje de ingresos"
					},
					"tipPercentageFee": {
						"label": "Tarifa de porcentaje de propina"
					},
					"paymentDaysOffset": {
						"label": "Días de pago (D+)",
						"maxValidation": "Debe estar entre 0 y {{count}}"
					},
					"anticipationFee": {
						"label": "Tarifa por adelantado"
					},
					"fiscalProfileId": {
						"label": "Perfil fiscal",
						"placeholder": "Seleccione el perfil fiscal"
					},
					"isFinancialVendor": {
						"label": "Proveedor financiero",
						"description": "Generar cierres financieros para este proveedor"
					},
					"paymentMethodFees": {
						"credit": "Tarifa por pago de crédito",
						"debit": "Tarifa por pago a débito",
						"pix": "Tarifa de pago en pix"
					},
					"floorComplement": "Guaranteed minimum per event"
				},
				"guidance": {
					"vendorData": {
						"title": "Editar datos de proveedores",
						"description": "Nombre, login y contraseña"
					},
					"linkingBarsAndLocations": {
						"title": "Editar ubicaciones y bares",
						"description": "Seleccionar ubicaciones de proveedores y sus bares"
					},
					"feesTaxProfile": {
						"title": "Modificar tarifas y perfil fiscal",
						"description": "Tarifas diarias, tarifa de porcentaje de ingresos, tarifa de porcentaje de propina, día de pago y perfil fiscal"
					}
				}
			}
		},
		"minimmConsummation": {
			"titleTab": "Configuración de Consumo mínimo",
			"titleColumnsTable": {
				"place": "Lugar",
				"fiscalProfile": "Perfil fiscal",
				"fiscalGroup": "Grupo fiscal",
				"ncm": "NCM",
				"action": "Acción"
			},
			"placeholders": {
				"fiscalProfile": "Seleccione un perfil fiscal",
				"fiscalGroup": "Seleccione un grupo fiscal",
				"ncm": "Ingrese el código NCM"
			},
			"errors": {
				"requiredField": "Campo obligatorio",
				"invalidFormatNcm": "El NCM debe contener 8 dígitos"
			},
			"messageWarning": "Al cancelar esta acción, los cambios realizados no se guardarán. ¿Desea continuar de todos modos?",
			"titleButtonOut": "Salir sin guardar"
		},
		"fiscalRecharge": {
			"titleTab": "Configuración de Recarga",
			"titleColumnsTable": {
				"place": "Lugar",
				"fiscalProfile": "Perfil fiscal",
				"fiscalGroup": "Grupo fiscal",
				"ncm": "NCM",
				"action": "Acción"
			},
			"placeholders": {
				"fiscalProfile": "Seleccione un perfil fiscal",
				"fiscalGroup": "Seleccione un grupo fiscal",
				"ncm": "Ingrese el código NCM"
			},
			"errors": {
				"requiredField": "Campo obligatorio",
				"invalidFormatNcm": "El NCM debe contener 8 dígitos"
			},
			"messageWarning": "Al cancelar esta acción, los cambios realizados no se guardarán. ¿Desea continuar de todos modos?",
			"titleButtonOut": "Salir sin guardar"
		},
		"vendor": {
			"form": {
				"modal": {
					"productFees": {
						"productFee": "Tarifa especial por producto",
						"productFeePlaceholder": "Buscar un producto",
						"percent": "Porcentaje",
						"button": "Agregar otro producto"
					}
				}
			},
			"modal": {
				"productModal": {
					"title": "Productos y tarifas especiales",
					"product": "Producto",
					"fee": "Tarifa",
					"closeConfirmTitle": "Descartar cambios de tarifas especiales",
					"closeConfirmSubtitle": "Ha realizado cambios y solo se guardarán si hace clic en 'guardar cambios'. ¿Quieres descartar los cambios que hiciste o volver a editar tarifas?",
					"closeConfirmCancelActionText": "Volver a la edición",
					"closeConfirmConfirmActionText": "Descartar cambios",
					"save": "Guardar cambios",
					"deleteConfirmTitle": "Eliminar tarifa especial",
					"deleteConfirmSubtitle": "¿Quieres eliminar la tarifa especial de '{{value}}'?",
					"deleteConfirmBoldSubtitle": "Esta acción no se puede deshacer"
				},
				"modalPermissions": {
					"single": {
						"edit": "Editar {{vendorName}}",
						"withdraw": "Bloquear retiro",
						"anticipation": "Permitir solicitud de anticipación",
						"remove": "Eliminar vendor"
					},
					"multiple": {
						"title": "{{count}} vendors seleccionados",
						"blockWithdraw": {
							"title": "Permitir retiro",
							"subtitle": "Bloquear retiro de {{count}} vendors",
							"description": "Esta acción bloqueará el retiro de los vendors a continuación en todos los lugares.",
							"confirm": "Confirmar bloqueo de retiro"
						},
						"canAnticipate": {
							"title": "Permitir anticipación",
							"subtitle": "Bloquear anticipación de {{count}} vendors",
							"description": "Esta acción bloqueará la anticipación de los vendors a continuación en todos los lugares.",
							"confirm": "Confirmar bloqueo de anticipación"
						},
						"cancel": "Cerrar",
						"applySelection": "Aplicar selección"
					},
					"thisAction": "Esta acción",
					"vendorsBelow": "de los proveedores de abajo en todas partes",
					"featureTitleBothAllowed": "Permitir retiro y anticipación",
					"featureTitleBothBlocked": "Bloquear retirada y anticipación",
					"featureTitleMixed": "{{withdraw}} retiro y {{anticipation}} anticipación",
					"block": "Bloquear",
					"allow": "Permitir",
					"vendorsCount_one": "de 01 proveedor",
					"vendorsCount_other": "de {{count}} proveedores"
				},
				"featureAlert": "La sobra de recarga sólo será distribuida si el bar principal del caja que hizo la recarga es del proveedor. También aplicará una tarifa sobre las ventas del sobrante de recarga del proveedor."
			},
			"list": {
				"productsSpecialFee": "Tarifa especial",
				"product": "producto",
				"products": "productos"
			}
		}
	},
	"place": {
		"placeTitle": "Lugares",
		"placeWithoutEvent": "Lugares sin eventos durante más de un mes",
		"placeWithOpenEvent": "Lugares con eventos en curso",
		"placeWithoutEventInProgress": "Lugares sin eventos en curso",
		"searchPlaceInputPlaceholder": "Buscar lugar",
		"timezone": "Zona horaria",
		"currency": "Moneda",
		"subtitle": "Subtítulo",
		"alphabeticalOrder": "Orden alfabético",
		"lastEventOrder": "Último evento creado",
		"initialDefaultDateOrder": "Filtro de fecha predeterminado",
		"financialFile": {
			"title": "Archivo financiero",
			"description": "Acompaña tus solicitudes de equipos y suscripciones.",
			"titleDescription": "Descripción",
			"downloadButton": "Descargar",
			"table": {
				"columns": {
					"name": "Nombre",
					"contractId": "ID del contrato",
					"period": "Período"
				}
			},
			"eventType": {
				"festival": "Festival",
				"fixedVenue": "Establecimiento fijo",
				"event": "Evento",
				"sports": "Deportivo",
				"fairs": "Ferias",
				"beachClub": "Club de playa",
				"retail": "Venta minorista",
				"bar": "Bar",
				"others": "Otros",
				"hotel": "Hotel",
				"restaurant": "Restaurante",
				"school": "Escuela",
				"arena": "Arena (Estadio)",
				"hospitality": "Hospitalidad",
				"nightclub": "Antro",
				"barRestaurant": "Bar y Restaurante",
				"beachTennisCourt": "Cancha de beach tennis",
				"carnival": "Carnaval",
				"juneParty": "Fiesta de junio",
				"musicFestival": "Festival de música",
				"show": "Espectáculo",
				"newYearsEve": "Año Nuevo",
				"eventVenue": "Lugar del evento",
				"musicShow": "Concierto de música",
				"sportsEvent": "Evento deportivo",
				"gastronomicEvent": "Evento gastronómico",
				"religiousEvent": "Evento religioso",
				"schoolEvent": "Evento escolar",
				"seasonalHouse": "Casa temporal"
			},
			"eventModel": {
				"monthly": "Mensual",
				"weekly": "Semanal",
				"oneTime": "Único"
			},
			"invoiceType": {
				"daily": "Diario",
				"weekly": "Semanal",
				"monthly": "Mensual",
				"atTermination": "Al finalizar",
				"perSession": "Por sesión"
			},
			"financialClosingTitle": "Cierre financiero",
			"zigDataSection": "Datos - Zig",
			"currency": "Moneda",
			"document": "Documento",
			"name": "Nombre",
			"address": "Dirección",
			"eventDataSection": "Datos - Evento",
			"period": "Período",
			"notInformed": "No informado",
			"type": "Tipo",
			"zigExecutive": "Ejecutivo Zig",
			"model": "Modelo",
			"billing": "Facturación",
			"automaticRepayment": "Transferencia automática",
			"yes": "Sí",
			"no": "No",
			"placeId": "PlaceId",
			"organizationId": "OrganizationId",
			"clientDataSection": "Datos - Cliente",
			"client": "Cliente",
			"contract": "Contrato",
			"contractValidity": "Vigencia del contrato",
			"eventBillingHeader": "Facturación - Evento",
			"value": "Valor",
			"total": "Total",
			"totalBilling": "Facturación total",
			"zigBillingHeader": "Facturación - Zig",
			"item": "Artículo",
			"base": "Base",
			"taxRate": "Tasa (%)",
			"zigInvoiceSummary": "Resumen de factura Zig",
			"finalResultHeader": "Resultado final",
			"integratedAcquiringBalance": "Saldo generado por adquirencia integrada",
			"nonIntegratedAcquiringBalance": "Saldo generado por adquirencia no integrada",
			"zigInvoice": "Factura Zig",
			"balanceToTransfer": "Saldo a transferir",
			"finalBalanceToTransfer": "Saldo final a transferir",
			"technicalAnalysisHeader": "Análisis técnico",
			"previousValue": "Valor anterior",
			"newValue": "Nuevo valor",
			"issuance": "Emisión",
			"date": "Fecha",
			"version": "Versión",
			"meta": "Meta",
			"others": "Otros",
			"eventEntries": "Entradas - Evento",
			"totalBalance": "Total final",
			"tpvOthers": "TPV Otros",
			"integratedAcquiring": "Adquirencia integrada",
			"nonIntegratedAcquiring": "Adquirencia no integrada",
			"zigBilling": "Facturación Zig",
			"balanceMovement": "Movimiento de saldo",
			"to": "a"
		},
		"subtitles": {
			"onGoingEvent": "Evento en curso",
			"recentEvent": "Evento reciente",
			"longTimeWithoutEvent": "Largo tiempo sin evento",
			"waitingForApproval": "Esperando Aprobación",
			"noEvent": "Sin evento"
		},
		"placelinks": {
			"post": "Post",
			"pre": "Pre",
			"noEvents": "Sin eventos",
			"none": "Ningún evento",
			"openEvent": "Evento abierto"
		},
		"storage": {
			"storage": {
				"zeroProducts": {
					"noProproductIsSelected": "Ningún producto seleccionado"
				},
				"removeProduct": {
					"noProproductIsSelected": "Ningún producto seleccionado"
				},
				"layout": {
					"goBack": "Volver"
				},
				"indicators": {
					"cost": {
						"title": "Valor total en inventario"
					},
					"turnover": {
						"high": "Mayor rotación",
						"low": "Menor rotación"
					},
					"zeroed": {
						"title": "Productos agotados",
						"seeMore": "Ver más"
					},
					"intervalNotice": "Valores referentes a los últimos 90 días",
					"updatedAt": "Actualizado el {{date}}"
				},
				"modalXML": {
					"title": "Importar XML",
					"warningMessage": {
						"line1": "Seleccione el inventario de destino, descargue la hoja de cálculo de ejemplo, complétela e impórtela nuevamente.",
						"line2": "¡Atención! El valor de los productos se informa en centavos. Ej: 123 equivale a {{currencySymbol}} 1,23"
					},
					"form": {
						"label": {
							"storage": "Inventario",
							"xml": "XML"
						},
						"placeholder": {
							"xml": "Elija un archivo .xml para importar"
						},
						"validation": {
							"missingField": "Campo obligatorio"
						},
						"submit": "Importar nota"
					}
				},
				"modalManualChange": {
					"title": {
						"add": "Añadir producto \"{{prodName}}\"",
						"subtract": "Eliminar producto \"{{prodName}}\""
					},
					"okText": {
						"add": "Añadir producto",
						"subtract": "Eliminar producto"
					},
					"cancel": "Cancelar",
					"message": {
						"add": "Ingrese la cantidad de producto que desea añadir y el precio de costo",
						"subtract": "Ingrese la cantidad que desea eliminar y una observación si es necesario"
					},
					"form": {
						"hasProductionRuleWarning": "Este producto tiene una ficha técnica y sus elementos se reducirán del inventario solo cuando estén agotados.",
						"label": {
							"quantity": "Cantidad",
							"costPrice": "Precio de costo",
							"obs": "Observación"
						},
						"validation": {
							"invalidQuantity": "Cantidad inválida",
							"missingProductInfo": "Falta información del producto",
							"missingActionInfo": "Falta información de la acción"
						}
					}
				},
				"header": {
					"searchPlaceHolder": "Buscar por producto",
					"importXML": "Importar XML",
					"transferProducts": "Transferir productos",
					"addProducts": "Añadir productos",
					"addProductsManually": "Añadir productos manualmente",
					"actionsToolbar": "Acciones del inventario",
					"importViaXlsx": "Importar via Excel"
				},
				"table": {
					"columns": {
						"name": "producto",
						"category": "categoría",
						"quantity": "cantidad",
						"action": "acción",
						"lastCost": "último precio",
						"avgCost": "precio promedio",
						"totalCost": "costo total"
					},
					"actions": {
						"zeroStorage": "Vaciar inventario",
						"removeProducts": "Eliminar productos",
						"label": "Acciones por lote",
						"message": "Seleccione la casilla para acciones por lote"
					},
					"confirmationModal": {
						"warnignHiddenProductsInSearch": "Atención, algunos productos pueden estar ocultos debido a la búsqueda, limpie la búsqueda para continuar",
						"deleteSingle": {
							"title": "Eliminar producto",
							"message": "Al confirmar la acción, eliminará permanentemente estos elementos del inventario. ¿Desea continuar?",
							"confirmMessage": "Sí, deseo eliminar"
						},
						"deleteMultiple": {
							"title": "Eliminar producto",
							"message": "Al confirmar la acción, eliminará permanentemente estos elementos del inventario. ¿Desea continuar?",
							"confirmMessage": "Sí, deseo eliminar"
						},
						"zero": {
							"title": "Vaciar productos",
							"message": "Al confirmar la acción, vaciará permanentemente todos los elementos seleccionados del inventario. ¿Desea continuar?",
							"confirmMessage": "Sí, deseo vaciar los productos"
						}
					}
				},
				"inputViaXlsx": {
					"header": {
						"title": "Importar productos vía Excel"
					},
					"layout": {
						"importProductsTable": "Importar tu tabla de productos",
						"tutorial": "Agrega 1 o más productos a la vez importando una hoja de cálculo."
					},
					"form": {
						"totalProducts": "Total de productos",
						"successfullyImported": "Productos importados",
						"productsWithErrors": "Productos con errores",
						"alert": {
							"title": "Productos con errores",
							"message": "Identificamos algunos productos con información incorrecta. Descarga la hoja de cálculo con errores, corrige los datos y luego importa nuevamente."
						},
						"tooltip": {
							"totalProducts": "Tu tabla tenía {{totalProducts}} productos",
							"successfullyImported": "{{totalProducts}} productos ya han sido importados con éxito a tu almacenamiento",
							"productsWithErrors": "Descarga la hoja de cálculo con errores y vuelve a subirla"
						}
					},
					"sheet": {
						"columns": {
							"productName": "Producto",
							"quantity": "Cantidad",
							"unit": "Unidad de medida",
							"costPrice": "Precio de costo",
							"costType": "Tipo de costo"
						},
						"costType": {
							"byUnit": "Costo por unidad",
							"byTotal": "Costo total"
						},
						"sampleFileName": "ejemplo_entrada_productos",
						"errorFileName": "entrada_productos_con_errores"
					}
				}
			},
			"storageList": {
				"layout": {
					"title": "Lista de inventarios"
				},
				"header": {
					"searchPlaceHolder": "Buscar inventario",
					"importXML": "Importar XML",
					"createStorage": "Crear inventario"
				},
				"indicators": {
					"cost": {
						"title": "Monto total del inventario",
						"footer": {
							"localStorage": "Inventario local",
							"centralStorage": "Inventario global"
						}
					},
					"turnover": {
						"high": "Alta rotación",
						"low": "Baja rotación"
					},
					"zeroed": {
						"title": "Productos con cantidad cero",
						"seeMore": "Ver más"
					},
					"intervalNotice": "Valores referentes a los últimos 90 días",
					"updatedAt": "Actualizado el {{date}}"
				},
				"list": {
					"local": "Local",
					"central": "Global",
					"rename": "Renombrar inventario",
					"delete": "Eliminar",
					"valueInStorage": "Valor en inventario",
					"productsInStorage": "Productos en inventario",
					"productsInStorageCount": "{{count}} productos",
					"createdAt": "Creado en {{date}}"
				},
				"modalXml": {
					"title": "Importar XML",
					"warningMessage": {
						"line1": "Seleccione el inventario destino, descargue la hoja de cálculo de ejemplo, complétela e impórtela nuevamente.",
						"line2": "¡Atención! El valor de los productos se informa en centavos. Ej: 123 equivale a {{currencySymbol}} 1.23"
					},
					"form": {
						"label": {
							"storage": "Inventario",
							"xml": "XML"
						},
						"placeholder": {
							"xml": "Elija un archivo .xml para importar"
						},
						"validations": {
							"missingFields": "Campo obligatorio"
						},
						"cancel": "Cancelar",
						"submit": "Guardar"
					}
				},
				"modalForm": {
					"title": {
						"createStorage": "Crear inventario",
						"editarStorage": "Editar inventario"
					},
					"form": {
						"label": {
							"name": "Nombre",
							"isCentral": "Tipo de inventario"
						},
						"options": {
							"central": "Global",
							"local": "Local"
						},
						"placeholder": {
							"name": "Nombre del inventario"
						}
					}
				},
				"modalDelete": {
					"title": "Eliminar inventario",
					"warningMessage": "¿Está seguro de que desea eliminar el inventario \"{{storageName}}\"?",
					"submit": "Eliminar"
				}
			},
			"storageAdd": {
				"warningProductAlreadyOnList": "¡Este producto ya ha sido añadido a la lista!",
				"title": "Añadir producto al inventario {{storageName}}",
				"cancel": "Cancelar",
				"finish": "Concluido",
				"addProductForm": {
					"form": {
						"modalWarning": {
							"title": "Producto con coste cero",
							"errorMessage": "El coste unitario cero afectará el seguimiento de tu CMV y perjudicará la lectura de algunos informes financieros. ¿Deseas continuar de todos modos?",
							"button": "No, completar el coste"
						},
						"label": {
							"product": "Producto",
							"count": "Cantidad",
							"cost": "Precio de coste"
						},
						"validation": {
							"missingField": "Campo obligatorio",
							"invalidQuantity": "Cantidad inválida"
						},
						"submit": "Añadir"
					}
				},
				"table": {
					"columns": {
						"product": "Producto",
						"count": "Cantidad",
						"unitcost": "Costo unitario",
						"totalcost": "Costo total",
						"action": "Acción"
					}
				}
			},
			"tabs": {
				"stockPositionReport": {
					"label": "Posición de Acciones",
					"title": "Informe de Posición de Inventario",
					"filters": {
						"period": "Período",
						"storage": "Almacenamiento",
						"apply": "Aplicar filtros",
						"clean": "Limpiar filtros"
					},
					"paragraph": "El informe de Posición de Inventario proporciona una visión de cómo estaba el inventario en un período determinado, mostrando los productos de los almacenes seleccionados, sus cantidades y costos.",
					"selectStock": "Seleccione el inventario",
					"emptyMessage": {
						"title": "Seleccione inventario para comenzar",
						"description": "Seleccione el inventario y el día deseado para ver el informe de posición de inventario"
					},
					"table": {
						"product": "Producto",
						"initialQuantity": "Cantidad inicial",
						"finalQuantity": "Cantidad final",
						"maxQuantity": "Cantidad máxima",
						"minQuantity": "Cantidad mínima",
						"replacement": "Reemplazo sugerido",
						"averageCost": "Costo promedio",
						"totalCost": "Costo total",
						"total": "Total"
					}
				},
				"manualInvoiceImporting": {
					"form": {
						"num": "Número de factura",
						"serie": "Serie de factura",
						"date": "Fecha de emisión",
						"inputDate": "Fecha de entrada en el stock físico",
						"operationType": "Tipo de operación",
						"accessKey": "Clave de acceso",
						"supplier": "Emisor",
						"suppliers": "Proveedores",
						"newSupplier": "Nuevo proveedor",
						"totalValue": "Valor de la factura",
						"discountValue": "Descuentos",
						"finalValue": "Valor total",
						"amountOfDuplicates": "Número de cuotas",
						"firstDueDate": "Primer vencimiento",
						"duplicateInterval": "Intervalo entre las cuotas",
						"duplicatesDetails": "Detalles del pago a plazos",
						"duplicateNumber": "Número de cuota",
						"dueDate": "Fecha de vencimiento",
						"value": "Valor",
						"intervalTypes": {
							"Month": "Mensual",
							"Week": "Semanal"
						},
						"shippingValue": "Envío",
						"insuranceValue": "Seguro",
						"otherExpensesValue": "Gastos adicionales",
						"icmsValue": "ICMS",
						"icmsstValue": "ICMS ST",
						"ipiValue": "IPI",
						"associatedProduct": "Producto asociado",
						"associatedChartAccount": "Plan de cuentas",
						"count": "Cantidad",
						"unitCostValue": "Costo unitario",
						"totalCost": "Costo total",
						"basicStorageUnit": "Unidad de medida",
						"success": "Factura importada con éxito",
						"storage": "Almacenamiento",
						"accessKeyInfo": "La clave de acceso de la NF-e está compuesta por 44 dígitos numéricos que identifican la factura electrónica. Incluye información como el NIF del emisor (CNPJ), el código del estado, el año y mes de emisión, el número de la factura, el modelo, la serie y un código único de control."
					},
					"sections": {
						"inviceDetails": "Detalles de la factura",
						"duplicates": "Pago a plazos",
						"expenses": "Envío y gastos",
						"taxes": "Impuestos",
						"products": "Productos"
					},
					"validations": {
						"storageIsRequired": "Es obligatorio seleccionar un almacenamiento.",
						"duplicateInvoice": "La factura ya existe en el almacenamiento seleccionado.",
						"supplierIsRequired": "Es obligatorio seleccionar un emisor.",
						"numIsRequired": "Es obligatorio proporcionar el número de la factura.",
						"numIsInvalid": "El número de factura debe contener solo cifras.",
						"serieIsInvalid": "La serie debe contener solo cifras.",
						"serieIsRequired": "Es obligatorio proporcionar la serie de la factura.",
						"operationTypeIsRequired": "Es obligatorio proporcionar el tipo de operación.",
						"totalValueIsRequired": "Es obligatorio proporcionar el valor total de la factura.",
						"productsIsRequired": "Es obligatorio informar pelo menos un producto.",
						"invalidAccessKey": "Clave de acceso inválida."
					}
				},
				"purchaseInvoice": {
					"titlePage": "Facturas de compra",
					"description": "La factura de compra es el documento que se refiere al movimiento del inventario de productos que está recibiendo su empresa. Aquí podrá importar sus facturas, ver su historial de importación, así como el desglose por producto de las mismas.",
					"tabs": {
						"importationInvoices": "Importación de facturas",
						"detailingByProduct": "Detallando por Producto",
						"historyNf": "Importar historial"
					},
					"detailingProduct": {
						"infoBasCalcUnitCost": "La base para calcular el costo unitario es: Valor total - Descuento + IPI + ICMS + Envío + Seguro + Otros gastos / Cantidad",
						"columns": {
							"associateProduct": "Aproducto asociado (ZIG)",
							"commercialUnit": "UN (NF)",
							"commercialUnitZig": "UN (ZIG)",
							"emission": "Fecha de emisión",
							"invoiceEntry": "Producto Importado",
							"nf": "NF",
							"inputDate": "Fecha de entrada de inventario",
							"supplierName": "Proveedor",
							"totalValue": "Coste total (NF)",
							"unitQuantity": "QTD (NF)",
							"unitQuantityZig": "QTD (ZIG)",
							"unitValue": "Costo Unitario (NF)",
							"unitValueZig": "Coste unitario (ZIG)"
						},
						"emptyText": "No hay productos no asociados en este perfil fiscal",
						"excelExportDetailingProduct": {
							"fileName": "detallando_producto",
							"title": "Detallando por producto"
						},
						"fields": {
							"isAssociatedProduct": "Solo productos no asociados",
							"searchDateRange": {
								"emissionDate": {
									"end": "Problema de fecha de finalización",
									"start": "Emisión de fecha de inicio"
								},
								"processedAtDate": {
									"end": "Entrada de fecha de finalización",
									"start": "Entrada de la fecha de inicio"
								}
							},
							"searchNf": "Introduzca el número de nota",
							"searchSupplier": "Ingrese el nombre del emisor"
						},
						"unassociatedProduct": "Producto no asociado"
					},
					"importHistory": {
						"actionTable": {
							"delete": "Borrar",
							"download": "Descargar",
							"unprocess": "Unprocess"
						},
						"columns": {
							"createdAt": "Fecha de importación",
							"emission": "Fecha de emisión",
							"nf": "NF",
							"status": "Estado",
							"statusMessage": {
								"Deprocessed": "Desprocesado",
								"Unprocessed": "sin procesar",
								"processed": "Procesada"
							},
							"supplier": "Proveedor",
							"totalValue": "Valor"
						},
						"excelExportHistoryImport": {
							"filename": "historial de importación",
							"title": "historial de importación"
						},
						"fields": {
							"searchDateEmissionRange": {
								"end": "Emisión de fecha de finalización",
								"start": "Emisión de fecha de inicio"
							},
							"searchDateImportRange": {
								"end": "Fecha final de importación",
								"start": "Importación de fecha de inicio"
							},
							"searchNf": "Número de nota",
							"searchSupplier": "Nombre del proveedor"
						},
						"modalDelete": {
							"cancelText": "Cancelar",
							"message1": "Eliminación de facturas",
							"message2": "es permanente ¿Quieres continuar de todos modos?",
							"okText": "Borrar",
							"title": "Borrar nota"
						},
						"modalEdit": {
							"associetedProduct": "Producto asociado",
							"cancelText": "Cancelar",
							"equals": "es igual",
							"okText": "Asociar producto",
							"selectStorage": "Seleccionar almacenamiento",
							"storage": "Almacenamiento",
							"title": "Asociar producto",
							"unitValue": "precio de costo por unidad"
						},
						"modalUnprocess": {
							"cancelText": "Cancelar",
							"closeText": "Cerca",
							"message1": "Al desprocesar una factura generas las siguientes acciones:",
							"message2": "Los productos añadidos al stock serán eliminados;",
							"message3": "La contabilización de la factura se eliminará de las cuentas por pagar.",
							"message4": "¿Quieres desprocesar la factura de todos modos?",
							"okText": "Factura sin procesar",
							"title": "Factura sin procesar"
						},
						"table": {
							"emptyText": "No hay notas para mostrar",
							"reportPrint": "Importar historial"
						}
					},
					"importationInvoices": {
						"btnUpdate": "Actualizar",
						"columns": {
							"issueDate": "Fecha de asunto",
							"issuerCnpj": "CNPJ or CPF",
							"issuerName": "Nombre del emisor",
							"status": {
								"authorized": "Autorizado",
								"imported": "Importado",
								"notAllowed": "No autorizado",
								"title": "Estado",
								"xmlUnavailable": "XML no disponible"
							},
							"totalValue": "Valor total"
						},
						"emptyText": "Sin factura de compra",
						"fiscalProfiles": "Seleccionar perfil fiscal",
						"issueDate": "Filtrar por fecha",
						"issuer": "Filtrar por nombre de proveedor",
						"xmlUnavailableInfo": "Para poner a disposición los archivos XML con estado no disponible, es necesario realizar la manifestación de la nota. Si tiene alguna duda sobre la manifestación, consulte a su contador.",
						"fiscalProfilesOptions": {
							"disabledMessage": "El perfil fiscal no está habilitado para buscar facturas, edite el perfil antes de continuar",
							"notEnabled": "(NO HABILITADO)"
						},
						"modalInfoImport": {
							"notAllowed": {
								"title": "No permitido"
							},
							"xmlUnavailable": {
								"reason": "El código XML de esta factura aún no está disponible. Esperar a importar la factura.",
								"title": "XML no disponible"
							}
						},
						"status": "Filtrar por estado",
						"title": "Seleccione un perfil fiscal para comenzar"
					}
				},
				"cmvCost": {
					"alert": "¡Aviso! Hay productos con cantidad negativa que deben ser revisados",
					"averageCost": "Costo promedio x precio de venta",
					"averageCostSelection": "Costo promedio x precio de venta de la selección",
					"export": "Exportar a Excel",
					"filter": {
						"apply": "Filtrar",
						"category": {
							"all": "Todas las categorias",
							"label": "Selecciona una categoría",
							"title": "Categoría"
						},
						"clear": "Limpiar filtro",
						"label": "Filtrado por",
						"product": {
							"all": "Todos los productos",
							"label": "Seleccionar producto",
							"title": "Producto"
						},
						"storage": {
							"all": "Todas las existencias",
							"label": "Seleccionar stock",
							"title": "Inventario"
						}
					},
					"label": "Costos",
					"products": "Productos",
					"selectTotalCost": "Coste total de la selección",
					"sheet": {
						"averageCost": "Coste medio",
						"count": "Cantidad",
						"fileName": "informe-costos-cmv",
						"fiscalCode": "SKU",
						"margin": "Margen",
						"name": "Producto",
						"realCost": "Precio de venta",
						"stockValue": "Valor en stock",
						"title": "CMV",
						"unityCount": "Unidad cuantitativa)"
					},
					"showAll": "Mostrar todos los {{count}} productos",
					"showLess": "Muestra menos",
					"storageTotalCost": "Coste total en stock",
					"table": {
						"checkbox": "No mostrar artículos con ficha técnica",
						"columns": {
							"averageCost": "Costo Promedio",
							"code": "SKU",
							"count": "Cántidad",
							"margin": "Margen",
							"name": "Producto",
							"realCost": "Precio de venta",
							"stockValue": "valor en stock"
						}
					}
				},
				"cmvReport": {
					"label": "CMV",
					"description": "El Costo de Mercancías Vendidas (CMV), también conocido como el Costo de Ventas, es el costo total incurrido para adquirir mercancías que fueron vendidas durante un período de tiempo específico. Es esencial para determinar el beneficio bruto de una empresa.",
					"periodInfo": "Mostrando informe del {{since}} al {{until}}",
					"columns": {
						"product": "Producto",
						"category": "Categoría",
						"quantity": "Cantidad",
						"fiscalCode": "SKU",
						"ncm": "NCM",
						"count": "Cantidad",
						"unitValue": "Valor unitario",
						"totalValue": "Valor total",
						"productUnitCost": "costo unitario",
						"totalCost": "Coste total",
						"percentageCost": "Costo porcentual",
						"margin": "Margen",
						"empty": "¡No se encontraron productos!",
						"total": "Total",
						"totalProduct": "Producto total}})",
						"supplie": "Aporte"
					},
					"infoCards": {
						"updated": "Actualizado",
						"titleCard1": "Cantidad de productos",
						"titleCard2": "Cantidad total",
						"titleCard3": "Coste total",
						"titleCard4": "Margen porcentual",
						"titleCard5": "Margen",
						"titleCard6": "Costo unitario cero",
						"titleCard6Action": "Ver todos"
					},
					"sheet": {
						"title": "informe CMV",
						"fileName": "informe_cmv",
						"fiscalCode": "SKU",
						"margin": "Margen",
						"ncm": "NCM",
						"percentageCost": "costo de margen",
						"product": "Producto",
						"productUnitCost": "Coste unitario",
						"total": "Total",
						"totalCost": "Coste total",
						"totalProduct": "Producto total}})",
						"totalValue": "Valor total",
						"unitValue": "Valor unitario"
					},
					"expandIcon": {
						"arrowDown": "Cerrar productos",
						"arrowUp": "mostrar productos"
					},
					"expandedTable": {
						"columns": {
							"codeProduct": "SKU",
							"margin": "Margen",
							"percentMargin": "Porcentaje de margen",
							"cmv": "CMV",
							"product": "Producto",
							"quantity": "Cantidad",
							"lostQuantity": "Perdas",
							"totalCost": "Coste total",
							"totalValue": "Valor total",
							"unitCost": "Costo unitario",
							"unitValue": "Costo unitario,"
						},
						"loading": "Cargando"
					},
					"export": "Exportar a Excel",
					"forms": {
						"cmvType": "Productos mostrados",
						"cmvType1": "Todos los productos",
						"cmvType2": "Colocar solo productos",
						"cmvType3": "solo productos endor",
						"period": "Período",
						"product": "Producto",
						"productPlaceholder": "Buscar por producto",
						"searchPlaceholder": "Buscar por categoría"
					}
				},
				"lossReport": {
					"add": "Añadir pérdida",
					"export": "Exportar a Excel",
					"description": "El informe de pérdidas agrupa todos los movimientos de inventario marcados como pérdidas. De esta manera, el administrador puede tener una visión general de los productos que se han perdido",
					"periodInfo": "Mostrando informe del {{since}} al {{until}}",
					"emptyText": "No se encontraron datos",
					"addModal": {
						"count": "Cantidad",
						"date": "Fecha",
						"loading": "Cargando...",
						"lossQuantity": "cantidad perdida",
						"none": "No se encontraron productos",
						"other": "Añadir otro producto",
						"productSelect": "Seleccionar producto",
						"storageSelect": "Seleccionar acciones"
					},
					"columns": {
						"manual": "Pérdida manual",
						"product": "Producto",
						"inventory": "Inventario",
						"production": "Pérdida de producción",
						"inventoryLoss": "Pérdida de inventario",
						"refund": "Pérdida de contracargo",
						"sku": "SKU",
						"subtotal": "Total parcial",
						"total": "Pérdida total",
						"totalLoss": "Valor total de pérdida"
					},
					"label": "Pérdidas",
					"period": "Período",
					"sheet": {
						"fileName": "informe de pérdida",
						"manual": "Pérdida manual",
						"product": "Producto",
						"inventory": "Inventario",
						"production": "Pérdida de producción",
						"inventoryLoss": "Pérdida de inventario",
						"refund": "Pérdida de contracargo",
						"sku": "SKU",
						"subtotal": "Total parcial",
						"title": "título",
						"basicStorageUnit": "Unidad",
						"total": "Pérdida total",
						"totalLoss": "Valor total de pérdida"
					},
					"title": "Informe de pérdidas",
					"validations": {
						"validDate": "Seleccione una fecha válida",
						"validProduct": "Seleccione un producto válido",
						"validQuantity": "Insertar una cantidad válida",
						"validStorage": "Seleccione un almacenamiento válido",
						"totalLossTooltip": "Valor total de pérdida correspondiente al período seleccionado.",
						"totalLossHeading": "Valor total de pérdida"
					}
				},
				"nfReport": {
					"columns": {
						"date": "Fecha de importación",
						"emission": "Fecha de asunto",
						"name": "Número de nota",
						"value": "Valor"
					},
					"empty": "Sin productos",
					"label": "Facturas de compra",
					"notAssociatedProduct": "(Producto no asociado)",
					"productColumns": {
						"name": "Productos",
						"quantity": "La cantidad",
						"total": "Cantidad",
						"unit": "Unidad",
						"unitValue": "valor unitario"
					}
				},
				"storageAlerts": {
					"addAlertModal": {
						"add": "Crear alerta",
						"invalidText": "El valor de stock de alerta no puede ser inferior o igual al valor de stock crítico",
						"selectProduct": "Seleccione el producto",
						"storageAlert": {
							"below": "Abajo",
							"label": "Alerta",
							"storageIn": "Acciones de"
						},
						"storageCritic": {
							"below": "Abajo",
							"label": "CRÍTICO",
							"storage": "Inventario"
						},
						"title": "Añadir nueva alerta"
					},
					"addEmailModal": {
						"email": "Correo electrónico",
						"emptyText": "Sin correos registrados",
						"name": "Nombre",
						"phone": "Teléfono",
						"placeholders": {
							"name": "Ingrese el nombre",
							"email": "Ingrese el email",
							"phone": "Ingrese el teléfono"
						},
						"title": "Configurar la recepción de alertas por correo electrónico"
					},
					"btnAddEmail": "Configurar la recepción de alertas",
					"btnAddProductAlert": "Agregar alerta para un producto",
					"description": "Configure y gestione las alertas de su inventario para no perder ningún movimiento",
					"titleAlertPhone": "¡Reciba alertas en su teléfono!",
					"descriptionAlertPhone": "Ahora puede registrar números de teléfono para recibir las alertas de inventario",
					"columns": {
						"actions": "Comportamiento",
						"product": "Producto",
						"storageAlert": {
							"from": "de",
							"label": "Alerta",
							"storageIn": "Acciones de"
						},
						"storageCritic": {
							"from": "de",
							"label": "CRÍTICO",
							"storage": "Inventario"
						},
						"storageQuantity": "Inventario actual"
					},
					"filters": {
						"ok": "OK",
						"storageAlert": "estado de alerta",
						"storageCritic": "Condición crítica"
					},
					"label": "Alertas de existencias",
					"search": "Buscar Productos"
				},
				"storageHistory": {
					"description": "El Informe de Movimiento de Stock permite un análisis detallado de todos los movimientos de entrada y salida realizados en un periodo determinado.",
					"print": "Imprimir",
					"export": "Exportar a Excel",
					"cleanFilters": "Limpiar filtros",
					"emptyState": {
						"title": "Seleccione y aplique filtros para comenzar",
						"description": "Debe seleccionar al menos un stock, una categoría o un producto y el período para comenzar"
					},
					"categorys": {
						"label": "Categorías",
						"placeholder": "Seleccionar categoría"
					},
					"columns": {
						"cardExchange": "Devoluciones",
						"inicial": "Cantidad inicial",
						"input": "Entrada de producto",
						"lost": "Pérdidas",
						"manual": "Ajuste manual",
						"name": "Producto",
						"productionIn": "Insumo de producción",
						"productionOut": "Salida de la producción",
						"result": "Final",
						"sell": "Ventas",
						"transfer": "Transferencia interna",
						"ube": "Unidad",
						"lossPercentage": "Porcentaje de pérdida"
					},
					"editModal": {
						"alert": "Alerta",
						"below": "abajo",
						"critical": "Crítico",
						"delete": "Eliminar alerta",
						"deleteWarning": "¿Está seguro de que desea eliminar la alerta de {{productName}}?",
						"invalidText": "El valor del stock de alerta no puede ser inferior al valor del stock crítico",
						"storage": "Existencias",
						"storageIn": "Acciones de",
						"title": "Editar alertas de existencias para {{productName}}"
					},
					"filter": "Aplicar filtros",
					"filterBy": {
						"category": "Categoría",
						"label": "Filtrado por",
						"product": "Producto"
					},
					"dateFilterBy": {
						"label": "Filtrar datos por",
						"options": {
							"events": "Eventos entre intervalo",
							"interval": "Todo entre intervalo"
						}
					},
					"hideProducts": "No mostrar elementos con hoja de datos",
					"label": "Reporte de transacción",
					"filename": "informe-de-transacciones",
					"period": "Período",
					"printable": {
						"final": "Fin",
						"initialQuantity": "Qtt inicial",
						"internalTransfer": "Transferencia interna",
						"losses": "Pérdida",
						"manualAdjustment": "Ajuste manual",
						"product": "Producto",
						"productEntry": "Prod Ent.",
						"productionEntry": "Entrada a producción",
						"productionOutput": "Salida de la producción",
						"sales": "Ventas",
						"withoutProducts": "No hay productos seleccionados"
					},
					"products": {
						"label": "Productos",
						"placeholder": "Seleccionar producto"
					},
					"storageReport": "Reporte de inventario",
					"storages": {
						"label": "Cepo",
						"placeholder": "Seleccionar acción(es)"
					}
				},
				"profitMarginReport": {
					"seeMore": "Ver más",
					"pageTitle": "Informe de Costos y Margen de Beneficio",
					"empty": "No hay informes disponibles",
					"label": "Costos y margen de beneficio",
					"notAssociatedReport": "(Informe no asociado)",
					"export": "Exportar",
					"print": "Imprimir",
					"selectPlaceholder": "Seleccione aquí",
					"excelFileName": "informe_costos_y_margen_de_beneficio",
					"successfullExportMsg": "Informe exportado exitosamente",
					"period": "Período",
					"header": {
						"description": "Este informe ofrece una vista de desempeño financiero de los productos mostrando su ingresos, ventas, precio de venta, costos y margen de beneficio."
					},
					"columns": {
						"productName": "Producto",
						"category": "Categoría",
						"quantity": "Cantidad",
						"value": "Valor promedio",
						"soldAmount": "Total",
						"invoicing": "Participación",
						"averageSellingPrice": "Precio de venta promedio",
						"totalCost": "Costo total",
						"costPercentage": "% Costo",
						"profitMarginValue": "Beneficio",
						"profitMarginPercentage": "% Beneficio"
					},
					"indicators": {
						"updatedAt": "Actualizado en {{ date }}",
						"profitMargin": {
							"title": "Margen de beneficio"
						},
						"totalBilling": {
							"title": "Facturación total"
						},
						"totalCost": {
							"title": "Costo total"
						},
						"mostProfitMargin": {
							"title": "Margen de beneficio más alto",
							"seeMore": "Productos con el margen de beneficio más alto"
						},
						"lessProfitMargin": {
							"title": "Margen de beneficio más bajo",
							"seeMore": "Productos con el margen de beneficio más bajo"
						}
					},
					"flags": {
						"red": "Entre los 5 productos con el margen de beneficio más bajo",
						"green": "Entre los 5 productos con el margen de beneficio más alto"
					},
					"filters": {
						"period": "Filtrar por período",
						"product": "Filtrar por producto",
						"category": "Filtrar por categoría",
						"allProducts": "Todos los productos",
						"allCategories": "Todas las categorías"
					}
				},
				"abcReports": {
					"abcPurchaseReport": {
						"title": "Informe de Compras ABC",
						"label": "ABC de Compras ",
						"description": "El método de la curva ABC en la gestión de inventario revelará principalmente la importancia de cada artículo para la empresa, es decir, cuáles son los bienes más costosos que requieren atención en el control de costos y procesos de compras.",
						"export": "Descargar en Excel",
						"filterByPlaceholder": "Todas las curvas",
						"contentTable": {
							"emptyReports": "No hay informes disponibles",
							"totalizers": {
								"totalValues": "Valores totales de los productos",
								"curveA": "Curva A",
								"curveB": "Curva B",
								"curveC": "Curva C",
								"tooltips": {
									"curveA": "Productos de alto valor que corresponden hasta el 80% del valor de las compras",
									"curveB": "Productos de valor intermedio que corresponden hasta el 15% del valor de las compras",
									"curveC": "Productos de bajo valor que corresponden hasta el 5% del valor de las compras"
								}
							},
							"columns": {
								"name": "Producto o Insumo",
								"quantity": "Cantidad Comprada",
								"unitaryValue": "Costo Unitario",
								"total": "Costo Total",
								"cumulateTotal": "Total Acumulado",
								"percentage": "Representación Individual",
								"cumulativePercentage": "Representación Acumulada",
								"tier": "Clasificación"
							}
						}
					},
					"abcSupplierReport": {
						"title": "Informe ABC de Proveedores",
						"label": "Proveedores ABC",
						"description": "Este informe clasifica a los proveedores en tres categorías (A, B, C) según el volumen de compras. Los proveedores de la categoría A son aquellos que concentran la mayor parte de los gastos en compras de productos, mientras que los de la categoría C son aquellos con gastos más bajos.",
						"export": "Descargar en Excel",
						"contentTable": {
							"emptyReports": "No hay informes disponibles",
							"totalizers": {
								"totalValues": "Valores totales de los productos",
								"curveA": "Curva A",
								"curveB": "Curva B",
								"curveC": "Curva C",
								"tooltips": {
									"curveA": "Proveedores con alto valor que corresponden hasta el 80% del valor de las compras",
									"curveB": "Proveedores con valor intermedio que corresponden hasta el 15% del valor de las compras",
									"curveC": "Proveedores con bajo valor que corresponden hasta el 5% del valor de las compras"
								}
							},
							"columns": {
								"name": "Proveedor",
								"total": "Costo Total",
								"cumulateTotal": "Total Acumulado",
								"percentage": "Representación Individual",
								"cumulativePercentage": "Representación Acumulada",
								"tier": "Clasificación"
							}
						}
					},
					"header": {
						"filter": "Filtrar por período",
						"searchPlaceholderProducts": "Buscar por producto o entrada",
						"searchPlaceholderSuppliers": "Buscar por proveedor"
					}
				},
				"storages": {
					"addNewStorage": "Añadir nuevo almacenamiento",
					"addProductModal": {
						"form": {
							"addedProducts": "Productos añadidos",
							"submit": "Finalizar importación",
							"successNotification": "Datos importados"
						},
						"manual": {
							"addOtherProduct": "Añadir otro producto",
							"costValue": "Precio de coste",
							"error": {
								"noneValidProduct": "No se ha seleccionado ningún producto válido",
								"zeroCount": "No se puede agregar producto con cantidad 0"
							},
							"label": "Manual",
							"product": "Producto",
							"quantity": "La cantidad"
						},
						"noteInfo": {
							"accessKey": "Llave de acceso",
							"addBill": "Agregar cuenta por pagar",
							"addSupplier": "Añadir emisor a tus favoritos",
							"bill": "Cuenta",
							"cpnj": "CNPJ",
							"error": "Ocurrió algún problema con la nota y no fue posible crear el Proveedor",
							"number": "Número de nota",
							"operationType": "Naturaleza de la operación",
							"provider": "Proveedor",
							"removeBill": "Eliminar cuenta por pagar",
							"series": "Serie",
							"supplierName": "Editor",
							"title": "Datos de facturación",
							"totalValue": "Valor total",
							"unavailable": "Indisponible"
						},
						"product": {
							"code": "SKU",
							"commercialQuantity": "Qty",
							"commercialUnit": "Un",
							"cost": "Precio de costo por",
							"description": "Descripción del Producto",
							"equals": "equivalente a",
							"label": "Producto",
							"skip": "Saltar",
							"unitValue": "Precio unitario"
						},
						"title": "Añadir productos",
						"xml": {
							"label": "Importar por Factura (XML)",
							"upload": "Haga clic o arrastre los archivos para cargar"
						}
					},
					"confirmMessage": "¿Está seguro de que desea eliminar este almacenamiento?",
					"createStorage": "Crear almacenamiento",
					"deleteAllProducts": "Eliminar todos los productos",
					"deleteProduct": {
						"title": "¿Está seguro de que desea eliminar este producto?",
						"tooltip": "Eliminar producto"
					},
					"editStorage": "Editar almacenamiento",
					"error": "Error al actualizar inventarios",
					"label": " Almacenamiento",
					"modalImportInvoice": {
						"errors": {
							"notKeyAccess": "No se puede obtener la clave de acceso XML"
						},
						"labelInputs": {
							"storage": "Almacenamiento",
							"xmlKey": "Clave XML"
						},
						"placeholders": {
							"selectStorage": "Seleccionar acción"
						},
						"typeOptionsImport": {
							"xmlFile": "Adjuntar archivo XML",
							"xmlKeyAccess": "Insertar clave de acceso XML"
						},
						"validationMessage": {
							"emptyFileXml": "Archivo XML no seleccionado",
							"emptySelectTypeImport": "Seleccione una opción de importación",
							"emptyStorage": "Seleccione una acción",
							"emptyXmlKey": "Campo de clave de acceso vacío"
						}
					},
					"modalTransfer": "Transferir productos de {{storage}}",
					"newStorage": "Nuevo almacenamiento",
					"removeStorage": "Eliminar almacenamiento",
					"search": "Busca un almacén",
					"storageCard": {
						"addProduct": "Agregar producto",
						"edit": "Editar almacenamiento",
						"error": "No se puede {{action}} producto con cantidad 0",
						"modal": {
							"add": "añadir y su precio de coste unitario",
							"addProducts": "Añadir productos",
							"amount": "Ingrese la cantidad que desea",
							"costValue": "Precio de coste",
							"count": "Cantidad",
							"note": "Nota",
							"removeProducts": "Eliminar productos"
						},
						"modalTransfer": {
							"error": {
								"selectCount": "Seleccione una cantidad",
								"selectStorage": "Seleccione una acción"
							},
							"okText": "Transferir",
							"quantity": "Cantidad",
							"storage": "Existencias",
							"title": "Transferir {{nombre}}"
						},
						"productSearch": "Buscar un producto",
						"transfer": "Transferir productos"
					},
					"storageName": "Nombre de almacenamiento",
					"tableProducts": {
						"add": "Agregar producto",
						"columns": {
							"actions": "Comportamiento",
							"category": "",
							"count": "Cantidad",
							"name": "Producto"
						},
						"cost": "Precio de coste",
						"countError": "No se puede agregar producto con cantidad 0",
						"product": "Producto",
						"productError": "Producto no encontrado",
						"quantity": "Calidad",
						"total": "en total"
					},
					"transferProductModal": {
						"destinyStorage": {
							"label": "Almacenamiento de destino",
							"placeholder": "Seleccionar stock"
						},
						"error": {
							"addProduct": "No se puede agregar producto sin cantidad",
							"selectProduct": "Cantidad negativa en almacenamiento. No se pudo seleccionar el producto"
						},
						"printTransfer": {
							"associate": "Haz clic aquí para asociarlos",
							"download": "Descargar Excel de transferencias",
							"infoText": "Transferencia realizada con éxito, consulte el resumen de productos transferidos a continuación",
							"none": "Ninguno",
							"notFound": "No encontrado",
							"notTransnfer": "Los siguientes productos no se pudieron transferir",
							"print": "Imprimir documento de transferencia",
							"quantity": "Cantidad",
							"responsible": "Responsable del stock de destino",
							"sheet": {
								"columns": {
									"count": "Cantidad",
									"name": "Producto",
									"totalCost": "Coste total",
									"unit": "Unidad",
									"unitaryCost": "Costo unitario"
								},
								"filename": "transferencia de acciones",
								"title": "Transferir de stock {{selectedStorage}} a {{toStorage}}"
							},
							"successNotification": "Productos asociados y transferidos",
							"text": "Este documento acredita la transferencia de productos del stock {{fromStorage}} al stock {{toStorage}}. El día {{fecha}} realizado por {{empleado}}. Los productos transferidos se encuentran en la siguiente lista:",
							"title": "prueba de transferencia",
							"unassociated": "No están asociados con la ubicación de destino",
							"withoutName": "Sin nombre"
						},
						"product": {
							"label": "Producto",
							"placeholder": "Seleccione un producto"
						},
						"quantity": "La cantidad",
						"table": {
							"empty": "Ningún producto seleccionado",
							"product": "Producto",
							"quantity": "La cantidad",
							"totalCost": "Coste total",
							"unityCost": "costo unitario"
						},
						"transferFor": {
							"central": "Almacenamiento general",
							"label": "Transferir a",
							"local": "Almacenamiento local",
							"placeSelect": {
								"label": "Destino",
								"placeholder": "Selecciona una ubicación"
							}
						}
					},
					"transferResume": "Informe de transferencia",
					"zeroBackoffice": "Borrar todos los productos almacenados"
				},
				"productionControl": {
					"label": "Recetas y producción",
					"at": "en",
					"attachedToModal": {
						"title": "Adjuntos del ítem",
						"description": "Lista de registros a los que este ítem está adjunto",
						"seeDetails": "Ver Detalles"
					},
					"tabs": {
						"production": "Recetas y Producción",
						"productionHistory": "Historial de Producción"
					},
					"list": {
						"emptyList": "No hay reglas de producción para mostrar",
						"actions": {
							"produce": "Producir"
						},
						"createdAt": "Creado el {{date}}",
						"title": "Recetas",
						"subtitle": "Seleccione la receta que desea producir",
						"searchPlaceholder": "Buscar una receta",
						"links": "Enlaces",
						"linksTotal": "{{count}} productos"
					},
					"history": {
						"table": {
							"name": "Nombre",
							"storage": "Almacenamiento",
							"fiscalCode": "SKU",
							"createdAt": "Fecha de Creación",
							"count": "Cantidad Producida",
							"cost": "Valor",
							"author": "Productor"
						},
						"filters": {
							"search": {
								"label": "Buscar por",
								"placeholder": "Nombre, productor o SKU"
							},
							"interval": {
								"label": "Filtrar por período"
							}
						}
					},
					"producer": "Productor",
					"expectedYield": "Rendimiento Esperado",
					"yield": "Rendimiento",
					"storage": "Almacenamiento",
					"production": {
						"title": "Producir Insumo",
						"steps": {
							"CONFIGURATION": {
								"title": "Configuración",
								"description": "Seleccione el almacenamiento para comenzar"
							},
							"PREPARE": {
								"title": "Preparación",
								"description": "Complete la cantidad de cada ingrediente y haga clic en siguiente para continuar"
							},
							"RESULT": {
								"title": "Rendimiento",
								"description": "Revise su producción y complete el rendimiento para finalizar"
							}
						},
						"fields": {
							"storage": {
								"label": "Almacenamiento",
								"placeholder": "Seleccione un almacenamiento"
							},
							"producer": {
								"label": "Productor"
							},
							"inputCount": {
								"label": "Cantidad Utilizada"
							},
							"inputLoss": {
								"label": "Pérdida"
							},
							"output": {
								"label": "Cantidad Producida"
							}
						},
						"statusDialog": {
							"loading": {
								"dialogTitle": "Producción",
								"title": "Produciendo...",
								"subtitle": "Estamos produciendo su producto, por favor espere un momento."
							},
							"success": {
								"dialogTitle": "Producción - Éxito",
								"title": "¡Producción Completada!",
								"subtitle": "{{count}} de {{recipe}} ingresados en el almacenamiento {{storage}}"
							},
							"error": {
								"dialogTitle": "Producción - Error",
								"title": "¡Oops, algo salió mal!",
								"subtitle": "No pudimos realizar la producción. Por favor, inténtelo nuevamente más tarde."
							}
						},
						"backToHome": "Volver a la Página de Inicio",
						"backToYield": "Volver a Rendimiento",
						"ingredientsTable": {
							"name": "Ingrediente",
							"count": "Cantidad",
							"loss": "Pérdida",
							"totalLoss": "Pérdida Total"
						},
						"outOfExpectedYield": {
							"cancelText": "Editar rendimiento",
							"description": "Tu producción está significativamente fuera de la regla de producción. ¿Deseas continuar de todos modos?"
						}
					},
					"validation": {
						"numberMustBeGreaterThanZero": "El valor debe ser mayor que 0",
						"numberMustBePositive": "El valor debe ser positivo",
						"nameMustHaveMaxCharacters": "El nombre debe tener un máximo de 30 caracteres",
						"skuMustHaveMaxCharacters": "El SKU debe tener un máximo de 30 caracteres"
					},
					"save": {
						"newTitle": "Nueva Regla",
						"editTitle": "Editar Regla",
						"createAction": "Crear Regla",
						"addSupplyAction": "Agregar Insumo",
						"detailsTitle": "Detalles de la Regla",
						"productionRule": "Regla de Producción",
						"inputsTable": {
							"name": "Insumo",
							"count": "Cantidad",
							"loss": "Pérdida",
							"actions": "Acciones"
						},
						"form": {
							"name": {
								"label": "Nombre",
								"placeholder": "Ingrese el nombre"
							},
							"yield": {
								"label": "Rendimiento de la Regla"
							},
							"image": {
								"label": "Foto",
								"caption": "Imagen cuadrada o de 500x500 píxeles"
							},
							"inputName": {
								"label": "Insumo ou producto"
							},
							"inputCount": {
								"label": "Cantidad"
							},
							"inputLoss": {
								"label": "Pérdida"
							},
							"output": {
								"label": "Cantidad Producida"
							}
						}
					},
					"deleteDialog": {
						"title": "Eliminar Regla",
						"content": "Al confirmar esta acción, eliminará permanentemente esta regla de producción. ¿Desea continuar?"
					},
					"actions": {
						"produce": "Producir",
						"delete": "Eliminar",
						"edit": "Editar"
					},
					"recipe": {
						"title": "Detalles de la Receta",
						"ingredientsTitle": "Receta y producción",
						"totalCost": "Costo Total",
						"yield": "Rendimiento esperado",
						"deleteInputDialog": {
							"content": "Al confirmar esta acción, eliminará el elemento de la receta. ¿Desea continuar?",
							"title": "Eliminar Elemento"
						},
						"multipleItems": "Artículos",
						"singleItem": "Artículo",
						"links": "Enlaces"
					}
				},
				"inventoryControl": {
					"label": "Inventario"
				}
			}
		},
		"audits": {
			"navTitle": " Audit"
		},
		"tagGroups": {
			"title": "Grupo de tarjetas",
			"total": "Total",
			"exportToExcel": "Exportar a excel",
			"importConsumption": "Importar Consumo",
			"blockCards": {
				"label": "Bloquear etiquetas seleccionadas",
				"confirmationMessage": "Está a punto de bloquear las etiquetas seleccionadas. ¿Está seguro de que desea continuar?",
				"confirmationButton": "Sí, bloquear etiquetas"
			},
			"unblockCards": {
				"label": "Habilitar etiquetas seleccionadas",
				"confirmationMessage": "Está a punto de activar las etiquetas seleccionadas. ¿Está seguro de que desea continuar?",
				"confirmationButton": "Sí, activar etiquetas"
			},
			"filter": {
				"zigCode": {
					"label": "Filtrar por código Zig",
					"placeholder": "Código Zig"
				},
				"group": {
					"label": "Filtrar por grupo",
					"placeholder": "Nombre del grupo"
				},
				"serial": {
					"label": "Filtrar por serie",
					"from": "De:",
					"to": "Hasta:",
					"placeholderFrom": "Ej: 1001",
					"placeholderTo": "Ej: 2001"
				},
				"status": {
					"label": "Estado",
					"options": {
						"all": "Todo",
						"blocked": "Bloqueado",
						"inUse": "En Uso",
						"used": "Usado",
						"inactive": "Inactivo"
					}
				},
				"userType": {
					"label": "Por tipo de usuario",
					"options": {
						"all": "Todo",
						"anonymous": "Anónimo",
						"nonAnonymous": "No Anónimo"
					}
				}
			},
			"table": {
				"export": {
					"fileName": "tarjetas-grupo-evento-{{eventName}}_{{eventDate}}",
					"titleName": "Grupo de tarjetas del evento {{eventName}}"
				},
				"selectedItems": "Artículos seleccionados:",
				"columns": {
					"zigCode": "Zig Code",
					"serialNumber": "Número de serie",
					"status": {
						"label": "Estado",
						"blocked": "Bloqueado",
						"inUse": "En Uso",
						"used": "Usado",
						"inactive": "Inactivo"
					},
					"user": {
						"label": "Usuario",
						"anonymous": "Anónimo"
					},
					"zigDeviceGroup": "Grupo de tarjetas",
					"totalValue": "Saldo",
					"actions": {
						"label": "Acciones",
						"block": "Bloquear",
						"blockCard": "Bloquear tarjeta",
						"unblock": "Desbloquear",
						"unblockCard": "Desbloquear Tarjeta",
						"addConsumption": "Agregar consumo"
					}
				}
			},
			"addConsumption": {
				"title": "Agregar consumación",
				"confirmButton": "Confirmar",
				"fields": {
					"rechargeType": {
						"label": "Tipo de recarga"
					},
					"balanceValue": {
						"label": "Valor de recarga",
						"required": "El valor de la recarga debe ser mayor a cero"
					},
					"reason": {
						"label": "Motivo",
						"required": "Ingrese el motivo"
					}
				}
			},
			"topUpCancelation": {
				"confirmation": {
					"title": "Confirmar cancelación de recargas pendientes",
					"description": "Estás a punto de cancelar todas las recargas pendientes asociadas con esta tarjeta. ¿Confirmar la cancelación?",
					"confirmButton": "Confirmar cancelación",
					"cancelButton": "Volver"
				},
				"confirmationByBatch": {
					"title": "Confirmar cancelación de recargas masivas",
					"description": "Estás a punto de cancelar todas las recargas pendientes para las tarjetas seleccionadas. ¿Continuar con la cancelación?",
					"confirmButton": "Confirmar cancelación",
					"cancelButton": "Volver"
				},
				"cancelationButton": "Cancelar recargas pendientes"
			}
		},
		"prechargeReports": {
			"title": "Informes de precarga",
			"filterByDate": "Filtrar por fecha",
			"cards": {
				"retrievedRecharge": "Recargas recuperadas",
				"consumedValue": "Valor consumido",
				"avgRechargedValue": "Valor promedio de recarga",
				"avgRetrievedValueByDay": "Valor promedio recuperado por día",
				"gender": {
					"label": "Distribución de género",
					"male": {
						"title": "{{percent}}% Hombres",
						"acronym": "H"
					},
					"female": {
						"title": "{{percent}}% Mujeres",
						"acronym": "M"
					},
					"other": {
						"title": "{{percent}}% Otros",
						"acronym": "O"
					}
				}
			},
			"table": {
				"exportToExcel": {
					"title": "{{placeName}}_{{date}}",
					"filename": "{{placeName}}_{{date}}"
				},
				"columns": {
					"date": "Fecha",
					"maleQuantity": "Total de recargas para hombres",
					"femaleQuantity": "Total de recargas para mujeres",
					"otherQuantity": "Total de recargas para otros",
					"topUpQuantity": "Cantidad total de recargas pendientes",
					"redeemedQuantity": "Cantidad total de recargas recuperadas",
					"accumulatedValue": "Valor acumulado",
					"bonusValue": "Valor de bonificación",
					"redeemedValue": "Valor recuperado",
					"usedValue": "Valor consumido"
				}
			}
		},
		"barReports": {
			"salesReport": {
				"title": "Informe de Ventas",
				"tabTitle": "Ventas",
				"exportButton": "Exportar",
				"exportLabelWithFilters": "Informe con filtros seleccionados",
				"exportAllSales": "Ventas detalladas",
				"exportOthersReportsLabel": "Otros informes",
				"exportTotalSales": "Productos vendidos",
				"exportDetailedSold": "Ventas Detalladas (Consolidado)",
				"exportSoldProductsAnalytic": "Productos Vendidos (Analítico)",
				"exportSoldProductsConsolidated": "Productos Vendidos (Consolidado)",
				"productsSoldLabel": "Cantidad de productos vendidos",
				"subtotalLabel": "Subtotal",
				"subtotalTooltip": "Valor unitario x Cantidad vendida",
				"discountsLabel": "Descuentos",
				"totalProductsSoldLabel": "Total en productos vendidos",
				"totalProductsSoldTooltip": "(Valor unitario x Cantidad vendida) - Descuentos",
				"allSalesTab": "Ventas detalladas",
				"totalSalesTab": "Productos vendidos",
				"paymentTypes": {
					"bonus": "Bono",
					"fromApp": "Pagado en la App",
					"fromEvent": "Pagado en el evento",
					"fromOtherEvent": "Pagado en otro evento",
					"minimumConsumption": "Consumo mínimo",
					"post": "Post",
					"ppu": "Pre"
				},
				"allSales": {
					"table": {
						"columns": {
							"date": "Fecha",
							"client": "Cliente",
							"document": "Documento",
							"employee": "Empleado",
							"products": "Productos",
							"paymentType": "Forma de pago",
							"isRefunded": "Reembolsado",
							"discount": "Descuento",
							"transactionValue": "Valor de la transacción"
						},
						"total": "Total",
						"method": "método",
						"methods": "métodos",
						"product": "producto",
						"products": "productos"
					},
					"filters": {
						"clientPlaceholder": "Filtrar por cliente",
						"employeePlaceholder": "Filtrar por empleado",
						"paymentTypePlaceholder": "Filtrar por pago"
					}
				},
				"totalSales": {
					"groupPlaceholder": "Agrupar por categoría de producto",
					"groupByBar": "Agrupar por bar",
					"groupByCategory": "Agrupar por categoría de producto",
					"noGroup": "Sin agrupación",
					"groupByProduct": "Agrupar por producto",
					"transactionPlaceholder": "Filtrar por tipo de transacción",
					"productPlaceholder": "Filtrar por producto",
					"barPlaceholder": "Filtrar por bar",
					"tableProductsSold": {
						"sectorsPlaceholder": "Filtrar por setores",
						"sku": "SKU",
						"name": "Nombre",
						"unitQuantity": "Cant. unit",
						"unitValue": "Valor unitario",
						"subtotal": "Subtotal",
						"discounts": "Descuentos",
						"totalValue": "Valor total",
						"addCategory": "Agregar categoría",
						"totalInBar": "Total en {{barName}}",
						"productImageAlt": "Imagen del producto",
						"category": "Categoría",
						"values": "{{length}} Valores",
						"mountable": "montable",
						"noBar": "Sin barra"
					},
					"mountableProductsTable": {
						"name": "Nombre",
						"section": "Sección Montable",
						"count": "Cantidad"
					}
				}
			},
			"by": "by",
			"chipsBurned": {
				"byEmployee": {
					"filename": "chips-quemado-empleado-",
					"printTitle": "Chips quemados por empleado",
					"tabTitle": "Chips quemados por empleado"
				},
				"fileName": "total-chips-quemado",
				"printTitle": "Total de fichas quemadas",
				"tabTitle": "Total de fichas quemadas",
				"table": {
					"count": "Importe",
					"fracionalCount": "Fract. Importe",
					"name": "Nombre",
					"product": "Producto",
					"totalValue": "Total",
					"unitCount": "Cantidad unitaria",
					"unitValue": "Valor unitario",
					"unitaryValue": "Valor unitario"
				},
				"title": "Total de fichas quemadas"
			},
			"deliveredProductsByBar": {
				"all": "Todo",
				"bar": "Pub",
				"byBars": "Por bares",
				"filename": "Productos entregados",
				"noSelectedBar": "Seleccione al menos una barra para ver el informe",
				"selectPlaceholder": "Seleccionar bar(es)",
				"selectVisualization": "Seleccionar vista",
				"selectedBars": "Barras seleccionadas",
				"tabTitle": "Productos entregados por barra",
				"table": {
					"count": "Unidades vendidas",
					"fracCount": "Cantidad fraccionaria",
					"fracionalCount": "Cantidad fraccionaria",
					"name": "Nombre",
					"proportionalValue": "Valor proporcional",
					"subtotal": "Subtotal",
					"total": "Total",
					"totalDiscount": "Descuentos",
					"totalValue": "Valor total",
					"totalVat": "Total IVA",
					"valueVat": "IVA",
					"unitCost": "Unitary value",
					"category": "Categoría"
				},
				"transactionType": "Tipo de transacción",
				"bars": "Bares",
				"sectors": "Setores",
				"productMasterKinds": "Tipo de producto",
				"applyFilters": "Aplicar filtros",
				"total": "Total",
				"emptyState": {
					"withoutFilters": {
						"title": "Sin filtros aplicados",
						"description": "Seleccione al menos un bar para generar un informe."
					},
					"anyResults": {
						"title": "No se encontraron resultados",
						"description": "¡No se pudieron encontrar resultados que coincidan con los filtros aplicados!"
					}
				},
				"totalizer": {
					"totalUnitsSold": "Total de unidades vendidas",
					"totalInDiscounts": "Total en descuentos",
					"totalValueSold": "Valor total vendido"
				}
			},
			"filter": "Filtrar por tipo de transacción",
			"filterOptions": {
				"all": "Todo",
				"balcony": "Balcón",
				"cashless": "Cashless",
				"dash": "Tablero",
				"delivery": "Entrega",
				"ficha": "Tapón",
				"grabngo": "Grab n Go",
				"onlineBill": "Factura en línea",
				"zigQrcode": "Código QR en zig"
			},
			"filterPlaceholder": "Seleccione un tipo de transacción",
			"grams": "Gramos",
			"kilos": "Kilos",
			"liter": "Litros",
			"no": "No",
			"printDate": "Fecha de emisión",
			"reportPeriod": "Período del informe",
			"soldBaseProductReport": {
				"emptyText": "No hay datos para mostrar.",
				"filename": "product_general_output_report",
				"tabTitle": "Producción general de productos",
				"table": {
					"code": "SKU",
					"count": "Cantidad",
					"product": "Producto"
				}
			},
			"soldProducts": {
				"fileName": "total-productos-vendidos",
				"filter": "Filtrar por tipo de transacción",
				"printTitle": "Productos vendidos",
				"tabTitle": "Total products sold",
				"table": {
					"category": "Categoría",
					"count": "Cantidad",
					"fiscalCode": "SKU",
					"fracionalCount": "Cantidad fraccionaria.",
					"mountableItem": "Artículo montable",
					"mountableProduct": "Aumentable",
					"mountableProducts": "Montable",
					"mountableSection": "Sesión montable",
					"mountableStage": "Paso montable",
					"name": "Nombre",
					"product": "Producto",
					"productCategory": "Categoría de producto",
					"subtotal": "Subtotal",
					"totalDiscount": "Descuentos",
					"totalValue": "Valor total",
					"unitCount": "Cantidad unitaria",
					"unitValue": "Valor unitario",
					"unitaryValue": "Valor unitario"
				},
				"title": "Productos vendidos",
				"filterByProducts": "Filtrar por productos",
				"filterByProductsPlaceholder": "Seleccionar producto",
				"filterByOperationType": "Filtrar por tipo de operación",
				"filterByOperationTypePlaceholder": "Todas",
				"filterByProductKind": "Filtrar por tipo de producto",
				"productKindOptions": {
					"food": "Alimentos",
					"drinks": "Bebidas",
					"tickets": "Taquillas",
					"other": "Otros"
				}
			},
			"soldRankingReport": {
				"tabTitle": "Ventas por productos",
				"pageTitle": "Ventas por productos",
				"pageDescription": "Informe comparativo entre operadores y sus ventas.",
				"exportReport": "Exportar reporte",
				"groupedView": "Vista agrupada",
				"selectPeriod": "Seleccione el período",
				"searchCategory": "Categoría",
				"searchCategoryPlaceholder": "Buscar categoría",
				"manageBar": "Bares",
				"searchProduct": "Producto",
				"searchProductPlaceholder": "Buscar producto",
				"filename": "relatorio_de_ventas",
				"table": {
					"columns": {
						"position": "Posición",
						"product": "Producto",
						"count": "Cantidad",
						"totalSold": "Total",
						"price": "Precio",
						"discount": "Descuento"
					},
					"withoutInfo": "No hay información para mostrar"
				},
				"productSoldTable": {
					"columns": {
						"waiter": "Mesero",
						"count": "Cantidad",
						"price": "Precio",
						"discount": "Descuento",
						"total": "Total"
					},
					"withoutInfo": "No hay información para mostrar"
				},
				"totalizers": {
					"highestSeller": "Mayor operador",
					"totalSellerSold": "Total del operador"
				}
			},
			"tipReport": {
				"title": "Informe de Propinas",
				"filename": "informe-de-propinas_{{date}}",
				"subtitle": "Lista de montos a ser recibidos por los operadores/empleados referentes a las propinas del servicio.",
				"filterByPeriod": "Filtrar por período",
				"filterByEmployee": "Filtrar por empleado",
				"filterByEmployeePlaceholder": "Seleccionar empleado(s)",
				"eventPeriod": "Período del evento",
				"statusRunning": "(en curso)",
				"columns": {
					"name": "Nombre",
					"total": "Total en propinas",
					"extraTip": "Propina extra",
					"cashTotal": "Efectivo",
					"debitTotal": "Débito",
					"creditTotal": "Crédito",
					"appTotal": "Aplicación",
					"pixTotal": "Pix",
					"bonusTotal": "Bonus"
				},
				"tooltip": {
					"total": "Total en propinas (conforme % definido por la casa)",
					"extraTip": "Valor de propina que excede el porcentaje de servicio definido por la casa"
				},
				"alert": {
					"title": "Atención",
					"message": "El total en propinas incluye cuentas abiertas, lo que puede causar discrepancias en los valores totales de los métodos de pago. Los métodos de pago se actualizarán después de cerrar la cuenta abierta."
				}
			},
			"productReturnsReport": {
				"title": "Devolución de productos",
				"product": "Producto",
				"quantity": "CANT",
				"returnValue": "Valor de devolución",
				"totalValue": "Total",
				"noRecords": "Sin registros",
				"noReturnedProducts": "No hubo devoluciones en este período",
				"noReturnsThisEvent": "No hubo devoluciones en este evento",
				"productReturnReport": "Informe de devolución de productos",
				"totalReturnedProducts": "Total de productos devueltos",
				"productsReturnedByEmployee": "Productos devueltos por el personal",
				"employee": "Empleado",
				"summary": "Resumen"
			},
			"waiterReport": {
				"description": "Informes sobre ventas de bares, operadores y rankings de productos.",
				"filename": "Ventas por empleados",
				"filter": "Filtrar por tipo de transacción",
				"filterWaiterLabel": "Nombre de empleado",
				"filterWaiterPlaceholder": "Seleccionar los empleados",
				"productSell": "Ventas por producto",
				"sellerProductTable": {
					"category": "Categoría",
					"count": "Cantidad",
					"discount": "Descuento",
					"filename": "sales-per-product",
					"name": "Nombre",
					"total": "Total",
					"value": "Valor"
				},
				"sellerTransactionTable": {
					"clients": "Clientela",
					"date": "Date",
					"cardNumber": "Número de tarjeta",
					"filename": "Ventas por transacción",
					"products": "Products",
					"refunded": "Invertido",
					"serialNumber": "Número serial (SN)",
					"tip": "Tip value",
					"transactionValue": "Valor de transacción"
				},
				"tabTitle": "Clasificación de ventas",
				"table": {
					"name": "Nombre",
					"soldValue": "Valor vendido",
					"tip": "Valor en el servicio",
					"total": "Total"
				},
				"title": "Ventas por barra",
				"transactionSell": "Ventas por transacción",
				"waiterSell": "Ventas de bar",
				"deletedEmployee": "Usuario eliminado"
			},
			"yes": "Yes"
		},
		"businessIntelligence": {
			"chartCards": {
				"filters": {
					"consumption": "Consumo",
					"ppu": "PPU"
				}
			},
			"clients": {
				"averagePublicPerWeekDay": {
					"averageTicket": "Ticket medio",
					"label": "Valor de audiencia promedio por día de la semana durante el período",
					"title": "Audiencia media por día de la semana"
				},
				"clientRecordPerDay": {
					"label": "Mayor cantidad de audiencia durante el período",
					"none": "None",
					"people": "{{num}} Gente",
					"person": "{{num}} persona",
					"title": "Récord de audiencia"
				},
				"headerChart": {
					"averagePublic": "Audiencia media",
					"filters": {
						"label": "Filtros",
						"men": "Hombres",
						"others": "Otros",
						"women": "Mujeres"
					},
					"label": "Durante el período",
					"total": "Total de clientes"
				},
				"topClients": {
					"infoLabel": "Seleccione un cliente para ver los detalles.",
					"label": "Valor durante el período",
					"title": "Clientes TOP"
				}
			},
			"employees": {
				"filters": {
					"checkins": {
						"average": "Promedio por empleado",
						"higher": "Empleado con más Check-ins",
						"label": "Check-ins",
						"lower": "Empleado con menos Check-ins",
						"quantity": "Número total de Check-ins",
						"shortName": "Check-ins"
					},
					"financialOperations": {
						"average": "Promedio por empleado",
						"best": "Mejor rendimiento",
						"label": "Ingresos financieros",
						"lower": "Menor rendimiento",
						"quantity": "Número de operaciones",
						"shortName": "Ingresos",
						"total": "Productos vendidos"
					},
					"refunds": {
						"label": "Reembolsos",
						"quantity": "Número de contracargos",
						"shortName": "Reembolsos",
						"total": "Valor total de las devoluciones de cargo"
					},
					"sellRefunds": {
						"label": "Quién causó la devolución de cargo",
						"shortName": "Contracargo"
					},
					"sells": {
						"average": "Promedio por empleado",
						"best": "Mejor rendimiento",
						"label": "Ventas",
						"lower": "Menor rendimiento",
						"quantity": "Cantidad de pedidos",
						"shortName": "Ventas",
						"total": "Valor total de los pedidos"
					},
					"tips": {
						"average": "Promedio por empleado",
						"higher": "Valor más alto",
						"label": "Consejos",
						"lower": "Valor más bajo",
						"percent": "% a la venta",
						"shortName": "Consejos",
						"total": "Propina total"
					}
				},
				"userCard": {
					"employeeName": "Nombre del empleado",
					"ofSales": "de ventas",
					"role": "Pergamino"
				}
			},
			"financial": {
				"bonus": {
					"label": "Bonus"
				},
				"filters": {
					"average": "Ticket medio",
					"bonus": "Bonus",
					"income": "Ingresos"
				},
				"financialChartCards": {
					"average": " Promedio",
					"averageTicket": "Ticket promedio",
					"billing": "Facturación",
					"bonus": "Bonus"
				},
				"graphCards": {
					"averageTicket": {
						"label": "Promedio de registros de tickets",
						"subtitle": "Importe facturado por día durante el período {{periodLabel}}"
					},
					"averageTicketPerWeekDay": {
						"label": "Días de la semana con el promedio más alto de entradas",
						"subtitle": "Valor medio del ticket medio por día de la semana durante el periodo {{periodLabel}}"
					},
					"billingsPerPeriod": {
						"label": "Días con los ingresos más altos",
						"subtitle": "Importe facturado por día de la semana durante el periodo {{periodLabel}}"
					},
					"billingsPerWeekDay": {
						"label": "Días de la semana con mayores ingresos",
						"subtitle": "Importe medio facturado por día de la semana durante el periodo {{periodLabel}}"
					},
					"bonusPerWeek": {
						"label": "Días de la semana con más bonificaciones",
						"subtitle": "Monto subsidiado por día durante el período {{periodLabel}}"
					},
					"consumptionTime": {
						"columns": {
							"friday": "Viernes",
							"general": "General",
							"monday": "Lunes",
							"period": "Periodo",
							"saturday": "Sábado",
							"sunday": "Domingo",
							"thursday": "Jueves",
							"tuesday": "Martes",
							"wednesday": "Miércoles"
						},
						"filename": "ventas_totales_por_hora",
						"formatPeriod": {
							"currPeriod": "at {{currPeriod}}",
							"nextPeriod": "{{período de curación}} a {{próximo período}}"
						},
						"label": "Ventas totales por tiempo",
						"subtitle": "Período: {{periodLabel}}",
						"tooltip": {
							"date": "Total consumida a {{fecha}} ",
							"dates": "Total consumido desde {{desde}} hasta {{hasta}}:"
						}
					},
					"highestBonus": {
						"label": "Bonos más grandes",
						"subtitle": "Importe subvencionado por día durante el periodo {{etiqueta del periodo}}"
					},
					"paymentMethod": {
						"anticipated": "Anticipado",
						"app": "Solicitud",
						"cash": "Dinero",
						"credit": "crédito",
						"dashboard": "Panel",
						"debit": "débito",
						"label": "Métodos de pago",
						"others": "Otros",
						"postEvent": "Después del evento",
						"subtitle": "Importe facturado por método de pago durante el periodo {{periodLabel}}",
						"uniformed": "Uniforme",
						"voucher": "Vale",
						"zigCredit": "Crédito ZigPay",
						"zigDebit": "Débito Zigpay"
					}
				},
				"income": {
					"label": "Comparar con",
					"labelChart": "Facturado"
				},
				"methodFilters": {
					"cash": "Dinero",
					"credit": "Crédito",
					"debit": "Débito",
					"total": "Promedio",
					"zigCredit": "Crédito Zigpay",
					"zigDebit": "Débito Zigpay"
				},
				"periodLabel": "({{desde}} hasta {{hasta}})",
				"ticket": {
					"average": "Boleto promedio",
					"real": "Boleto real"
				}
			},
			"header": {
				"clients": "Clientes",
				"employees": "Empleados",
				"financial": "Financiero",
				"period": "Período"
			}
		},
		"coala": {
			"config": {
				"form": {
					"additionalFields": "Campos Adicionales",
					"addressInfo": "Datos del Domicilio",
					"deliveryInfo": "información de entrega",
					"initialInfo": "información inicial",
					"paymentMethods": "Métodos de pago",
					"qrCodesGenerate": "Generar Códigos QR",
					"webpageInfo": "ver información"
				},
				"newImageSaved": "Nueva imagen guardada",
				"savedData": "Datos guardados",
				"subForms": {
					"additionalFields": {
						"add": "Agregar nuevo campo",
						"empty": "No hay campos registrados",
						"label": "Subtítulo",
						"required": "Requerido",
						"save": "Guardar campos adicionales",
						"slug": "Babosa",
						"type": {
							"date": "Fecha",
							"label": "Tipo",
							"number": "Número",
							"options": {
								"label": "Opciones",
								"placeholder": "Añadir una nueva opción"
							},
							"remove": "Eliminar",
							"select": {
								"a": "Opción A",
								"b": "OpciónB",
								"c": "Opción C",
								"label": "Opción multiple"
							},
							"text": "Alfanumérico"
						}
					},
					"address": {
						"city": "Ciudad",
						"complement": "Añadir",
						"country": "País",
						"formattedAddress": "DIRECCIÓN",
						"neighborhood": "Vecindario",
						"postalCode": "ZIP",
						"save": "Guardar información de dirección",
						"state": "Estado",
						"streetName": "Nombre de la calle",
						"streetNumber": "Número de calle"
					},
					"delivery": {
						"attendanceRadius": {
							"label": "Radio de servicio",
							"sufix": "km"
						},
						"avgWaitTime": {
							"label": "Tiempo medio de entrega",
							"sufix": "Minutos"
						},
						"deliveryFeePerKm": "Tarifa de entrega por Km",
						"fixedDeliveryFee": "Tarifa mínima de envío",
						"save": "Guardar información de entrega"
					},
					"initialInfo": {
						"isManualMenu": "Activación manual del menú",
						"isOrganization": "Modo de organización",
						"name": "Nombre",
						"save": "Guardar información inicial"
					},
					"payments": {
						"methods": {
							"alelo": "Alelo",
							"amex": "Amex",
							"ben": "Ben",
							"cash": "Dinero",
							"creditCard": "Tarjeta de crédito",
							"creditCardOnline": "Tarjeta de crédito en línea",
							"debitCard": "Tarjeta de débito",
							"diners": "Comensales",
							"elo": "Elo",
							"hipercard": "Hipertarjeta",
							"mastercard": "Tarjeta MasterCard",
							"others": "Otros métodos de pago",
							"sodexo": "Sodexo",
							"ticket": "Boleto",
							"visa": "Visa",
							"voucherInPlace": "Vale",
							"vr": "VR"
						},
						"save": "Guardar métodos de pago"
					},
					"qrCodeGenerator": {
						"chooseSheet": "Elige una hoja",
						"columns": {
							"params": "Parámetro",
							"url": "URL",
							"value": "Valor del parámetro"
						},
						"download": "Descargar códigos QR",
						"import": "Importar códigos QR",
						"new": "Nuevo código QR",
						"paramsRequired": "Se requiere parámetro",
						"sheetFilename": "QR codes",
						"urlRequired": "Se requiere URL",
						"valueRequired": "Se requiere el valor del parámetro",
						"warningNotification": "Por favor rellena todos los campos."
					},
					"webPage": {
						"image": "Imagen",
						"primaryColor": "Color primario",
						"save": "Guardar información de vista",
						"secondaryColor": "Color secundario",
						"slug": "Babosa"
					}
				},
				"title": "Configuración de la tienda de entrega",
				"updatingData": "Actualizando datos"
			},
			"editMenu": {
				"add": "Agregar producto",
				"deleteConfirm": "¿Estás segura de que quieres eliminar el menú? ",
				"deleteProducts": "Eliminar productos",
				"deleteProductsConfirm": "¿Está seguro de que desea eliminar todos los productos seleccionados del menú?",
				"errorEditNotification": "Error in ",
				"errorProductIdentify": "no puede identificar el producto correspondiente de {{name}}, descargue una nueva hoja de plantilla y tenga cuidado con la columna 'identificador'",
				"goBack": "Volver a todos los menús",
				"massDelete": "Quitar productos a granel",
				"massEdit": "Editar productos de forma masiva",
				"menuActive": "Activar menú",
				"okText": "¡Sí, lo quiero!",
				"search": "Buscar Productos",
				"successNotification": "Toda la información del producto ha sido editada con éxito",
				"updatedPrices": "Precios actualizados",
				"warningNotification": "Menú editado, pero hubo un problema al registrar el horario de apertura:"
			},
			"menu": {
				"header": {
					"create": "Crear Menú",
					"manualMode": "Modo manual",
					"search": "Menús de búsqueda"
				},
				"menuCard": {
					"active": "activo",
					"at": "at",
					"businessHour": "Horas de funcionamiento",
					"delivery": "Entrega",
					"inactive": "inactivo",
					"message": "operación 24h",
					"table": "orden en la mesa",
					"type": "Tipo"
				},
				"menuList": "Menú para la entrega",
				"noMenu": {
					"create": "Crear Menú",
					"message": "Parece que aún no tienes ningún menú creado",
					"title": "Menú para la entrega"
				},
				"warningNotification": "Menú para la entrega"
			},
			"orderReport": {
				"channelLabel": {
					"marketplace": "Mercado",
					"phone": "Teléfono",
					"whatsapp": "Whatsapp",
					"whitelabel": "Etiqueta blanca"
				},
				"columns": {
					"chanel": "Plataforma",
					"customerName": "Cliente",
					"customerPhone": "Teléfono del cliente",
					"date": "Fecha y hora",
					"deliveryFee": "Gastos de envío",
					"discount": "Descuento",
					"note": "OBS",
					"paymentMethods": "Métodos de pago",
					"reference": "Número de orden",
					"status": "Estado",
					"subtotal": "Total parcial",
					"tip": "Consejo",
					"value": "Valor",
					"vendor": "Proveedor"
				},
				"methodsLabel": {
					"alelo": "Alelo",
					"amex": "Amex",
					"ben": "Ben",
					"cash": "Dinheiro",
					"creditCard": "Carta de crédito",
					"creditCardOnline": "Carta de crédito en línea",
					"debitCard": "Carta de débito",
					"diners": "Comensales",
					"elo": "Elo",
					"hipercard": "Hipertarjeta",
					"mastercard": "Tarjeta MasterCard",
					"sodexo": "Sodexo",
					"ticket": "Boleto",
					"visa": "Visa",
					"voucherInPlace": "Vale",
					"vr": "VR",
					"pix": "PIX"
				},
				"sheet": {
					"columns": {
						"chanel": "Plataforma",
						"customerName": "Cliente",
						"customerPhone": "Teléfono del cliente",
						"date": "Fecha y hora",
						"deliveryFee": "Gastos de envío",
						"discount": "Descuento",
						"note": "OBS",
						"paymentMethods": "Métodos de pago",
						"reference": "Número de orden",
						"status": "Estado",
						"subtotal": "Total parcial",
						"tip": "Consejo",
						"value": "Valor",
						"vendor": "Proveedor"
					},
					"filename": "informe de entrega del proveedor",
					"title": "Entrega de ventas"
				},
				"statusLabel": {
					"canceled": "Cancelado",
					"concluded": "Concluído",
					"confirmed": "Confirmado",
					"dispatched": "Despachado",
					"integrated": "integrado",
					"pendingPayment": "pago pendiente",
					"pickupAreAssigned": "Cliente no local",
					"placed": "Criado",
					"ready": "Pronto",
					"scheduled": "agenda"
				},
				"title": "Informe de pedido",
				"vendorLabels": {
					"coala": "Etiqueta blanca",
					"ifood": "Icomida",
					"rappi": "Rappi",
					"ubereats": "Uber come"
				}
			},
			"productReport": {
				"columns": {
					"baseValue": "Valor base",
					"count": "Cantidad",
					"integration": "Integración",
					"name": "Producto",
					"sku": "SKU",
					"totalValue": "Precio total"
				},
				"sheet": {
					"allOrdersProductsReport": {
						"columns": {
							"baseUnitPrice": "Precio base",
							"count": "Cantidad",
							"deliveryOrderId": "Identificador de pedido",
							"name": "Producto",
							"obs": "Nota",
							"productId": "Identificador de Producto",
							"sku": "SKU",
							"totalUnitPrice": "Precio total"
						},
						"title": "Informe de pedido de productos"
					},
					"filename": "entrega-informe",
					"generalProductReport": {
						"columns": {
							"baseValue": "Valor base",
							"count": "Cantidad",
							"integration": "Integración",
							"name": "Producto",
							"sku": "SKU",
							"totalValue": "Precio total"
						},
						"title": "Informe de productos de entrega"
					}
				},
				"title": "Informe de entrega por producto",
				"vendors": {
					"coala": "Whitelabel 4911",
					"ifood": "Ifood",
					"rappi": "Rappi",
					"ubereats": "Uber eats"
				}
			},
			"products": {
				"bottomText": "Todos los cambios realizados aquí afectarán a todos los menús",
				"error": "No se puede intentar el producto correspondiente de {{name}}, descargue una nueva hoja de plantilla y tenga cuidado con la columna 'Identificador'",
				"errorIn": "Error en ",
				"header": {
					"add": "Agregar productos",
					"delete": "Eliminar productos",
					"deleteConfirm": "¿Está seguro de que desea eliminar todos los productos seleccionados?",
					"edit": "Edición masiva de productos",
					"massDelete": "Eliminar productos de forma masiva",
					"search": "Buscar productos"
				},
				"success": "Todos los productos editados con éxito",
				"title": "Productos"
			},
			"tabs": {
				"config": "Configuración",
				"menu": "Menu",
				"orderReport": "Informe de pedido",
				"productReport": "Informe por producto",
				"products": "Productos",
				"vendorReport": "Informe de proveedores"
			},
			"vendorReport": {
				"columns": {
					"deliveryFee": "Gastos de envío",
					"tip": "Consejo",
					"value": "Value",
					"vendor": "Vendedor"
				},
				"sheet": {
					"columns": {
						"deliveryFee": "Tarifa de entrega",
						"tip": "Propina",
						"value": "Valor",
						"vendor": "Proveedor"
					},
					"filename": "Proveedor-entrega-reporte",
					"title": "Entrega de ventas por proveedor"
				},
				"title": "Informe de entrega de proveedores"
			}
		},
		"contracts": {
			"solicitation": {
				"columns": {
					"id": "Id del Ticket",
					"requestBy": "Nombre del solicitante",
					"requestDate": "Fecha de solicitud",
					"requestReason": "Motivo de la solicitud",
					"requestType": "Tipo de solicitud",
					"returnDate": "Fecha de retorno",
					"status": "Estado"
				},
				"filter": {
					"periodTimeLabel": "Fecha de solicitud",
					"statusLabel": "Estado",
					"statusPlaceholder": "Selecciona el estado de la solicitud"
				},
				"incident": "Incidente",
				"status": {
					"closed": "Finalizado",
					"hold": "En espera",
					"open": "Abierto",
					"new": "Nuevo",
					"pending": "Pendiente",
					"solved": "Resuelto"
				},
				"title": "Solicitudes"
			},
			"history": {
				"title": "Historial de Contratos",
				"filename": "historial_de_contratos",
				"status": {
					"approved": "Aprobado",
					"pendingApproval": "Aprobación Pendiente",
					"pendingSign": "Firma Pendiente"
				},
				"columns": {
					"requestDate": "Fecha de Solicitud",
					"signatureDate": "Fecha de Firma",
					"contract": "Contrato",
					"managerName": "Gerente de Ventas",
					"signedBy": "Firmado Por",
					"status": "Estado"
				},
				"filter": {
					"periodTimeLabel": "Fecha de Solicitud",
					"statusLabel": "Estado",
					"statusPlaceholder": "Seleccione el estado de la solicitud"
				},
				"details": {
					"title": "Solicitud realizada en el modelo",
					"temporary": "Temporal",
					"permanent": "Permanente",
					"contractNotFound": "Contrato no encontrado",
					"equipments": {
						"equipment": "Equipo",
						"quantity": "Cantidad",
						"unitValue": "Valor Unitario",
						"totalValue": "Valor Total"
					},
					"manager": {
						"managerName": "Responsable ZIG",
						"managerContact": "Canal de Contacto"
					},
					"file": {
						"type": "Tipo de Solicitud",
						"requestModel": "Modelo de Solicitud",
						"contractPeriod": "Período del Contrato"
					}
				},
				"actionsTable": {
					"details": "Ver detalles de la solicitud",
					"downloadDocuments": "Descargar Documentos"
				}
			}
		},
		"discountCategory": {
			"activeCategories": "Categorías de descuento activas",
			"allCategories": "Todas las categorías de descuento",
			"create": "Crear nueva categoría",
			"drawer": {
				"create": "Crear categoría de descuento",
				"edit": "Edit Discount Category"
			},
			"errorNotification": "Por favor, seleccione una ubicación primero",
			"filter": {
				"label": "Filtrar por",
				"placeholder": "Elegir filtro"
			},
			"form": {
				"and": "and",
				"between": "Entre",
				"discount": {
					"label": "Descuento otorgado en",
					"percentage": "Por ciento",
					"value": "Real"
				},
				"employees": {
					"label": "Empleados autorizados para utilizar la categoría",
					"placeholder": "Buscar por nombre"
				},
				"errors": {
					"name": "Introduce un nombre válido",
					"stabilizedType": "Seleccione una opción arriba"
				},
				"name": {
					"label": "Nombre de la categoría",
					"placeholder": "Asigne un nombre a la categoría de descuento"
				},
				"stabilizedType": {
					"fixed": "Valor fijo",
					"label": "Establecido",
					"range": "Rango"
				},
				"observation": "Observaciones",
				"addObservation": "Permitir agregar observación"
			},
			"inactiveCategories": "Categorías de descuento inactivas",
			"label": "Crear, editar, eliminar, activar o desactivar categorías de descuento",
			"modal": {
				"message": "¿Desea eliminar la categoría de '{{name}}'?",
				"title": "Eliminar categoría de descuento"
			},
			"search": {
				"label": "Buscar",
				"placeholder": "Nombre de la categoría de descuento de búsqueda"
			},
			"table": {
				"discountType": "DESCUENTO DADO EN",
				"editCategory": "Editar categoría de descuento",
				"employee": "Empleado con permiso",
				"emptyText": "Parece que aún no has creado una categoría de descuento",
				"hideEmployees": "Ocultar empleados con permiso",
				"loading": "Carga",
				"name": "NOMBRE DE LA CATEGORÍA DE DESCUENTO",
				"removeCategory": "Eliminar categoría de descuento",
				"showEmployees": "Ver empleados con permiso",
				"status": "ESTADO",
				"value": "RANGO O VALOR FIJO"
			},
			"title": "Categorías de descuento"
		},
		"emissionErrors": {
			"drawer": {
				"clients": "Clientes",
				"count": "Cantidad",
				"date": "Primer día no emitido",
				"details": "Detalles de la última nota por error",
				"message": "Mensaje",
				"products": "Productos",
				"profile": "Perfil fiscal",
				"status": "Estado",
				"title": "Historial de errores",
				"type": "Tipo de error",
				"updatedAt": "Último día no emitido"
			},
			"export": "Exportar Excel",
			"period": "Periodo",
			"table": {
				"columns": {
					"count": "Cantidad",
					"createdAt": "Primer día no emitido",
					"errorMessage": "Mensaje",
					"errorType": "Tipos de error",
					"fiscalProfileId": "Perfil fiscal",
					"status": "Estado",
					"updatedAt": "Último día no emitido"
				},
				"errorTypeLabel": {
					"unknown": "Desconocido"
				},
				"statusLabel": {
					"pending": "Pendiente",
					"resolved": "Resuelto"
				}
			},
			"tabs": {
				"invoices": "Notas emitidas",
				"products": "Productos no expedidos"
			},
			"title": "Errores de emisión"
		},
		"emited": {
			"details": "Detalles de emisiones",
			"fiscalGroup": "Emisiones por grupo fiscal",
			"fiscalProfile": "Emisiones por perfil fiscal",
			"byBars": "Emisiones por bar",
			"byEmployee": "Emisiones por empleado",
			"foreignDescription": "Este informe presenta un desglose agregado del monto bruto emitido y el monto neto emitido. Muestra un agrupamiento por perfil fiscal, grupo fiscal del producto, barra, empleado y método de pago.",
			"sheets": {
				"details": {
					"columns": {
						"description": "Descripción",
						"financialValue": "Valor financiero",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido",
						"title": "Título",
						"unitValue": "Valor unitario"
					},
					"filename": "Emisiones_Detalles",
					"title": "Detalles de emisiones"
				},
				"fiscalGroup": {
					"columns": {
						"name": "Grupo de productos",
						"value": "Valor",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido"
					},
					"filename": "Emisiones_por_grupo_fiscal",
					"title": "Emisiones por grupo fiscal"
				},
				"byBars": {
					"title": "Emissiones por bar",
					"filename": "emissiones_por_bar",
					"columns": {
						"name": "Bar",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido"
					}
				},
				"fiscalProfile": {
					"columns": {
						"name": "Perfil Fiscal",
						"value": "Valor emitido",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido"
					},
					"filename": "Emisiones_por_perfil_fiscal",
					"title": "Emisiones por perfil fiscal"
				},
				"byEmployee": {
					"title": "Emisiones por empleado",
					"filename": "emisiones_por_empleado",
					"columns": {
						"name": "Empleado",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido"
					}
				}
			},
			"subtitle": "Este informe solo tiene en cuenta las notas emitidas bajo el régimen NFC-e",
			"table": {
				"fiscalGroups": {
					"columns": {
						"name": "Grupo fiscal",
						"value": "Valor",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido"
					}
				},
				"fiscalProfiles": {
					"columns": {
						"name": "Perfil Fiscal",
						"value": "Valor emitido",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido"
					}
				},
				"byBars": {
					"columns": {
						"name": "Bar",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido"
					}
				},
				"byEmployee": {
					"columns": {
						"name": "Empleado",
						"valueForeign": "Valor Bruto Emitido",
						"netValueForeign": "Valor Neto Emitido"
					}
				},
				"title": "Título",
				"value": "Valor",
				"valueForeign": "Valor Bruto Emitido",
				"netValueForeign": "Valor Neto Emitido"
			},
			"title": "Emisiones"
		},
		"entrance": {
			"add": "Añadir",
			"addEntrance": "Agregar entrada",
			"cancel": "Cancel",
			"deleteEntrance": "¿Desea eliminar la entrada {{entranceName}}?",
			"edit": "Para editar",
			"entranceForm": {
				"addEntrance": "Agregar entrada",
				"bonus": "Bonus",
				"category": "Categoría",
				"categoryPlaceholder": "Seleccione la categoría de la entrada",
				"cest": "CEST",
				"cestPlaceholder": "Ingrese el CEST de la entrada",
				"code": "SKU",
				"codePlaceholder": "Ingrese el SKU referente a la entrada",
				"consumptionObligation": "Consumo mínimo",
				"details": "Información de entrada",
				"editEntrance": "Editar entrada",
				"fiscalData": "Datos fiscales",
				"fiscalGroup": "Grupo fiscal",
				"fiscalGroupPlaceholder": "Seleccione el grupo fiscal de la entrada",
				"fiscalProfile": "Perfil fiscal",
				"fiscalProfilePlaceholder": "Seleccione el perfil fiscal de la entrada",
				"image": "Fotografía",
				"minimumConsumptionValue": "Consumo temprano",
				"minimumValueCharged": "Importe mínimo cobrado",
				"minimumValueChargedTooltip": "El monto mínimo cobrado es el monto más bajo que el cliente pagará en la cuenta y es la suma del consumo mínimo con el precio de entrada.",
				"name": "Nombre",
				"namePlaceHolder": "Ingrese el nombre de la entrada",
				"ncm": "NCM",
				"ncmPlaceholder": "Ingrese el NCM de esta entrada",
				"price": "Price",
				"variablePrice": "Precio variable",
				"newCategory": "Crearás una nueva categoría"
			},
			"errors": {
				"consumption": "No es posible registrar más de un tipo de consumación",
				"mandatoryField": "Este campo es obligatorio",
				"validValue": "Introduzca un valor válido"
			},
			"table": {
				"active": "Active",
				"bonus": "Prima",
				"category": "Categoría",
				"consumptionObligation": "Consumicion Obligatoria",
				"entrance": "Prohibido",
				"minimumConsumptionValue": "Consumo mínimo",
				"value": "Valor",
				"variable": "variable",
				"sku": "SKU"
			},
			"title": "Aperitivo"
		},
		"entranceBilling": {
			"tabs": {
				"boxOfficeBilling": {
					"title": "Facturación de Taquilla",
					"tabLabel": "Facturación"
				},
				"entranceReport": {
					"columns": {
						"count": "La cantidad",
						"discountValue": "Descuentos",
						"name": "Nombre",
						"subtotal": "Subtotal",
						"totalValue": "Importe",
						"unitValue": "Valor unitario"
					},
					"title": "Total de Entradas Vendidas",
					"tabLabel": "Entradas Vendidas",
					"tabs": {
						"total": "Total",
						"clients": "Clientes por Entrada"
					}
				}
			}
		},
		"events": {
			"averageTicket": "ticket medio",
			"card": {
				"averageTicket": "Ticket medio",
				"clients": "Clientela",
				"income": "Facturación",
				"lastSyncAfterClosedAt": "Última sincronización en:",
				"pdv": "TPV abiertos",
				"status": {
					"canceled": "Cancelado",
					"created": "Cerrado",
					"finished": "Terminado",
					"running": "Abrir"
				},
				"syncAfterClosed": "Sincronización después de cerrado"
			},
			"lastEventMonth": "Último mes del evento",
			"currentMonth": "Mes actual",
			"eventsNumber": "Eventos",
			"newEvent": {
				"form": {
					"addButton": "Añadir",
					"backgroundEventPicture": "Foto de portada del evento:",
					"cancel": "Cancelar",
					"editButton": "Para editar",
					"eventPicture": "Foto del evento:",
					"labelBegin": "Empezar:",
					"labelDescription": "Descripción:",
					"labelName": "Nombre:",
					"peopleCapacity": "Capacidad del evento",
					"peopleCapacityTooltip": "Número de personas que acoge el evento."
				},
				"modalTitle": "Agregar evento",
				"title": "Nuevo evento"
			},
			"receipts": "ingresos",
			"sales": "ventas",
			"timeline": {
				"label": "Otros próximos eventos, modifique el período para ver más"
			},
			"tooltip": {
				"calculation": "Memorial de cálculo: Importe total pagado - Descuentos concedidos",
				"incomeSummaryCalc": "Valor recibido en los eventos realizados a lo largo de este mes",
				"minimumConsumption": "Consumo Mínimo",
				"productSold": "Productos Vendidos",
				"sales": "Ventas",
				"service": "Servicio",
				"ticket": "Entrada",
				"manualInvoices": "Facturas manuales"
			},
			"title": "Eventos en {{place}}",
			"totalClients": "Clientes totales"
		},
		"extract": {
			"bankAccounts": {
				"titlePage": "Cuentas bancarias",
				"addAccount": "Registrar cuenta",
				"columnsTable": {
					"name": "Nombre",
					"bank": "Banco",
					"agency": "Agencia",
					"purpose": "Finalidad de la cuenta",
					"actions": "Acciones",
					"account": "Cuenta",
					"cpfOrCnpj": "CPF/CNPJ",
					"ownerName": "Titular",
					"currentBalance": "Saldo actual",
					"initialBalance": "Saldo inicial"
				},
				"form": {
					"newNameBankAccount": "Nombre de la cuenta",
					"bank": "Institución bancaria",
					"agency": "Código de la agencia",
					"purpose": "Finalidad de la cuenta",
					"account": "Cuenta corriente con dígito",
					"cpfOrCnpj": "CPF/CNPJ",
					"ownerName": "Titular",
					"addAccount": "Añadir cuenta bancaria",
					"namePlaceholder": "Ingrese un nombre para la cuenta",
					"bankPlaceholder": "Buscar por institución",
					"purposePlaceholder": "Buscar por tipo de cuenta",
					"selectPurpose": "Sigue las instrucciones para continuar",
					"followInstructions": "Cuenta corriente con dígito",
					"accessBankAccount": "Para continuar, accede a tu banca por internet y consulta si es posible descargar tu extracto en formato OFX.",
					"verifyBankAccount": "Si el banco no exporta este formato de archivo, haga clic en Finalizar para continuar sin validación.",
					"successContent": "La información importada desde OFX está acorde con lo completado en el paso anterior",
					"inconsistentContent": "Parte de la información importada de OFX no concuerda con el llenado realizado en el paso anterior. A medida que avancemos, reemplazaremos la información completada con la información importada.",
					"emptyBankData": "Falta alguna información necesaria para la validación de la cuenta en el archivo OFX seleccionado. Haga clic en continuar para completar el registro sin validación.",
					"imported": "Importado",
					"registered": "Registrado",
					"titlesContentVerifield": {
						"success": "Información verificada",
						"inconsistency": "Información conflictiva",
						"emptyBankData": "Información faltante"
					},
					"ofxTitles": {
						"upload": "Haga clic o arrastre el archivo OFX",
						"file": "Archivo OFX"
					},
					"incompatibleFile": "Archivo incompatible",
					"purposeList": {
						"inHouseFlow": "Caja (fondo de cambio)",
						"creditCard": "Tarjeta de crédito",
						"virtualWallet": "Cartera virtual",
						"applicationAccount": "Cuenta de inversión",
						"checkingAccount": "Cuenta corriente",
						"savingsAccount": "Cuenta de ahorro"
					},
					"accountPlaceholder": "Ingrese la cuenta",
					"agencyPlaceholder": "Ingrese el código",
					"cpfPlaceholder": "000.000.000-00",
					"ownerNamePlaceholder": "Nombre del titular de la cuenta",
					"unlink": "Desvincular cuenta bancaria",
					"linkBankAccount": "Vincular cuenta bancaria",
					"defaultAccount": "Definir como cuenta principal:",
					"defaultAccountTooltip": "La cuenta principal se utiliza para completar automáticamente los formularios que requieran esta información.",
					"default": "Por defecto",
					"initialBalance": "Saldo inicial en €",
					"initialBalanceDate": "Fecha del saldo inicial",
					"balancePlaceholder": "0,00",
					"balanceDatePlaceholder": "dd/mm/aaaa",
					"saveChanges": "Guardar cambios",
					"errors": {
						"required": "Campo obligatorio",
						"name": "Ingrese un nombre válido",
						"account": "Ingrese un número de cuenta válido",
						"agency": "Ingrese un número de agencia válido",
						"cpf": "CPF inválido",
						"cnpj": "CNPJ inválido",
						"formatInvalid": "Este tipo de formato no es compatible"
					}
				},
				"confirmModal": {
					"editInfo": "Editar información",
					"cancelMessage": "No ha guardado los cambios realizados. ¿Desea continuar de todos modos?",
					"cancelButton": "Salir sin guardar",
					"confirmButton": "Guardar cambios",
					"deleteAccount": "Eliminar cuenta",
					"deleteMessage": "La eliminación de la cuenta es una acción definitiva. ¿Desea continuar?",
					"deleteTransferError": "La eliminación de esta cuenta no puede realizarse porque está vinculada a pagos o cobros registrados.",
					"deleteMainError": "La eliminación de esta cuenta no puede realizarse porque está registrada como cuenta principal.",
					"updateMainAccount": "Cambiar cuenta principal",
					"updateMainAccountMessage": "Ya existe una cuenta registrada como principal en este lugar, si continúa, esta cuenta será reemplazada. ¿Desea continuar de todos modos?",
					"confirmUpdate": "Cambiar cuenta"
				},
				"emptyStateTitle": "Ninguna cuenta bancaria registrada",
				"emptyStateSubtitle": "Agrega tu primera cuenta bancaria para empezar a usar",
				"notification": {
					"deleteAccount": "Cuenta eliminada con éxito",
					"createAccount": "Cuenta creada con éxito",
					"updateAccount": "Cuenta editada con éxito"
				}
			},
			"actionLabelBlocked": "Retirar / Pagar factura",
			"adjustments": {
				"filename": "Ajustes",
				"label": {
					"advance": "Avanzar",
					"advanceFee": "Tarifa anticipada",
					"anticipationFee": "Tarifa de anticipación",
					"balanceAdjustment": "Equilibrio de equilibrio",
					"totenRental": "Alquiler de totem",
					"balanceRetention": "Retención de saldo",
					"bonifications": "Otros bonos",
					"cardActivations": "Tarifa de activación",
					"equipmentsMaintenance": "Mantenimiento de equipos",
					"equipmentsPurchase": "Compra de equipos",
					"equipmentsRental": "Alquiler de equipos",
					"expiredRecharges": "Recargas caducadas",
					"generalZigMachineTPV": "Facturación a través de ZIG integrado adquiriendo",
					"generalZigMachineTax": "Tasas de adquisición en máquinas integradas",
					"genericOperationsFee": "Gastos generales de explotación",
					"genericServices": "Otros servicios y cargos",
					"lendingCards": "Préstamo de tarjeta",
					"loanBracelet": "Préstamo de pulsera",
					"notUsedRecharges": "Recarga las sobras ",
					"operatorFee": "Diario del operador",
					"others": "Otros",
					"payments": "Pagos",
					"paymentsTax": "Tarifa de pago a proveedores",
					"pos": "Facturación en máquinas no integradas (POS)",
					"posTax": "Comisión de adquisición en máquinas no integradas (POS)",
					"reimbursements": "Reembolsos a clientes",
					"renegotiation": "Renegociación",
					"residueRemain": "Retención de residuos",
					"systemSetup": "Configuración del sistema",
					"totemFee": "Tarifa de Tótem",
					"wifiAssistance": "Asistencia Técnica Wifi",
					"wifiSetup": "Configuración de Wifi",
					"withdraw": "Retiros",
					"zigDevicePurchase": "Compra de comandos",
					"zigFee": "Zig Fee",
					"missingCards": "Tarjetas Extraviadas",
					"billingInvoice": "Cobro de facturas",
					"guaranteedMinimumSupplement": "Suplemento Mínimo Garantizado",
					"commandFiscalPurchase": "Compra de Comanda Fiscal",
					"accountsReceivableLegal": "Cuentas a Cobrar - Legal",
					"cardDiscount": "Descuento Tarjeta",
					"discountGeneralOperatingExpenses": "Descuento Gastos Generales de Operación",
					"discountOperatorDailyRate": "Descuento Honorarios Operador Diario",
					"generalDiscount": "Descuento general",
					"dailyCoordinatorRate": "Tarifa Diaria de Coordinadores",
					"dailyHeadsRate": "Tarifa Diaria de Heads",
					"setupDailyCoordinatorRate": "Dietas de los coordinadores",
					"setupDailyHeadsRate": "Tarifa Setup Heads",
					"setupDailySupervisorsRate": "Tarifa Setup Supervisores ",
					"setupDailyTechnicalRate": "Tarifa Setup Técnicos",
					"setupDailyTraineeRate": "Tarifa Setup Trainee",
					"dailySupervisorRate": "Tarifa de Supervisores",
					"dailyTechnicianRate": "Tarifa de Técnico",
					"dailyTraineeRate": "Tarifa de Trainee",
					"damagedEquipment": "Equipos Averiados",
					"integratedAPPBilling": "Facturación App Integrada ",
					"apartCreditBilling": "Facturación de Crédito Apartado",
					"integratedCreditBilling": "Facturación a Crédito Integrada",
					"apartDebitBilling": "Facturación Débito Apartado",
					"integratedDebitBilling": "Facturación a Débito Integrada",
					"apartBillingPIX": "Facturación PIX Apartado",
					"integratedPIXBilling": "Facturación PIX integrada",
					"integratedAdvancedRechargeBilling": "Facturación de Recarga Anticipada Integrada",
					"interestandPenalties": "Intereses y multas",
					"softwareLicense": "Licencia Software",
					"replacedMachines": "Máquinas de sustitución",
					"minimumGuaranteedpermachine": "Mínimo garantizado por máquina",
					"otherEquipment": "Otros equipos",
					"rebate": "Reembolso",
					"setupAdvancedRecharge": "Setup Recarga anticipada",
					"setupRefundSite": "Setup Sitio de Reembolso",
					"acquirementfeeforIntegratedZIGApplication": "Tasa de adquirência en aplicación ZIG integrada",
					"acquiringfeeonapartCredit": "Tasa de adquirência para crédito por separado",
					"acquiringfeeforIntegratedCredit": "Tasa de adquirência para crédito integrado",
					"acquiringfeeforapartDebit": "Tasa de adquirência para debito por separado",
					"acquiringfeeonIntegratedDebit": "Tasa de adquirência en Débito integrado",
					"acquiringfeeforapartPIX": "Tasa de adquirência en PIX por separado",
					"acquiringfeeforIntegratedPIX": "Tasa de adquirência de PIX Integrado",
					"acquiringfeeforAdvancedRecharge": "Tasa de adquirência para Recarga anticipada",
					"refundfee": "Tasa de reembolso",
					"relatedpartyretentionfee": "Tasa de retención de partes vinculadas",
					"rappiFee": "Tasa Rappi",
					"SMSFee": "Tasa SMS",
					"residualFee": "Tasa de Residuos",
					"cardtoCashExchange": "Cambio de Tarjetas por Efectivo",
					"cardtoProductExchange": "Cambio de Tarjetas por Producto",
					"travelFood": "Alimentos de viaje",
					"shipping": "Carga",
					"accommodation": "Alojamiento",
					"transport": "Transporte",
					"pixRefundFee": "Tasa de reembolso PIX",
					"softwareLicenseMachine": "Licencia de Software de Máquina",
					"softwareLicenseTotem": "Licencia de Software de Tótem",
					"integratedAdvanceDebitBilling": "Facturación de Débito Anticipado Integrado",
					"integratedAdvanceCreditBilling": "Facturación de Crédito Anticipado Integrado",
					"integratedAdvancePixBilling": "Facturación Pix Anticipado Integrado",
					"integratedAdvanceDebitFee": "Tarifa de Débito Anticipado Integrado",
					"integratedAdvanceCreditFee": "Tarifa de Crédito Anticipado Integrado",
					"integratedAdvancePixFee": "Tarifa de Pix Anticipado Integrado",
					"zeDeliveryDiscount": "Descuento Zé Delivery",
					"ticketPrinting": "Impresión de entradas",
					"validatorRental": "Licencia de Validadores",
					"zeDeliveryRetention": "Retención Zé Delivery",
					"valueAddedTax": "IVA",
					"moneyTPV": "TPV Dinero",
					"acquiringFeeForIntegratedInstallmentCredit": "Tarifa de adquisición para Crédito a Plazos",
					"issuedCharge": "Cobro Emitido",
					"externalResourceContribution": "Aporte de recursos externos",
					"integratedOnlineDeliveryIncome": "Ingresos por entrega en línea integrada",
					"generalZigMachineCreditIn2Installments": "TPV Crédito en 2 pagos",
					"generalZigMachineCreditIn3Installments": "TPV Crédito en 3 pagos",
					"generalZigMachineCreditIn4Installments": "TPV Crédito en 4 pagos",
					"generalZigMachineCreditIn5Installments": "TPV Crédito en 5 pagos",
					"generalZigMachineCreditIn6Installments": "TPV Crédito en 6 pagos",
					"generalZigMachineCreditIn7Installments": "TPV Crédito en 7 pagos",
					"generalZigMachineCreditIn8Installments": "TPV Crédito en 8 pagos",
					"generalZigMachineCreditIn9Installments": "TPV Crédito en 9 pagos",
					"generalZigMachineCreditIn10Installments": "TPV Crédito en 10 pagos",
					"generalZigMachineCreditIn11Installments": "TPV Crédito en 11 pagos",
					"generalZigMachineCreditIn12Installments": "TPV Crédito en 12 pagos",
					"generalZigMachineCreditIn2InstallmentsFEE": "Tasa por crédito en 2 pagos",
					"generalZigMachineCreditIn3InstallmentsFEE": "Tasa por crédito en 3 pagos",
					"generalZigMachineCreditIn4InstallmentsFEE": "Tasa por crédito en 4 pagos",
					"generalZigMachineCreditIn5InstallmentsFEE": "Tasa por crédito en 5 pagos",
					"generalZigMachineCreditIn6InstallmentsFEE": "Tasa por crédito en 6 pagos",
					"generalZigMachineCreditIn7InstallmentsFEE": "Tasa por crédito en 7 pagos",
					"generalZigMachineCreditIn8InstallmentsFEE": "Tasa por crédito en 8 pagos",
					"generalZigMachineCreditIn9InstallmentsFEE": "Tasa por crédito en 9 pagos",
					"generalZigMachineCreditIn10InstallmentsFEE": "Tasa por crédito en 10 pagos",
					"generalZigMachineCreditIn11InstallmentsFEE": "Tasa por crédito en 11 pagos",
					"generalZigMachineCreditIn12InstallmentsFEE": "Tasa por crédito en 12 pagos",
					"totalTpvBarIncome": "Tasa de ingresos del bar",
					"totalTpvEntranceIncome": "Tasa de ingresos de taquilla",
					"totalTpvEntranceIncomeConsumption": "Tasa de ingresos por consumo en taquilla",
					"totalTpvBarMinimumConsumption": "Tasa mínima de ingresos del bar",
					"totalTpvBonus": "Tasa de ingresos por bonos",
					"bankRefund": "Reembolso bancario",
					"acquirerRefund": "Reembolso del adquirente",
					"advanceRenegotiation": "Renegociación de anticipos",
					"zigTicketsRetention": "Retención de entradas Zig",
					"onlineDeliveryAcquisitionFee": "Tarifa de adquisición de entrega en línea",
					"pixPreventiveBlock": "Pix - Bloqueo Preventivo",
					"pixAuthorizedUnblock": "Pix - Desbloqueo Autorizado",
					"pixRefundByChargeback": "Pix - Reembolso por Chargeback",
					"relatedStakeholderRetentionReprocessing": "Reprocesamiento de Retención de partes relacionadas",
					"electrical": "Electricidad",
					"hydraulics": "Hidráulico",
					"cleaning": "Limpieza",
					"supply": "Suministro",
					"other": "Otros"
				},
				"noDataToShow": "No hay nada que mostrar para el período seleccionado",
				"table": {
					"actions": "Acciones",
					"balance": "Equilibrar",
					"category": "Categoría",
					"date": "Fecha de competencia",
					"noObs": "Sin observación",
					"obs": "Observación",
					"payDate": "Fecha de liquidación",
					"total": "Total",
					"totalToPay": "Pagable",
					"totalToReceive": "Por cobrar"
				},
				"title": "Ajustes"
			},
			"anticipationDrawer": {
				"accountData": "Información de la cuenta",
				"anticipationValue": "Valor de anticipación",
				"form": {
					"accountType": "Transferir a",
					"accountTypes": {
						"default": "Cuenta predeterminada",
						"existing": "Cuenta registrada",
						"new": "Nueva cuenta",
						"tooltip": "El firmado en contrato"
					},
					"bankData": "Datos bancarios",
					"liquidValue": "Valor neto",
					"liquidValuePlaceholder": "Introduzca el importe neto aquí",
					"name": "Identificador de cuenta",
					"reason": "Motivo de la solicitud",
					"reasonPlaceholder": "Ingrese aquí el motivo de la anticipación",
					"selectAccountPlaceholder": "Ingrese o seleccione la cuenta",
					"shouldSaveForFutureRequests": "Guardar cuenta para futuras transacciones",
					"summaryAnticipationFee": "Comisión de anticipación",
					"summaryLiquidValue": "Valor líquido solicitado",
					"summaryReason": "Razón",
					"summaryThirdPartyFee": "Tarifa de anticipación de terceros",
					"summaryTitle": "Revisión de valores",
					"summaryTotal": "Importe total a anticipar",
					"summaryValue": "Importe solicitado",
					"totalValue": "Total a anticipar",
					"totalValueTooltip": "El importe neto más la comisión por adelantado.",
					"withdrawAll": "Anticipar todo el valor disponible"
				},
				"formStatusError": "No se pudo completar la solicitud.",
				"formStatusSuccess": "Avance solicitado correctamente!",
				"summary": "Revisión de datos",
				"title": "Solicitar Anticipación y Pago de Factura",
				"titleAnticipation": "Solicitar Anticipación",
				"titleBilletPayment": "Solicitar Pago de Factura",
				"warningAccountChoice": "Se cobrará una tarifa de {{value}} por anticipación en cuentas de terceros..",
				"warningBanner": "Las solicitudes realizadas después de las 10:30 am (hora de Brasilia) solo serán atendidas al día siguiente."
			},
			"availableInMoreThanOneMonth": "Cantidad a liberar en más de 32 días",
			"availableInTwoDays": "El saldo se liberará en los próximos 2 días",
			"availableMoreThanOneMonth": "Valor disponible en 30 días",
			"totalBalanceAnticipation": "Saldo total para la anticipación",
			"valueAvailableToAnticipate": "Valor disponible para anticipación",
			"availableToAnticipate": "Disponible para anticipar",
			"availableToWithdraw": "Disponible para retiro",
			"withdrawRequestDrawer": {
				"bankSlid": {
					"bankSlipInfo": "Información del recibo bancario",
					"bankSlipValue": "Valor del recibo bancario",
					"dataReview": "Revisión de datos",
					"form": {
						"anticipationTax": "Comisión de anticipación",
						"anticipationValue": "Importe total a anticipar",
						"attachment": "Seleccione el archivo de boleto bancario",
						"available": "Saldo disponible para retiro",
						"bankSlipInfo": "Información de sllip bancario",
						"bankSlipValue": "Valor del resguardo bancario",
						"barCode": "Número de código de barras",
						"beneficiary": "Beneficiario",
						"calculating": "Calculador...",
						"dueDate": "Fecha de vencimiento",
						"liquidAmmountRequested": "Importe neto solicitado",
						"liquidValue": "Valor neto",
						"liquidValuePlaceholder": "Introduzca el importe neto aquí",
						"thidPartyWithdrawFee": "Tarifa de retiro de terceros",
						"totalValue": "Valor total",
						"valuesReview": "Revisión de valores"
					},
					"transactionDetails": {
						"available": "Valor de retiro",
						"calculating": "Calculador...",
						"paymentValue": "Importe del pago",
						"title": "Detalle de la transacción",
						"totalValue": "Valor total"
					}
				},
				"bankslipPaymentOption": "Pago de recibos bancarios",
				"bankslipValue": "Valor del banquillo bancario",
				"downloadBankslipPdf": "Descargar bankslip en PDF",
				"expireDate": "Fecha de caducidad",
				"pendingBankslip": "Recibo bancario pendiente",
				"title": "Solicitar un retiro o pago de un boleto",
				"titleBankslip": "Pago del billete",
				"titlePendingBankslip": "Pago de recibos bancarios en zig",
				"titleTransfer": "Transferir saldo entre lugares",
				"titleWithdraw": "Solicitar retiro",
				"transferOption": "Traslado entre lugares",
				"warning": "Solo se pueden solicitar montos hasta el saldo disponible para retiro.",
				"withdraw": {
					"account": "Cuenta",
					"accountInfo": "Información de la cuenta",
					"accountPlaceholder": "Ingrese o seleccione la cuenta",
					"dataReview": "Revisión de datos",
					"errorMessage": "No se pudo completar la solicitud.",
					"liquidValue": "Valor neto",
					"liquidValuePlaceholder": "Introduzca el importe neto aquí",
					"reason": "Motivo de la solicitud",
					"reasonPlaceholder": "Ingrese el motivo del retiro aquí",
					"successMessage": "Retiro solicitado con éxito!",
					"warning": "Las solicitudes realizadas después de las 10:30 am (hora de Brasilia) solo serán atendidas al día siguiente.",
					"warningAccountChoice": "Se cobrará una tarifa de {{value}} por retiros a cuentas de terceros.",
					"withdrawValue": "Valor de retiro"
				},
				"withdrawOption": "Retirada"
			},
			"errorsValidations": {
				"anticipation": {
					"accountData": {
						"accountAgency": "Ingrese el número de agencia",
						"accountAgencyInvalid": "Agencia no válida",
						"accountBank": "Seleccione el banco al que pertenece la cuenta",
						"accountDigit": "Introduzca el dígito de la cuenta",
						"accountDocument": "Introduzca el documento del titular de la cuenta (CPF/CNPJ)",
						"accountDocumentInvalid": "Documento no válido",
						"accountHolder": "Introduzca el nombre del titular de la cuenta",
						"accountName": "Introduzca el nombre para identificar la cuenta",
						"accountNumber": "Introduzca el número de cuenta",
						"accountPixKey": "Clave PIX no válida",
						"accountType": "Seleccione el tipo de cuenta",
						"accountTypeExisting": "Seleccione una de las cuentas existentes",
						"accountTypeWrapper": "Rellene sus datos bancarios o clave PIX",
						"noAccountType": "Seleccione un tipo de cuenta para el anticipo"
					},
					"value": {
						"liquidValue": "Importe solicitado superior al importe neto disponible ({{totalAvailable}})",
						"noLiquidValue": "Introduzca el importe neto para la anticipación",
						"noTotalValue": "Ingrese el monto total para la anticipación",
						"reason": "Introduzca un motivo de anticipación",
						"totalValue": "Importe solicitado superior al importe total disponible ({{totalAvailable}})"
					}
				},
				"bankSlip": {
					"attachment": "Adjunte el archivo de recibo bancario",
					"barCode": "Introduzca el código de barras del recibo bancario",
					"basicInfoValue": "Importe solicitado superior al importe total disponible ({{totalAvailable}})",
					"beneficiary": "Ingrese el beneficiario del boleto bancario",
					"dueDate": "ATENCIÓN: El recibo bancario solo se pagará si el saldo restante cubre los costos de intereses y multas..",
					"invalidBarCode": "Código de barras no válido"
				},
				"withdraw": {
					"value": {
						"accountBank": "Seleccione el banco al que pertenece la cuenta",
						"accountChoice": "Seleccione un tipo de cuenta para la solicitud",
						"accountDigit": "Introduzca el dígito de la cuenta",
						"accountHolder": "Introduzca el nombre del titular de la cuenta",
						"accountName": "Introduzca el nombre para identificar la cuenta",
						"accountNumber": "Introduzca el número de cuenta",
						"accountType": "Seleccione el tipo de cuenta",
						"agencyInvalid": "Agencia no válida",
						"agencyNumber": "Ingrese el número de agencia",
						"documentInvalid": "Documento no válido",
						"documentNumber": "Introduzca el documento del titular de la cuenta (CPF/CNPJ)",
						"existingAccount": "Seleccione una de las cuentas existentes",
						"noWithdrawValue": "Ingrese el monto para el retiro",
						"pixKeyInvalid": "Clave PIX no válida",
						"reason": "Introduzca un motivo para la solicitud",
						"receiverDataWrapper": "Rellene sus datos bancarios o clave PIX",
						"withdrawValue": "Importe solicitado superior al importe total disponible ({{totalAvailable}})"
					}
				}
			},
			"transferForm": {
				"balanceAvailable": "Saldo disponible",
				"enoughBalanceMessage": "Saldo disponible para transferencia",
				"loadingTargetPlaceData": "Carga de datos desde el lugar de destino...",
				"reviewLabels": {
					"balanceAfterTransferAtSourcePlace": "Saldo después de la transferencia en el lugar de origen",
					"balanceAfterTransferAtTargetPlace": "Saldo después de la transferencia en el lugar objetivo"
				},
				"selectPlaceLabel": "Seleccione el lugar de destino",
				"selectPlacePlaceholder": "Seleccione el lugar para recibir la transferencia",
				"submitFailedMessage": "Error al transferir valor",
				"submitSucceededMessage": "Valor transferido con éxito",
				"transferTotalValueBtn": "Transferir todo el saldo disponible",
				"wizardLabels": {
					"review": "Revisar datos",
					"target": "Objetivo",
					"value": "Valor a transferir"
				}
			},
			"withdrawConfirmation": {
				"modal": {
					"title": "Confirmación de solicitud sin procesar",
					"message": "Para confirmar la solicitud de retiro, ingrese el código enviado al método de confirmación configurado en el lugar.",
					"codeInput": {
						"label": "Código",
						"placeholder": "Escriba aquí el código de confirmación"
					},
					"resendCodeBtnLabel": "No recibí mi código"
				},
				"form": {
					"errors": {
						"onlyNumbers": "El código debe contener sólo números",
						"minLength": "El código debe tener al menos 6 dígitos"
					},
					"submit": {
						"success": "La solicitud se aprobó correctamente",
						"error": "Código no válido o caducado"
					}
				},
				"resendConfirmationSuccessfully": "El código se reenvió correctamente",
				"notification": "Su solicitud se procesó correctamente, pero debe confirmarse utilizando el código enviado al contacto de confirmación configurado en la configuración del lugar."
			},
			"bankSlipForm": {
				"error": "No se pudo completar la solicitud.",
				"request": "Pedir",
				"success": "Pago del billete solicitado con éxito!",
				"tryAgain": "Vuelve a intentarlo",
				"warningBanner": {
					"description": "Las solicitudes realizadas después de las 10:30 am (hora de Brasilia) solo serán respondidas al día siguiente.",
					"title": "Atención"
				}
			},
			"bankslipAvailable": "Factura disponible",
			"consolidated": {
				"excelButton": "Exportar a Excel",
				"extract": "Extracto",
				"filename": "extract-zig",
				"formatFee": "De {{minFee}} a {{maxFee}}",
				"table": {
					"fee": "Tarifa",
					"feeMax": "Tarifa máxima",
					"feeMin": "Tarifa mínima",
					"name": "Nombre",
					"payValue": "Cuentas por cobrar/pagar Zig",
					"section": "Sección",
					"totalValue": "Valor total"
				}
			},
			"devolution": {
				"expired": "Caducado",
				"title": "Recargas caducadas",
				"toExpire": "A caducar",
				"totalExpired": "Total de recargas vencidas",
				"totalToExpire": "Total de recargas a punto de caducar"
			},
			"dueDate_Abrev": "Exp",
			"excelButton": "Exportar a Excel",
			"financial": {
				"details": "Ver detalles",
				"event": "Eventos",
				"filename": "extracto diario",
				"modality": "Modalidad",
				"noDataToShow": "No hay nada que mostrar para el período seleccionado",
				"noResume": "No hay cierre en el período",
				"pay": "Pagable",
				"payvalue": "Cuentas por pagar/cobrar",
				"receive": "Por cobrar",
				"summaryTitle": "Resumen para {{date}}",
				"table": {
					"balance": "Equilibrar",
					"datetime": "Fecha",
					"in": "Entrada",
					"out": "Salida",
					"total": "Total",
					"withdrew": "Se retiró"
				},
				"title": "Extracto diario"
			},
			"flow": {
				"emptyText": "No hay nada que mostrar para el período seleccionado",
				"filename": "Extracto de flujo de caja",
				"table": {
					"balance": "Equilibrio",
					"competency": "Fecha de la transacción",
					"date": "Fecha de liquidación",
					"title": "Descripción",
					"value": "Valor"
				},
				"title": "Extracto de flujo de caja"
			},
			"hooks": {
				"accountData": "Información de la cuenta",
				"summary": "Revisión de datos",
				"value": "Valor de anticipación"
			},
			"lastUpdated": "actualizado {{lastUpdated}} hace",
			"owedToZig": "Saldo debido a ZIG",
			"paidToZig": "Importe a pagar a ZIG",
			"paidToZigMoreThanOneMonth": "Importe a pagar a ZIG en más de 30 días",
			"period": "Periodo",
			"tabs": {
				"accounts": "Cuentas guardadas",
				"adjustments": "Configuración",
				"consolidated": "Fusionado",
				"devolution": "Recargas caducadas",
				"financial": "Declaración diaria",
				"flow": "Extracto de flujo de efectivo",
				"withdraws": "Retiros, anticipos y bancos",
				"automaticWithdraw": "Retiro automático"
			},
			"title": "Extraer",
			"totalBalance": "Saldo total",
			"vendorOwned": "Debido a los proveedores",
			"vendors": "Vendors",
			"withdrawRequestDetails": {
				"drawerTitle": "Solicitud de tipo {{type}}",
				"successNotification": "Solicitud cancelada correctamente",
				"errorNotification": "Error al cancelar la solicitud",
				"cancelWithdrawPlaceConfirmationButtonLabel": "Cancelar confirmación",
				"confirmWithdrawButtonLabel": "Confirmar solicitud",
				"cancelWithdrawRequestButtonLabel": "Cancelar solicitud",
				"sections": {
					"summary": {
						"title": "Resumen de la solicitud",
						"fields": {
							"place": "Lugar",
							"timestamp": "Fecha/Hora",
							"employee": "Empleado"
						}
					},
					"details": {
						"title": "Solicitar detalles",
						"requestedValue": "Valor solicitado",
						"anticipatedValue": "Valor anticipado",
						"proRata": "Prorrateado",
						"totalValue": "Valor total",
						"bankAccount": "Cuenta bancaria",
						"obs": "Observación",
						"paymentMethod": "Forma de pago",
						"attachments": "Archivos adjuntos"
					}
				},
				"valueLabel": "Valor:"
			},
			"withdraws": {
				"filename": "Retiros anticipados-bancoslips",
				"table": {
					"datetime": "Fecha de solicitud",
					"type": "Tipo",
					"status": "Estado",
					"requestedValue": "Importe solicitado",
					"liquidAnticipatedValue": "Valor anticipado",
					"proRataFee": "Prorrateado",
					"appliedFee": "Tasa aplicada",
					"proRataFeeTooltip": "Tipo de anticipo proporcional al período del saldo que se ha de adelantar",
					"totalBruteValue": "Importe total",
					"bankAccount": "Cuenta bancaria",
					"ticketPayment": "Pago de recibo bancario",
					"username": "Usuario",
					"vendor": "Lugar",
					"clientObservation": "Razón",
					"obs": "Observación",
					"paymentMethod": "Forma de pago",
					"attachments": "Accesorios",
					"confirmWithdrawBtnLabel": "Confirmar solicitud"
				},
				"withdrawType": {
					"anticipation": "Anticipación",
					"withdraw": "Retirarse",
					"bankslip": "Deslizamiento bancario"
				},
				"statusType": {
					"pending": "Pendiente",
					"paid": "Pagado",
					"refused": "Rechazado",
					"processing": "Tratamiento",
					"pendingPlaceConfirmation": "Pendiente de confirmación",
					"cancelled": "Cancelado",
					"processingCancellation": "Cancelación de procesamiento",
					"pixProcessing": "Procesamiento Pix",
					"bankslipProcessing": "Procesamiento de boleta bancaria",
					"pendingManagerApproval": "Pendiente de aprobación del gerente",
					"canceledPlaceConfirmation": "Cancelado",
					"approvedByZigManager": "Aprobado por el gerente de Zig",
					"pendingAnticipation": "Pendiente de anticipación"
				},
				"paymentType": {
					"bankAccount": "Cuenta bancaria",
					"bankPaymentSlip": "Recibo de pago bancario"
				},
				"filters": {
					"searchAccountPlaceholder": "Buscar por cuenta",
					"filterTypePlaceholder": "Filtrar por tipo",
					"filterStatusPlaceholder": "Filtrar por estado"
				}
			},
			"automaticWithdraw": {
				"type": "Tipo",
				"vendorName": "Nombre del proveedor",
				"expectedAmount": "Monto de retiro programado",
				"placeBalance": "Colocar saldo",
				"actualAmount": "Cantidad retirada",
				"status": "Estado",
				"vendor": "Vendor",
				"place": "Place",
				"error": "Error",
				"success": "éxito",
				"partial": "parcial"
			},
			"retainedBalance": "Saldo retenido",
			"twentyPercentRetention": "20% de retención de valores de los últimos 7 días",
			"totalRetained": "Total retenido",
			"relatedPartDataTooltip": "Datos especificados desde el 21/05/2024"
		},
		"guestList": {
			"columns": {
				"active": "ACTIVO",
				"description": "Descripcion",
				"expiresAt": "Vencimiento",
				"inactive": "DESACTIVADO",
				"name": "Lista de nombres",
				"status": "Estado",
				"userCount": "Invitados",
				"guest": "Invitado"
			},
			"addGuestError": {
				"relationReachesLimit": "La lista ya ha alcanzado el límite de invitados",
				"userAlreadyExists": "Invitado ya registrado en la lista",
				"userWithoutDocument": "Invitado sin documento"
			},
			"createList": "Crear lista",
			"guestsNotImported": "Invitados no importados",
			"deleteModal": {
				"confirm": "Eliminar lista",
				"message": "¿Está seguro de que desea eliminar estas listas?",
				"title": "Eliminar lista"
			},
			"emptyList": {
				"defaultMessage": "Parece que aún no has creado una lista.",
				"defaultText": "Parece que aún no has creado una lista."
			},
			"importList": "Importar Lista",
			"importNewList": {
				"alert": "Antes de importar la hoja de cálculo, asegúrese de eliminar todas las líneas en blanco",
				"altText": "Ejemplo de cómo se debe estructurar la hoja de cálculo a importar",
				"errorMessageDefault": "Hoja de cálculo no válida, descárguela de nuevo y realice los cambios necesarios. En caso de líneas vacías en rojo, elimínelas e inténtelo de nuevo.",
				"error": "Error",
				"list": "Lista",
				"message": "Mensaje",
				"form": {
					"at": "en",
					"colorSelect": "Asignar un color",
					"couvertPercentage": "Descuento en cobertura",
					"description": {
						"label": "Descripciónn",
						"limit": "Quedan {{count}} caracteres",
						"placeholder": "Añade una nota a tu lista si quieres"
					},
					"entranceIds": {
						"label": "Entrada asociada",
						"placeholder": "Seleccione el tipo de entrada asociado"
					},
					"errorExpires": "Fecha y hora de caducidad.",
					"errorName": "Introduce el nombre de la lista.",
					"expiresAtDate": "Caducidad de la lista",
					"listName": "Lista de nombres",
					"documentIsRequired": "El documento es obligatorio",
					"canBeInvitedByLink": "Compartir lista mediante enlace",
					"addGuestTimeLimit": "Plazo límite para agregar invitados"
				},
				"format": "formato de hoja de trabajo",
				"goBackModal": {
					"description": "Cuando salgas de esta página perderás toda la información que has rellenado, ¿quieres salir de todos modos?",
					"leavePage": "Dejar página",
					"title": "Dejar"
				},
				"goBackText": "volver a las listas",
				"importList": "Importar una lista existente en este evento",
				"middleTitle": "Para importar una nueva lista, simplemente cargue una hoja de cálculo",
				"or": "o",
				"relationUsers": "Clientes a agregar a la lista",
				"secondTitle": "Importar lista nueva o existente",
				"selectText": "Importar lista de dicho lugar para este evento",
				"sheetFileName": "Lista de invitados",
				"successMessage": "Hoja de cálculo importada con éxito",
				"title": "Importar nueva lista de invitadost"
			},
			"infos": {
				"addGuest": "Agregar invitado",
				"addGuestModal": {
					"cpf": {
						"error": "DNI invalido",
						"label": "dni"
					},
					"name": {
						"error": "Nombre inválido",
						"label": "Nombre y apellido",
						"placeholder": "nombre completo del cliente"
					},
					"phone": "Teléfono",
					"promoter": {
						"label": "nombre del promotor",
						"placeholder": "Nombre del responsable de la lista"
					},
					"successImport": "Hoja de cálculo importada con éxito",
					"title": "Cliente {{cuenta}}"
				}
			},
			"goBackToLists": "Volver a las listas",
			"print": "Imprimir",
			"steps": {
				"first": {
					"description": "¿Qué lista es esta?",
					"title": "Datos de la lista"
				},
				"last": {
					"description": "Descargar e imprimir",
					"title": "Lista lista"
				},
				"second": {
					"description": "¿Quiénes son sus clientes?",
					"title": "Clientes"
				}
			},
			"title": "Nueva lista de invitados",
			"view": "Ver lista creada",
			"promoter": {
				"title": "Promotores",
				"promoter": {
					"menu": {
						"deactivate": "Desactivar",
						"activate": "Activar",
						"edit": "Editar"
					},
					"table": {
						"name": "Nombre",
						"email": "Correo electrónico",
						"phone": "Teléfono",
						"accessLevel": "Nivel de acceso",
						"active": "Activo",
						"pending": "Pendiente",
						"inactive": "Inactivo"
					},
					"content": {
						"titleAddPromoter": "Añadir promotor",
						"titleEditPromoter": "Editar promotor"
					},
					"header": {
						"title": "Promotores",
						"text": "Área del promotor:",
						"promoter": "promotor",
						"promoters": "promotores",
						"buttonAddPromoter": "Añadir promotor",
						"buttonCopyPromoter": "Copiar",
						"buttonCopyPromoterSuccess": "Enlace copiado",
						"buttonSearch": "Buscar",
						"active": "Activo",
						"inactive": "Inactivo",
						"pending": "Pendiente"
					},
					"addPromoter": {
						"subtitle": "Enviar invitación a:",
						"textAddPromoter": "Ingrese el correo electrónico del promotor al que desea permitir el acceso a las listas de invitados.",
						"messageAddPromoter": "Para añadir más de un promotor, simplemente separe los correos electrónicos con comas (,)",
						"buttonInvite": "Enviar invitación",
						"successTittle": "Invitación enviada con éxito",
						"successText": "La invitación ha sido enviada a los correos electrónicos registrados",
						"successButton": "Añadir promotor"
					},
					"editPromoter": {
						"textStatusPromoter": "Estado",
						"textLevelPromoter": "Nivel de acceso",
						"name": "Nombre",
						"email": "Correo electrónico",
						"phone": "Teléfono",
						"messageLevelPromoter": "Puede ver eventos, agregar y editar invitados en las listas",
						"messageToolTipPromoter": "El estado define si el promotor tiene acceso a sus listas",
						"pendingStatus": "Pendiente",
						"buttonInvite": "Reenviar invitación",
						"buttonInviteSave": "Guardar edición",
						"successTittle": "Invitación enviada con éxito",
						"successText": "La invitación ha sido enviada a los correos electrónicos registrados",
						"successButton": "Añadir promotor",
						"active": "Activo",
						"inactive": "Inactivo"
					},
					"store": {
						"messageActive": "Usuario activado con éxito",
						"messageDeactive": "Usuario desactivado con éxito",
						"messageSuccess": "Invitación reenviada con éxito",
						"messageEdit": "Datos del promotor modificados con éxito"
					}
				}
			},
			"report": {
				"empty": {
					"filters": {
						"subtitle": "Seleccione otra opción e inténtelo de nuevo",
						"title": "No se encontraron resultados para esta selección."
					},
					"noneList": {
						"subtitle": "Los informes aparecen aquí cuando tienes una lista guardada.",
						"title": "Los informes aparecerán aquí cuando tengas una lista guardada."
					},
					"search": "No hemos encontrado resultados para tu búsqueda."
				},
				"file": {
					"checkinDetails": "Detalles de entrada",
					"consumptionTotal": "Consumo total",
					"document": "CPF",
					"entranceTotal": "Total de entradas",
					"entranceType": "Tipo de entrada",
					"filename": "informe-lista-invitados",
					"listName": "Nombre de la lista",
					"name": "Nombre",
					"numberOfActiveGuests": "Registro realizado",
					"numberOfGuests": "Total invitados",
					"promoter": "Promotor",
					"titleByGuestList": "Informe por lista de invitados",
					"titleGeneral": "Informe general",
					"total": "Total General",
					"upgrade": "Mejora de entrada",
					"phone": "Teléfono",
					"birthDate": "Fecha de nacimiento"
				},
				"filters": {
					"period": "Período",
					"promoter": {
						"placeholder": "Agregar filtro por promotor",
						"title": "Filtrar por promotor"
					},
					"relation": {
						"placeholder": "Agregar filtros por lista",
						"title": "Filtrar por lista de invitados"
					}
				},
				"search": "Buscar",
				"tabs": {
					"byList": {
						"columns": {
							"consumptionTotal": "Consumo total",
							"entranceTotal": "Total de entradas",
							"guests": "Invitados",
							"promoters": "Promotores",
							"relationLists": "Listas",
							"total": "Total General"
						},
						"title": "Por lista de invitados"
					},
					"general": {
						"cards": {
							"consumptionTotal": "Consumo total",
							"entranceTotal": "Total de entradas",
							"guests": "Invitados",
							"promoters": "Promotores",
							"relationLists": "Listas",
							"total": "Total General"
						},
						"columns": {
							"checkin": "Detalles de entrada",
							"consumption": "Consumo",
							"cpf": "CPF",
							"entrance": "Tipo de entrada",
							"generalTotal": "Total General",
							"guestName": "Nombre",
							"listName": "Lista",
							"promoter": "Promotor",
							"upgradeEntrance": "Mejora de entrada",
							"phone": "Teléfono",
							"birthDate": "Fecha de nacimiento"
						},
						"title": "Vista general"
					}
				},
				"templateTitle": "Informe General",
				"title": "Informes"
			}
		},
		"financialReport": {
			"getSubTitle": "De {{desde}} a {{hasta}}",
			"letterhead": "Expedido por \"{{name}}\" at {{momentLT}} en{{momentL}}",
			"menu": {
				"bonusByProduct": "Bonificación por producto",
				"bonusReport": "Bonificación",
				"cashierClose": "Cierres de cajeros",
				"consumptionObligationReport": "Consumo mínimo",
				"debtorsReport": "Cuentas de pluma",
				"devolutionReport": "Devolución de tarjeta por caja",
				"discountsReportForPlace": "Descuentos de cuenta",
				"financialReport": "Clausura",
				"refundedProductsReport": "Productos invertidos",
				"seeRefundReports": "Servicios eliminados",
				"openedBillPayment": "Pago de cuentas abiertas",
				"openedBillReports": {
					"title": "Cuentas abiertas",
					"description": "Visualice y gestione cuentas abiertas y pagos",
					"stillOpenInPeriod": "Aún abiertas en el período",
					"stillOpenInPeriodTooltip": "Se refiere al valor de cuentas abiertas en el período seleccionado",
					"linksGenerated": "Enlaces generados",
					"paidInPeriod": "Pagos de cuentas abiertas resueltos en el período",
					"tabs": {
						"debtors": "Cuentas abiertas",
						"payments": "Pagos de cuentas abiertas"
					}
				},
				"reserveReport": "Informe del paquete",
				"rappiDiscountsReport": "Descuentos Rappi",
				"minimumConsumptionReport": "Consumo temprano",
				"openSalesReport": "Ventas individuales",
				"transactionTransfer": "Transferencias de facturas",
				"promotionsReports": "Promociones utilizadas",
				"transactionTransferReport": "Transferencias de facturas",
				"cashierAdjustmentsReport": "Fondo de Sangrado y Cambio",
				"zigAppTransactions": "Ventes par transações Zig.app"
			},
			"print": "Imprimir informe",
			"tabs": {
				"bonusReport": {
					"title": "Bonificación",
					"description": "Vea todos los informes de concesión y uso de bonificaciones",
					"filenameBonus": "bonificacion-concedida",
					"filenameAnticipated": "consumo-anticipado",
					"filenameConsumption": "consumación",
					"total": "Total de {{category}}",
					"subtitle": "Aquí puedes ver todos los bonos otorgados por los empleados.",
					"tabs": {
						"given": "Bonificación Concedida",
						"used": "Bonificación Utilizada"
					},
					"usedBonus": "Bonificaciones Utilizadas",
					"columns": {
						"client": "Empleado responsable",
						"category": "Categoría",
						"date": "Fecha",
						"dateTime": "Fecha y Hora",
						"reason": "Motivo",
						"receivedValue": "Valor recibido",
						"spentValue": "Valor gastado en el período",
						"spentValueInOtherEvents": "Valor gastado en otro período",
						"spentValueInBonus": "Valor de Pago en Bonificación",
						"givenBy": "Concedido por",
						"total": "Total"
					}
				},
				"cashierClose": {
					"billed": "Facturado",
					"cashiers": "Buzones",
					"changeFund": "Cambiar fondo",
					"closed": "Cerrado",
					"difference": "Diferencia",
					"excelExport": "Exportar a Excel",
					"methods": {
						"ame": "Ame",
						"anticipated": "Anticipado",
						"bonus": "Bonus",
						"cash": "Efectivo",
						"credit": "Credito",
						"dashboard": "Dashboard",
						"debit": "Debit",
						"deliveryOnline": "Entrega en línea",
						"foodVoucher": "Vale de Alimentación",
						"ifood": "Ifood",
						"installment": "Plazo",
						"pix": "Pix",
						"postEvent": "Después del evento",
						"rappi": "Rappi",
						"uber": "Uber",
						"voucher": "Voucher",
						"zigCredit": "Zig Credit",
						"zigDebit": "Zig Debit"
					},
					"modality": "Modalidad",
					"resume": "Resumen",
					"search": "Caja de recuperación",
					"searchSectors": "Buscar setores",
					"title": "Cierres de cajeros",
					"hawkers": "Ambulantes",
					"hawkerCashier": "Cajero de Ambulantes",
					"searchBars": "Buscar barras"
				},
				"consumptionObligationReport": {
					"columns": {
						"client": "Cliente",
						"date": "Fecha",
						"employee": "Dada por",
						"paidValue": "Excedente de consumación",
						"total": "Total",
						"userProductsValueAtEvent": "Utilizado en productos",
						"value": "Value"
					},
					"filename": "mínimo-consumption",
					"filenameObligation": "Obligación de consumo",
					"title": "Consumo mínimo"
				},
				"debtorsReport": {
					"clientInfo": "Información del cliente",
					"clientTotal_one": "Total ({{debtors}} client)",
					"clientTotal_other": "Total ({{debtors}} clients)",
					"columns": {
						"date": "Date",
						"filters": {
							"paid": "Ya pagado",
							"unpaid": "No pago"
						},
						"others": {
							"allBillsPaid": "Todas las facturas pagadas",
							"paid": "Ya pagado",
							"payAllBills": "Pagar todas las facturas",
							"paymentOptions": "Opciones de pago",
							"pixCharge": "Generar cargo a través de PIX"
						},
						"paidValue": "Pago total",
						"paidInOtherEvents": "Pagado después del evento",
						"phone": "Teléfono",
						"status": {
							"paid": "Pagado",
							"title": "Estado",
							"unpaid": "Pagar"
						},
						"stillOpen": "Sigue abierto",
						"tipValue": "Abierto en servicio",
						"totalOpen": "Total abierto",
						"username": "Nombre ",
						"value": "Cuenta abierta",
						"documento": "Documento"
					},
					"filename": "Abrir-Cuentas",
					"goTo": "Vete a",
					"modalTitleDebts": "Pago de {{debts}} bills",
					"modalTitleName": "Pago de {{userName}}",
					"search": "Buscar cliente...",
					"filterByStatus": "Filtrar por estado",
					"total": "Total",
					"title": "Abrir cuentas",
					"paymentLink": {
						"sendCharge": "Cobrar",
						"generatedLink": "Enlace generado",
						"charged": "Cargado",
						"noReturn": "Sin retorno",
						"cancel": "Cancelar",
						"discharge": "Descargar",
						"chooseShippingMethod": "Elegir método de envío",
						"finalPaymentLink": "Haga clic aquí para copiar el enlace",
						"error": "El número proporcionado por el cliente no tiene WhatsApp.",
						"details": "Detalles {{userName}}",
						"openValues": "Valores abiertos",
						"openConsumption": "Consumo abierto",
						"totalDebit": "Débito total",
						"tip": "Propina",
						"mail": "Correo electrónico",
						"phone": "Teléfono",
						"consumedProducts": "Productos consumidos",
						"viewBillingDetails": "Ver detalles de facturación",
						"status": {
							"created": "Enlace generado",
							"notCharged": "No cargado",
							"expired": "Sin respuesta",
							"partiallyCreated": "Parcialmente cobrado"
						},
						"paidBillMessage": "No es posible facturar una factura que ya ha sido pagada.",
						"selectService": "¿Desea incluir la tarifa de servicio en el monto pendiente?",
						"selectServiceText": "Al elegir incluir la tarifa de servicio, el monto de la tarifa se agregará al saldo pendiente de la cuenta.",
						"dontIncludeService": "No incluir",
						"includeService": "Incluir tarifa de servicio",
						"openService": "Servicio Pendiente",
						"seeMore": "Ver más",
						"copyValidLink": "Asegúrese de que este es un enlace válido",
						"retrieveLink": "Recuperar enlace de facturación",
						"moreOptions": "Más opciones",
						"confirmRemoveTip": "Al eliminar el servicio del cobro mediante enlace, el monto se establecerá en cero y no podrá retomarse.",
						"wishToProceed": "¿Desea continuar?"
					}
				},
				"devolutionReport": {
					"cashDevolution": "Reembolso en efectivo",
					"cashier": "Por cajeros",
					"columns": {
						"employee": "Empleado",
						"quantity": "Cantidad",
						"type": "Tipo",
						"value": "Valor"
					},
					"devolution": "Descentralización en {{method}}",
					"devolutions": "{{value}} Descentralizaciones",
					"filename": "card-return-per-cashier",
					"filenameCard": "Tarjeta de devolución",
					"sheetTitle": "Devolución de tarjeta - {{sheetName}}",
					"title": "Devolución de tarjeta por cajero",
					"total": "Total",
					"totalCategory": "Total ({{category}})",
					"totalGeral": "Grand total"
				},
				"minimumConsumptionReport": {
					"title": "Consumo temprano"
				},
				"openSalesReport": {
					"columns": {
						"date": "Fecha",
						"employee": "Empleado",
						"isRefunded": "Fue reembolsado",
						"method": "Método",
						"no": "no",
						"refundedAt": "ERefunded at",
						"refundedBy": "Reembolsado por",
						"total": "Total",
						"value": "Valor",
						"yes": "Sí"
					},
					"employeeSales": "Ventas únicas de {{employeeName}}",
					"searchPlaceholder": "Buscar por nombre de empleado",
					"seeAllSales": "Ver todas las ventas",
					"title": "Informe de ventas único",
					"totalSales": "Total de ventas abiertas"
				},
				"openedBillPayment": {
					"columns": {
						"client": "Client",
						"date": "Día de pago",
						"employee": "Pagado por",
						"method": "Método",
						"observation": "Observación",
						"openedEventDate": "Fecha de apertura de la cuenta",
						"tipValue": "Valor de propina",
						"total": "Total",
						"value": "Valor",
						"document": "Documento"
					},
					"emptyText": "No hay datos para mostrar.",
					"mixed": "Mixed",
					"title": "Abrir pagos de cuenta",
					"tooltip": "Información del cliente"
				},
				"transactionTransferReport": {
					"title": "Transferencias de facturas",
					"fileName": "transferencias_de_facturas",
					"columns": {
						"originCardId": "ID de la tarjeta de origen",
						"receiverCardId": "ID de la tarjeta receptora",
						"originDocument": "Documento original del cliente/Mesa",
						"receiverDocument": "Documento del receptor/Mesa",
						"productValue": "Valor del producto",
						"productDiscountValue": "Descuento",
						"productName": "Nombre del producto",
						"employeeName": "Nombre del empleado",
						"date": "Tiempo"
					}
				},
				"financialReport": {
					"analyticPayments": {
						"bonus": "Bonificación por producto",
						"columns": {
							"author": "Empleado",
							"client": "Cliente",
							"date": "Fecha",
							"method": "Método",
							"value": "Valor"
						},
						"searchMethod": "Seleccione un método...",
						"searchName": "Búsqueda por cliente o empleado...",
						"title": "Informe analítico"
					},
					"cmv": {
						"name": "Nombre",
						"title": "CMV",
						"value": "Valor",
						"valuesName": "Coste total de los productos vendidos"
					},
					"columnSection": {
						"percentage": "porcentaje",
						"quantity": "cantidad",
						"receipt": "Recibo",
						"value": "valor"
					},
					"filename": "Reanudar informe",
					"goTo": "Ir a",
					"seeAllPaymentsButton": "Ver todos los pagos",
					"title": "Financiero de {{placeName}}"
				},
				"promotionsReports": {
					"title": "Promociones utilizadas de {{placeName}}",
					"userPromotionReportFileName": "promociones-por-el-cliente",
					"userPromotionReportLabel": "Promociones utilizadas por el cliente",
					"tablePromotionReportLabel": "Utilizadas por Mesas",
					"tableTitle": "Mesa",
					"promotionTitle": "Promoções",
					"tablePlaceholder": "Todos",
					"promotionReportFileName": "promociones-usadas",
					"promotionReportLabel": "Promociones utilizadas",
					"totalDiscount": "Descuento total",
					"totalUses": "Uso total",
					"columns": {
						"userName": "Nombre",
						"userDocument": "Documento",
						"productName": "Producto",
						"promotionName": "Promoción",
						"productCategory": "Categoría",
						"uses": "Número de usos",
						"totalDiscount": "Descuento total"
					}
				},
				"tableReports": {
					"title": "Promoções utilizadas de {{placeName}}",
					"promotionReportLabel": "Promoções utilizadas",
					"promotionReportFileName": "promocoes-utilizadas",
					"userPromotionReportLabel": "Utilizadas por pessoas",
					"tablePromotionReportLabel": "Utilizadas por Mesas",
					"userPromotionReportFileName": "promocoes-utilizadas-por-pessoa",
					"totalDiscount": "Total de desconto",
					"tablePlaceholder": "Todos",
					"totalUses": "Total de uso",
					"columns": {
						"userName": "Nome",
						"productName": "Produto",
						"promotionName": "Promoções",
						"productCategory": "Categoria",
						"uses": "Quantidade de usos",
						"totalDiscount": "Desconto total",
						"openedAt": "Abertura",
						"closedAt": "Fechamento"
					}
				},
				"discountsReportForPlace": {
					"columns": {
						"category": "Categoría",
						"clients": "Clientela",
						"date": "Fecha",
						"discount": "Descuento",
						"employee": "Empleado",
						"justify": " Justificación",
						"percentage": "Porcentaje",
						"products": "Productos",
						"total": "Total"
					},
					"discounts": "Descuentos",
					"filename": "Descuentos",
					"filter": "Filtrar por categoría",
					"selectCategory": "Elegir categoría",
					"title": "Descuentos utilizados desde {{placeName}}"
				},
				"refundedProductsReport": {
					"columns": {
						"author": "Recarga realizada por",
						"client": "Cliente",
						"date": "Date",
						"refundedBy": "Revertido por",
						"totalValue": "Importe",
						"usedValue": "Valor utilizado"
					},
					"filenameRecharges": "recargas devueltas",
					"title": "Productos reservados",
					"titleRecharges": "Recargas devueltas"
				},
				"seeRefundReports": {
					"title": "Quitar servicios de cajeros",
					"printButton": "Imprimir reporte",
					"exportButton": "Exportar relatório"
				},
				"reserveReport": {
					"columns": {
						"confirmedPeople": "Confirmado",
						"invitedPeople": "invitados",
						"issued": "Invoice issuance",
						"name": "Package name",
						"products": "Productos",
						"revenue": "Ticket total",
						"value": "Valor del paquete"
					},
					"manyPackages": "{{quantity}} paquetes activados",
					"moreDetails": "Mas detalles",
					"onePackage": "Paquete activado por un periodo",
					"title": "Paquetes",
					"total": "Total",
					"totalCategory": "Total ({{category}})",
					"withoutPackage": "Paquetes no activados"
				},
				"rappiDiscountReport": {
					"sheet": {
						"columns": {
							"date": "Fecha",
							"employee": "Empleado que aplicó el descuento",
							"products": "Productos",
							"value": "Importe del descuento"
						},
						"filename": "rappi_discounts_report",
						"title": "Descuentos Rappi"
					},
					"title": "Descuentos Rappi"
				},
				"zigAppReport": {
					"title": "Vendas por transações do Zig.app",
					"searchByClientName": "Busque por nome do cliente",
					"paymentMethod": "Forma de pagamento",
					"searchByIdOrCpf": "Busque por ID ou CPF",
					"totemLabel": "Totem",
					"enterOrSelectTotem": "Digite ou selecione o totem",
					"balance": "Saldo",
					"creditCard": "Cartão de crédito",
					"refunded": "Estornado",
					"creditCardPayment": "Pagamento cartão de crédito",
					"paymentWithBalance": "Pagamento com saldo",
					"averageTicket": "Ticket Médio",
					"totalSales": "Total em vendas",
					"totalClients": "Total de clientes",
					"date": "Data",
					"client": "Cliente",
					"clients": "clientes",
					"operator": "Operador (PDV)",
					"details": "Detalhes",
					"totalPeriod": "Total período",
					"transactionDetail": "Detalhes da transação",
					"produtcs": "Produtos",
					"zigId": "ID da zig",
					"transactionId": "ID da transação",
					"copyTextSuccess": "Id copiado com sucesso!",
					"total": "Total pago com Zig.app",
					"service": "Serviço",
					"close": "Fechar",
					"justification": "Justificativa",
					"refundTransaction": "Estornar transação",
					"cancelTransaction": "Cancelar transação",
					"optional": "Opcional",
					"charactersLimit": "Até 150 caracteres",
					"inputCancelationPlaceholder": "Escreva o motivo do estorno",
					"cancelAlertMessage": "Ao cancelar, os produtos irão voltar para o estoque e a ação NÃO poderá ser desfeita. Deseja continuar mesmo assim?",
					"serviceCharge": "Taxa de serviço",
					"status": "Status",
					"selectRefundProductsList": "Produtos:",
					"shouldGoBackToStock": "Os produtos devem voltar para o estoque?",
					"inputJustificationPlaceholder": "Escreva o motivo do estorno",
					"refundAdlertMessage": "Ao estornar, os produtos NÃO VOLTARÃO para o estoque e a ação NÃO poderá ser desfeita. Deseja continuar mesmo assim?"
				}
			},
			"fiscalReport": {
				"activeTab": "fiscal-report",
				"columns": {
					"date": "Date",
					"emitted": "Billing issued",
					"emittedNfce": "Consumer Notes",
					"emittedNfse": "Service Notes",
					"eventName": "Event",
					"total": "Total",
					"totalReceipt": "Issuable Billing"
				},
				"errorNotification": "Deadline {{date}}",
				"fiscalProfile": "Fiscal Profile",
				"period": "Period",
				"sheet": {
					"columns": {
						"date": "Date",
						"emitted": "Billing issued",
						"emittedNfce": "Notas para el Consumidor",
						"emittedNfse": "Notas de servicio",
						"eventName": "Evento",
						"totalReceipt": "Facturación Emitible"
					},
					"filename": "Reportes Fiscales",
					"title": "informes de impuestos"
				},
				"title": "informes de impuestos"
			},
			"report": {
				"empty": {
					"filters": {
						"subtitle": "Seleccione otra opción y vuelva a intentarlo",
						"title": "No se encontraron resultados para esta selección."
					},
					"noneList": {
						"subtitle": "Los informes aparecerán aquí cuando tenga una lista registrada",
						"title": "Parece que aún no has creado una lista."
					},
					"search": "No encontramos resultados para su búsqueda."
				},
				"file": {
					"checkinDetails": "Detalles de facturación",
					"consumptionTotal": "Total en consumo",
					"document": "CPF",
					"entranceTotal": "Total en consumo",
					"entranceType": "Tipo de entrada",
					"filename": "informe de lista de invitados",
					"listName": "Lista de nombres",
					"name": "Nombre",
					"numberOfActiveGuests": "Check-in performed",
					"numberOfGuests": "Total guest",
					"promoter": "Promoter",
					"titleByGuestList": "Report by guest list",
					"titleGeneral": "General report",
					"total": "Total General",
					"upgrade": "Entrance upgrade",
					"phone": "Teléfono",
					"birthDate": "Fecha de nacimiento"
				},
				"filters": {
					"period": "Period",
					"promoter": {
						"placeholder": "Add filter by promoters",
						"title": "Filter by promoter"
					},
					"relation": {
						"placeholder": "Add filters by list",
						"title": "Filter by guest list"
					}
				},
				"search": "Search",
				"tabs": {
					"byList": {
						"columns": {
							"consumptionTotal": "Total in consumption",
							"entranceTotal": "Total in input",
							"guests": "Guests",
							"promoters": "Promoters",
							"relationLists": "Lists",
							"total": "Grand total"
						},
						"title": "By guest list"
					},
					"general": {
						"cards": {
							"consumptionTotal": "Total in consumption",
							"entranceTotal": "Total in input",
							"guests": "Guests",
							"promoters": "Promoters",
							"relationLists": "Lists",
							"total": "Grand total"
						},
						"columns": {
							"checkin": "Check in details",
							"consumption": "Consumption",
							"cpf": "CPF",
							"entrance": "Input type",
							"generalTotal": "Grand total",
							"guestName": "Name",
							"listName": "List",
							"promoter": "Promoter",
							"upgradeEntrance": "Entry upgrade",
							"phone": "Teléfono",
							"birthDate": "Fecha de nacimiento"
						},
						"title": "Overview"
					}
				},
				"templateTitle": "General Report",
				"title": "Reports"
			},
			"searchList": "search list",
			"sheet": {
				"columns": {
					"cpf": "CPF",
					"name": "Name",
					"phone": "Phone",
					"promoter": "Promoter"
				},
				"error": "Invalid worksheet",
				"example": "list (example)",
				"filename": "list_{{name}}",
				"title": "List: {{name}}"
			},
			"title": "Guest list",
			"utils": {
				"expires": "Expires",
				"expiresAt": "Expires in",
				"hasExpired": "Expired there",
				"insertLastName": "Insert a last name",
				"invalidName": "Invalid name"
			}
		},
		"placeTabs": {
			"bars": " Barras",
			"beer": " Cerveza de barril",
			"cmv": " Ing. del Menú",
			"combos": " Combinados",
			"gng": " Agarra y vete",
			"products": " Productos",
			"supplies": " Entradas",
			"config": "Configuraciones de menús"
		},
		"productMenu": {
			"all": "Todos los productos",
			"activedProducts": "Productos activos",
			"inactivedProducts": "Productos inactivos",
			"isDisabledMenu": "Los menús principales no pueden ser editados o eliminados",
			"defaultMenuName": "Menú Principal",
			"manageMenu": "Gestión de menús",
			"manageBars": "Bares",
			"tooltipActive": "Menú activo",
			"tooltipInactive": "Menú inactivo",
			"tooltipMenuType": "Menú del tipo",
			"info": {
				"product": "producto",
				"products": "productos"
			},
			"menuTooltipInactive": "Menú vinculado a este bar e inactivo",
			"manageProducts": "Gestión de productos",
			"newMenu": "Nuevo menú",
			"createNewMenu": "Crea, edita y gestiona menús con estado, activando o desactivando según la demanda.",
			"requiredField": "Campo Obligatorio",
			"menuName": "Nombre de menú duplicado",
			"duplicateMenu": "Duplicar Menú",
			"editMenu": "Editar Menú",
			"closeAction": "Cerrar",
			"addProducts": "Agregar Productos",
			"newMenuName": "Nombre del Menú",
			"duplicateMenuError": "Ya existe un menú de este tipo activo. Solo puede haber un menú activo por tipo.",
			"menus": "Menús",
			"status": "Estado",
			"type": "Tipo",
			"createFirstMenu": "Crea tu primer menú ahora",
			"createMenuInstructions": "Crea ahora tu primer menú y vincula productos y precios.",
			"createMenu": "Crear Menú",
			"duplicate": "Duplicar",
			"delete": "Eliminar",
			"edit": "Editar",
			"deleteMenu": "Eliminar Menú",
			"confirmDelete": "¿Deseas eliminar {{menuName}}? Se eliminarán todas las informaciones y esta acción no se puede deshacer.",
			"active": "Activo",
			"inactive": "Inactivo",
			"confirmDuplicateMenu": "¿Quieres duplicar el {{menuName}}? Toda la información de la réplica será idéntica a la original, pero no estará vinculada a ninguna área.",
			"menuType": {
				"normal": "Normal",
				"delivery": "Entrega a Domicilio",
				"dineIn": "Pedido en la mesa",
				"hawker": "Vendedor Ambulante",
				"grabAndGo": "Grab and Go",
				"onlineFicha": "Recibo en línea",
				"pickUp": "Recoger",
				"deliveryByMarketplace": "Entrega por el restaurante",
				"onlineTab": "Pedido en línea",
				"viewMenu": "Menú digital",
				"deliveryIntegrated": "Delivery Integrado"
			},
			"activateMenu": "Activar Menú",
			"deactivateMenu": "Desactivar Menú",
			"importProducts": "Desde la importación de productos",
			"importWithSheet": "Utilice una hoja de cálculo para importar automáticamente nuevos productos al nuevo menú",
			"linkExistingProducts": "Vincular productos existentes",
			"selectImportedProducts": "Seleccione productos ya importados para vincularlos al nuevo menú",
			"importCategoriesProducts": "Se importarán y crearán categorías y productos. En caso de que el producto ya exista, se duplicará en esta importación.",
			"emptyText": {
				"title": "No hay nada aquí todavía",
				"description": "Comienza vinculando categorías, luego agrega productos al menú."
			},
			"menuTypeLabel": "Tipo de Menú",
			"downloadSampleSheet": "Haga clic aquí para descargar la hoja de cálculo de ejemplo",
			"clickToAddSheet": "Haga clic para agregar hoja de cálculo",
			"importSheet": "Importar Hoja de Cálculo",
			"importProductsTitle": "Importar Productos",
			"emptyRowsWarning": "Su hoja de cálculo contiene filas vacías",
			"linkProductsToMenu": "Vincular productos al menú",
			"noProductFound": "No se encontraron productos",
			"typeToSearch": "Escribe para buscar",
			"enterNewMenuName": "Ingrese el nombre del nuevo menú",
			"selectMenuType": "Seleccione el tipo de menú",
			"addProductsCount": "Agregar {{products}} productos",
			"selectProductsToLink": "Seleccione los productos que desea vincular al nuevo menú",
			"loadingProducts": "Cargando productos",
			"fileLoadError": "No pudimos cargar su archivo. Por favor, confirme si el archivo se guardó correctamente e intente nuevamente",
			"loadingSheet": "Cargando hoja de cálculo",
			"invalidRowsError": "Filas inválidas, verifique las siguientes columnas: {{rows}}",
			"linkProductToMenu": "Vincular producto",
			"createProduct": "Crear Producto",
			"confirmRemoveProdutFromMenu": "¿Desea desvincular {{productName}} del menú? Si hay información de precio editada, la perderá. Si solo desea desactivar el producto del menú, puede hacer clic en el interruptor de estado en la tabla de productos del menú.",
			"removeProductFromMenu": "Desvincular producto del menú",
			"confirmRemoveProductFromMenuLabel": "Desvincular producto",
			"revertProductPriceTitle": "Deshacer cambio de precio",
			"confirmRevertProductPriceDescription": "Al confirmar esta acción, volverá al precio original del producto, descartando la alteración realizada previamente. El precio del producto se define en la sección 'Gestión de Producto'.",
			"editProductTitle": "Editar {{productName}}",
			"category": "Categoría",
			"price": "Precio",
			"saveChanges": "Guardar Cambios",
			"editMenuProduct": "Editar producto en el menú",
			"yes": "Sí",
			"no": "No",
			"positivePriceErrorMessage": "El precio debe ser un valor positivo",
			"viewProductPage": "Ver Página del Producto",
			"product": "Producto",
			"mountable": "Montable",
			"searchProduct": "Buscar Producto",
			"importWithSheetToMenu": "Utilice una hoja de cálculo para importar automáticamente nuevos productos para el menú",
			"createProductFromScratch": "Crear producto desde cero",
			"createNewProduct": "Cree un nuevo producto completando todos los datos necesarios",
			"selectProductsToLinkToMenu": "Seleccione los productos que desea vincular al menú",
			"addProductsToMenu": "Añadir productos al menú",
			"emptyMenu": "Menú vacío",
			"addProductsToStartUsingIt": "Añade productos para empezar a usarlo",
			"sku": "SKU",
			"nameMaxLength": "Límite de {{maxLength}} caracteres excedido",
			"menuCreated": "Menú creado con éxito",
			"menuUpdated": "Menú editado con éxito",
			"menuRemoved": "Menú eliminado con éxito",
			"menuDuplicated": "Menú duplicado",
			"menuStatusChanged": "Estado del menú cambiado",
			"menuProductPriceChanged": "El precio de {{productName}} ha sido cambiado con éxito en {{menuName}}.",
			"menuProductUpdated": "El producto {{productName}} ha sido actualizado con éxito en {{menuName}}.",
			"menuProductRemoved": "El producto {{productName}} ha sido eliminado con éxito de {{menuName}}.",
			"productsAmountAtMenu": "cant. de productos",
			"products": "producto(s)",
			"allCategories": "Todas las categorías",
			"filters": {
				"all": "Todos",
				"filterByName": "Filtrar por nombre",
				"filterByMenuType": "Filtrar por tipo de menú",
				"allMenuTypes": "Todos los tipos",
				"filterByLinkedBars": "Filtrar por bares vinculados",
				"activeFilters": "Filtros activos",
				"clearAll": "Limpiar todos los filtros",
				"noResults": "No se encontraron resultados con los filtros actuales",
				"clearFilters": "Limpiar filtros"
			},
			"createMenuModal": {
				"menuNameLabel": "Nombre del menú",
				"menuNamePlaceholder": "Nombre del menú",
				"title": "Crear Menú"
			},
			"editMenuModal": {
				"title": "Editar Menú"
			},
			"bars": "Bares",
			"dashboard": {
				"productCount": "Cantidad de productos",
				"categoryCount": "Categorías",
				"barCount": "Bares"
			},
			"linkProductsDrawer": {
				"newlySelected": "Seleccionado",
				"addAllProducts": "Agregar todos los productos",
				"linkProducts": "Vincular productos",
				"title": "Vincular productos al menú",
				"successMessage": "Producto(s) vinculado al menú con éxito",
				"typeToSearch": "Escribe para buscar",
				"noProductFound": "No se encontraron productos",
				"product": "Producto",
				"sku": "SKU",
				"closeAction": "Cerrar",
				"saveChanges": "Guardar Cambios",
				"selectProductsToLinkToMenu": "Seleccione los productos que desea vincular al menú",
				"searchProduct": "Buscar Producto"
			},
			"allowFichaExport": "Permitir la exportación de fichas."
		},
		"importXml": {
			"duplicatesCardInfo": {
				"dueDate": "Due date",
				"subtitle": "Duplicate",
				"title": "Duplicates",
				"value": "Value"
			},
			"invoicecCardInfo": {
				"CFOP": "CFOP",
				"CNPJAndCPF": "CNPJ/CPF",
				"accesskey": "Access key",
				"amount": "Amount",
				"billNumber": "Bill number",
				"issuer": "Issuer",
				"natureOfOperation": "Nature of operation",
				"noteData": "Note data",
				"noteSeries": "Note series",
				"title": "Invoice data"
			},
			"paymentCardInfo": {
				"cashPayment": "In cash",
				"installmentsPayment": "Installments",
				"payment": "Payment"
			},
			"productCard": {
				"code": "SKU:",
				"costPricePerUnit": "Precio por unidad",
				"costPricePerUnitTooltip": "Valor por unidad en el sistema Zig",
				"costTypeOptions": {
					"total": "en total",
					"unit": "por unidad",
					"milliliter": "por mililitro",
					"gram": "por gramo",
					"kilogram": "por kilogramo",
					"liter": "por litro"
				},
				"equivalentProduct": "Equivalent product",
				"equivalentUnit": "1 {{product}} equals",
				"infoProduct": "Skipped \"{{nameProduct}}\" product",
				"quantities": "Qty:",
				"restoreproduct": "Haga clic aquí para restaurar",
				"unit": "unidad:",
				"unitPrice": "Pagado por unidad:",
				"unitPriceTooltip": "Valor por unidad en factura",
				"chartAccount": "Plan de cuentas",
				"chartAccountPlaceholder": "Seleccione un plan de cuentas"
			},
			"stockItens": "Artículos en stock",
			"title": "importación XML"
		},
		"invoicesIva": {
			"columns": {
				"actions": {
					"cancel": {
						"okText": "Sí, cancelar factura",
						"title": "¿Estás seguro de que deseas cancelar la factura?"
					},
					"cancelUnnavailable": {
						"okText": "Ok",
						"title": "Las facturas emitidas hace más de 30 minutos no pueden cancelarse"
					},
					"image": "imagen",
					"pdf": "pdf",
					"title": "comportamiento",
					"json": "JSON",
					"cancelledJson": "JSON de cancelación",
					"xml": "XML",
					"cancelledXml": "XML de cancelación",
					"downloadXml": "Descargar XML",
					"downloadJson": "Descargar JSON"
				},
				"tooltips": {
					"nc": "Abono / Abono cancelado",
					"ft": "Factura / Facturas"
				},
				"eventDate": "Fecha del evento",
				"fiscalProfile": "Perfil fiscal",
				"isCanceled": "cancelado",
				"issuedAt": "emitido el",
				"transaction": "Transacción",
				"recharge": "Recarga",
				"errorMsg": "Error",
				"employee": "Empleado",
				"type": "Tipo",
				"mode": "Modo de emisión",
				"number": "Número de nota",
				"serie": "Serie de notas",
				"value": "Valor de la nota",
				"expirationDate": "Fecha de caducidad",
				"status": {
					"label": "Estado",
					"pending": "Pendiente de creación",
					"waiting": "Pendiente de emisión"
				}
			},
			"downloadXML": "Descargar XML",
			"descriptionForeign": "Este informe muestra las Facturas y Notas de Crédito emitidas, permitiendo filtrar por período, perfil fiscal, empleado, tipo de factura (Factura y Nota de Crédito) y tipo de ítem (Recarga o Producto).",
			"descriptionForeignMEX": "Este informe muestra todas las Notas pendientes, lo que significa 1) aquellas que han llegado al sistema pero no han sido emitidas por algún motivo y 2) aquellas para las cuales se ha creado una orden de autofacturación y están esperando que el cliente las emita. Permite ver el mensaje de error asociado con cada Nota pendiente.",
			"downloadJSON": "Descargar JSON",
			"missing": {
				"columns": {
					"actions": "comportamiento",
					"date": "fecha",
					"number": "número",
					"employee": "Empleado",
					"serie": "serie"
				},
				"download": "Descargar XML",
				"fiscalProfile": "Perfil fiscal",
				"descriptionForeign": "Este informe muestra todas las Notas pendientes, es decir, aquellas que han llegado al sistema pero no han sido emitidas por algún motivo. Permite visualizar el mensaje de error asociado con cada Nota Pendiente.",
				"fiscalProfileLabel": "Filtrer par profil fiscal",
				"employeeLabel": "Filtrer par employé",
				"itemTypeLabel": "Filtrar tipo de artículo",
				"recharges": "Recargas",
				"products": "Productos",
				"invoiceTypeLabel": "Filtrer par type de document",
				"documentId": "Identificador",
				"pendingAutoissuanceOrders": "Total bruto pendiente",
				"zigSystemEmployee": "ZIG (système)",
				"creditInvoiceLabel": "Notes de crédit",
				"invoiceLabel": "Factures",
				"period": "Período",
				"selectFiscalProfile": "Seleccione un perfil fiscal",
				"title": "Notas faltantes",
				"titleForeign": "Notas pendientes"
			},
			"modelLabel": {
				"ivaVendus": "IVA - Vendus",
				"ivaFactura": "IVA - Factura",
				"nfce": "NFC-e",
				"nfse": "NFS-e",
				"nfsen": "NFS-e Nacional",
				"sat": "SAT"
			},
			"period": "Período",
			"sheet": {
				"columns": {
					"eventDate": "Fecha del evento",
					"fiscalProfile": "Perfil fiscal",
					"imgUrl": "Imagen URL",
					"isCanceled": "Cancelado",
					"issuedAt": "emitido el",
					"transaction": "Transacción",
					"transactionDate": "Fecha de transacción",
					"employee": "Empleado",
					"mode": "Modo de emisión",
					"number": "c",
					"pdfUrl": "URL del PDF",
					"serie": "serie de notas",
					"value": "Valor de la nota",
					"xml": "XML",
					"json": "JSON"
				},
				"filename": "facturas",
				"title": "facturas"
			},
			"title": "Facturas",
			"downloadBackupModal": {
				"title": "Descargar archivos XML",
				"placeholder": "Seleccionar",
				"error": "Error: {{error}}",
				"empty": "No hay copias de seguridad disponibles",
				"content": "Para descargar esta cantidad de archivos, es necesario descargar el mes completo.",
				"selectMonth": "Seleccione a continuación el mes de referencia para la descarga."
			},
			"filters": {
				"zigSystemEmployee": "ZIG (sistema)",
				"fiscalProfileLabel": "Filtrar por perfil fiscal",
				"employeeLabel": "Filtrar por empleado",
				"invoiceItemType": "Filtrar por tipo de ítem",
				"invoiceItemTypeProduct": "Productos",
				"invoiceItemTypeRecharge": "Recargas",
				"invoiceType": "Filtrar por tipo de factura",
				"invoiceTypeAll": "Todas las facturas",
				"invoiceTypeWithCreditInvoice": "Facturas con abono",
				"invoiceTypeWithoutCreditInvoice": "Facturas sin abono en cuenta"
			}
		},
		"invoicesNational": {
			"title": "Facturas",
			"description": "Descargar facturas individuales o grupales emitidas en el periodo seleccionado.",
			"acitons": {
				"exportToExcel": "Exportar a Excel",
				"downloadXml": "Descargar XML"
			},
			"filters": {
				"fiscalProfileLabel": "Perfil fiscal",
				"invoiceNumberLabel": "Número de factura",
				"invoiceNumberPlaceholder": "Buscar por número de factura",
				"rangePickerLabel": "Período de emisión"
			},
			"table": {
				"issuedAt": "Emitido en",
				"mode": "Modo de emisión",
				"createdBy": "Empleado",
				"fiscalProfile": "Perfil fiscal",
				"eventDate": "Fecha del evento",
				"isCanceled": "Cancelado",
				"serie": "Serie de notas",
				"num": "Número de nota",
				"value": "Valor de la nota",
				"actions": "Acciones",
				"downloadInvoice": {
					"download": "Descargar",
					"pdf": "PDF",
					"image": "Imagen",
					"xml": "XML",
					"cancelXml": "Cancelar XML"
				},
				"cancelInvoice": {
					"yesCancel": "Sí, cancelar factura",
					"confirm": "ok",
					"areYouSure": "¿Está seguro de que desea cancelar la factura?",
					"cancel": "Cancelar"
				},
				"paginationTotal": " de {{total}}"
			}
		},
		"invoicesBackups": {
			"title": "Copias de seguridad",
			"description": "Archivos de facturas emitidas por mes.",
			"filters": {
				"fiscalProfile": {
					"label": "Perfil fiscal",
					"placeholder": "Buscar por perfil fiscal"
				}
			},
			"table": {
				"fiscalProfile": "Perfil fiscal",
				"month": "Mes",
				"files": "Archivos",
				"downloadDanfes": "Descargar DANFEs",
				"downloadXmls": "Descargar XML",
				"unavaliable": "no disponible"
			}
		},
		"kardex": {
			"at": "hasta",
			"destiny": "destino",
			"download": "Descargar hoja de trabajo",
			"seeProduct": "Ver producto",
			"applyFilters": "Aplicar filtros",
			"emptyState": {
				"title": "Seleccione acciones para comenzar",
				"description": "Seleccione el stock, producto y período para ver el Archivo Kardex del producto"
			},
			"header": {
				"count": "cantidad",
				"date": "Fecha",
				"obs": "Observación",
				"employeeName": "Empleado",
				"ending": "Saldo final",
				"initial": "Saldo inicial",
				"noValue": "Valor no informado",
				"note": "nota",
				"type": "Transacción",
				"unitCostValue": "Costo unitario",
				"selectStock": "Seleccione el stock",
				"selectProduct": "Seleccione el producto",
				"applyFilters": "Aplicar filtros",
				"description": "La forma kardex es una representación del stock y movimientos de un artículo. Es similar a la pantalla de movimientos, mostrando el histórico de entradas y salidas, la cantidad movida, el saldo y valores de cada movimiento."
			},
			"label": "Existencias",
			"nameNotFound": "Nombre no encontrado",
			"origin": "Origen",
			"period": "Período",
			"product": "Producto",
			"storage": "Existencias",
			"title": "Tarjeta Kárdex",
			"dateFilterBy": {
				"label": "Filtrar datos por",
				"options": {
					"events": "Eventos entre intervalo",
					"interval": "Todo entre intervalo"
				}
			},
			"transferTypeTranslate": {
				"cardExchange": "cambio por tarjeta",
				"input": "Aporte",
				"inventory": "Inventario",
				"invoice": "Entrada de factura",
				"lost": "Pérdida",
				"manual": "Ajuste manual",
				"productionIn": "Entrada de producción",
				"productionLost": "Pérdida de producción",
				"productionOut": "Producción de",
				"refund": "Pérdida por contracargo",
				"sell": "Vender",
				"transferIn": "Transferencia (entrada)",
				"transferOut": "Transferencia (salida)"
			}
		},
		"settings": {
			"title": "Editar configuraciones",
			"error": "Sin permiso para editar local",
			"alterImage": "Imagen cambiada exitosamente",
			"attention": "¡Atención!",
			"url": "nombredelproducto",
			"daysAndWorkingPeriod": "Días y horario de funcionamiento",
			"address": {
				"postalCode": "Código Postal",
				"state": "Estado",
				"city": "Ciudad",
				"neighborhood": "Barrio",
				"address": "Dirección",
				"number": "Número",
				"complement": "Complemento"
			},
			"workingPeriod": {
				"deletedPeriod": "Período eliminado.",
				"addDaysAndTime": "Agregar días y horarios",
				"addOpeningHours": "Agregar horario de funcionamiento",
				"daysOfTheWeek": "Días de la semana",
				"start": "Início",
				"end": "Fin"
			},
			"defaultDateFilter": "Filtro de fecha predeterminado",
			"menu": {
				"title": "Otras opciones de configuración",
				"general": {
					"title": "Generales",
					"subtitle": "Informar límites, correos electrónicos y otros"
				},
				"record": {
					"title": "Configuración de Fichas",
					"subtitle": "Configure el modo ficha"
				},
				"couvert": {
					"title": "Couvert",
					"subtitle": "Establecer el valor del couvert"
				},
				"features": {
					"title": "Funcionalidades",
					"subtitle": "Active las funcionalidades deseadas"
				},
				"pdv": {
					"title": "PDV",
					"subtitle": "Configure el punto de venta"
				},
				"vendor": {
					"title": "Proveedor",
					"subtitle": "Configure información general"
				},
				"totem": {
					"title": "Tótem",
					"subtitle": "Personalizar un tótem"
				},
				"refundReason": {
					"title": "Razones para reembolso/cancelación",
					"subtitle": "Configure el motivos para punto de venta"
				},
				"fiscalPrinter": {
					"title": "Impresoras fiscales",
					"subtitle": "Configura las impresoras fiscales"
				}
			},
			"warningDialog": "Está habilitando pagos postpagados en '{{name}}'. ¿Está seguro de esto? Para confirmar la modificación, por favor escriba '{{text}}'",
			"data": {
				"label": "Datos",
				"name": "Nombre",
				"selectProduct": "Seleccione un producto para habilitar el depósito de garantía automático",
				"noneProduct": "Ningún producto",
				"peopleCapacity": "Capacidad",
				"slug": "Slug",
				"peopleCapacityTooltip": "Cantidad de personas que el local puede albergar."
			},
			"passTemplate": "ID del modelo de pase",
			"limits": {
				"label": "Límites y servicios",
				"postPaidLimit": "Límite de postpago",
				"serviceTax": "Tasa de servicio",
				"rechargeNotIntegratedLimit": "Límite de recarga no integrada",
				"nonIntegratedPaymentLimit": "Límite de pago no integrado por dispositivo y evento",
				"enableBuiltInLimit": "Activar límite de recarga no integrada",
				"enableNonIntegratedPaymentLimit": "Activar límite de pago no integrado por dispositivo y evento",
				"nonIntegratedPaymentLimitTooltip": "Este límite se refiere al valor máximo de pagos no integrados que un dispositivo puede recibir durante el evento. Este parámetro es la suma del total de Recargas y Ventas Sin Tarjeta hechas con pagos no integrados.",
				"nonIntegratedRechargeLimitTooltip": "Este límite se refiere al valor máximo que un empleado puede realizar en una recarga no integrada."
			},
			"settings": {
				"label": "Configuraciones",
				"myActionsPassword": {
					"label": "Contraseña de ¨Mis acciones¨",
					"placeholder": "Ingrese una contraseña numérica o la contraseña predeterminada será 9090"
				},
				"sellVisualizationFormat": {
					"label": "Formato de visualización de productos en la venta",
					"grid": "Cuadrícula",
					"list": "Lista"
				},
				"kdsServer": {
					"label": "IP del servidor KDS",
					"placeholder": "Escriba la IP"
				}
			},
			"everest": {
				"label": "Everest",
				"user": "Usuario",
				"password": "Contraseña",
				"cnpj": "CNPJ",
				"host": "Host"
			},
			"placeFeatures": "Funcionalidades",
			"email": "Correos electrónicos para recibir el cierre de los eventos",
			"emailError": "Correo electrónico inválido",
			"consumption": {
				"label": "Configuración fiscal de consumición mínima",
				"fiscalProfile": "Perfil fiscal",
				"fiscalGroup": "Grupo fiscal",
				"ncm": "NCM"
			},
			"alert": "Se han realizado modificaciones, guarde para mantenerlas",
			"save": "Guardar",
			"saveSettings": "Guardar configuraciones",
			"image": "Foto",
			"ficha": {
				"label": "Ficha",
				"text": "Título de la Ficha",
				"placeholderText": "Ingrese el título de la ficha",
				"logo": "Imagen en la ficha",
				"upload": "Adjuntar imagen",
				"formatError": "Formato no soportado",
				"imageFormatMessage": "Es necesario que la imagen sea un PNG o SVG.",
				"recommendationMessage": "Recomendamos que la imagen asignada sea el <strong>logo</strong> de la empresa en <strong>color negro</strong>, ya que no es posible realizar la impresión de otro color.",
				"dragOrSelectMessage": "Arrastre la imagen desde el ordenador o seleccione a partir de 'Adjuntar imagen'.",
				"logoFormatMessage": "Es necesario que el <strong>fondo de la imagen/logo esté en blanco</strong>, para que quede transparente en la impresión.",
				"dimensionsMessage": "Las dimensiones sugeridas para una buena resolución son de <strong>472x472</strong> px.",
				"size": {
					"Small": "P - Pequeño",
					"Medium": "M - Medio",
					"Large": "G - Grande",
					"NoImage": "Sin imagen",
					"NoQRCode": "Sin código QR",
					"recommend": "recomendado"
				},
				"fontSize": "Tamaño de fuente",
				"imageSize": "Imagen",
				"qrCodeSize": "Tamaño del código QR"
			},
			"devices": {
				"label": "PDVs del lugar ({{counter}})",
				"placeholder": "Añadir un PDV a este lugar",
				"requestDevices": "Solicitar dispositivos"
			},
			"errors": {
				"invalidName": "Introduzca un nombre válido",
				"invalidTip": "Introduzca un valor de hasta el 25%",
				"postPaidLimit": "Introduzca un valor válido",
				"rechargeNotIntegratedLimit": "Valor mínimo de",
				"hasConsumptionObligation": "Campo obligatorio para la configuración de obligación de consumo",
				"minNonIntegratedPaymentLimit": "Valor mínimo de {{value}}",
				"tipOptionsValuesRequired": "Los valores de las propinas son necesarios",
				"tipOptionLowerValue": "El \"Valor menor\" debe ser menor que los valores medio y mayor",
				"tipOptionHigherValue": "El \"Valor mayor\" debe ser mayor que el valor medio"
			},
			"fiscalPrinter": {
				"title": "Impresoras fiscales",
				"name": "Nombre",
				"type": "Tipo",
				"ip": "IP",
				"actions": "Acciones",
				"deletedSuccessfully": "Impresora eliminada con éxito",
				"addedSuccessfully": "Impresora añadida con éxito"
			},
			"totem": {
				"logoSelectDescription": "<strong>Seleccione el logo que mejor se aplique en su imagen</strong> (ignore el color de fondo)",
				"addLogo": "Añadir",
				"important": "Importante",
				"instructions": "Recomendaciones",
				"image": "La imagen debe tener las dimensiones de <strong>1080 x 1920</strong> px de altura",
				"logo": "El logo de <strong>Zig</strong> aparecerá sobre la imagen asignada, centrado en la parte superior.",
				"recomendations": "Se recomienda insertar el mensaje <strong>'toque para iniciar'</strong> para orientar al usuario",
				"defaultMessage": "Si no añade una imagen de inicio, la pantalla estándar de Zig será su pantalla de inicio (ver la primera imagen en <strong>'Colores'</strong>).",
				"totemImgLabel": "Imagen de inicio (opcional)",
				"totenCustomizationLabel": "Personalización Tótem Ficha",
				"removeTotemImage": {
					"title": "¿Desea eliminar la pantalla de inicio?",
					"content": "Al eliminar, la pantalla de inicio volverá a ser la pantalla estándar de Zig.",
					"confirmBtn": "Sí, quiero eliminar",
					"cancelBtn": "No"
				},
				"saveMessage": "Guardar personalización"
			},
			"refundReason": {
				"addReason": "Crear nuevo motivos",
				"cancel": "Cancelación",
				"modalDelete": {
					"confirmation": "¿Desea eliminar el motivos de la lista de motivos de reembolso y cancelación?",
					"description": "Al eliminar el motivo, ya no aparecerá, pero permanecerá en informes antiguos.",
					"title": "Eliminar motivo"
				},
				"modalForm": {
					"addReason": "Crear Motivo",
					"allowOpenText": "Habilitar justificación",
					"creatingReason": "Creando un motivo",
					"editReason": "Guardar cambios",
					"editingReason": "Editando un motivo",
					"reason": "Nombre de motivo",
					"reasonPlaceholder": "Ingrese el nombre para motivo de reembolso y/o cancelación"
				},
				"reason": "Nombre de motivo",
				"removeReason": "Editar motivo",
				"refund": "Reembolso",
				"table": {
					"editReason": "Editar motivo",
					"observation": "Observación",
					"reason": "Nombre de motivo",
					"removeReason": "Eliminar motivo",
					"status": "Estado",
					"type": "Tipo"
				},
				"title": "Motivos de reembolso y cancelación"
			},
			"tip": {
				"taxType": "Tipo de tasa",
				"tip": "Propina",
				"tipSuggestions": "Sugerencias de propina",
				"serviceTax": "Tasa de servicio",
				"none": "Sin tasa",
				"lowerValue": "Valor menor",
				"medValue": "Valor medio",
				"higherValue": "Valor mayor",
				"tooltip": "Las sugerencias de propina facilitan el pago de la cuenta, ofreciendo tres opciones de porcentajes (Menor, Media y Mayor) basadas en el valor total de la cuenta, por ejemplo: 5%, 10% y 15% limitado al 25%"
			},
			"vendor": {
				"definitions": "Definiciones",
				"serviceFee": "Tasa de servicio",
				"serviceTransfer": "Transferencia de servicio",
				"serviceFeeVendor": "Proveedor de la tasa de servicio",
				"serviceFeeVendorRequired": "Seleccione el proveedor de la tasa de servicio",
				"serviceFeeVendorPlaceholder": "Seleccione el proveedor que recibirá la transferencia",
				"paymentMethodSuccess": "¡Los métodos de pago del Vendor se actualizaron con éxito!",
				"serviceTransferSuccess": "¡Proveedor de la tasa de servicio actualizado con éxito!",
				"saveMethods": "Guardar retenciones",
				"resetChanges": "Restaurar valores iniciales",
				"vendor": "Proveedor",
				"selectVendor": "Seleccione un proveedor",
				"paymentMethods": "Retención de todos los montos negociados en el lugar",
				"tooltip": "Si se selecciona un proveedor, el monto total de la transacción utilizando el método de pago elegido se retendrá en el estado de cuenta de ese proveedor.",
				"paymentMethod": "Método de pago",
				"paymentMethodOptions": {
					"credit": "Crédito no integrado",
					"debit": "Débito no integrado",
					"cash": "Efectivo",
					"voucher": "Voucher"
				},
				"reprocessButton": "Reprocesar proveedores",
				"confirmReprocess": "Confirmar reprocesamiento",
				"reprocessLabel": "Evento",
				"reprocessPlaceholder": "Ingrese el ID del evento",
				"reprocessEmptySelect": "Selecione pelo menos um evento para reprocessar",
				"reprocessSuccess": "Proveedores reprocesados exitosamente",
				"reprocessError": "ID de evento inválido"
			}
		},
		"transactionsReport": {
			"title": "Lista de transacciones",
			"descriptionPlace": "Lista de todas las transacciones del período",
			"descriptionEvent": "Lista de todas las transacciones de evento",
			"filter": {
				"title": "Filtro",
				"emptyFilter": "Haga clic para filtrar",
				"modal": {
					"inputPlaceholder": "Escriba aquí",
					"selectPlaceholder": "Seleccione aquí",
					"descriptionEnd": "para filtrar transacciones"
				},
				"modalOptions": {
					"terminal": {
						"label": "Terminal",
						"title": "Número de terminal",
						"description": "Ingrese el número de terminal"
					},
					"clientDocument": {
						"label": "Documento del cliente",
						"title": "CPF o número de documento",
						"description": "Ingrese el CPF o número de documento del cliente"
					},
					"employee": {
						"label": "Empleado",
						"title": "Nombre del empleado",
						"description": "Ingrese el nombre del empleado"
					},
					"zigCode": {
						"label": "Zig Code",
						"description": "Ingrese el número de Zig Code"
					},
					"paymentMethod": {
						"label": "Método de pago",
						"description": "Seleccione un método de pago"
					},
					"transactionType": {
						"label": "Tipo de transacción",
						"description": "Seleccione un tipo de transacción"
					},
					"bar": {
						"label": "Filtrar por barra",
						"title": "Barra",
						"description": "Seleccione una barra"
					}
				}
			},
			"print": "Imprimir informe",
			"table": {
				"id": "ID",
				"date": "Fecha",
				"syncDate": "Sincronizar fecha",
				"type": "Tipo",
				"employee": "Empleado",
				"terminal": "Terminal",
				"deviceId": "ID del dispositivo",
				"zigCode": "Zig Code",
				"bar": "Barra",
				"client": "Cliente",
				"product": "Producto",
				"quantity": "Cantidad",
				"source": "Fuente",
				"paymentMethod": "Método de pago",
				"status": "Estado",
				"document": "Documento",
				"acquirer": "Adquirente",
				"acquirerTransactionId": "Adquiriendo ID de transacción",
				"cardBrand": "Bandera de tarjeta",
				"nsu": "NSU",
				"nsuHost": "NSU Host",
				"authorizationCode": "Código de autorización",
				"bin": "Bin",
				"service": "Servicio",
				"value": "Valor",
				"hawkerDocument": "Documento ambulante",
				"hawkerName": "Nombre ambulante"
			},
			"transactionTypes": {
				"recharge": "Recarga",
				"transaction": "Transacción",
				"ficha": "Ficha",
				"canceled": "Cancelada",
				"refund": "Reembolso",
				"digitalCashless": "Cashless digital"
			},
			"maxSearchPeriod": "El período máximo de búsqueda es de 31 días",
			"exportExcel": {
				"success": "Email con exportación enviada exitosamente.",
				"title": "Informe de exportación",
				"label": "Por favor ingrese su correo electrónico para enviar la hoja de cálculo",
				"error": "Ingrese un correo electrónico válido",
				"placeholder": "Ingrese su correo electrónico"
			}
		},
		"multivendor": {
			"debtorsReport": {
				"filters": {
					"vendor": "Proveedor",
					"period": "Período"
				},
				"table": {
					"title": "Informe de Cuentas Pendientes",
					"filename": "informe_de_cuentas_pendientes__{{vendor}}__{{date}}",
					"totalizer": {
						"totalOpen": "Total Pendiente",
						"paidAfterEvent": "Pagado Después del Evento",
						"clients": "Clientes",
						"stillOpen": "Aún Pendiente"
					},
					"columns": {
						"actions": "Comportamiento",
						"cpf": "DNI",
						"emptyText": "no hay información para mostrar.",
						"name": "Nombre",
						"phone": "Phone",
						"promoter": "Promotor"
					},
					"couvert": "descuento cubierto",
					"description": {
						"empty": "Sin descripción añadida",
						"label": "Descripción"
					},
					"download": "Descargar lista",
					"edit": "Editar informacion",
					"editGuest": "Editar invitado",
					"editInfos": "Editar información de la lista",
					"editModal": {
						"color": "Asignar un color",
						"couvert": "descuento cubierto",
						"description": {
							"label": "Descripción",
							"limit": "Quedan {{limit}} caracteres",
							"placeholder": "Añade una nota a tu lista si quieres"
						},
						"entrance": {
							"label": "Entrada asociada entry",
							"placeholder": ""
						},
						"errors": {
							"description": "xc",
							"emptyName": "Introduce el nombre de la lista.",
							"expires": "Fecha y hora de caducidad",
							"length": "Fecha y hora de caducidad"
						},
						"expiresAt": "Caducidad de la lista",
						"name": {
							"label": "lista de nombres",
							"placeholder": "Especifique su lista para que se identifique rápidamente (nombre de la lista - evento - fecha - ubicación)"
						},
						"new": "Lista nueva",
						"save": "Guardar editar",
						"title": "Editar lista"
					},
					"emptyList": {
						"defaultMessage": "Parece que no has registrado ningún invitado",
						"importList": "Importar lista",
						"text": "La lista de invitados aparecerá aquí cuando hayas registrado invitados.."
					},
					"entrances": {
						"empty": "Sin entrada asociada",
						"error": "No hay ninguna entrada asociada a esta lista",
						"label": "Entrada asociada"
					},
					"expires": "vencimiento",
					"goBack": "volver a las listas",
					"guest": "Invitados",
					"guests": "Invitados",
					"import": "Importar hoja de cálculo",
					"print": " Imprimir",
					"search": "Buscar invitado o promoverr"
				},
				"list": {
					"delete": {
						"list": "eliminar lista",
						"lists": "Eliminar listas",
						"permanentlyList": "Eliminar lista de forma permanente",
						"permanentlyLists": "Eliminar listas de forma permanente",
						"selectedList": "La lista seleccionada se eliminará definitivamente y su información (huéspedes, check-in, ticket promedio, entrada, consumo, promotores) se eliminará de los informes. Esta acción no se puede deshacer. ¿Quieres continuar de todos modos?",
						"selectedLists": "Las listas seleccionadas se eliminarán definitivamente y su información (huéspedes, check-in, ticket promedio, entrada, consumo, promotores) se eliminará de los informes. Esta acción no se puede deshacer. ¿Quieres continuar de todos modos?"
					},
					"goBack": "Volver a Listas",
					"import": {
						"description": "Para importar una lista de invitados, simplemente cargue una hoja de cálculo",
						"label": "Importar hoja de invitados"
					},
					"print": {
						"date": "Fecha de Emisión",
						"description": "Descripción",
						"discount": "Tipo de descuento",
						"entrance": "Entrada asociada",
						"expiresAt": "Expira en",
						"noEntrance": "Ninguna entrada asociada con esta lista."
					},
					"sheet": {
						"error": "Hoja de cálculo no válida, descárguela de nuevo y realice los cambios necesarios. En caso de líneas vacías en rojo, elimínelas y vuelva a intentarlo.",
						"title": "Lista de invitados"
					},
					"success": "Hoja de trabajo importada con éxito",
					"warning": "Antes de importar la hoja de cálculo, asegúrese de eliminar todas las líneas en blanco"
				},
				"list_one": "Lista",
				"list_other": "Liza",
				"menuDrop": {
					"delete": "Borrar",
					"disable": "Deshabilitar lista",
					"download": "Descargar",
					"edit": "Editar",
					"enable": "Habilitar lista",
					"print": "Imprimir"
				},
				"newList": {
					"create": "Crear lista",
					"downloadList": "Descargar lista",
					"forms": {
						"firstStep": {
							"colorSelect": "Asignar un color",
							"couvertPercentage": "Descuento en el cargo de entrada",
							"description": {
								"error": "La descripción de la lista debe tener menos de 280 caracteres",
								"label": "Descripción",
								"leftCharacters": "Quedan {{count}} caracteres",
								"placeholder": "Agrega una nota a tu lista si quieres"
							},
							"canBeInvitedByLink": {
								"label": "Compartir lista a través de un link",
								"error": "Para que una lista se pueda compartir, se requiere un límite de invitados"
							},
							"isDocumentRequired": {
								"label": "CPF obligatorio"
							},
							"hasAutomaticEntranceCharge": {
								"label": "Cargar entrada automáticamente"
							},
							"entranceIds": {
								"label": "Entrada asociada",
								"placeholder": "Seleccione el tipo de entrada asociado"
							},
							"expiresAtDate": {
								"at": "at",
								"error": "Fecha y hora de caducidad",
								"label": "Caducidad de la lista"
							},
							"addGuestTimeLimit": "Plazo límite para agregar invitados",
							"name": {
								"errorLength": "El nombre de la lista debe tener menos de 100 caracteres",
								"errorName": "Introduce el nombre de la lista.",
								"label": "Lista de nombres",
								"placeholder": "Ingrese el nombre de su lista aquí"
							},
							"guestsLimitByPromoter": {
								"label": "Límite de invitados por promotor",
								"placeholder": "Ingrese el número límite"
							},
							"guestsLimit": {
								"label": "Límite de invitados",
								"placeholder": "Ingrese el número límite"
							},
							"title": "Lista nueva"
						},
						"lastStep": {
							"cardTitle": "Descargar/imprimir",
							"title": "Lista creada con éxito"
						},
						"secondStep": {
							"addNewClient": "Agregar invitado",
							"cpf": {
								"duplicate": "CPF duplicado",
								"error": "CPF no válido ",
								"label": "CPF"
							},
							"label": "Puedes agregar invitados manualmente o importar una hoja de cálculo. Si lo deseas, puedes continuar y agregar o importar invitados en otro momento",
							"name": {
								"error": "Nombre inválido",
								"label": "Nombre y apellido",
								"placeholder": "Ingrese el nombre del invitado"
							},
							"phone": "Teléfono",
							"promoter": {
								"label": "nombre del promotor",
								"placeholder": "Nombre del responsable de la lista"
							},
							"successImport": "Hoja de cálculo importada con éxito",
							"title": "Cliente {{cuenta}}"
						}
					},
					"goBackToLists": "Volver a las listas",
					"print": "Imprimir",
					"list": "Lista",
					"steps": {
						"first": {
							"description": "¿Qué lista es esta?",
							"title": "Datos de la lista"
						},
						"last": {
							"description": "Descargar e imprimir",
							"title": "Lista lista"
						},
						"second": {
							"description": "¿Quiénes son sus clientes?",
							"title": "Clientes"
						}
					},
					"title": "Nueva lista de invitados",
					"view": "Ver lista creada"
				},
				"promoter": {
					"title": "Promotores"
				},
				"report": {
					"empty": {
						"filters": {
							"subtitle": "Seleccione otra opción y vuelva a intentarlo",
							"title": "No se encontraron resultados para esta selección."
						},
						"noneList": {
							"subtitle": "Los informes aparecerán aquí cuando tenga una lista registrada",
							"title": "Parece que aún no has creado una lista."
						},
						"search": "No encontramos resultados para su búsqueda."
					},
					"file": {
						"checkinDetails": "Detalles de facturación",
						"consumptionTotal": "Total en consumo",
						"document": "CPF",
						"entranceTotal": "Total en consumo",
						"entranceType": "Tipo de entrada",
						"filename": "informe de lista de invitados",
						"listName": "Lista de nombres",
						"name": "Nombre",
						"numberOfActiveGuests": "Check-in performed",
						"numberOfGuests": "Total guest",
						"promoter": "Promoter",
						"titleByGuestList": "Report by guest list",
						"titleGeneral": "General report",
						"total": "Total General",
						"upgrade": "Entrance upgrade",
						"phone": "Teléfono",
						"birthDate": "Fecha de nacimiento"
					},
					"filters": {
						"period": "Period",
						"promoter": {
							"placeholder": "Add filter by promoters",
							"title": "Filter by promoter"
						},
						"relation": {
							"placeholder": "Add filters by list",
							"title": "Filter by guest list"
						}
					},
					"search": "Search",
					"tabs": {
						"byList": {
							"columns": {
								"consumptionTotal": "Total in consumption",
								"entranceTotal": "Total in input",
								"guests": "Guests",
								"promoters": "Promoters",
								"relationLists": "Lists",
								"total": "Grand total"
							},
							"title": "By guest list"
						},
						"general": {
							"cards": {
								"consumptionTotal": "Total in consumption",
								"entranceTotal": "Total in input",
								"guests": "Guests",
								"promoters": "Promoters",
								"relationLists": "Lists",
								"total": "Grand total"
							},
							"columns": {
								"checkin": "Check in details",
								"consumption": "Consumption",
								"cpf": "CPF",
								"entrance": "Input type",
								"generalTotal": "Grand total",
								"guestName": "Name",
								"listName": "List",
								"promoter": "Promoter",
								"upgradeEntrance": "Entry upgrade",
								"phone": "Teléfono",
								"birthDate": "Fecha de nacimiento"
							},
							"title": "Overview"
						}
					},
					"templateTitle": "General Report",
					"title": "Reports"
				},
				"searchList": "search list",
				"sheet": {
					"columns": {
						"cpf": "CPF",
						"name": "Name",
						"phone": "Phone",
						"promoter": "Promoter"
					},
					"error": "Invalid worksheet",
					"example": "list (example)",
					"filename": "list_{{name}}",
					"title": "List: {{name}}"
				},
				"utils": {
					"expires": "Expires",
					"expiresAt": "Expires in",
					"hasExpired": "Expired there",
					"insertLastName": "Insert a last name",
					"invalidName": "Invalid name"
				}
			},
			"importXml": {
				"duplicatesCardInfo": {
					"dueDate": "Due date",
					"subtitle": "Duplicate",
					"title": "Duplicates",
					"value": "Value"
				},
				"invoicecCardInfo": {
					"CFOP": "CFOP",
					"CNPJAndCPF": "CNPJ/CPF",
					"accesskey": "Access key",
					"amount": "Amount",
					"billNumber": "Bill number",
					"issuer": "Issuer",
					"natureOfOperation": "Nature of operation",
					"noteData": "Note data",
					"noteSeries": "Note series",
					"title": "Invoice data"
				},
				"paymentCardInfo": {
					"cashPayment": "In cash",
					"installmentsPayment": "Installments",
					"payment": "Payment"
				},
				"productCard": {
					"code": "SKU:",
					"costPricePerUnit": "Cost price per unit",
					"equivalentProduct": "Equivalent product",
					"equivalentUnit": "1 {{product}} equals",
					"infoProduct": "Skipped \"{{nameProduct}}\" product",
					"quantities": "Qty:",
					"restoreproduct": "Haga clic aquí para restaurar",
					"unit": "unidad:",
					"unitPrice": "Precio por unidad:"
				},
				"stockItens": "Artículos en stock",
				"title": "importación XML"
			},
			"invoices": {
				"columns": {
					"actions": {
						"cancel": {
							"okText": "Sí, cancelar factura",
							"title": "¿Estás seguro de que deseas cancelar la factura?"
						},
						"image": "imagen",
						"pdf": "pdf",
						"title": "comportamiento",
						"xml": "XML"
					},
					"eventDate": "Fecha del evento",
					"fiscalProfile": "Perfil fiscal",
					"isCanceled": "cancelado",
					"issuedAt": "emitido el",
					"mode": "Modo de emisión",
					"number": "Número de nota",
					"serie": "Serie de notas",
					"value": "Valor de la nota"
				},
				"download": "Descargar XML",
				"missing": {
					"columns": {
						"actions": "comportamiento",
						"date": "fecha",
						"number": "número",
						"serie": "serie"
					},
					"download": "Descargar XML",
					"fiscalProfile": "Perfil fiscal",
					"period": "período",
					"selectFiscalProfile": "Seleccione un perfil fiscal",
					"title": "Notas faltantes"
				},
				"modelLabel": {
					"ivaVendus": "IVA - Vendus",
					"ivaFactura": "IVA - Factura",
					"nfce": "NFC-e",
					"nfse": "NFS-e",
					"nfsen": "NFS-e Nacional",
					"sat": "SAT"
				},
				"period": "período",
				"sheet": {
					"columns": {
						"eventDate": "Fecha del evento",
						"fiscalProfile": "Perfil fiscal",
						"imgUrl": "Imagen URL",
						"isCanceled": "Cancelado",
						"issuedAt": "emitido el",
						"mode": "Modo de emisión",
						"number": "c",
						"pdfUrl": "URL del PDF",
						"serie": "serie de notas",
						"value": "Valor de la nota",
						"xml": "XML"
					},
					"filename": "facturas",
					"title": "facturas"
				},
				"title": "facturas"
			},
			"kardex": {
				"at": "hasta",
				"destiny": "destino",
				"download": "Descargar hoja de trabajo",
				"header": {
					"count": "cantidad",
					"date": "Fecha",
					"employeeName": "Empleado",
					"ending": "Saldo final",
					"initial": "Saldo inicial",
					"noValue": "Valor no informado",
					"note": "nota",
					"type": "Transacción",
					"unitCostValue": "costo unitario."
				},
				"label": "Existencias",
				"nameNotFound": "Nombre no encontrado",
				"origin": "Origen",
				"period": "Período",
				"product": "Producto",
				"storage": "Existencias",
				"title": "Tarjeta Kárdex",
				"dateFilterBy": {
					"label": "Filtrar datos por",
					"options": {
						"events": "Eventos entre intervalo",
						"interval": "Todo entre intervalo"
					}
				},
				"transferTypeTranslate": {
					"cardExchange": "cambio por tarjeta",
					"input": "Aporte",
					"inventory": "Inventario",
					"invoice": "Entrada de factura",
					"lost": "Pérdida",
					"manual": "Ajuste manual",
					"productionIn": "Entrada de producción",
					"productionLost": "Pérdida de producción",
					"productionOut": "Salida de la producción",
					"productionOutTo": "Producción de",
					"refund": "Pérdida por contracargo",
					"sell": "Vender",
					"transferIn": "Transferencia (entrada)",
					"transferOut": "Transferencia (salida)"
				}
			},
			"multivendor": {
				"debtorsReport": {
					"title": "Cuentas Pendientes",
					"filters": {
						"vendor": "Proveedor",
						"period": "Período"
					},
					"table": {
						"title": "Informe de Cuentas Pendientes",
						"filename": "informe_de_cuentas_pendientes__{{vendor}}__{{date}}",
						"totalizer": {
							"totalOpen": "Total Pendiente",
							"paidAfterEvent": "Pagado Después del Evento",
							"clients": "Clientes",
							"stillOpen": "Aún Pendiente"
						},
						"columns": {
							"userName": "Nombre",
							"userDocument": "DNI",
							"phone": "Teléfono",
							"totalOpen": "Total Pendiente",
							"paidAfterEvent": "Pagado Después del Evento",
							"stillOpen": "Aún Pendiente"
						}
					}
				},
				"closings": {
					"calendar": {
						"toReceive": "Cuenta por cobrar",
						"totalSoldValue": "Valor total"
					},
					"choosePeriod": "Elija el período para exportar la hoja de cálculo",
					"download": "Descargar hoja",
					"modal": {
						"details": "Detalles del día",
						"eventDate": "Fecha del evento",
						"fixedFee": "Tarifa de alquiler fijo",
						"generalFeeValue": "Tarifa variable general",
						"generalPercentageFee": "Tarifa variable en la facturación",
						"otherProductsFeeValue": "Tarifa Variable en Productos Especiales",
						"payDate": "Fecha de pago",
						"totalSoldValue": "Facturación total",
						"vendorName": "Proveedor",
						"vendorValueToReceive": "cantidad a recibir"
					},
					"sheet": {
						"columns": {
							"eventDate": "tasa de eventos",
							"fixedFee": "Tarifa de alquiler fijo",
							"generalFeeValue": "Tarifa variable general",
							"generalPercentageFee": "Tarifa variable en la facturación",
							"otherProductsFeeValue": "Tarifa Variable en Productos Especiales",
							"payDate": "c",
							"totalSoldValue": "Facturación total",
							"vendorName": "proveedor",
							"vendorValueToReceive": "cantidad a recibir"
						},
						"filename": "cierre de proveedores",
						"title": "Cierre del proveedor"
					},
					"title": "Cierre por proveedor"
				},
				"extract": {
					"adjustments": {
						"add": "Agregar nueva configuración",
						"deleteAdjustmentSuccess": "Ajuste Suprimido",
						"originalPayDate": "Fecha de elegibilidad",
						"date": "Fecha de liquidación",
						"obs": "Nota",
						"title": {
							"label": "Nombre del ajuste",
							"placeholder": "Introduzca el nombre del ajuste."
						},
						"type": {
							"label": "Tipo de ajuste",
							"vendorShouldPay": "Pagar al proveedor",
							"vendorShouldReceive": "Cuenta por cobrar del proveedor"
						},
						"value": "Valor",
						"vendor": {
							"label": "Vendedor para lanzar el ajuste",
							"placeholder": "Seleccionar proveedor para iniciar ajustes"
						},
						"adjustValue": "Ajustes",
						"electrical": "Eléctrico",
						"hydraulics": "Hidráulica",
						"cleaning": "Limpieza",
						"supply": "Suministro",
						"other": "Otro",
						"category": "Categoría",
						"categoryPlaceholder": "Seleccione una categoría"
					},
					"period": "Período",
					"placeAvaliable": "Su saldo disponible",
					"requiredField": "Campo requerido",
					"tabs": {
						"adjustments": {
							"add": "Añadir ajuste",
							"columns": {
								"originalPayDate": "Fecha de elegibilidad",
								"date": "Fecha de liquidación",
								"obs": "Nota",
								"title": "Nombre",
								"value": "Valor",
								"vendorName": "Nombre del vendedor"
							},
							"export": "Exportar a Excel",
							"sheet": {
								"columns": {
									"originalPayDate": "Fecha de elegibilidad",
									"date": "Fecha de liquidación",
									"obs": "Nota",
									"title": "Nombre",
									"value": "Valor",
									"vendorName": "Nombre del vendedor"
								},
								"filename": "Extracto de proveedor",
								"title": "Extracto de proveedor"
							},
							"title": "Ajustes",
							"import": {
								"vendorId": "ID de vendor",
								"title": "Nombre del ajuste",
								"value": "Valor (en centavos)",
								"originalPayDate": "Fecha de elegibilidad",
								"date": "Fecha de liquidación",
								"type": "Tipo de ajuste",
								"category": "Categoría",
								"obs": "Observación",
								"importButton": "Importar ajuste",
								"vendorName": "Nombre del vendor",
								"successNotification": "Ajuste importado exitosamente.",
								"vendors": "Vendors",
								"electrical": "Eléctrico",
								"hydraulics": "Hidráulica",
								"supply": "Suministro",
								"cleaning": "Limpieza",
								"other": "Otro",
								"vendorIdTextError": "Error: Ingrese el ID del proveedor",
								"vendorIdIsValidError": "Error: Ingrese un ID de proveedor válido",
								"titleTextError": "Error: Ingrese un nombre para la configuración",
								"titleIsValidError": "Error: configuración de nombre con más de 255 caracteres",
								"valueZeroError": "Error: Ingrese un valor de ajuste distinto de 0",
								"categoryError": "Error: Ingrese una categoría de ajuste válida",
								"obsError": "Error: Obs de ajuste con más de 255 caracteres",
								"valueCentsError": "¡Atención! El valor está expresado en centavos, por ejemplo 123 equivale a R$ 1,23"
							},
							"total": "Total",
							"modal": {
								"deleteAdjustments": "Borrar ajustes",
								"wantToDelete": "¿Está seguro de que desea eliminar este ajuste?",
								"cantBeUndone": "Esta acción no puede deshacerse",
								"cancel": "Cancelar"
							}
						},
						"history": {
							"columns": {
								"attachment": "Adjunto",
								"attachments": "Adjunto",
								"paymentMethod": "Método de pago",
								"requestDate": "Fecha",
								"status": "Estado",
								"vendorName": "Proveedor",
								"withdrawValue": "Valor"
							},
							"export": "Exportar a Excel",
							"labels": {
								"paid": "Pagado",
								"pending": "Pendiente",
								"processing": "Procesando",
								"refused": "Rechazado"
							},
							"sheet": {
								"columns": {
									"paymentMethod": "Método de pago",
									"requestDate": "Fecha",
									"status": "Estado",
									"vendorName": "Proveedor",
									"withdrawValue": "Valor"
								},
								"filename": "Extracto de proveedor",
								"title": "Extracto de proveedor"
							},
							"title": "Historia"
						},
						"withdraws": {
							"columns": {
								"totalAvailable": "Balance",
								"totalRequestedValue": "Solicitudes de retiro",
								"vendorName": "Vendor",
								"type": {
									"label": "Tipo",
									"Withdraw": "Retiro",
									"Anticipation": "Anticipación"
								}
							},
							"export": "Exportar a Excel",
							"sheet": {
								"columns": {
									"availableValue": "Balance",
									"requestDate": "Fecha",
									"vendorName": "Proveedor",
									"withdrawValue": "Solicitud de Retiro",
									"anticipationValue": "Solicitudes de anticipación"
								},
								"filename": "Extracto de proveedor",
								"title": "Extracto de proveedor"
							},
							"title": "Solicitudes financieras"
						},
						"extractByVendor": {
							"title": "Extracto del proveedor",
							"filename": "extracto-por-proveedor",
							"columns": {
								"title": "Resumen del período",
								"payValue": "Total"
							},
							"selectPlaceholder": "Seleccione un proveedor",
							"available": "Saldo disponible",
							"toBeReleased": "Anticipación disponible",
							"emptyTitle": "Aquí todavía no hay nada",
							"emptySubtitle": "Seleccione un proveedor o vuelva a consultar más tarde.",
							"themes": {
								"retention": "Retención",
								"productsCommissionPayment": "Tasa porcentual sobre la facturación",
								"productsSoldInPaymentMethods": "Tarifa de métodos de pago",
								"productsSold": "Ingresos con productos",
								"tips": "Ingresos con servicio",
								"adjustments": "Ajustes hechos en casa"
							}
						}
					},
					"title": "Extracto de proveedor",
					"withdraw": {
						"requests": {
							"approve": "Aprobar seleccionado",
							"anticipationValue": "Monto a anticipar",
							"availableValue": "balance",
							"label": "¿Quieres confirmar las siguientes solicitudes de retiro??",
							"prorata": "Valor prorrateado",
							"reject": "Rechazar seleccionado",
							"requestDate": "Solicitado el",
							"title": "Peticiones",
							"totalValue": "Total",
							"type": {
								"anticipation": "Anticipación",
								"label": "Tipo",
								"withdraw": "Retiro"
							}
						},
						"title": "Solicitudes de retiro para {{name}}",
						"transference": {
							"attachments": "Adjuntos / Vales",
							"message": "Las solicitudes realizadas después de las 10:30 am (hora de Brasilia) solo serán respondidas al día siguiente.",
							"paymentMethod": {
								"label": "Método de pago",
								"placeholder": "Introduce el método de pago"
							},
							"title": "Transferir",
							"totalValue": "Monto del pago",
							"typeMethod": {
								"label": "Transferir con",
								"other": "Otro",
								"zigAvailable": " Usar el saldo de Zig PayZig Pay balance"
							},
							"warning": "ATENCIÓN"
						}
					},
					"anticipationBalance": "Tu saldo disponible para anticipación",
					"pendingWithdraws": "Retiros pendientes",
					"pendingAnticipations": "Adelantos pendientes",
					"vendorsOwned": {
						"seeDetails": "Ver detalles",
						"name": "Nombre",
						"total": "Total",
						"alertTitle": "Cálculo de proveedores",
						"alertMessage": "Para calcular el monto adeudado a los proveedores, sólo se suman los saldos positivos.",
						"list": "Lista de proveedores"
					}
				},
				"productsSold": {
					"activeTab": "producto-vendido-por-vendor",
					"bonus": "bono por producto",
					"title": "Products sold by vendor"
				},
				"revenues": {
					"activeTab": "ingresos de proveedores",
					"columns": {
						"name": "Proveedor",
						"rent": "Alquilar",
						"revenue": "Receta",
						"subtotal": "Total parcial",
						"totalSoldValue": "Productos vendidos",
						"totalTipValue": "Servicio",
						"billing": "Facturación",
						"percentageFee": "Tarifa",
						"salesFee": "Tasa de Venta",
						"salesFeeValue": "Transferencia de Ventas",
						"serviceFee": "Tasa de Servicio",
						"serviceFeeValue": "Transferencia de Servicio",
						"percentageFeeText": "Tarifa en {{fee}}",
						"adjustValue": "Ajustes",
						"electrical": "Eléctrico",
						"hydraulics": "Hidráulica",
						"supply": "Suministro",
						"cleaning": "Limpieza",
						"other": "Otro",
						"cashRetention": "Retención de efectivo",
						"cashPayment": "Pago en dinero",
						"voucherPayment": "Pago en vale",
						"debitPayment": "Pago en débito",
						"creditPayment": "Pago en credito",
						"total": "Total",
						"totalSoldValueInCredit": "Facturación de crédito",
						"totalSoldValueInDebit": "Factura de Débito",
						"totalSoldValueInPix": "Facturación en Pix",
						"creditFee": "Taxa sobre Crédito",
						"debitFee": "Tarifa de Débito",
						"pixFee": "Tarifa por Pix",
						"totalSoldValueInCreditFeeValue": "Cargo de Crédito",
						"totalSoldValueInDebitFeeValue": "Cargo de Débito",
						"totalSoldValueInPixFeeValue": "Cargar en Pix",
						"totalSoldValueInOtherPaymentMethods": "Facturación en otros métodos de pago",
						"billingTooltip": "Esta columna se refiere a la suma de los montos facturados por el proveedor por productos, servicios, ajustes y sobras de recarga.",
						"revenueTooltip": "Esta columna es el resultado de los ingresos menos todas las tarifas y ajustes cobrados al proveedor.",
						"voucherRetention": "Retención de vale",
						"productsFee": "Traslado de Productos con Tarifa Especial",
						"floorComplement": "Complemento mínimo garantizado",
						"rechargeLeftovers": "Recargar sobras"
					},
					"description": "Informe de relación de facturación y cada proveedor registrado como parte del sitio.",
					"period": "valores referidos a los periodos {{ since }} - {{ until }}",
					"sheet": {
						"columns": {
							"name": "Proveedor",
							"total": "Total",
							"totalSoldValue": "Productos vendidos",
							"totalTipValue": "Servicio",
							"rent": "Alquiler",
							"revenue": "Ingresos",
							"billing": "Facturación",
							"percentageFee": "Tarifa",
							"salesFee": "Tasa de Venta",
							"salesFeeValue": "Transferencia de Ventas",
							"serviceFee": "Tasa de Servicio",
							"serviceFeeValue": "Transferencia de Servicio",
							"percentageFeeText": "Tarifa en {{fee}}",
							"adjustValue": "Ajustes",
							"electrical": "Eléctrico",
							"hydraulics": "Hidráulica",
							"supply": "Suministro",
							"cleaning": "Limpieza",
							"other": "Otro",
							"cashRetention": "Retención de efectivo",
							"totalSoldValueInCredit": "Facturación de crédito",
							"totalSoldValueInDebit": "Factura de Débito",
							"totalSoldValueInPix": "Facturación en Pix",
							"creditFee": "Taxa sobre Crédito",
							"debitFee": "Tarifa de Débito",
							"pixFee": "Tarifa por Pix",
							"totalSoldValueInCreditFeeValue": "Cargo de Crédito",
							"totalSoldValueInDebitFeeValue": "Cargo de Débito",
							"totalSoldValueInPixFeeValue": "Cargar en Pix",
							"totalSoldValueInOtherPaymentMethods": "Facturación en otros métodos de pago",
							"voucherRetention": "Retención de vale",
							"productsFee": "Traslado de Productos con Tarifa Especial",
							"floorComplement": "Complemento mínimo garantizado",
							"rechargeLeftovers": "Recargar sobras"
						},
						"filename": "proveedor_facturación_en_local",
						"title": "Facturación de proveedores"
					},
					"title": "Facturación de proveedores",
					"totalizers": {
						"totalSold": "Ingresos totales del proveedor",
						"totalReceipt": "Ingresos totales del proveedor",
						"highestVendor": "Proveedor más grande"
					}
				}
			},
			"notEmitedProducts": {
				"activeTab": "productos-no-emitidos",
				"columns": {
					"combo": "combinado",
					"count": "Cantidad",
					"firstNotEmittedSellDate": "Cantidad",
					"lastNotEmittedSellDate": "Último día no emitido",
					"name": "Producto"
				},
				"export": "Exportar a Excel",
				"sheet": {
					"columns": {
						"combo": "combinado",
						"count": "Cantidad",
						"firstNotEmittedSellDate": "Primer día no emitido",
						"lastNotEmittedSellDate": "Último día no emitido",
						"name": "Producto"
					},
					"filename": "productos_no_emitidos",
					"title": "Productos no emitidos"
				},
				"title": "Productos no emitidos"
			},
			"passwordCard": {
				"blockCard": "Bloquear tarjeta",
				"columns": {
					"authorizedTransactioneration": "Operación/Transacción Autorizada",
					"cardCreator": "c",
					"cardNumber": "Número de tarjeta",
					"cardOwner": "Dueño de la tarjeta",
					"cardStatus": "Estado de la carta",
					"date": "Fecha/Hora",
					"pdvId": "Identificación de PDV",
					"permissions": "Acciones que autorizan",
					"timeCreation": "Creación de fecha/hora",
					"value": "Valor",
					"employeeName": "Empleado",
					"sourceId": "Id de transacción"
				},
				"passwordCardDeleteModal": {
					"complement": {
						"multiple": "las tarjetas de contraseña seleccionadas?",
						"single": "la tarjeta de contraseña de {{cardName}}"
					},
					"confirmButton": "Sí, quiero bloquear la tarjeta de contraseña",
					"text": "En caso de pérdida de una tarjeta de contraseña, es recomendable bloquearla. Al confirmar el bloqueo, su historial se registra, pero ya no es válido. Por lo tanto, desea bloquear "
				},
				"passwordCardHeader": {
					"blockButton": "Bloquear varias tarjetas",
					"main": {
						"description": "Se utilizan tarjetas de contraseña en lugar de contraseñas escritas y funcionan por aproximación, lo que agiliza la operación. De esta forma, solo quien cuente con estas tarjetas podrá autorizar ciertas acciones en el TPV, ofreciendo mayor control y seguridad para trámites relevantes como sangrado y reversión.",
						"labelText": "Buscar",
						"placeholder": "Buscar por titular de la tarjetar",
						"statusFilter": "Show only active cards",
						"title": "tarjeta de contraseña"
					},
					"stockHistory": {
						"cardOwner": "Dueño de la tarjeta: {{name}}",
						"title": "Tarjeta de contraseña - Historial de existencias"
					}
				},
				"statusEmployeeCard": {
					"active": "Activo",
					"blocked": "Activo",
					"inactive": "Inactivo"
				},
				"stockHistory": "Historial de existencias",
				"filename": "historial_de_existencias"
			},
			"placeTabs": {
				"bars": " Barras",
				"beer": " Cerveza de barril",
				"cmv": " Ing. del Menú",
				"combos": " combinados",
				"gng": " Agarra y vete",
				"products": " Productos",
				"supplies": " Entradas",
				"config": "Configuraciones de menús"
			},
			"placeTitle": "Lugares",
			"placelinks": {
				"hybrid": "Híbrido",
				"noEvents": "Sin eventos",
				"none": "No evento",
				"openEvent": "Evento abierto",
				"post": "Correo",
				"pre": "Pre"
			},
			"pos": {
				"methodTranslate": {
					"credit": "Credit",
					"debit": "Débito"
				},
				"operations": {
					"columns": {
						"brand": "Bandera",
						"date": "Fecha y hora",
						"lastDigits": "dígitos",
						"method": "Método",
						"value": "Valor"
					},
					"search": "Buscar por bandera, dígitos o valor",
					"title": "Operaciones"
				},
				"others": "Otros",
				"selectDate": "Seleccione un día para ver las transacciones",
				"sidebar": {
					"clear": "Limpio",
					"credit": "Crédito",
					"day": "Día",
					"debit": "Débito",
					"info": "Seleccione una o más fechas para ver los detalles.",
					"title": "Total de {{mes}}",
					"total": "Total"
				},
				"title": "ventas POS"
			},
			"productFeatureForm": {
				"fields": "Campos",
				"observation": "Observación",
				"org": "ORG",
				"selectHere": "Selecciona aquí...",
				"templatesOptionsPlaceholder": "Seleccionar plantilla",
				"typeHere": "Escriba aquí...",
				"validateMessage": "Este campo es obligatorio.",
				"zig": "ZIG"
			},
			"productsTab": {
				"filters": {
					"status": {
						"all": "Todos",
						"active": "Activo",
						"inactive": "Inactivo"
					}
				},
				"activeAll": "activar todo",
				"activeAllQuestion": "¿Activar todo?",
				"addProductButton": "Agregar producto",
				"importProductsButton": "Importar productos en masa",
				"checkAllItems": "Seleccionar todos los productos ({{counter}})",
				"deleteProducts": "Quitar productos",
				"deleteSelect": "Eliminar seleccionado",
				"deleteSelectedProducts": "Eliminar seleccionado",
				"disableAll": "Desactivar todo",
				"disableAllQuestion": "¿Desactivar todo?",
				"downloadQrCodeAppSell": "Descargar códigos QR de ventas para la Zig App",
				"editProducts": "Editar productos",
				"editProductsViaExcel": "Editar productos a través de Excel",
				"exportToExcelButton": "Exportar a Excel",
				"findFiscalGroupError": "Grupo fiscal registrado no encontrado",
				"findFiscalProfileError": "Perfil fiscal registrado no encontrado",
				"getDescriptionDialogActive": "¿Quieres activar este producto en los productos montables que lo componen?",
				"getDescriptionDialogDisable": "¿Desea deshabilitar este producto en los productos montables que lo componen?",
				"getTitleDialogActive": "Activar producto",
				"getTitleDialogDisable": "Deshabilitar producto",
				"importModal": {
					"alertMessage": "¡Aviso! el valor de los productos es informado en centavos, ej: 123 equivale a R$ 1,23",
					"buttonText": "Elegir hoja",
					"downloadSheet": "Descargar hoja de cálculo",
					"import": "Importar",
					"sheetFileName": "Productos",
					"title": "Importar dispositivos de hoja de cálculo",
					"table": {
						"columns": {
							"product": "Producto",
							"error": "Error",
							"description": "Descripción"
						},
						"errors": {
							"invalidTaxData": "Datos fiscales",
							"ncm": "NCM",
							"cest": "CEST",
							"duplicatedFiscalCode": "SKU duplicado",
							"productNotFound": "Producto no encontrado",
							"categoryWithSubcategory": "Categoria",
							"supercategoryNotFound": "Tipo de producto",
							"name": "Nombre",
							"category": "Categoría",
							"hasAlcohol": "Contiene alcohol",
							"isHiddenFromApp": "Ocultar producto",
							"value": "Precio",
							"kind": "Tipo de producto",
							"beerAbv": "ABV - Contenido de alcohol",
							"other": "Desconocido"
						},
						"errorsDescription": {
							"name": "Nombre del producto no informado",
							"category": "Categoría de producto no especificada",
							"hasAlcohol": "El campo debe ser true o false",
							"isHiddenFromApp": "El campo debe ser true o false",
							"value": "El precio del producto no es válido",
							"kind": "El tipo de producto no es válido",
							"beerAbv": "ABV - El contenido de alcohol debe ser un número",
							"other": "Error desconocido"
						}
					}
				},
				"importProductsButton": "Importar productos",
				"limitOver": "Límite por encima de {{limit}} seleccionado",
				"onDeleteMessage": {
					"cancelText": "No",
					"content": "¡Aviso! Los productos se eliminarán de forma permanente.",
					"okText": "Sí",
					"title_one": "¿Quieres eliminar {{counter}} producto?",
					"title_other": "¿Quieres eliminar {{counter}} productos?"
				},
				"onDeleteSelectProductsError": "¡Ups! Ha ocurrido un problema, inténtalo de nuevo",
				"productWithoutCategory": "Productos sin categoría de menú",
				"productsByCategory": "Productos por categoría",
				"searchLabel": "Buscar",
				"searchPlaceholder": "Buscar Productos...",
				"sortByCategory": "Ordenar por categoría",
				"sortByMenuCategory": "Ordenar por categoría de menú",
				"syncModal": {
					"activeSyncOptionCheckbox": "Activar productos sincronizados para venta a domicilio",
					"alertMessage": "Los productos que no estén en entrega serán creados con la misma información",
					"chooseTheVariablesCheckbox": {
						"all": "Todo",
						"category": "Categoría",
						"description": "Descripción",
						"mountableItems": "Artículos construibles",
						"name": "Nombre",
						"order": "Orden",
						"picture": "Fotografía",
						"price": "Precio",
						"add": "Agregar"
					},
					"editInput": {
						"inputName": "Entrada",
						"count": "Cantidad",
						"loss": "Pérdida",
						"value": "Precio de costo",
						"price": "Precio",
						"delete": "Eliminar"
					},
					"header": {
						"addButton": "Agregar entrada",
						"editButton": "Editar ficha técnica"
					},
					"infoCard": {
						"value": "Precio de venta",
						"totalCost": "Coste total",
						"cmv": "CMV %",
						"profitMargin": "Margen de beneficio"
					},
					"table": {
						"columns": {
							"inputName": "Entrada",
							"count": "Cantidad",
							"unitCostValue": "Coste unitario",
							"yieldPercentage": "Rendimiento",
							"unitCostWithYield": "Costo con rendimiento",
							"totalCost": "Coste total",
							"actions": "Acciones"
						}
					}
				},
				"supplies": {
					"pageTitle": "Insumos",
					"pageDescription": "Los insumos son todos los materiales que se utilizan para la producción de un determinado producto o en la creación de otro insumo. En esta pantalla es posible registrar y visualizar todos los insumos registrados en un solo lugar.",
					"addSupplies": "Añadir entrada",
					"addSuppliesModal": {
						"errorMessage": "Este campo es obligatorio",
						"name": "Nombre",
						"unitMeasure": "Unidad de medida",
						"units": "Unidades"
					},
					"step": {
						"supply": "Insumo",
						"ingredients": "Ingredientes"
					},
					"addInputModal": {
						"title": "Añadir insumo",
						"supply": "Insumo o Producto",
						"name": "Nombre",
						"placeholderName": "Ingrese el nombre del insumo",
						"sku": "SKU",
						"placeholderSKU": "Ingrese el SKU",
						"image": "Foto",
						"descriptionImage": "Imagen cuadrada o 500x500 píxeles",
						"yieldPercentage": "Rendimiento",
						"basicStorageUnit": "Unidad de medida",
						"placeholderBasicStorageUnit": "Ingrese la unidad de medida",
						"aboutIngredients": "Sobre ingredientes",
						"ingredientsInfo": "Complete los campos de ingredientes solo si el producto es una receta que utiliza otros insumos. Por ejemplo, salsa de tomate necesita ingredientes, pero tomate no.",
						"selectInput": "Seleccione insumo o producto",
						"quantity": "Cantidad",
						"loss": "Pérdida",
						"addIngredient": "Agregar ingrediente"
					},
					"suppliesErrorsTableColumns": {
						"supply": "Insumo",
						"error": "Error"
					},
					"cancel": "Cancelar",
					"conclude": "Concluir",
					"delete": "Borrar",
					"deleteWarning": "¿Está seguro de que desea eliminar este elemento?",
					"edit": "Para editar",
					"editSupplies": "Editar entrada",
					"erase": "Borrar",
					"exportToExcel": "Exportar a Excel",
					"importModal": {
						"buttonText": "Elige una hoja de trabajo",
						"conclude": "Concluir",
						"sheetFileName": "Entradas",
						"title": "Importar entrada"
					},
					"importSupplies": "Importar entradas",
					"no": " No",
					"noCaps": "NO",
					"productRule": {
						"addAnotherSupply": "Agregar otra entrada",
						"form": {
							"loss": "Pérdida",
							"product": "Producto",
							"quantity": "La cantidad"
						},
						"generatedQuantity": "Cantidad generada",
						"hasProductionRuleError": "Atención, esta hoja de datos es un error. Eliminar la hoja de datos y agregarla nuevamente.",
						"title": "Hoja de datos: {{productName}}",
						"tooltipMessage": "Para cambiar la cantidad generada, es necesario eliminar la hoja de datos y crearla nuevamente.",
						"warnings": {
							"emptyQuantity": "Añadir la cantidad de entrada",
							"emptySupplies": "Seleccione una entrada",
							"repeatEntry": "Agregaste entradas repetidas"
						}
					},
					"remove": "Para eliminar",
					"searchPlaceholder": "Entradas de búsqueda",
					"table": {
						"name": "Nombre",
						"productionRule": "Recetas y producción",
						"actions": "Acciones",
						"sku": "SKU",
						"yieldPercentage": "Rendement",
						"links": "Productos y insumos Vinc.",
						"stocks": "Inventarios",
						"clickToEdit": "Cliquer pour modifier",
						"hasProductionRule": "¿Tienes una ficha técnica?"
					},
					"supplyActionModal": {
						"title": {
							"supply": "Vínculos del insumo",
							"stock": "Vínculos del inventario"
						},
						"description": {
							"supply": "Lista de registros con los que este artículo está vinculado",
							"stock": "Lista de inventarios donde el producto está presente"
						},
						"seeProductButton": "Ver producto",
						"seeStockButton": "Ver inventario"
					},
					"yes": "Yes",
					"yesCaps": "YES",
					"link": "Vínculo",
					"links": "Vínculos",
					"deleteSelectedSupplies": "Eliminar insumos seleccionados",
					"deleteSelectedItens": "Eliminar elementos seleccionados",
					"deleteSupply": "Eliminar insumo",
					"deleteItems": "Eliminar elementos",
					"importSupply": "Importar insumo",
					"import": "Importar",
					"confirmDeleteMessage": {
						"multiple": "Al confirmar la acción, elimina permanentemente {{quantity}} insumos. ¿Desea continuar?",
						"single": "Al confirmar la acción, elimina permanentemente el insumo {{supply}}. ¿Desea continuar?"
					},
					"viewRules": "Ver recetas",
					"doesNotHave": "No tiene",
					"copiedSuccessfully": "Copiado exitosamente",
					"cannotDeleteSupply": "No se puede eliminar porque el insumo está vinculado a otros productos"
				}
			},
			"promotion": {
				"categoryModal": {
					"label": "Producto o categoría",
					"noneProduct": "No se encontraron productos",
					"placeholder": "Buscar un producto o categoría",
					"title": "Añadir nuevo producto"
				},
				"copyModal": {
					"message": "¿Quieres crear una copia de la promoción?",
					"okText": "Copiar",
					"placeholder": "Nombre de la copia promocional",
					"title": "Crear copia de promoción"
				},
				"creationStep": {
					"error": "No se puede redirigir la página.",
					"formatter": {
						"convertGoals": {
							"checkinTime": "Hora de llegada",
							"empty": "No tiene",
							"everybody": "Tu promoción no requiere ningún objetivo"
						},
						"convertUsageConditions": {
							"at": "hasta",
							"days": "días",
							"empty": "No tiene"
						},
						"frequencyOfEarning": {
							"eachEvent": "Una vez por evento",
							"everytime": "Siempre",
							"oncePerMonth": "Una vez al mes",
							"oncePerWeek": "Una vez por semana"
						},
						"promotionEarning": {
							"birthdayPerson": {
								"description": "Para especiales de cumpleaños del mes, semana o día.",
								"name": "Cumpleaños"
							},
							"checkinTime": {
								"description": "Para promociones requieren una hora de llegada específica.",
								"name": "Hora de llegada"
							},
							"everybody": {
								"description": "Para promociones que no requieran condiciones de uso",
								"name": "Todos los clientes "
							},
							"gender": {
								"description": "Para promociones exclusivas para mujeres, hombres u otros.",
								"name": "Género"
							},
							"guestList": {
								"name": "Lista de invitados"
							},
							"maximumPlaceFrequency": {
								"name": "Máxima frecuencia en el sitio"
							},
							"maximumValueConsumed": {
								"name": "Cantidad máxima consumida"
							},
							"minimumPlaceFrequency": {
								"name": "Frecuencia mínima de ubicación"
							},
							"minimumRechargeValue": {
								"description": "Para promociones que requieren una recarga mínima de cliente.",
								"name": "Importe mínimo de recarga"
							},
							"minimumValueConsumed": {
								"description": "Para promociones que requieran que el usuario consuma una cantidad mínima para poder optar a la promoción.",
								"name": "Cantidad mínima consumida"
							},
							"ppuUsage": {
								"description": "Para promociones de venta realizadas exclusivamente a través de la App.",
								"name": "PPU Usage"
							},
							"productsConsumed": {
								"description": "Para promociones a las que el cliente tiene derecho de promoción al comprar un producto o categoría de productos.",
								"name": "Compra un producto o categoría específica"
							},
							"productsConsumedQuantity": {
								"name": "Número de productos consumidos"
							}
						},
						"promotionUsage": {
							"period": {
								"description": "Definir un rango de tiempo que el cliente puede utilizar la promoción",
								"name": "Tiempo"
							},
							"secondsToExpire": {
								"description": "Definir cuánto tiempo tiene el cliente para aprovechar la promoción a la que tiene derecho",
								"name": "Caducidad posterior a la ganancia"
							},
							"weekDays": {
								"description": "Definir qué días de la semana el cliente puede hacer uso de la promoción",
								"name": "Días de la semana"
							}
						}
					},
					"steps": {
						"awards": "Premios",
						"goals": "Objetivos",
						"promotionInfo": "Datos de promoción",
						"resume": "Resumen",
						"usageConditions": "Condiciones de Uso"
					},
					"stepsPages": {
						"goals": {
							"tableWarningMessage": "Información no disponible para mesas.",
							"add": "Añadir objetivo",
							"conditions": {
								"birthday": {
									"day": "Cumpleañero",
									"month": "cumpleaños del mes",
									"week": "Cumpleañero de la semana"
								},
								"checkin": {
									"label": "Hora de llegada"
								},
								"gender": {
									"female": "Mujer",
									"male": "Hombres",
									"others": "Otros"
								},
								"minimumRecharge": {
									"label": "Importe mínimo de recarga"
								}
							},
							"error": "Condición TODOS LOS CLIENTES deben ser eliminados",
							"label": "Recurrencia de ganancias",
							"new": "Nuevo gol",
							"placeholder": "Seleccione una recurrencia máxima de ganancias"
						},
						"usageConditions": {
							"conditions": {
								"expiration": {
									"label": "Días del calendario:",
									"suffix": "Días"
								},
								"modal": {
									"add": "Agregar condición de uso",
									"new": "Nueva condición de uso"
								},
								"period": {
									"beginTime": "De:",
									"endTime": "Hasta:",
									"error": "Formato de hora no válido para la conversión"
								},
								"week": {
									"infoText": "Como los eventos pueden comenzar un día de la semana y terminar el otro, la promoción es válida el día de inicio del evento. Así el cliente puede hacer uso de la promoción al día siguiente si el evento empezó el día anterior.",
									"validPromotion": "Promoción válida"
								}
							}
						}
					},
					"stepsWrapper": {
						"description": "Descripción no encontrada",
						"save": "Guardar cambios",
						"title": "Título no encontrado"
					}
				},
				"defaultName": "Copia de {{promoción}}",
				"errors": {
					"nameLength": "El nombre de la promoción no ha alcanzado el número mínimo de caracteres.",
					"notFilledCorrectly": "Los campos no se completaron correctamente.",
					"sameName": "El nombre de la copia es el mismo que el nombre original.."
				},
				"peopleTable": {
					"download": "Descargar hoja de trabajo de muestra",
					"error": "Formato inválido",
					"example": "hoja de trabajo de ejemplo",
					"import": "Importar hoja"
				},
				"table": {
					"goals": {
						"empty": "Sin meta",
						"label": "Lista de objetivos de promoción",
						"new": "Nuevo gol"
					},
					"usageConditions": {
						"empty": "Sin condiciones de uso",
						"label": "Listado de condiciones de uso de la promoción",
						"new": "Nueva condición de uso"
					}
				}
			},
			"promotions": {
				"card": {
					"active": "Activo",
					"expiresAt": "Caduca en {{date}} día(s)",
					"inactive": "Inactivo",
					"noExpirationDate": "Sin fecha de vencimiento",
					"subtitle": "{{descuento}} descuento",
					"withoutDiscount": "Sin descuento"
				},
				"create": "Crear promoción",
				"createPromotion": {
					"awards": {
						"description": "Seleccione los productos y descuentos a los que tendrá derecho el cliente.",
						"discountType": {
							"error": "Los siguientes productos valen menos que el descuento dado",
							"label": "Tipo de descuento",
							"percentage": "Porcentaje",
							"table": {
								"add": "Añadir productos",
								"empty": {
									"description": "Si no selecciona productos, la promoción funcionará en todos los productos.",
									"label": "No hay productos seleccionados"
								},
								"error": "El valor máximo y mínimo no coincide",
								"price": "Precio de venta",
								"product": "Producto",
								"promotionalPrice": "Precio promocional",
								"total": "Total de {{count}} producto(s)"
							},
							"value": "Valor"
						},
						"maxUses": {
							"label": "Número máximo de usos por ganancia",
							"withoutLimits": "Sin límites"
						},
						"title": "Premios"
					},
					"goals": {
						"description": "Los objetivos son parámetros que determinarán lo que su cliente debe hacer para obtener la promoción",
						"title": "Objetivos"
					},
					"promotionInfo": {
						"automaticMessage": {
							"info": "Todos los clientes que ganan la promoción reciben mensajes automáticos del canal seleccionado. Estos envíos cuestan",
							"label": "Mensajes automatizados a los clientes",
							"sendMessage": "Enviar mensajes automáticos"
						},
						"description": "Establece todos los parámetros necesarios para crear una promoción especializada para tus clientes.",
						"errors": {
							"dateFormat": "Formato de fecha inválido",
							"dayDiff": "Se requiere al menos un día de diferencia",
							"requiredField": "Este campo es obligatorio",
							"selectPlace": "Seleccione al menos una ubicación",
							"maxUses": "El valor no debe superar la cantidad de productos definida en el paso anterior"
						},
						"expiration": {
							"info": "La promoción será válida hasta la fecha seleccionada. Cuando llegue la fecha de caducidad, la promoción estará inactiva y podrás cambiar la fecha de caducidad.",
							"label": "Vencimiento",
							"notExpire": "No caduca"
						},
						"places": "Ubicaciones de promoción",
						"promotionDescription": {
							"label": "Descripción de la promoción",
							"placeholder": "Ingrese la descripción de la promoción"
						},
						"promotionName": {
							"label": "Nombre de la promoción",
							"placeholder": "Introduce el nombre de la promoción"
						},
						"title": "Datos de promoción",
						"whatsUp": {
							"info": "Todas las promociones habilitadas se mostrarán en 'Qué pasa'.",
							"label": "Ver promociones en 'Whats Up'",
							"showPromotions": "Ver promociones en 'Whats Up'"
						}
					},
					"resume": {
						"description": "Comprueba que toda la información es correcta y luego publica la promoción. Se activará automáticamente y estará listo para usar.",
						"sections": {
							"allProducts": "Todos los productos",
							"andMore": "y más {{count}} productos",
							"awards": {
								"discount": "Descuento(%) sobre el valor del producto",
								"products": "productos de descuento",
								"title": "Premios"
							},
							"goals": {
								"frequency": "Recurrencia de ganancias",
								"title": "Objetivos"
							},
							"promotionInfo": {
								"description": "Descripción",
								"maxUses": {
									"label": "Cantidades de usos por ganancia",
									"oneUse": "{{uso}} uso",
									"uses": "{{usos}} usos"
								},
								"name": "Nombre",
								"places": "Ubicaciones",
								"title": "Datos de la promoción"
							},
							"usageConditions": "Condiciones de Uso"
						},
						"title": "Resumen"
					},
					"usageConditions": {
						"description": "En este paso, puede definir los parámetros de uso de la promoción. Cuando el cliente gana la promoción, solo puede utilizarla si sigue estas condiciones de uso.",
						"title": "Condiciones de uso",
						"warning": "- Los términos de uso de \"Compre y Gane\" también se utilizan para ganar la promoción. \n - El vencimiento posterior a ganar no se aplica a \"Compre y gane\"."
					}
				},
				"empty": "La búsqueda no encontró resultados",
				"filter": {
					"active": "Activo",
					"all": "Todo",
					"inactive": "Inactivo",
					"label": "Filtrar"
				},
				"search": "Buscar por nombre de la promoción",
				"selected": {
					"feature": "La función 'Comprar y ganar' debe estar activa",
					"active": "Activo",
					"clientList": "Lista de clientes",
					"clientListModal": {
						"addClient": {
							"label": "Agregar clientes a la lista",
							"placeholder": "Ingrese la identificación del cliente",
							"placeholderForeign": "Ingrese el número de teléfono del cliente",
							"addClient": "Agregar cliente",
							"foreign": "Extranjero"
						},
						"columns": {
							"cpf": "CPF",
							"cpfForeign": "Documento",
							"name": "Nombre",
							"phone": "Teléfono"
						},
						"error": "No se pueden agregar los clientes a continuación:",
						"remove": "Eliminar clientes seleccionados",
						"search": "Buscar por nombre o CPF",
						"searchForeign": "Buscar por nombre o teléfono",
						"title": "Lista de clientes {{promotionName}}"
					},
					"copy": "Crear copia",
					"discountValue": {
						"title": "{{descuento}} descuento",
						"unavailable": "Indisponible"
					},
					"erasePromotion": {
						"confimation": "¿Seguro que quieres eliminar la promoción?",
						"title": "Eliminar promoción"
					},
					"expirationTime": {
						"noExpires": "Sin fecha de vencimiento",
						"title": "Caduca en: {{date}} Días"
					},
					"inactive": "Inactivo",
					"maxUses": {
						"title": "{{usos}} usos por persona",
						"withoutLimit": "Sin límite de uso único"
					},
					"productsList": {
						"all": "todos los productos",
						"seeLess": "Ver menos",
						"seeMore": "Ver más",
						"title": "PRODUCTOS EN PROMOCIÓN",
						"unavailable": "Producto no disponible"
					},
					"title": "Nombre de la promoción"
				},
				"sideTab": {
					"delete": "Borrar",
					"modalConfirm": {
						"additionalText": "Al desactivar la promoción, todos los clientes que la recibieron no podrán utilizarla hasta que se vuelva a activar. Además, a pesar de aparecer en la lista de promociones del POS, la brigada no podrá otorgárselo a ningún cliente.",
						"errorMessage": "Nombre de promoción incorrecto",
						"inactivePomotion": "Deshabilitar promoción",
						"infoText": "Introduce el nombre completo de la promoción para confirmar tu acción",
						"placeholderInactivePromotion": "Introduce aquí el nombre de la promoción",
						"text": "Actualmente hay eventos abiertos. Al deshabilitar esta promoción, deberá volver a iniciar sesión manualmente en cada dispositivo.",
						"title": "Deshabilitar promoción",
						"tooltipInactivePromotion": "Debe ingresar el nombre de la promoción exactamente como está registrada para completar la desactivación"
					},
					"popConfirm": {
						"deletePromotion": "Eliminar promoción",
						"title": "¿Seguro que quieres eliminar la promoción?"
					},
					"promotionIs": {
						"active": "Activo",
						"inactive": "Inactivo"
					}
				},
				"title": "Promociones",
				"withoutPromotions": "No hay promociones registradas"
			},
			"search": {
				"title": "Buscar facturas",
				"activeTab": "búsqueda",
				"placeholder": "Número de factura",
				"search": "Buscar",
				"export": "Exportar a Excel",
				"foreignDescription": "Permite buscar por el número de documento fiscal y filtrar por período",
				"sheet": {
					"title": "Buscar facturas",
					"filename": "busqueda_notas",
					"columns": {
						"xml": "XML",
						"cancelledXml": "XML de cancelación",
						"jsonInvoice": "JSON factura",
						"jsonCreditNote": "JSON nota de crédito",
						"emitted": "Fecha de emisión",
						"everestUploadTime": "Fecha de carga a Everest",
						"isCanceled": "Cancelada"
					}
				},
				"columns": {
					"xml": {
						"label": "XML",
						"download": "Descargar XML de la factura",
						"labelCancelledInvoice": "XML de factura cancelada",
						"downloadCancelledInvoice": "Descargar XML de cancelación"
					},
					"json": {
						"download": "Descargar JSON",
						"labelInvoice": "JSON del documento",
						"labelCreditNote": "JSON de nota de crédito"
					},
					"downloadPDF": "Descargar PDF",
					"emitted": "Fecha de emisión",
					"transactionDate": "Fecha de la transacción",
					"type": "Tipo",
					"everestUploadTime": "Fecha de carga a Everest",
					"isCanceled": "Cancelada"
				}
			},
			"searchPlaceInputPlaceholder": "Buscar un lugar",
			"placeWithoutEvent": "Lugares sin evento por más de un mes",
			"ajustes": {
				"alert": "Se han realizado modificaciones, guardar para mantenerlos ",
				"attention": "¡Atención!",
				"consumption": {
					"fiscalGroup": "grupo fiscal",
					"fiscalProfile": "perfil fiscal",
					"label": "Configuración del impuesto mínimo al consumo",
					"ncm": "NCM"
				},
				"data": {
					"peopleCapacity": "Capacidad",
					"peopleCapacityTooltip": "Número de personas que alberga el lugar.",
					"label": "Datos",
					"name": "Nombre",
					"noneProduct": "sin productos",
					"selectProduct": "Seleccione un producto para habilitar el depósito de seguridad automático"
				},
				"devices": {
					"label": "Colocar PDV ({{counter}})",
					"placeholder": "Agregar un PDV a esta ubicación"
				},
				"email": "Emails para recibir eventos de cierre",
				"emailError": "Email inválido",
				"error": "Sin permiso para editar el lugar",
				"errors": {
					"hasConsumptionObligation": "Campo obligatorio para la configuración de la obligación de consumo",
					"invalidName": "Por favor ingrese un nombre valido",
					"invalidTip": "Ingrese un valor de hasta 25%",
					"postPaidLimit": "Please enter a valid value",
					"rechargeNotIntegratedLimit": "Valor mínimo de",
					"minNonIntegratedPaymentLimit": "Valor mínimo de {{value}}",
					"tipOptionsValuesRequired": "Se requieren los valores de propina",
					"tipOptionLowerValue": "El \"Valor inferior\" debe ser menor que los valores Medio y Superior",
					"tipOptionHigherValue": "El \"Valor superior\" debe ser mayor que el valor Medio"
				},
				"tip": {
					"taxType": "Tipo de impuesto",
					"tipSuggestions": "Sugerencias de propina",
					"tip": "Propina",
					"serviceTax": "Cargo por servicio",
					"none": "Ninguna",
					"lowerValue": "Valor inferior",
					"medValue": "Valor medio",
					"higherValue": "Valor superior",
					"tooltip": "Las recomendaciones de propina hacen que el pago de la cuenta sea más fácil, ofreciendo tres opciones de porcentajes (Menor, Medio y Mayor) basadas en el valor total de la cuenta, por ejemplo: 5%, 10% y 15%, limitadas al 25%."
				},
				"everest": {
					"cnpj": "CNPJ",
					"host": "Anfitrión",
					"label": "Everest",
					"password": "Contraseña",
					"user": "Usuario"
				},
				"ficha": {
					"fichaImage": "Imagen",
					"fichaText": "Título",
					"label": "Token",
					"text": "Título del token",
					"placeholderText": "Inserta el título del token",
					"logo": "Imagen a imprimir",
					"upload": "Adjuntar imagen",
					"formatError": "Formato no soportado",
					"imageFormatMessage": "La imagen debe estar en formato PNG o SVG.",
					"recommendationMessage": "Recomendamos que la imagen asignada sea el logo de la empresa en negro, ya que no es posible imprimir en otro color.",
					"dragOrSelectMessage": "Arrastra la imagen desde tu computadora o selecciónala desde 'Adjuntar imagen'.",
					"logoFormatMessage": "El logo debe estar en formato PNG o SVG con fondo transparente."
				},
				"limits": {
					"label": "Límites y servicios",
					"postPaidLimit": "Límite pospago",
					"rechargeNotIntegratedLimit": "Límite de recarga no integrado",
					"serviceTax": "Cargo por servicio",
					"nonIntegratedPaymentLimit": "Límite de pago no integrado por dispositivo y evento",
					"enableBuiltInLimit": "Habilitar límite de recarga no integrado",
					"enableNonIntegratedPaymentLimit": "Habilitar límite de pago no integrado por dispositivo y evento",
					"nonIntegratedPaymentLimitTooltip": "Este límite se refiere a la cantidad máxima de pagos no integrados que puede recibir un dispositivo durante el evento. Este parámetro es la suma del total de Recargas y Ventas sin Tarjeta realizadas con pagos no integrados.",
					"nonIntegratedRechargeLimitTooltip": "Este límite se refiere a la cantidad máxima que un empleado puede hacer en una recarga no integrada."
				},
				"paymentBilling": {
					"hybrid": "Híbrido",
					"pos": "Pos",
					"pre": "Pre"
				},
				"placeFeatures": "Funcionalidades",
				"save": "Guardar",
				"settings": {
					"label": "Ajustes",
					"myActionsPassword": {
						"label": "¨Mis Acciones¨ contraseña",
						"placeholder": "Ingrese una contraseña numérica o la contraseña predeterminada será 9090"
					},
					"sellVisualizationFormat": {
						"grid": "Red",
						"label": "Formato de visualización de productos en oferta",
						"list": "Lista"
					}
				},
				"title": "Editar ajustes",
				"warningDialog": "Está habilitando los pagos de pospago en '{{name}}'. ¿Estas seguro acerca de esto? Para confirmar la modificación, escriba '{{text}}'",
				"invoiceMoment": {
					"fieldLabel": "Seleccione el momento para la emisión de la factura cashless",
					"tip": "Seleccione el momento de emisión de la factura para pagos sin efectivo. Para todos los demás métodos de pago que no sean sin efectivo, la factura siempre se emitirá al momento del consumo.",
					"recharge": "Recarga",
					"rechargeAndActivation": "Recarga y activación",
					"consumption": "Consumo",
					"consumptionAndActivation": "Consumo y activación"
				}
			},
			"subtitle": "Leyenda",
			"subtitles": {
				"longTimeWithoutEvent": "Mucho tiempo sin evento",
				"noEvent": "No evento",
				"onGoingEvent": "evento en curso",
				"recentEvent": "Evento reciente",
				"waitingForApproval": "A la espera de la aprobación"
			},
			"timezone": "Zona horaria",
			"recharges": {
				"title": "Recargas",
				"activeTab": "recargas",
				"period": "Período",
				"transactionedValue": "Valor Negociado",
				"export": "Exportar Excel",
				"value": "Valor Emitido",
				"netValue": "Valor Neto Emitido",
				"periodFilter": "Filtrar por período",
				"eventsFilter": "Filtrar por eventos",
				"filterIssuedLabel": "Filtrar por estado",
				"descriptionForeign": "Este informe muestra todas las recargas y muestra información de la Factura asociada, si la hay. Permite filtrar por período, eventos y estado.",
				"eventsSelected": "eventos seleccionados",
				"eventsFilterPlaceholder": "Selecciona los eventos",
				"columns": {
					"totalValue": "Valor de la recarga",
					"usedValue": "Valor utilizado",
					"date": "Fecha",
					"eventName": "Nombre del evento",
					"eventDate": "Fecha del evento",
					"cnpj": "CNPJ Emisor",
					"cpf": "CPF Cliente",
					"type": "Tipo",
					"issuerNIF": "NIF del comerciante",
					"recipientNIF": "NIF del cliente",
					"invoiceSeries": "Serie de la factura",
					"invoiceNumber": "N° de factura",
					"invoiceNetValue": "Valor Neto de la Factura",
					"invoiceValue": "Valor de la factura",
					"invoiceDate": "Fecha de emisión"
				}
			},
			"transactions": {
				"activeTab": "actas",
				"columns": {
					"transactionId": "Id de transacción",
					"cnpj": "Emitiendo CNPJ",
					"count": "cuant.",
					"cpf": "Identificación del cliente",
					"issuerNIF": "Emitiendo NIF",
					"recipientNIF": "Cliente NIF",
					"date": "Fecha",
					"discountValue": "Descuento",
					"type": "Tipo",
					"eventDate": "Fecha del evento",
					"eventName": "Evento",
					"invoiceDate": "Fecha de Emisión",
					"invoiceNumber": "No.",
					"invoiceSeries": "Serie de notas",
					"invoiceValue": "Valor de la nota",
					"invoiceNetValue": "Valor neto de la nota",
					"isCombo": "combinado",
					"productName": "Producto",
					"value": "Valor unitario",
					"total": "Valor total",
					"netValue": "Valor neto"
				},
				"export": "Export Excel",
				"period": "Período",
				"sheet": {
					"columns": {
						"transactionId": "Id de transacción",
						"cnpj": "CNPJ emisor",
						"count": "Cantidad",
						"cpf": "Identificación del cliente",
						"date": "Fecha",
						"discountValue": "Descuento",
						"eventDate": "Fecha del evento",
						"eventName": "Evento",
						"invoiceDate": "Fecha de Emisión",
						"invoiceNumber": "No.",
						"invoiceSeries": "Serie de notas",
						"invoiceValue": "Valor de la nota",
						"invoiceNetValue": "Valor neto de la nota",
						"isCombo": "es combinado",
						"productName": "Producto",
						"value": "Valor unitario",
						"total": "Valor total",
						"netValue": "Valor neto"
					},
					"filename": "actas",
					"filenameForeign": "productos",
					"title": "Actas",
					"titleForeign": "Productos"
				},
				"title": "Actas",
				"descriptionForeign": "En este informe, es posible tener una visión de la facturación fiscal emitida considerando cada producto transaccionado, con la opción de filtrar por período y estado. El monto bruto emitido incluye el Impuesto al Valor Agregado (IVA), mientras que el monto neto emitido se calcula después de deducir el IVA",
				"valueTransactioned": "Valor transaccionado",
				"value": "Valor bruto de emisión",
				"netValue": "Valor neto de emisión",
				"titleForeign": "Productos",
				"filterIssued": "Emitido",
				"filterNotIssued": "No emitido",
				"filterIssuedLabel": "Filtrar por estado"
			},
			"whatsUp": {
				"aboutSection": {
					"arena": "Arena",
					"bar": "Pub",
					"barAndRestaurant": "bar y restaurante",
					"beachClub": "club de playa",
					"bistro": "Pequeño restaurante",
					"descriptionEvent": "En este paso, debe completar la información sobre el evento. Intenta rellenar toda la información de forma clara y sencilla.",
					"descriptionInput": "Descripción (opcional)",
					"descriptionPlace": "En esta etapa, debe completar la información sobre la ubicación. Intenta rellenar toda la información de forma clara y sencilla.",
					"event": "Evento",
					"eventCategory": "Categoría de evento",
					"eventDescriptionPlaceHolder": "Escriba una breve descripción sobre el evento",
					"eventName": "Nombre del evento",
					"eventTagLimit": "Puede seleccionar hasta 6 etiquetas. Las etiquetas ayudarán a los usuarios a aprender más sobre los diferenciadores de su evento",
					"festival": "Festival",
					"musicTagLimit": "Use etiquetas de estilo para ayudar a mostrar su ubicación/evento a los usuarios interesados en los mismos estilos",
					"musicTagPlaceholder": "Seleccione hasta 3 estilos de música",
					"musicTags": "Estilo de musica",
					"nightclub": "Balada",
					"placeCategory": "Categoría de ubicación",
					"placeDescriptionPlaceHolder": "Escriba una breve descripción sobre la ubicación",
					"placeName": "Place name",
					"placeTagLimit": " Puede seleccionar hasta 6 etiquetas. Las etiquetas ayudarán a los usuarios a aprender más sobre los diferenciadores de tu ubicación",
					"pub": "Pub",
					"restaurant": "Restaurante",
					"show": "Espectáculo",
					"tags": "Etiquetas",
					"tagsPlaceholder": "Seleccione hasta 6 etiquetas",
					"titleEvent": "Sobre el evento",
					"titlePlace": "Sobre el lugar"
				},
				"active": {
					"description": "No se cobrará ninguna tarifa adicional para mostrar su casa en la aplicación ZIG",
					"titleEvent": "Mostrar evento en la aplicación de usuario",
					"titlePlace": "Mostrar inicio en la aplicación de usuario",
					"unfilledFields": "No se pudo activar. Campos obligatorios no rellenados."
				},
				"addressSection": {
					"address": "DIRECCIÓN",
					"addressPlaceholder": "Nombre de calle o avenida",
					"city": "Ciudad",
					"complement": "Complemento (opcional)",
					"complementPlaceholder": "Complemento de dirección",
					"neighborhood": "Vecindario",
					"number": "Número",
					"state": "Estado",
					"title": "Datos del Domicilio",
					"titleOptional": "Información de la dirección (opcional)",
					"zigLocation": "ubicación en zigzag",
					"zigLocationTooltip": "Es el centro de Zig donde se registró su ubicación. Si quieres cambiar, contacta con nuestro equipo",
					"zipCode": "Código postal",
					"zipCodeLink": "No conozco mi CEP"
				},
				"appearsInAppModal": {
					"description": "Al deshabilitar, su ubicación no se mostrará en la aplicación del usuario. ¿Desea continuar de todos modos?",
					"title": "No compartir ubicación en la aplicación"
				},
				"cancelEditModal": {
					"description": "Cuando cancela la edición, los cambios no se guardarán. ¿Desea continuar de todos modos?",
					"title": "Cancelar editar"
				},
				"description": "Rellena los datos y comparte tu evento con tus clientes a través de la aplicación ZIGPAY. Permitir a los usuarios el acceso a horarios de apertura, redes sociales, fotos y enlaces externos.",
				"edit": "Editar informacion",
				"eventPublishObs": "Al publicar, acepta mostrar la información de su evento en la aplicación ZIG y ser responsable del contenido publicado",
				"formValidations": {
					"city": "La ciudad es un campo obligatorio",
					"date": "La fecha es un campo obligatorio",
					"description": "Límite de 160 caracteres alcanzado",
					"generalError": "*Datos obligatorios no cumplimentados",
					"image": "La imagen es obligatoria",
					"imageSize": "Subir imágenes hasta 500kb",
					"link": "Por favor ingrese un enlace válido",
					"linkHighlightType": "El botón Resaltar es un campo obligatorio",
					"locationCategory": "La categoría de ubicación es un campo obligatorio",
					"name": "El nombre es un campo obligatorio",
					"nameMaxLength": "El límite máximo de caracteres es {{maxLength}}",
					"neighborhood": "Barrio es un campo obligatorio",
					"postalCode": "El código postal es un campo obligatorio",
					"state": "El estado es un campo obligatorio",
					"streetName": "La dirección es un campo obligatorio",
					"streetNumber": "El número es un campo obligatorio",
					"tags": "Solo puede seleccionar hasta {{numberTags}} etiquetas",
					"zigLocation": "Ubicación Zig es un campo obligatorio"
				},
				"inactive": {
					"eventTitle": "Su evento no se muestra en la aplicación. Es necesario habilitar la visualización..",
					"placeTitle": "Tu ubicación no se muestra en la aplicación. Es necesario habilitar la visualización."
				},
				"linkSection": {
					"buttonHighlight": "Botón Resaltar (opcional)",
					"facebook": "Facebook",
					"instagram": "Instagram",
					"pasteHere": "Pegar aquí",
					"reservation": "Reservas",
					"site": "Sitio",
					"ticket": "Entradas",
					"title": "Enlaces externos (opcional)"
				},
				"operationSection": {
					"add": "Agregar",
					"date": "Fecha",
					"day": "Día",
					"eventDescription": "Ingresa el día y horario de tu evento.",
					"eventTitle": "Fechas de eventos",
					"friday": "Viernes",
					"monday": "Lunes",
					"placeDescription": "Informar el día y horario de funcionamiento de su casa. Si su casa no funciona algún día de la semana, simplemente no lo agregue a la lista a continuación.",
					"placeTitle": "Horario de apertura",
					"saturday": "Sábado",
					"sunday": "Domingo",
					"thursday": "Jueves",
					"time": "Tiempo (opcional)",
					"tuesday": "Martes",
					"until": "Hasta",
					"wednesday": "Miércoles"
				},
				"placePublishObs": "Al publicar, acepta mostrar la información de su ubicación en la aplicación ZIG y ser responsable del contenido publicado",
				"profileSection": {
					"brandImage": "Imagen de marca",
					"brandImageObs": "Imagen cuadrada o 500x500 píxeles",
					"description": "Puedes subir imágenes de hasta 500kb en formato .png, .jpg o .jpeg según las dimensiones que se mencionan a continuación:",
					"frontCoverImage": "Imagen de portada",
					"galleryImage": "Imagen para galería (opcional)",
					"horizontalImageObs": "Imagen horizontal o 1280x780 píxeles",
					"seePreview": "Ver vista previa de la aplicación",
					"title": "Perfil"
				},
				"publish": "Publicar",
				"successModal": {
					"description": "Asegúrese de que la función \"Mostrar inicio en la aplicación de usuario\" esté habilitada para que su ubicación se muestre en Zig.app.",
					"eventTitle": "¡La información ha sido guardada con éxito!",
					"placeTitle": "¡La información se ha guardado correctamente!"
				},
				"title": "¿Qué pasa?"
			},
			"store": {
				"backofficeStore": {
					"addBar": "Barra añadida",
					"addStorage": "Inventario creado con éxito",
					"createBillTypes": "Tipo de cuenta creado con éxito",
					"createCategorie": "Categoría creada",
					"createCostCenters": "Centro de coste creado",
					"createNewSupplier": "Nuevo proveedor añadido con éxito",
					"createTransfer": "Transferencia realizada con éxito",
					"deleteAccount": "Cuenta de cliente eliminada",
					"deleteBackofficeProduct": "Producto eliminado del stock",
					"deleteBackofficeProducts": "Todos los productos han sido eliminados del stock",
					"deleteBar": "Barra eliminada con éxito",
					"deleteBill": "Cuenta borrada",
					"deleteBillTypes": "Cuenta borrada",
					"deleteCategorie": "Categoría eliminada",
					"deleteCostCenter": "Centro de Costo Eliminado",
					"deleteSupplier": "Proveedor eliminado exitosamente ",
					"deleteTransfer": "Transferencia eliminada con éxito",
					"editAccount": "Cuenta de cliente editada",
					"editBill": "Cuenta editada con éxito",
					"editBillTypes": "Tipo de cuenta editada",
					"editCategorie": "Categoría editada",
					"editCostCenter": "Centro de costos editado",
					"editSupplier": "Proveedor editado con éxito",
					"editTransfer": "Transferencia editada con éxito",
					"importBackofficeBills": "Cuentas importadas",
					"inputBackofficeProductsV2_other": "No se agregaron uno o más productos",
					"inputBackofficeProductsV2_zero": "Productos añadidos al stock",
					"saveBackofficeProductsQuantityV2": "Producto actualizado",
					"transferBackofficeProduct": "Producto transferido",
					"updateBar": "Barra editada con éxito",
					"updateStorage": "Stock modificado con éxito",
					"zeroBackofficeAllProductsAtStorage": "Todos los productos puestos a cero"
				},
				"barStore": {
					"addTableBarRange": "Configuración de impresión de tabla agregada.",
					"deleteBar": "Barra eliminada.",
					"deleteRange": "Configuración de impresión de tableta eliminada'..",
					"editBar": "Barra actualizada.",
					"editTableBarRange": "Configuración de impresión de tabla actualizada."
				},
				"cashierStore": {
					"addCashierClosingObs": "Nota añadida.",
					"bleedCashier_other": "El sangrado fue exitoso.",
					"bleedCashier_zero": "Fondo de intercambio exitoso",
					"createBleedLEGACY": "Sangrado añadido",
					"createCashierChangeLEGACY": "Fondo de cambio agregado",
					"createMultipleChangesLEGACY": "Todos los fondos han sido registrados",
					"createMultipleChangesLEGACYError": "{{errors}} de {{cashiersId}} dio error: {{jsonErrors}}",
					"updateCashierClosingLEGACY": "Cajero cerrado con éxito"
				},
				"clientStore": {
					"clientAlreadyAdded": "Este cliente ya ha sido agregado",
					"createPixCharge": "PIX generado con éxito",
					"editClientDetails": "Datos actualizados del cliente.",
					"editClientDetailsPlace": "Datos del cliente actualizados.",
					"editUserDetails": "Detalles del cliente actualizados.",
					"getClientByCPFOrPhone": "Cliente añadido",
					"payAllBillsAtPlace": "Facturas pagadas con éxito",
					"payBillAtPlace": "Cuenta pagada con éxito",
					"payBillsLoading": "Marcar como pagado",
					"payBillsSuccess": "Cuentas pagadas con éxito",
					"payBillsWarning": "{{success}} facturas pagadas con éxito y {{errors}} errores al pagar las facturas"
				},
				"cmvStore": {
					"error": {
						"getCategories": "Error al obtener la categoría"
					}
				},
				"comboStore": {
					"createCombo": "Combo creado.",
					"deleteCombo": "Combo eliminado.",
					"editCombo": "Combo actualizado."
				},
				"deliveryStore": {
					"activateManyProductsLoading": "Activando productos",
					"activateManyProductsWarning": "{{countFailures}} producto(s) no se pudo actualizar.",
					"addProduct": "¡Producto agregado con éxito!",
					"addProductV2": "¡Producto agregado con éxito!",
					"deactivateManyProductsLoading": "Deshabilitar productos",
					"deactivateManyProductsWarning": "{{countFailures}} productos no se pudieron actualizar.",
					"deleteMenu": "¡Menú eliminado con éxito!"
				},
				"deviceStore": {
					"addDevice": "Dispositivo agregado a la ubicación con éxito",
					"removeDeviceFromEvent": "Dispositivo eliminado del evento.",
					"updateEmployeeDeviceConfigs": "POS configurado con éxito "
				},
				"employeeStore": {
					"addEmployee": "Empleado agregado.",
					"addMultipleEmployees": {
						"error": "Error al agregar empleados:",
						"success": "Empleados añadidos con éxito: "
					},
					"removeMultipleEmployees": "{{successCount}} empleados eliminados con éxito",
					"removeMultipleEmployeesError": "{{errorCount}} empleados no se pudieron eliminar",
					"createRole": "Rol creado con éxito",
					"deleteRole": "Rol eliminado con éxito",
					"editEmployee": "Empleado actualizado.",
					"removeEmployee": "Empleado eliminado.",
					"updateRole": "Rol editado con éxito"
				},
				"eventStore": {
					"closeEvent": "Evento cerrado.",
					"closeEventLoading": "Evento de clausura",
					"createEvent": "Evento creado.",
					"deleteEvent": "Evento eliminado.",
					"emitInnovaroGeneralInvoices": "Billetes emitidos con éxito",
					"giveRechargeToUser": "Recarga creada con éxito",
					"eventEditedSuccessfully": "Evento editado con éxito",
					"openEvent": "Evento abierto",
					"payAllBillsAtEvent": "Facturas pagadas con éxito",
					"payBillAtEventWithMultiplePayments": "Factura pagada con éxito",
					"refundFichaSell": "Token invertido con éxito "
				},
				"extractStore": {
					"createAdjustmentInVendorExtract": "Ajuste agregado con éxito",
					"createBankAccount": "Cuenta bancaria creada con éxito.",
					"deleteBankAccount": "Bank account successfully removed!",
					"orderWithdrawCancellation": "Solicitud de cancelación enviada con éxito.",
					"payVendorWithdrawRequests": "Aprobaciones enviadas con éxito!",
					"revertManyVendorsWithDrawRequests": "Solicitud de rechazo enviada con éxito!",
					"updateBankAccount": "¡Cuenta bancaria actualizada con éxito!"
				},
				"fiscalStore": {
					"createFiscalProductGroup": "Creación exitosa del grupo fiscal.",
					"createFiscalProfile": "Creación exitosa del perfil fiscal",
					"deleteFiscalProductGroup": "Éxito al actualizar el grupo fiscal.",
					"editFiscalProductGroup": "Éxito al actualizar el grupo fiscal",
					"editFiscalProfile": "Éxito al actualizar el perfil fiscal.",
					"issueManualInvoiceForReserveError": "Error n°{{número}}: {{error}}",
					"issueManualInvoiceForReserveError_zero": "Error al generar {{failedInvoiceCount}} facturas",
					"issueManualInvoiceForReserve_other": "{{issuedInvoices}} Facturas generadas con éxito",
					"issueManualInvoiceForReserve_zero": "Todas las facturas generadas con éxito",
					"minimumConsumptionFiscalSuccess": "Consumo mínimo configurado con éxito",
					"rechargeFiscalSuccess": "Recarga configurada con éxito"
				},
				"invoiceStore": {
					"cancelInvoice": "¡Factura cancelada con éxito!",
					"cancelInvoiceNC": "Nota de crédito generada correctamente Su nota de crédito estará disponible en breve",
					"issueAllEventInvoices": "Facturas de eventos emitidas.",
					"issueInvoicesOfTransactions": "Facturas que se emiten",
					"notifyOfIssuingWarning_other": "{{issuedInvoices}} facturas emitidas, pero se encontraron los siguientes errores: {{errors}}",
					"notifyOfIssuingWarning_zero": "No se emitió factura, se encontraron los siguientes errores: {{errors}}",
					"notifyOfIssuing_other": "{{invoiceCount}} facturas emitidas",
					"notifyOfIssuing_zero": "No había notas para emitir",
					"sendInvoicesByEmail": "Notas enviadas por correo electrónico."
				},
				"itemStore": {
					"activateMountableSectionItem_all": "Elementos activados con éxito",
					"activateMountableSectionItem_one": "Elemento activado con éxito",
					"activateProductsInPlace": "Productos activados",
					"activateProductsInPlaceLoading": "Activación de productos",
					"activateSingleProductInPlace": "Producto activado",
					"activatedEntrance": "Entrada activada",
					"activatedProduct": "producto activado",
					"activatingEntrance": "Activando entrada",
					"activatingProduct": "Activando producto",
					"addProduct": "Producto añadido",
					"addSupply": "Entrada añadida",
					"attachProductionRule": "Hoja de datos creada con éxito",
					"createBeerTap": "¡Tienda creada con éxito!",
					"createCategory": "Categoría creada con éxito",
					"createEntrance": "Added Entry",
					"deactivateMountableSectionItem_all": "Elementos desactivados con éxito",
					"deactivateMountableSectionItem_one": "Artículo desactivado con éxito",
					"deactivateProductsInPlace": "Productos Desactivados",
					"deactivateProductsInPlaceLoading": "Desactivación de productos",
					"deactivateSingleProductInPlace": "Producto desactivado",
					"deactivatedEntrance": "Entrada desactivada",
					"deactivatedProduct": "Producto desactivado",
					"deactivatingEntrance": "Desactivar entrada",
					"deactivatingProduct": "Desactivando producto",
					"deleteCategory": "Categoría eliminada",
					"deleteEntrance": "Entrada eliminada",
					"deleteMultipleProducts": "Eliminado con éxito",
					"deleteProduct": "Producto eliminado",
					"deleteProductError": "Error al eliminar producto",
					"deleteProductFromPlace": "Producto eliminado",
					"editBeerTap": "¡Chopeira edita con éxito!",
					"editCategory": "Categoría actualizada",
					"editEntrance": "Entrada actualizada",
					"editEntranceImage": "Entrada actualizada",
					"editMultipleProducts": "¡{{nombre}} modificado con éxito! ",
					"editMultipleProductsError": "{{name}} no se pudo cambiar: {{reason}}",
					"editProduct": "Producto actualizado",
					"editProductionRule": "Regla de producción actualizada",
					"removedProductionRuleInput": "Insumo removido con éxito",
					"editSupply": "Entrada cambiada",
					"errorToAdd": "Error al agregar {{nombre}}",
					"importProducts": "{{productos}} Productos importados",
					"importProductsError": "Error al editar el producto {{name}}: {{message}}",
					"importProductsToEdit": "{{productos}} Productos editados",
					"importProductsToEditError": "Error al editar el producto {{name}}: {{mensaje}}",
					"importProductsToEditWarning": "{{products}} Productos editados y {{errorCounter}} productos tenían problemas de edición",
					"importProductsWarning": "{{products}} productos importados y {{errorCounter}} productos tuvieron problemas para importar",
					"removeBeerTap": "¡Cervecería eliminada con éxito!",
					"removeProductionRule": "Hoja de datos eliminada con éxito"
				},
				"organizationStore": {
					"addGiftback": "Giftback creado con éxito",
					"addMultipleOrgProducts": "Productos añadidos",
					"addMultipleProductsInPlace": "Ubicaciones cambiadas",
					"addProductToOrg": "Added Product",
					"deleteMultipleOrgProducts": "({{products}}) productos se han eliminado del inventario en todas las ubicaciones.",
					"deleteMultipleOrgProductsQueued": "La eliminación de ({{products}}) productos fue puesta en cola y será procesada en segundo plano.",
					"deleteGiftback": "Giftback eliminado con éxito",
					"deleteProduct": "Product removed",
					"deleteProductError": "Error al eliminar el producto",
					"editGiftback": "Giftback editado con éxito",
					"editMultipleOrgProducts": "Productos editados",
					"editOrgProduct": "Producto editado",
					"tooglePlaces": "Las ubicaciones cambiaron",
					"activateGiftback": "Giftback activado con éxito",
					"deactivateGiftback": "Giftback desactivado con éxito"
				},
				"placeStore": {
					"activateDiscountCategory": "¡Descuento activado con éxito!",
					"addEmailToMinimumStorageAlert": "Correos electrónicos registrados con éxito",
					"alterFichaLogo": "Imagen de imagen enviada.",
					"alterFichaText": "Título del formulario enviado.",
					"createManualLostReport": "Pérdida manual creada con éxito",
					"createStorageAlerts": "Alert created successfully",
					"deleteDiscountCategory": "¡Descuento eliminado con éxito!",
					"deleteStorageAlerts": "Alerta eliminada con éxito",
					"disableDiscountCategory": "¡Descuento deshabilitado con éxito!",
					"editEverestConfig": "Datos actualizados del Everest.",
					"editEverestConfigWarning": "Validando datos con everest",
					"editPlace": "Ubicación actualizada",
					"editStorageAlerts": "Alerta editada con éxito",
					"removeEmailToMinimumStorageAlert": "Correo electrónico eliminado con éxito"
				},
				"productFeatureStore": {
					"createProductFeature": "Característica del producto creada con éxito!",
					"createProductFeatureTemplate": "¡Modelo de funcionalidad del producto creado con éxito!",
					"editProductFeature": "¡Característica del producto editada con éxito!",
					"editProductFeatureTemplate": "Plantilla de funcionalidad del producto editada con éxito!",
					"org": "ORG",
					"removeProductFeature": "¡Funcionalidad del producto eliminada con éxito!",
					"removeProductFeatureTemplate": "¡La plantilla de funcionalidad del producto se eliminó con éxito!",
					"removeProductFeaturesByTemplateId": "¡Las características del producto vinculadas a la plantilla se eliminaron con éxito!",
					"zig": "ZIG"
				},
				"promotionStore": {
					"createPromotion": "Promoción creada con éxito",
					"editPromotion": "Promoción editada con éxito",
					"updatePromotionPeople": "Clientes actualizados con éxito",
					"usersInfoRewriteLoading": "Obteniendo datos del cliente, esto puede llevar mucho tiempo",
					"deletePromotion": "Promoción eliminada con éxito"
				},
				"relationStore": {
					"activateOrDeactivateRelation_active": "Listas activadas con éxito",
					"activateOrDeactivateRelation_deactive": "Lista desactivada con éxito",
					"addRelationUser": "¡Invitado añadido con éxito!",
					"deleteMultipleRelation_one": "Lista eliminada con éxito",
					"deleteMultipleRelation_other": "Listas eliminadas con éxito",
					"deleteRelation": "Lista eliminada con éxito",
					"deleteRelationUser": "Usuario eliminado de la lista con éxito ",
					"editRelation": "¡Información de la lista editada con éxito!",
					"editRelationUser": "Invitado editado con éxito!"
				},
				"reserveStore": {
					"addReserve": "Paquete creado con éxito",
					"createReserveTemplate": "¡Plantilla de paquete creada con éxito!",
					"deleteReserve": "Paquete eliminado con éxito",
					"editReserve": "Paquete modificado con éxito"
				},
				"smsStore": {
					"cancelSmsCampaign": "Horario cancelado",
					"editSmsCampaignClients": "Grupo de destinatarios cambiado"
				},
				"vendorStore": {
					"createVendor": "Vendedor creado con éxito",
					"editVendor": "Proveedor editado con éxito"
				},
				"whatsUpStore": {
					"setPlaceDetailStatus_active": "Ubicación activa en Zig App",
					"setPlaceDetailStatus_inactive": "Colocar inactivo en la aplicación Zig "
				}
			},
			"alphabeticalOrder": "Orden alfabético",
			"lastEventOrder": "Último evento creado",
			"initialDefaultDateOrder": "Filtro de fecha predeterminado",
			"rechargeManagement": {
				"title": "Gestión del saldo",
				"titleWithPeriod": "Recargas de los últimos {{period}} días",
				"titleWithoutPeriod": "Recargas",
				"editButton": "Editar saldo seleccionados",
				"statusSelect": "Estado",
				"statusPlaceholder": "Filtrar por estado",
				"employeesSelect": "Empleado que creó",
				"employeesPlaceholder": "Filtrar por empleado",
				"clientSearch": "Documento de cliente",
				"clientPlaceholder": "Filtrar por cliente",
				"period": "Período",
				"editTitle_other": "Editando {{value}} saldos",
				"editTitle_one": "Editando saldo",
				"save": "Guardar cambios",
				"validPlace": "Lugares donde los saldos son válidos",
				"validPlacePlaceholder": "Haga clic para seleccionar ubicaciones. Todas las ubicaciones válidas anteriormente perderán su validez si no están en esta selección, excepto la ubicación donde se realizó originalmente la recarga",
				"expirationDate": "Fecha de vencimiento",
				"valid": "Válido por más {{value}} días",
				"expireToday": "Expira hoy",
				"expired": "Caducó hace {{value}} días",
				"required": "Campo requerido",
				"columns": {
					"id": "ID",
					"date": "Fecha de creación",
					"method": "método de pago",
					"author": "Empleado que creó",
					"user": "Cliente",
					"totalValue": "Valor",
					"expiresAt": "Fecha de vencimiento",
					"validPlaces": "válido en lugares",
					"status": "Estado",
					"rechargeType": "Tipo",
					"minimumConsumption": "Consumo Temprano",
					"bonus": "Bonificación",
					"recharge": "Recargar"
				},
				"activeLabel": "Válido",
				"expiredLabel": "Caducada",
				"refundedLabel": "Reembolsado",
				"emptyTitle": "No hubo saldos",
				"emptySubtitle": "No hubo saldos en el período seleccionado",
				"warningMessage": "Esta recarga se seguirá utilizando <b>aunque aparezca invertida en el historial</b> hasta que el cliente se vuelva a registrar si ya está en su ZigTag.",
				"hasBonusOrMinimumConsumptionPlaceIdsError": "Edición de Places bloqueadas para bonificación y consumo temprano",
				"hasBonusOrMinimumConsumptionexpiresAtError": "Para Consumo Temprano, edición sólo para fechas vencidas",
				"editAllButton": "Editar todos los saldos",
				"editAllMessage": "¿Está seguro de que desea editar todos los saldos?",
				"editAllConfirm": "Sí, ve a editar",
				"order": "Orden",
				"asc": "Más antiguo",
				"desc": "Lo último"
			},
			"transactionTypes": {
				"recharge": "Recarga",
				"transaction": "Transacción",
				"ficha": "Ficha",
				"canceled": "Cancelada",
				"refund": "Reembolso"
			},
			"maxSearchPeriod": "El período máximo de búsqueda es de 31 días",
			"exportExcel": {
				"success": "Email con exportación enviada exitosamente.",
				"title": "Informe de exportación",
				"label": "Por favor ingrese su correo electrónico para enviar la hoja de cálculo",
				"error": "Ingrese un correo electrónico válido",
				"placeholder": "Ingrese su correo electrónico"
			}
		},
		"precharge": {
			"report": {
				"precharge": "Precarga",
				"edit": "Editar sitio",
				"showSite": "Ver sitio",
				"costumersTitle": "{{value}} personas",
				"costumersDescription": "Precargaron",
				"ticketsDescription": "Boleto promedio",
				"collectedDescription": "Cantidad cobrada",
				"redeemedDescription": "Valor canjeado",
				"maleTitle": "{{value}} hombres",
				"femaleTitle": "{{value}} mujeres",
				"otherTitle": "{{value}} otros",
				"paymentMethod": "Método de pago",
				"value": "Valor",
				"prechargePerDay": "Precargas por día",
				"date": "Fecha",
				"dateHour": "Fecha/Hora",
				"name": "Nombre",
				"document": "Documento",
				"email": "Email",
				"bonus": "Bonificación",
				"cardSymmary": "Tarjeta usada",
				"cardBrand": "Bandera de tarjeta",
				"filter": {
					"title": "Filtro",
					"emptyFilter": "Haga clic para filtrar",
					"modal": {
						"inputPlaceholder": "Escriba aquí",
						"selectPlaceholder": "Seleccione aquí",
						"descriptionEnd": "para filtrar transacciones"
					},
					"modalOptions": {
						"terminal": {
							"label": "Terminal",
							"title": "Número de terminal",
							"description": "Ingrese el número de terminal"
						},
						"clientDocument": {
							"label": "Documento del cliente",
							"title": "CPF o número de documento",
							"description": "Ingrese el CPF o número de documento del cliente"
						},
						"employee": {
							"label": "Empleado",
							"title": "Nombre del empleado",
							"description": "Ingrese el nombre del empleado"
						},
						"zigCode": {
							"label": "Zig Code",
							"description": "Ingrese el número de Zig Code"
						},
						"paymentMethod": {
							"label": "Método de pago",
							"description": "Seleccione un método de pago"
						},
						"transactionType": {
							"label": "Tipo de transacción",
							"description": "Seleccione un tipo de transacción"
						},
						"bar": {
							"label": "Filtrar por barra",
							"title": "Barra",
							"description": "Seleccione una barra"
						}
					}
				},
				"print": "Imprimir informe",
				"table": {
					"id": "ID",
					"date": "Fecha",
					"syncDate": "Sincronizar fecha",
					"type": "Tipo",
					"employee": "Empleado",
					"terminal": "Terminal",
					"deviceId": "ID del dispositivo",
					"zigCode": "Zig Code",
					"bar": "Barra",
					"client": "Cliente",
					"product": "Producto",
					"quantity": "Cantidad",
					"source": "Fuente",
					"paymentMethod": "Método de pago",
					"status": "Estado",
					"document": "Documento",
					"acquirer": "Adquirente",
					"acquirerTransactionId": "Adquiriendo ID de transacción",
					"cardBrand": "Bandera de tarjeta",
					"nsu": "NSU",
					"nsuHost": "NSU Host",
					"authorizationCode": "Código de autorización",
					"bin": "Bin",
					"service": "Servicio",
					"value": "Valor",
					"hawkerDocument": "Documento ambulante",
					"hawkerName": "Nombre ambulante"
				},
				"transactionTypes": {
					"recharge": "Recarga",
					"transaction": "Transacción",
					"ficha": "Ficha",
					"canceled": "Cancelada",
					"refund": "Reembolso"
				},
				"maxSearchPeriod": "El período máximo de búsqueda es de 31 días",
				"exportExcel": {
					"success": "Email con exportación enviada exitosamente.",
					"title": "Informe de exportación",
					"label": "Por favor ingrese su correo electrónico para enviar la hoja de cálculo",
					"error": "Ingrese un correo electrónico válido",
					"placeholder": "Ingrese su correo electrónico"
				}
			},
			"bonusCategories": {
				"title": "Categorías de bonificación"
			}
		},
		"products": {
			"productArea": {
				"titles": {
					"productArea": "Área del producto",
					"editProduct": "Editar producto",
					"addInput": "Agregar otra entrada",
					"editTechnicalSheet": "Editar ficha técnica"
				},
				"tabs": {
					"productDetail": "Detalles do producto",
					"technicalSheet": "Ficha técnica"
				}
			},
			"productDetail": {
				"isActive": "Producto activo",
				"isInactive": "Producto inactivo",
				"buttonEditProduct": "Editar prodcuto",
				"variable": "Variable",
				"modalDeleteProduct": {
					"titleModal": "Confirmación requerida",
					"confirmDeleteProduct": "¿Desea eliminar el producto: {{productName}}?"
				},
				"sectionsCards": {
					"productDetail": "Detalles del producto",
					"fiscalData": "Datos fiscales",
					"cardProductSoldBy": "Producto vendido por g/ml",
					"cardProductMountable": "Producto edificable",
					"releaseValue": "Valor de liberación",
					"conversionRule": "Regla de conversión"
				},
				"duplicateProductMountable": "Duplicar producto ensamblado",
				"contentsSection": {
					"contentFiscalData": {
						"fieldName": {
							"ncm": "NCM",
							"cest": "CEST",
							"fiscalProfile": "Perfil fiscal",
							"fiscalGroup": "Grupo fiscal",
							"fiscalCode": "SKU"
						},
						"contentProductDetail": {
							"fieldName": {
								"image": "Imagen",
								"name": "Nombre",
								"productType": "Tipo de producto",
								"unitOfMeasurement": "Stock controlado por",
								"category": "Categoría",
								"menuCategory": "Categoría del menú",
								"price": "Precio",
								"description": "Descripción",
								"drinkStyle": "Estilo de bebida",
								"alcoholContent": "Contenido de alcohol",
								"hasAlcohol": "Contiene alcohol",
								"hiddenZigApp": "No mostrar el producto en ZigApp",
								"sincMyTapp": "Sincronizar con MyTapp",
								"productReturn": "Producto retornable",
								"brand": "Marca",
								"variableValue": "Precio variable",
								"stockableProduct": "Producto almacenable",
								"preparationTime": "Tiempo de preparación",
								"preparationTimePlaceholder": "30 minutos"
							},
							"requiredField": "Campo obligatorio",
							"editImage": "Haz clic en la imagen para editar",
							"preparationTimeMustBeGreaterThanZero": "El tiempo de preparación debe ser mayor que 0"
						},
						"infoMessageMyTapp": "No es posible desactivar esta función mientras esté activo el modo 'Sincronizar con My Tapp'.",
						"requiredField": "Campo obligatorio",
						"validationMessage": {
							"ncm": "El NCM debe contener 8 dígitos",
							"cest": "El CEST debe contener 7 dígitos",
							"fiscalCode": "En caso de no ser completado, el código será generado automáticamente",
							"patternFiscalCode": "Números, letras, puntos y guiones únicamente"
						},
						"infoMessageManualcest": "¿Agregar CEST manualmente?"
					},
					"contentProductDetail": {
						"fieldName": {
							"image": "Imagen",
							"name": "Nombre",
							"productType": "Tipo de producto",
							"unitOfMeasurement": "Stock controlado por",
							"category": "Categoría",
							"menuCategory": "Categoría del menú",
							"price": "Precio",
							"description": "Descripción",
							"drinkStyle": "Estilo de bebida",
							"alcoholContent": "Contenido de alcohol",
							"hasAlcohol": "Contiene alcohol",
							"hiddenZigApp": "No mostrar el producto en ZigApp",
							"sincMyTapp": "Sincronizar con MyTapp",
							"productReturn": "Producto retornable",
							"brand": "Marca",
							"variableValue": "Precio variable",
							"stockableProduct": "Producto almacenable"
						},
						"requiredField": "Campo obligatorio",
						"editImage": "Haz clic en la imagen para editar"
					},
					"contentProportionalValue": {
						"quantity": "Cantidad",
						"unityMeasurement": "Unidad de medida",
						"requiredField": "Campo obligatorio",
						"infoMessageMyTapp": "No es posible desactivar esta función mientras esté activa la opción 'Sincronizar con My Tapp'.",
						"placeholder": {
							"quantity": "Ingrese una cantidad",
							"unitMeasurement": "Seleccione"
						},
						"optionsUnitMeasurement": {
							"ml": "Mililitros",
							"gm": "Gramos",
							"un": "Unidad"
						}
					},
					"contentProductMountable": {
						"labelStep": "Paso",
						"labelItems": "ÍTEMS",
						"labelTitleInfo": "INFORMACIÓN",
						"addNewItem": "Agregar otro ítem",
						"fields": {
							"labelRequiredField": "Campo obligatorio",
							"title": "Título",
							"pricing": "Precios",
							"max": {
								"title": "Máximo",
								"errorMessage": {
									"notNullable": "El valor máximo no puede ser cero",
									"cannotLessMinimum": "El valor máximo no puede ser menor que el valor mínimo"
								}
							},
							"min": {
								"title": "Mínimo",
								"errorMessage": {
									"cannotGreaterMaximum": "El valor mínimo no puede ser mayor que el valor máximo"
								}
							},
							"item": "Ítem",
							"SelectableMaxQuantity": "Cantidad máxima seleccionable",
							"AmountSlaughtered": {
								"title": "Cantidad sacrificada",
								"errorMessage": {
									"notNullable": "La cantidad sacrificada debe ser mayor que cero"
								}
							},
							"price": "Valor"
						},
						"modalToggleStatusItem": {
							"activeItem": "Activar ítem ensamblado",
							"deactiveItem": "Desactivar ítem ensamblado",
							"warningMessage": {
								"active": "¿Desea activar este ítem en otros productos ensamblados a los que pertenece?",
								"deactive": "¿Desea desactivar este ítem en otros productos ensamblados a los que pertenece?"
							}
						},
						"modalWarningMontable": {
							"excludeStep": "Excluir paso",
							"excludeItem": "Excluir ítem",
							"warningMessage": {
								"exludeLastStep": "No es posible excluir todos los pasos de un producto ensamblado.",
								"excludeLastItem": "No es posible excluir todos los ítems de un producto ensamblado."
							}
						}
					}
				},
				"bars": {
					"activeProducts": "Productos Activos",
					"addBar": "Añadir barra",
					"cancel": "Cancelar",
					"delete": "Borrar",
					"deleteBar": "Eliminar barra",
					"yesDeleteBar": "Si, eliminar barra",
					"deleteMessage": "La exclusión impactará la operación: los productos dejarán de ser visibles y las impresoras se desasociarán. Esta acción no se puede deshacer. ¿Desea continuar?",
					"editBar": "Barra de edición",
					"emptyMessage": "No hay elementos para mostrar",
					"inactiveProducts": "Productos Inactivos",
					"notifications": {
						"productActivated": "Producto activado correctamente",
						"productDeactivated": "Producto desactivado correctamente"
					},
					"transfer": {
						"noItems": "No hay elementos disponibles",
						"noCategoryFound": "No se encontró categoría para \"{{category}}\"",
						"noProductFound": "No se encontró producto para \"{{product}}\"",
						"noResultsFound": "No se encontraron resultados para la categoría \"{{category}}\" y el producto \"{{product}}\"",
						"selectProductsToActivate": "Seleccionar productos para activar",
						"selectProductsToDeactivate": "Seleccionar productos para desactivar",
						"inactiveProductTooltip": "Este producto no está activo en el lugar y no estará disponible para la venta en POS o impreso en pedidos de entrega"
					},
					"modal": {
						"addNewIp": "Agregar IP de impresora (Opcional)",
						"barName": "Nombre del bar",
						"barStock": "Inventario",
						"printerType": "Tipo",
						"printerOffline": "Offline",
						"numberOfLanes": "Número de vias",
						"numberOfLanesDescription": "Número de copias impresas en la impresora después del pedido.",
						"menu": "Menú",
						"logoFicha": "Logo en la ficha",
						"logoFichaInfo": "Caso não selecione uma logo para ficha no bar, a logo impressa na ficha será a do {{placeName}}",
						"logoFichaDescription": "Imagen que aparecerá impresa en la ficha.",
						"stockDescription": "El stock seleccionado será utilizado por este bar.",
						"menuDescription": "El cardápio seleccionado será utilizado por este bar.",
						"barNamePlaceholder": "Digite el nombre del bar",
						"barStockPlaceholder": "Seleccionar",
						"menuPlaceholder": "Seleccionar un o más cardápios",
						"saveModifiedBar": "Guardar cambios",
						"addBar": "Agregar barra",
						"errors": {
							"printerTypeRequired": "El campo tipo de impresora es obligatorio",
							"printerNameRequired": "El campo nombre de la impresora es obligatorio",
							"printerStockRequired": "El campo stock de la impresora es obligatorio",
							"pagesToPrintMin": "El número de copias debe ser al menos de {{min}}",
							"pagesToPrintMax": "El número de copias debe ser al máximo de {{max}}",
							"validIp": "El campo IP debe ser válido",
							"requiredField": "Campo obligatorio",
							"maxLength": "El campo debe tener no máximo {{max}} caracteres"
						}
					},
					"printerIps": "IP de la impresora",
					"search": "Buscar",
					"searchBarPlaceholder": "Buscar por nombre de la barra",
					"searchProductPlaceholder": "Buscar por producto",
					"searchCategoryPlaceholder": "Buscar por categoría de producto",
					"manageBar": "Gerenciar Bar",
					"menuTooltip": "Menú vinculado a esta barra",
					"stock": "Inventario:",
					"tableRangeSettings": {
						"card": {
							"barsLabel": "Imprimir en barras",
							"title": "Ambiente {{desde}} a {{a}}",
							"subtitle": "Tablas {{desde}} a {{a}}",
							"hideBtn": "Ocultar"
						},
						"deleteModal": {
							"title": "¿Desea eliminar este ambiente?",
							"messageLine1": "Las mesas asignadas también serán eliminadas, pero los datos asociados a ellas se mantendrán en sus informes.",
							"messageLine2": "No será posible deshacer esta acción.",
							"confirmBtn": "Sí, deseo eliminar"
						},
						"drawer": {
							"title": "Rango de mesa"
						},
						"form": {
							"addIntervalBtn": "Agregar otro ambiente",
							"bars": {
								"label": "Bares que imprimirán órdenes desde este entorno",
								"placeholder": "Buscar por nombre"
							},
							"environmentNameLabel": "Nombre del ambiente",
							"environmentNamePlaceholder": "Define un título para este grupo de mesas",
							"editingWarningTooltip": "No puedes agregar nuevos rangos en el modo de edición.",
							"errors": {
								"missingEnvironmentName": "Escriba el nombre del ambiente (rango {{número}})",
								"atLeastOneBar": "Debe seleccionar al menos una barra para imprimir los pedidos de las tablas anteriores. (rango {{número}})",
								"fromTableAlreadyUsed": "La primera tabla del rango (rango {{número}}) ya se usa en otro rango",
								"missingFromTable": "Escriba el número de la primera tabla del rango (rango {{número}})",
								"missingToTable": "Escriba el número de la última tabla del rango (rango {{número}})",
								"toTableAlreadyUsed": "La última tabla del rango (rango {{número}}) ya se usa en otro rango."
							},
							"generalWrapperLabel": "Rango {{número}}",
							"intervalWrapperLabel": "Rango de mesa",
							"removeIntervalBtn": "Eliminar rango",
							"status": {
								"errors": {
									"description": "No fue posible agregar el rango. Comprueba si no hay un número de tabla que ya se haya utilizado en otro rango.",
									"title": "Algo salió mal."
								},
								"success": {
									"titleCreating": "¡Rangos de tablas creados con éxito!",
									"titleEditing": "Actualizado correctamente"
								}
							}
						},
						"header": {
							"addBtn": "Agregar ambiente",
							"searchPlaceholder": "Buscar por bar"
						},
						"list": {
							"emptyState": {
								"title": "Aún no hay nada aquí",
								"subtitle": "No has agregado ambientes para tu establecimiento."
							}
						}
					}
				},
				"beerDispenser": {
					"emptyText": "No se encontró cerveza",
					"error": {
						"invalidIp": "Formato de IP inválido",
						"requiredField": "Campo requerido"
					},
					"ip": "IP",
					"modal": {
						"addBeerDispenser": "Añadir cerveza de barril",
						"deleteDispenser": "Eliminar cerveza de barril",
						"deleteText": "¿Está seguro de que desea eliminar la cerveza de barril <b>{{chopName}}</b>?",
						"dispenserIp": "IP de cerveza de barril",
						"editBeerDispenser": "Editar cerveza de barril",
						"name": "Nombre",
						"number": "Número",
						"product": "Producto",
						"productTooltip": "Solo productos en mililitros/litros"
					},
					"newBeerDispenser": "Nueva cerveza de barril",
					"number": "Número de grifo de cerveza",
					"product": "Producto",
					"searchPlaceholder": "Buscar",
					"title": "Cerveza de barril"
				},
				"personalizationSettings": {
					"personalizationSettings": "Configure y personalice sus menús",
					"description": "Aquí personalizarás la parte visual y configurarás la información que se mostrará en los menús. La personalización es única y se aplicará a todos los menús que tengas.",
					"yourActiveProducts": "Tus productos activos",
					"onlinePostPayment": "Paga en la mesa",
					"delivery": "Delivery",
					"dineIn": "Pedido en la mesa",
					"onlineTab": "Comanda en línea",
					"viewMenu": "Menú digital",
					"title": "Título",
					"placeName": "Nombre del lugar",
					"logo": "Logo",
					"coverImg": "Imagen de portada",
					"assignedImgInYourMenu": "La imagen asignada aparecerá en tu menú.",
					"infoImage": "Si no agregas una imagen, el encabezado de tu producto será el logo y el nombre del lugar.",
					"recommendations": "Recomendaciones",
					"highQualityImg": "Recomendamos que tu logo y la imagen de portada estén en alta calidad para una mejor aplicación.",
					"imgs": "Imágenes",
					"primaryColor": "Color destacado",
					"colors": "Colores",
					"contrastColor": "Color de Contraste",
					"secondaryColor": "Color Secundario",
					"saveCustomization": "Guardar personalización",
					"serviceInformation": "Información de servicio",
					"deliverySettings": "Configuraciones de entrega",
					"pickUpAddress": "Dirección de recogida",
					"generateQrCode": "Generar código QR",
					"state": "Estado",
					"select": "Seleccionar",
					"city": "Ciudad",
					"enterOrSelect": "Escribe o selecciona",
					"neighborhood": "Barrio",
					"neighborhoodName": "Escribe el nombre del barrio",
					"address": "Dirección",
					"street": "Nombre de la calle o avenida",
					"number": "Número",
					"complement": "Complemento",
					"typeOfFee": "Tipo de tarifa",
					"currentHold": "Espera actual",
					"holdPlaceholder": "15 minutos",
					"baseValue": "Valor base",
					"valuePerkm": "Valor por Km",
					"visible": "Dejar visible",
					"averageTime": "Tiempo promedio de espera",
					"status": "Estado (abierto o cerrado)",
					"copyOrTypeLink": "Pega o escribe el enlace aquí",
					"parameter": "Parámetro",
					"searchParameter": "Buscar parámetro",
					"parameterValue": "Valor del parámetro",
					"value": "Valor",
					"newQrCode": "Nuevo código QR",
					"importQrCode": "Importar código QR",
					"downloadQrCode": "Descargar código QR",
					"uniqueFee": "Única",
					"basePlusKm": "Base + Variable por Km",
					"perRatio": "Tarifa por radio",
					"addMoreFee": "Agregar otra tarifa",
					"fromTo": "De {{beginning}} a {{end}}",
					"time": "{{minutes}} minutos",
					"chairNumber": "Número de silla",
					"tableNumber": "Número de mesa",
					"roomNumber": "Número de habitación",
					"referencePoint": "Punto de referencia",
					"savedSuccessfully": "¡Actualizaciones guardadas con éxito!",
					"deliveryInfo": "Solicitar información de entrega (opcional)",
					"selectInfo": "Seleccione la información que necesita",
					"radiusUntil": "Radio hasta",
					"complementExample": "Ej: Tienda A",
					"chair": "silla",
					"table": "mesa",
					"room": "habitación",
					"reference": "referencia",
					"menu": "Menú",
					"selectProduct": "Seleccione el producto",
					"importSheet": "Importar hoja de cálculo para generar códigos QR",
					"importQrCodes": "Importar QrCodes",
					"somethingWentWrong": "Algo salió mal",
					"couldNotImportSheet": "No pudimos importar su hoja de cálculo. Verifique si sigue el modelo propuesto o solicite ayuda a nuestro soporte.",
					"importInstructions": "Después de importar, los códigos QR se descargarán automáticamente en sus descargas.",
					"configSlug": "Configura tu slug aquí",
					"generateMultipleQrCode": "Generar múltiples códigos QR"
				},
				"cmv": {
					"details": {
						"contributionMargin": "Margen de contribución",
						"cost": "Costo",
						"editProductPrice": "Cambio de precio",
						"markup": "Margen",
						"productSimulator": "Simulador CMV",
						"realCost": "Costo Real",
						"salePrice": "Precio de venta"
					},
					"searchPlaceholder": "Seleccione un producto o categoría",
					"searchProduct": "Encuentra un producto",
					"supply": {
						"columns": {
							"input": "Aporte",
							"loss": "Pérdida",
							"quantity": "Qty",
							"realCost": "costo real",
							"unitCost": "Costo unitario"
						}
					}
				},
				"combo": {
					"activateMultipleCombosButton": "Activar combos múltiples",
					"activatedMultipleCombos": "Combos activados",
					"activatedSingleCombo": "Combo activado",
					"addComboButton": "Añadir combinación",
					"addComboModal": {
						"add": " Agregar",
						"addCombo": "Añadir combinación",
						"cancel": "Cancelar",
						"category": "Categoría",
						"description": "Descripción",
						"edit": "Para editar",
						"editCombo": "Editar combinación",
						"errors": {
							"invalidValue": "Valor no válido",
							"obrigatoryField": "Este campo es obligatorio",
							"products": "El combo debe estar asociado con al menos un producto"
						},
						"fiscalData": "datos fiscales",
						"fiscalFields": {
							"cest": "CEST",
							"code": "SKU",
							"fiscalGroup": "grupo fiscal",
							"fiscalProfile": "perfil fiscal",
							"ncm": "NCM"
						},
						"include": "Incluir",
						"includeFiscal": "¿Incluir datos fiscales?",
						"name": "Nombre",
						"picture": "Fotografía:",
						"price": "Precio",
						"products": "Productos"
					},
					"columns": {
						"active": "Activo",
						"category": "Categoría",
						"description": "Descripción",
						"name": "combo",
						"price": "Precio",
						"products": "Productos"
					},
					"deactivatedMultipleCombos": "combos desactivados",
					"deactivatedSingleCombo": "Combo desactivado",
					"deleteCombo": "¿Desea eliminar el producto \"{{nombre}}\"?",
					"disableMultipleCombosButton": "Deshabilitar múltiples combos",
					"placeholder": "Filtrar combos",
					"table": {
						"active": "Activo",
						"category": "Categoría",
						"description": "Descripción",
						"fiscalInfo": "Este combo no tiene datos fiscales. Por lo tanto, los datos fiscales de sus productos serán considerados",
						"name": "Combo",
						"price": "Precio",
						"products": "Productos",
						"warning": "¡Aviso! Para que este combo esté disponible para la venta, configure su precio en el lateral"
					}
				},
				"editProducts": {
					"categoryChange": "Cambiar categoría:",
					"categoryNone": "Ninguno",
					"confirm": "¿Quiere modificar los siguientes productos?",
					"save": "Ahorrar",
					"title": "Editar producto",
					"typeChange": "Cambiar tipo:",
					"typeNone": " Ninguno"
				},
				"grabAndGo": {
					"activeProducts": "Productos activos para Grab and Go",
					"disabledProducts": "Productos desactivados para Grab and Go",
					"searchPlaceholder": "Filtrar productos"
				},
				"newAndEditProduct": {
					"cancelButton": "Cancelar",
					"confirmButton": "Confirmar",
					"errors": {
						"abvQuantity": "El porcentaje debe ser inferior a 100",
						"categoryId": "Elige o crea una categoría",
						"length": "máx. {{longitud}} caracteres",
						"name": "Usar solo caracteres válidos",
						"newCategory": "Crearás una nueva categoría",
						"productFeature": "Crearás una nueva categoría",
						"productFeatures": "Las funciones {{wrongFeatures}} no se completan correctamente",
						"productRules": "Hay entradas sin llenar",
						"proportionalQuantity": "La cantidad debe ser mayor que 0",
						"requiredField": "Este campo es obligatorio",
						"wrongSection": "El paso {{wrongStep}} no se completó correctamente.",
						"wrongSections": "Los pasos {{wrongSteps}} no se completaron correctamente.",
						"fiscalCode": "Solo números, puntos y letras"
					},
					"forms": {
						"details": {
							"beerABV": "ABV - Contenido de alcohol",
							"beerIbu": "IBU - International Bitterness Units",
							"beerBrand": "caducidad",
							"beerStyle": "Estilo de cerveza",
							"category": "Categoría",
							"description": "Descripción",
							"fiscalDataMessage": "El código del producto se generará automáticamente.",
							"hasAlcohol": "Contiene alcohol",
							"hasFiscalData": "Datos fiscales",
							"hasMountableProduct": "Producto montable",
							"hasProductRule": "Ficha de datos",
							"hasProportionalProduct": "Producto en g/ml",
							"isHiddenFromApp": "No mostrar el producto en la aplicación ZigApp",
							"measurement": "Stock controlado por",
							"menuCategory": "Categoría del menú",
							"beerIntegrationPlaceFeatureWarning": "Función deshabilitada. Póngase en contacto con el soporte para activarlo en el administrador..",
							"beerIntegrationDisabledWarning": "No es posible deshabilitar esta función con 'Sincronizar con {{integration}}' activo.",
							"beerIntegrationEnabledWarning": "No es posible activar esta función con 'Sincronizar con {{integration}}' activo.",
							"name": "Nombre del producto",
							"productReturn": "Producto retornable",
							"picture": "Fotografía",
							"price": " Precio",
							"priceIn": "Precio en",
							"selectType": "Seleccione un tipo de producto",
							"syncWithBeerIntegration": "Sincronizar con {{integration}}",
							"type": "tipo de producto",
							"variablePrice": "precio variable",
							"isSupplyToggle": "Insumo",
							"conversionRule": {
								"unit": "Unidad",
								"amount": "Cantidad",
								"unitMeansure": "Unidad de medida",
								"placeholderSelect": "Seleccionar",
								"convertionName": "Regla de conversión",
								"title": {
									"unitDefault": "Unidad de medida predeterminada",
									"unitConvertion": "Regla de conversión"
								},
								"field": {
									"quantity": "Cantidad",
									"unitMeansure": "Unidad de medida"
								},
								"resumeDescription": "equivale a:",
								"infoConvertionRule": "Crea una segunda unidad de medida para tu producto, permitiendo su movimiento de diferentes formas en tu inventario.",
								"warningConvertionRule": "La regla de conversión solo puede habilitarse cuando el producto esté controlado por unidad."
							}
						},
						"fiscal": {
							"cest": "CEST",
							"code": "SKU",
							"codeErrorMessage": "Si no se completa, el código se generará automáticamente",
							"fiscalGroup": "Grupo fiscal",
							"fiscalProfile": "Perfil fiscal",
							"fiscalCode": "SKU",
							"hasIcmsRetidoOptions": {
								"yes": "Sim, possui ICMS pago anteriormente por ST",
								"no": "Não, não possui ICMS pago anteriormente por ST"
							},
							"fiscalIcmsBaseCalculoRetSt": "Base de Cálculo do ICMS Retido na operação anterior",
							"fiscalIcmsValorSubistituto": "Valor do ICMS Próprio do Substituto",
							"fiscalIcmsAliquotaFinal": "Alíquota Suportada pelo Consumidor Final"
						},
						"placeholder": {
							"ncm": "Ingrese el NCM",
							"cestInput": "CEST",
							"cestSelect": "Seleccione el CEST",
							"fiscalProfile": "Seleccione el perfil fiscal",
							"fiscalGroup": "Seleccione el grupo fiscal",
							"fiscalCode": "Ingrese el SKU"
						},
						"infoMessageMyTapp": "No es posible desactivar esta función mientras esté activo el modo 'Sincronizar con My Tapp'.",
						"requiredField": "Campo obligatorio",
						"validationMessage": {
							"ncm": "El NCM debe contener 8 dígitos",
							"cest": "El CEST debe contener 7 dígitos",
							"fiscalCode": "En caso de no ser completado, el código será generado automáticamente",
							"patternFiscalCode": "Números, letras, puntos y guiones únicamente"
						},
						"infoMessageManualcest": "¿Agregar CEST manualmente?"
					},
					"contentProductDetail": {
						"fieldName": {
							"image": "Imagen",
							"name": "Nombre",
							"productType": "Tipo de producto",
							"unitOfMeasurement": "Unidad de medida",
							"category": "Categoría",
							"menuCategory": "Categoría del menú",
							"price": "Precio",
							"description": "Descripción",
							"drinkStyle": "Estilo de bebida",
							"alcoholContent": "Contenido de alcohol",
							"hasAlcohol": "Contiene alcohol",
							"hiddenZigApp": "No mostrar el producto en ZigApp",
							"sincMyTapp": "Sincronizar con MyTapp",
							"productReturn": "Producto retornable",
							"brand": "Marca",
							"variableValue": "Precio variable",
							"stockableProduct": "Producto almacenable",
							"preparationTime": "Tiempo de preparación",
							"preparationTimePlaceholder": "30 minutos"
						},
						"requiredField": "Campo obligatorio",
						"editImage": "Haz clic en la imagen para editar",
						"preparationTimeMustBeGreaterThanZero": "El tiempo de preparación debe ser mayor que 0"
					},
					"contentProportionalValue": {
						"quantity": "Cantidad",
						"unityMeasurement": "Unidad de medida",
						"requiredField": "Campo obligatorio",
						"infoMessageMyTapp": "No es posible desactivar esta función mientras esté activa la opción 'Sincronizar con My Tapp'.",
						"placeholder": {
							"quantity": "Ingrese una cantidad",
							"unitMeasurement": "Seleccione"
						},
						"optionsUnitMeasurement": {
							"ml": "Mililitros",
							"gm": "Gramos",
							"un": "Unidad"
						}
					},
					"contentProductMountable": {
						"labelStep": "Paso",
						"labelItems": "ÍTEMS",
						"labelTitleInfo": "INFORMACIÓN",
						"addNewItem": "Agregar otro ítem",
						"fields": {
							"labelRequiredField": "Campo obligatorio",
							"title": "Título",
							"pricing": "Precios",
							"max": {
								"title": "Máximo",
								"errorMessage": {
									"notNullable": "El valor máximo no puede ser cero",
									"cannotLessMinimum": "El valor máximo no puede ser menor que el valor mínimo"
								}
							},
							"min": {
								"title": "Mínimo",
								"errorMessage": {
									"cannotGreaterMaximum": "El valor mínimo no puede ser mayor que el valor máximo"
								}
							},
							"item": "Ítem",
							"SelectableMaxQuantity": "Cantidad máxima seleccionable",
							"AmountSlaughtered": {
								"title": "Cantidad sacrificada",
								"errorMessage": {
									"notNullable": "La cantidad sacrificada debe ser mayor que cero"
								}
							},
							"price": "Valor"
						},
						"modalToggleStatusItem": {
							"activeItem": "Activar ítem ensamblado",
							"deactiveItem": "Desactivar ítem ensamblado",
							"warningMessage": {
								"active": "¿Desea activar este ítem en otros productos ensamblados a los que pertenece?",
								"deactive": "¿Desea desactivar este ítem en otros productos ensamblados a los que pertenece?"
							}
						},
						"modalWarningMontable": {
							"excludeStep": "Excluir paso",
							"excludeItem": "Excluir ítem",
							"warningMessage": {
								"exludeLastStep": "No es posible excluir todos los pasos de un producto ensamblado.",
								"excludeLastItem": "No es posible excluir todos los ítems de un producto ensamblado."
							}
						}
					}
				}
			},
			"bars": {
				"activeProducts": "Productos Activos",
				"addBar": "Añadir barra",
				"cancel": "Cancelar",
				"delete": "Borrar",
				"deleteBar": "Eliminar barra",
				"deleteMessage": "¿Estás seguro de que quieres eliminar esta barra?",
				"editBar": "Barra de edición",
				"emptyMessage": "No hay elementos para mostrar",
				"inactiveProducts": "Productos Inactivos",
				"modal": {
					"barName": "Nombre de la barra",
					"barStock": "Material en barra",
					"addNewIp": "Agregar una nueva ip",
					"printerType": "Tipo",
					"printerOffline": "Offline",
					"numberOfLanes": "Número de vías",
					"numberOfLanesDescription": "Cantidad de vías impresas en la impresora después del pedido.",
					"menu": "Menú",
					"logoFicha": "Logo del comprobante",
					"logoFichaInfo": "Si no selecciona un logo para el comprobante en el bar, el logo impreso en el comprobante será el de {{placeName}}",
					"logoFichaDescription": "Imagen que aparecerá impresa en el comprobante.",
					"stockDescription": "El inventario seleccionado será utilizado por este bar.",
					"menuDescription": "El menú seleccionado será utilizado por este bar.",
					"barNamePlaceholder": "Escriba el nombre del bar",
					"barStockPlaceholder": "Seleccione",
					"menuPlaceholder": "Seleccione uno o más menús",
					"saveModifiedBar": "Guardar cambios",
					"addBar": "Añadir bar",
					"errors": {
						"printerTypeRequired": "El campo tipo de impresora es obligatorio",
						"printerNameRequired": "Campo nombre obligatorio",
						"printerStockRequired": "Campo inventario obligatorio",
						"pagesToPrintMin": "El campo N° de vías debe ser como mínimo {{min}}",
						"pagesToPrintMax": "El campo N° de vías debe ser como máximo {{max}}",
						"validIp": "El campo de IP debe ser válido",
						"requiredField": "Campo obligatorio",
						"maxLength": "El campo debe tener como máximo {{max}} caracteres",
						"pagseguroFieldsRequired": "Complete los datos de Pagseguro"
					},
					"addImage": "Agregar imagen",
					"fileTypeInfo": "Tipo de archivo: jpeg, pjpeg, png",
					"multiEc": {
						"alertTitle": "Atención",
						"warning": "Todos los terminales asociados a esta barra transaccionarán con la información proporcionada. Información incorrecta puede impedir transacciones!",
						"placeholder": "Escriba el",
						"pagseguroActivationCode": "Código de Activación Pagseguro",
						"checkBox": "Configurar terminales del cliente (EC del cliente)"
					}
				},
				"newBarButton": "Nueva barra",
				"printerIps": "ips de impresora",
				"kds": "Kds",
				"search": "Buscar",
				"searchBarPlaceholder": "Introduzca el nombre de la barra",
				"searchProductPlaceholder": "Nombre del producto",
				"searchCategoryPlaceholder": "Buscar por categoría de producto",
				"manageBar": "Bares",
				"stock": "Inventario:",
				"tableRangeSettings": {
					"card": {
						"barsLabel": "Imprimir en barras",
						"title": "Ambiente",
						"subtitle": "Tablas {{desde}} a {{a}}",
						"deleteBtn": "Eliminar ambiente"
					},
					"deleteModal": {
						"message": "¿Está seguro de que desea eliminar el intervalo de la tabla {{from}} a {{to}}? Esta acción no se puede deshacer.",
						"title": "Eliminar rango de tabla"
					},
					"drawer": {
						"title": "Configurar ambientes",
						"saveBtn": "Guardar"
					},
					"form": {
						"addIntervalBtn": "Agregar otro ambiente",
						"bars": {
							"label": "Bares que imprimirán órdenes desde este entorno",
							"placeholder": "Buscar por nombre"
						},
						"editingWarningTooltip": "No puedes agregar nuevos rangos en el modo de edición.",
						"errors": {
							"atLeastOneBar": "Debe seleccionar al menos una barra para imprimir los pedidos de las tablas anteriores. (rango {{número}})",
							"fromTableAlreadyUsed": "La primera tabla del rango (rango {{número}}) ya se usa en otro rango",
							"missingFromTable": "Escriba el número de la primera tabla del rango (rango {{número}})",
							"missingToTable": "Escriba el número de la última tabla del rango (rango {{número}})",
							"toTableAlreadyUsed": "La última tabla del rango (rango {{número}}) ya se usa en otro rango."
						},
						"generalWrapperLabel": "Rango {{número}}",
						"intervalWrapperLabel": "Rango de mesa",
						"removeIntervalBtn": "Eliminar rango",
						"status": {
							"errors": {
								"description": "No fue posible agregar el rango. Comprueba si no hay un número de tabla que ya se haya utilizado en otro rango.",
								"title": "Algo salió mal."
							},
							"success": {
								"titleCreating": "¡Rangos de tablas creados con éxito!",
								"titleEditing": "Actualizado correctamente"
							}
						}
					},
					"header": {
						"addBtn": "Agregar rango de tabla",
						"filter": {
							"label": "Filtrar por barra",
							"optionAllLabel": "Mostrar todo",
							"placeholder": "Seleccionar o buscar una barra"
						}
					},
					"tabs": {
						"generalSettings": "Configuraciones generales",
						"printByTableSettings": "Configurar impresión por mesa"
					}
				}
			},
			"beerDispenser": {
				"emptyText": "No se encontró cerveza",
				"error": {
					"invalidIp": "Formato de IP inválido",
					"requiredField": "Campo requerido"
				},
				"ip": "IP",
				"modal": {
					"addBeerDispenser": "Añadir cerveza de barril",
					"deleteDispenser": "Eliminar cerveza de barril",
					"deleteText": "¿Está seguro de que desea eliminar la cerveza de barril <b>{{chopName}}</b>?",
					"dispenserIp": "IP de cerveza de barril",
					"editBeerDispenser": "Editar cerveza de barril",
					"name": "Nombre",
					"number": "Número",
					"product": "Producto",
					"productTooltip": "Solo productos en mililitros/litros"
				},
				"newBeerDispenser": "Nueva cerveza de barril",
				"number": "Número de grifo de cerveza",
				"product": "Producto",
				"searchPlaceholder": "Buscar",
				"title": "Cerveza de barril"
			},
			"personalizationSettings": {
				"personalizationSettings": "Configure y personalice sus menús",
				"description": "Aquí personalizarás la parte visual y configurarás la información que se mostrará en los menús. La personalización es única y se aplicará a todos los menús que tengas.",
				"yourActiveProducts": "Tus productos activos",
				"onlinePostPayment": "Paga en la mesa",
				"delivery": "Delivery",
				"dineIn": "Pedido en la mesa",
				"onlineTab": "Comanda en línea",
				"viewMenu": "Menú digital",
				"title": "Título",
				"placeName": "Nombre del lugar",
				"logo": "Logo",
				"coverImg": "Imagen de portada",
				"assignedImgInYourMenu": "La imagen asignada aparecerá en tu menú.",
				"infoImage": "Si no agregas una imagen, el encabezado de tu producto será el logo y el nombre del lugar.",
				"recommendations": "Recomendaciones",
				"highQualityImg": "Recomendamos que tu logo y la imagen de portada estén en alta calidad para una mejor aplicación.",
				"imgs": "Imágenes",
				"primaryColor": "Color destacado",
				"colors": "Colores",
				"contrastColor": "Color de Contraste",
				"secondaryColor": "Color Secundario",
				"saveCustomization": "Guardar personalización",
				"serviceInformation": "Información de servicio",
				"deliverySettings": "Configuraciones de entrega",
				"pickUpAddress": "Dirección de recogida",
				"generateQrCode": "Generar código QR",
				"state": "Estado",
				"select": "Seleccionar",
				"city": "Ciudad",
				"enterOrSelect": "Escribe o selecciona",
				"neighborhood": "Barrio",
				"neighborhoodName": "Escribe el nombre del barrio",
				"address": "Dirección",
				"street": "Nombre de la calle o avenida",
				"number": "Número",
				"complement": "Complemento",
				"typeOfFee": "Tipo de tarifa",
				"currentHold": "Espera actual",
				"holdPlaceholder": "15 minutos",
				"baseValue": "Valor base",
				"valuePerkm": "Valor por Km",
				"visible": "Dejar visible",
				"averageTime": "Tiempo promedio de espera",
				"status": "Estado (abierto o cerrado)",
				"copyOrTypeLink": "Pega o escribe el enlace aquí",
				"parameter": "Parámetro",
				"searchParameter": "Buscar parámetro",
				"parameterValue": "Valor del parámetro",
				"value": "Valor",
				"newQrCode": "Nuevo código QR",
				"importQrCode": "Importar código QR",
				"downloadQrCode": "Descargar código QR",
				"uniqueFee": "Única",
				"basePlusKm": "Base + Variable por Km",
				"perRatio": "Tarifa por radio",
				"addMoreFee": "Agregar otra tarifa",
				"fromTo": "De {{beginning}} a {{end}}",
				"time": "{{minutes}} minutos",
				"chairNumber": "Número de silla",
				"tableNumber": "Número de mesa",
				"roomNumber": "Número de habitación",
				"referencePoint": "Punto de referencia",
				"savedSuccessfully": "¡Actualizaciones guardadas con éxito!",
				"deliveryInfo": "Solicitar información de entrega (opcional)",
				"selectInfo": "Seleccione la información que necesita",
				"radiusUntil": "Radio hasta",
				"complementExample": "Ej: Tienda A",
				"chair": "silla",
				"table": "mesa",
				"room": "habitación",
				"reference": "referencia",
				"menu": "Menú",
				"selectProduct": "Seleccione el producto",
				"importSheet": "Importar hoja de cálculo para generar códigos QR",
				"importQrCodes": "Importar QrCodes",
				"somethingWentWrong": "Algo salió mal",
				"couldNotImportSheet": "No pudimos importar su hoja de cálculo. Verifique si sigue el modelo propuesto o solicite ayuda a nuestro soporte.",
				"importInstructions": "Después de importar, los códigos QR se descargarán automáticamente en sus descargas.",
				"configSlug": "Configura tu slug aquí",
				"generateMultipleQrCode": "Generar múltiples códigos QR"
			},
			"cmv": {
				"details": {
					"contributionMargin": "Margen de contribución",
					"cost": "Costo",
					"editProductPrice": "Cambio de precio",
					"markup": "Margen",
					"productSimulator": "Simulador CMV",
					"realCost": "Costo Real",
					"salePrice": "Precio de venta"
				},
				"searchPlaceholder": "Seleccione un producto o categoría",
				"searchProduct": "Encuentra un producto",
				"supply": {
					"columns": {
						"input": "Aporte",
						"loss": "Pérdida",
						"quantity": "Qty",
						"realCost": "costo real",
						"unitCost": "Costo unitario"
					}
				}
			},
			"combo": {
				"activateMultipleCombosButton": "Activar combos múltiples",
				"activatedMultipleCombos": "Combos activados",
				"activatedSingleCombo": "Combo activado",
				"addComboButton": "Añadir combinación",
				"addComboModal": {
					"add": " Agregar",
					"addCombo": "Añadir combinación",
					"cancel": "Cancelar",
					"category": "Categoría",
					"description": "Descripción",
					"edit": "Para editar",
					"editCombo": "Editar combinación",
					"errors": {
						"invalidValue": "Valor no válido",
						"obrigatoryField": "Este campo es obligatorio",
						"products": "El combo debe estar asociado con al menos un producto"
					},
					"fiscalData": "datos fiscales",
					"fiscalFields": {
						"cest": "CEST",
						"code": "SKU",
						"fiscalGroup": "grupo fiscal",
						"fiscalProfile": "perfil fiscal",
						"ncm": "NCM"
					},
					"include": "Incluir",
					"includeFiscal": "¿Incluir datos fiscales?",
					"name": "Nombre",
					"picture": "Fotografía:",
					"price": "Precio",
					"products": "Productos"
				},
				"columns": {
					"active": "Activo",
					"category": "Categoría",
					"description": "Descripción",
					"name": "combo",
					"price": "Precio",
					"products": "Productos"
				},
				"deactivatedMultipleCombos": "combos desactivados",
				"deactivatedSingleCombo": "Combo desactivado",
				"deleteCombo": "¿Desea eliminar el producto \"{{nombre}}\"?",
				"disableMultipleCombosButton": "Deshabilitar múltiples combos",
				"placeholder": "Filtrar combos",
				"table": {
					"active": "Activo",
					"category": "Categoría",
					"description": "Descripción",
					"fiscalInfo": "Este combo no tiene datos fiscales. Por lo tanto, los datos fiscales de sus productos serán considerados",
					"name": "Combo",
					"price": "Precio",
					"products": "Productos",
					"warning": "¡Aviso! Para que este combo esté disponible para la venta, configure su precio en el lateral"
				}
			},
			"editProducts": {
				"categoryChange": "Cambiar categoría:",
				"categoryNone": "Ninguno",
				"confirm": "¿Quiere modificar los siguientes productos?",
				"save": "Ahorrar",
				"title": "Editar producto",
				"typeChange": "Cambiar tipo:",
				"typeNone": " Ninguno"
			},
			"grabAndGo": {
				"activeProducts": "Productos activos para Grab and Go",
				"disabledProducts": "Productos desactivados para Grab and Go",
				"searchPlaceholder": "Filtrar productos"
			},
			"newAndEditProduct": {
				"cancelButton": "Cancelar",
				"confirmButton": "Confirmar",
				"errors": {
					"abvQuantity": "El porcentaje debe ser inferior a 100",
					"categoryId": "Elige o crea una categoría",
					"length": "máx. {{longitud}} caracteres",
					"name": "Usar solo caracteres válidos",
					"newCategory": "Crearás una nueva categoría",
					"productFeature": "Crearás una nueva categoría",
					"productFeatures": "Las funciones {{wrongFeatures}} no se completan correctamente",
					"productRules": "Hay entradas sin llenar",
					"proportionalQuantity": "La cantidad debe ser mayor que 0",
					"requiredField": "Este campo es obligatorio",
					"wrongSection": "El paso {{wrongStep}} no se completó correctamente.",
					"wrongSections": "Los pasos {{wrongSteps}} no se completaron correctamente.",
					"fiscalCode": "Solo números, puntos y letras"
				},
				"forms": {
					"details": {
						"beerABV": "ABV - Contenido de alcohol",
						"beerIbu": "IBU - International Bitterness Units",
						"beerBrand": "caducidad",
						"beerStyle": "Estilo de cerveza",
						"category": "Categoría",
						"description": "Descripción",
						"fiscalDataMessage": "El código del producto se generará automáticamente.",
						"hasAlcohol": "Contiene alcohol",
						"hasFiscalData": "Datos fiscales",
						"hasMountableProduct": "Producto montable",
						"hasProductRule": "Ficha de datos",
						"hasProportionalProduct": "Producto en g/ml",
						"isHiddenFromApp": "No mostrar el producto en la aplicación ZigApp",
						"measurement": "Unidad de medida",
						"menuCategory": "Categoría del menú",
						"beerIntegrationPlaceFeatureWarning": "Función deshabilitada. Póngase en contacto con el soporte para activarlo en el administrador..",
						"beerIntegrationDisabledWarning": "No es posible deshabilitar esta función con 'Sincronizar con {{integration}}' activo.",
						"beerIntegrationEnabledWarning": "No es posible activar esta función con 'Sincronizar con {{integration}}' activo.",
						"name": "Nombre del producto",
						"productReturn": "Producto retornable",
						"picture": "Fotografía",
						"price": " Precio",
						"priceIn": "Precio en",
						"selectType": "Seleccione un tipo de producto",
						"syncWithBeerIntegration": "Sincronizar con {{integration}}",
						"type": "tipo de producto",
						"variablePrice": "precio variable",
						"isSupplyToggle": "Insumo",
						"isStockable": "Almacenable",
						"conversionRule": {
							"unit": "Unidad",
							"amount": "Cantidad",
							"unitMeansure": "Unidad de medida",
							"placeholderSelect": "Seleccionar",
							"convertionName": "Regla de conversión",
							"title": {
								"unitDefault": "Unidad de medida predeterminada",
								"unitConvertion": "Regla de conversión"
							},
							"field": {
								"quantity": "Cantidad",
								"unitMeansure": "Unidad de medida"
							},
							"resumeDescription": "equivale a:",
							"infoConvertionRule": "Crea una segunda unidad de medida para tu producto, permitiendo su movimiento de diferentes formas en tu inventario.",
							"warningConvertionRule": "La regla de conversión solo puede habilitarse cuando el producto esté controlado por unidad."
						}
					},
					"fiscal": {
						"cest": "CEST",
						"code": "SKU",
						"codeErrorMessage": "Si no se completa, el código se generará automáticamente",
						"fiscalGroup": "Grupo fiscal",
						"fiscalProfile": "Perfil fiscal",
						"ncm": "NCM"
					},
					"mountable": {
						"step": "Etapa",
						"addStep": "Agregar paso",
						"getDescriptionDialog": {
							"activate": "¿Quieres activar este artículo en los demás productos montables que compone?",
							"disable": "¿Desea deshabilitar este elemento en los otros productos montables que compone??"
						},
						"getTitleDialog": {
							"activate": "Activar elemento montable",
							"disable": "Deshabilitar elemento montable"
						},
						"information": "INFORMACIÓN",
						"itemsTitle": "ELEMENTOS",
						"infos": {
							"invalidValue": "valor no válido",
							"label": "Información",
							"max": "Max",
							"min": "Min",
							"precification": "Precios",
							"precificationErrorMessage": "Elige un método",
							"precificationSelect": {
								"average": "Promedio",
								"averageTooltip": "El promedio de los elementos seleccionados se incrementará",
								"higher": "valor más alto",
								"higherTooltip": "El valor más alto entre los artículos se agregará al valor del producto.",
								"label": "Elección...",
								"sum": "Adicional",
								"sumTooltip": "Cada elemento añadido se incrementará en el valor del producto"
							},
							"title": "Título",
							"titleErrorMessage": "Nombre inválido",
							"tooltipMax": "Máximo de elementos a seleccionar.",
							"tooltipMin": "Artículos mínimos a seleccionar.",
							"validateMaxMinErrors": {
								"maxBiggerThenMin": "El valor máximo debe ser mayor que el valor mínimo",
								"maxValueZero": "El valor máximo no puede ser igual a cero",
								"negativeValue": "No se permite valor negativo"
							}
						},
						"items": {
							"additionalItems": "Añadir otro elemento",
							"itemKey": "Artículo {{itemKey}}",
							"label": "Elementos",
							"maxQuantity": "Cantidad máxima seleccionable",
							"maxQuantityTooltip": "Número máximo de veces que se puede seleccionar este elemento en la sección",
							"storageCount": "Cantidad reducida",
							"storageCountErrorMessage": "Cantidad no válida",
							"storageCountTooltip": "Cantidad a descontar del stock por unidad.",
							"title": " Artículo",
							"titleErrorMessage": "No hay elementos seleccionados",
							"value": "Valor",
							"valueErrorMessage": "Valor adicional no válido"
						},
						"sheetHumanizeErrorMessage": {
							"default": "Hubo un error al importar la hoja",
							"emptyHeaderCell": "Falta el nombre en las columnas",
							"emptySheet": "Esta hoja de trabajo está vacía",
							"sheetPoorlyFormatted": "Formatee la hoja de cálculo para la fuente Calibri, tamaño 11, elimine espacios, saltos de línea innecesarios y negrita",
							"unidentifieldColumn": "Error de nombres de columna",
							"verifyBaseSheet": ", consulte la plantilla de hoja de cálculo de muestra o utilícela como hoja de cálculo base."
						},
						"sheetNameExample": "(ejemplo)",
						"sheetNameInvalid": "(inválido)",
						"sheetXlsxPicker": "Elige una hoja de trabajo"
					}
				},
				"supplies": {
					"pageTitle": "Suministros",
					"pageDescription": "Los suministros son todos los materiales que se utilizan para la producción de un determinado producto o para la creación de otro suministro. En esta pantalla es posible registrar y visualizar todos los suministros registrados en un lugar.",
					"searchPlaceholder": "Buscar suministros",
					"formErrors": {
						"supplyName": "El nombre del insumo debe ser completado",
						"conversionRule": "Los valores de la regla de conversión deben ser completados"
					},
					"table": {
						"name": "Nombre",
						"productionRule": "Recetas y producción",
						"conversionRule": "Regla de conversión",
						"hasProductionRule": "¿Tiene ficha técnica?",
						"actions": "Acciones",
						"clickToEdit": "Haz clic para editar",
						"sku": "SKU",
						"yieldPercentage": "Rendimiento",
						"links": "Productos y suministros vinculados",
						"stocks": "Inventarios"
					},
					"supplyActionModal": {
						"title": {
							"supply": "Vínculos del suministro",
							"stock": "Vínculos del inventario"
						},
						"description": {
							"supply": "Relación de registro con los cuales este ítem está vinculado",
							"stock": "Relación de inventarios donde el producto está presente"
						},
						"seeProductButton": "Ver producto",
						"seeStockButton": "Ver inventario"
					},
					"deleteWarning": "¿Estás seguro de que deseas eliminar este ítem?",
					"addSupplies": "Agregar suministro",
					"editSupplies": "Editar suministro",
					"importSupplies": "Importar suministros",
					"exportToExcel": "Exportar a Excel",
					"addSuppliesModal": {
						"name": "Nombre",
						"unitMeasure": "Unidad de medida",
						"units": "Unidades",
						"errorMessage": "Este campo es obligatorio",
						"yieldPercentage": "Rendimiento"
					},
					"suppliesErrorsTableColumns": {
						"supply": "Suministro",
						"error": "Error"
					},
					"importModal": {
						"title": "Importar suministro",
						"sheetFileName": "Suministros",
						"conclude": "Concluir",
						"buttonText": "Elige una hoja de cálculo"
					},
					"step": {
						"supply": "Suministro",
						"ingredients": "Ingredientes"
					},
					"addInputModal": {
						"title": "Agregar suministro",
						"supply": "Suministro o producto",
						"name": "Nombre",
						"placeholderName": "Introduce el nombre del suministro",
						"sku": "SKU",
						"placeholderSKU": "Introduce el SKU",
						"image": "Foto",
						"descriptionImage": "Imagen cuadrada o 500x500 píxeles",
						"yieldPercentage": "Rendimiento",
						"basicStorageUnit": "Unidad de medida",
						"placeholderBasicStorageUnit": "Introduce la unidad de medida",
						"aboutIngredients": "Sobre los ingredientes",
						"ingredientsInfo": "Rellena los campos de ingredientes solo si el producto es una receta que utiliza otros suministros. Por ejemplo, la salsa de tomate necesita ingredientes, pero el tomate no.",
						"selectInput": "Selecciona un suministro o producto",
						"quantity": "Cantidad",
						"loss": "Pérdida",
						"addIngredient": "Agregar ingrediente"
					},
					"productRule": {
						"title": "Ficha técnica - {{productName}}",
						"generatedQuantity": "Cantidad generada",
						"tooltipMessage": "Para cambiar la cantidad generada es necesario eliminar la ficha técnica y crearla nuevamente.",
						"form": {
							"product": "Producto",
							"quantity": "Cantidad",
							"loss": "Pérdida"
						},
						"addAnotherSupply": "Agregar otro suministro",
						"hasProductionRuleError": "Atención, esta ficha técnica tiene un error. Elimina la ficha técnica y agrégala nuevamente.",
						"warnings": {
							"emptySupplies": "Selecciona un suministro",
							"emptyQuantity": "Agrega la cantidad del suministro",
							"repeatEntry": "Has agregado suministros repetidos"
						}
					},
					"cancel": "Cancelar",
					"conclude": "Concluir",
					"erase": "Borrar",
					"remove": "Eliminar",
					"yes": "Sí",
					"no": "No",
					"yesCaps": "SÍ",
					"noCaps": "NO",
					"edit": "Editar",
					"delete": "Eliminar",
					"link": "Vínculo",
					"links": "Vínculos",
					"deleteSelectedSupplies": "Eliminar suministros seleccionados",
					"deleteSelectedItens": "Eliminar ítems seleccionados",
					"deleteSupply": "Eliminar suministro",
					"deleteItems": "Eliminar ítems",
					"importSupply": "Importar suministro",
					"import": "Importar",
					"confirmDeleteMessage": {
						"multiple": "Al confirmar la acción, eliminas permanentemente {{quantity}} suministros. ¿Deseas continuar?",
						"single": "Al confirmar la acción, eliminas permanentemente el suministro {{supply}}. ¿Deseas continuar?"
					},
					"viewRules": "Ver recetas",
					"viewConversionRule": "Ver regla",
					"doesNotHave": "No posee",
					"copiedSuccessfully": "Copiado con éxito",
					"cannotDeleteSupply": "No es posible eliminar porque el suministro está vinculado a otros productos"
				},
				"duplicateMountableProduct": {
					"duplicateMountable": "Duplicar Montable",
					"createNewProduct": "Crear Nuevo Producto",
					"createNewProductDescription": "Duplica el producto montable y edita un nuevo producto",
					"importDuplicateInBatch": "Importar Duplicado en Lote",
					"importDuplicateInBatchDescription": "Importa el paso montable para productos ya creados",
					"importDuplicate": "Importar Duplicado",
					"selectProductsDisclaimer": "Selecciona los productos para los cuales deseas importar los datos montables",
					"linkToProducts": "Vincular a Productos",
					"addProductsToMountable": "Añadir productos para agregar la parte montable",
					"addProductsCount": "Añadir {{countProducts}} productos",
					"duplicateConfirmation": "Confirmación de Duplicado",
					"selectedProducts": "Se han seleccionado {{countProducts}} producto(s) para duplicar los pasos montables.",
					"finishStep": "¿Deseas finalizar la adición de los pasos?",
					"finishStepNote": "NOTA: si se seleccionaron productos montables, sus pasos actuales serán reemplazados.",
					"backStage": "Regresar Etapa",
					"confirmDuplicate": "Confirmar Duplicado",
					"successMessage": "Se han añadido pasos montables en productos de la lista."
				},
				"technicalSheet": {
					"title": "Hoja técnica",
					"modalDelete": {
						"title": "Borrar ficha técnica",
						"text": "Al confirmar la acción, elimina definitivamente la ficha técnica. ¿Desea continuar?",
						"okText": "Sí, quiero eliminar la ficha técnica"
					},
					"addInput": {
						"columns": {
							"inputName": "Entrada",
							"count": "Cantidad",
							"unitCostValue": "Coste unitario",
							"totalCost": "Coste total",
							"actions": "Acciones"
						},
						"warnings": {
							"withoutInput": "Seleccione una entrada",
							"withoutQuantity": "Añadir una cantidad",
							"alreadyExist": "La entrada ya existe en la lista de entradas, seleccione una entrada diferente"
						},
						"inputName": "Entrada",
						"count": "Cantidad",
						"loss": "Pérdida",
						"value": "Coste",
						"price": "Precio",
						"add": "Agregar"
					},
					"proportionalValue": {
						"grams": "Gramos",
						"measurement": "Unidad medible",
						"mililiters": "Mililitros",
						"quantity": "La cantidad"
					}
				},
				"titles": {
					"add": "Agregar producto",
					"downloadQRCodeToSell": "Descargar código QR para vender",
					"edit": "Editar producto",
					"hasFiscalData": "Datos fiscales",
					"hasMountableProduct": "Producto montable",
					"hasProductRule": "Ficha de datos",
					"hasProportionalProduct": "Producto en g/ml",
					"productDetails": "Detalles de producto",
					"releaseValue": "Valor de liberación"
				},
				"undefined": "indefinido"
			},
			"productFeatureForm": {
				"fields": "Campos",
				"observation": "Observación",
				"org": "ORG",
				"selectHere": "Selecciona aquí...",
				"templatesOptionsPlaceholder": "Seleccionar plantilla",
				"typeHere": "Escriba aquí...",
				"validateMessage": "Este campo es obligatorio.",
				"zig": "ZIG"
			},
			"productsTab": {
				"activeAll": "activar todo",
				"activeAllQuestion": "¿Activar todo?",
				"addProductButton": "Agregar producto",
				"checkAllItems": "Seleccionar todos los productos ({{counter}})",
				"deleteProducts": "Quitar productos",
				"deleteSelect": "Eliminar seleccionado",
				"deleteSelectedProducts": "Eliminar seleccionado",
				"disableAll": "Desactivar todo",
				"disableAllQuestion": "¿Desactivar todo?",
				"downloadQrCodeAppSell": "Descargar códigos QR de ventas para la Zig App",
				"editProducts": "Editar productos",
				"editProductsViaExcel": "Editar productos a través de Excel",
				"exportToExcelButton": "Exportar a Excel",
				"findFiscalGroupError": "Grupo fiscal registrado no encontrado",
				"findFiscalProfileError": "Perfil fiscal registrado no encontrado",
				"getDescriptionDialogActive": "¿Quieres activar este producto en los productos montables que lo componen?",
				"getDescriptionDialogDisable": "¿Desea deshabilitar este producto en los productos montables que lo componen?",
				"getTitleDialogActive": "Activar producto",
				"getTitleDialogDisable": "Deshabilitar producto",
				"importModal": {
					"alertMessage": "¡Aviso! el valor de los productos es informado en centavos, ej: 123 equivale a R$ 1,23",
					"buttonText": "Elegir hoja",
					"downloadSheet": "Descargar hoja de cálculo",
					"import": "Importar",
					"sheetFileName": "Productos",
					"title": "Importar dispositivos de hoja de cálculo"
				},
				"filters": {
					"status": {
						"all": "Todos",
						"active": "Activo",
						"inactive": "Inactivo"
					}
				},
				"importProductsButton": "Importar productos en masa",
				"limitOver": "Límite por encima de {{limit}} seleccionado",
				"onDeleteMessage": {
					"cancelText": "No",
					"content": "¡Aviso! Los productos se eliminarán de forma permanente.",
					"okText": "Sí",
					"title_one": "¿Quieres eliminar {{counter}} producto?",
					"title_other": "¿Quieres eliminar {{counter}} productos?"
				},
				"onDeleteSelectProductsError": "¡Ups! Ha ocurrido un problema, inténtalo de nuevo",
				"productWithoutCategory": "Productos sin categoría de menú",
				"productsByCategory": "Productos por categoría",
				"searchLabel": "Buscar",
				"searchPlaceholder": "Buscar Productos...",
				"sortByCategory": "Ordenar por categoría",
				"sortByMenuCategory": "Ordenar por categoría de menú",
				"syncModal": {
					"activeSyncOptionCheckbox": "Activar productos sincronizados para venta a domicilio",
					"alertMessage": "Los productos que no estén en entrega serán creados con la misma información",
					"chooseTheVariablesCheckbox": {
						"all": "Todo",
						"category": "Categoría",
						"description": "Descripción",
						"mountableItems": "Artículos construibles",
						"name": "Nombre",
						"order": "Orden",
						"picture": "Fotografía",
						"price": "Precio",
						"subcategory": "Subcategoría",
						"title": "Elija las variables que se sincronizarán para los productos ya registrados en la entrega:"
					},
					"chooseYourMenusMultiSelect": "Elige tus menús",
					"successFeedback": "¡Éxito, todos los productos sincronizados!",
					"title": "sincronizar productos",
					"warningFeedback": "Algunos productos tenían problemas de sincronización.",
					"warningFeedbackTable": {
						"description": "Descripción",
						"type": "Type"
					}
				},
				"syncWithDelivery": "Sincronizar con la entrega",
				"tabTitle": "Productos",
				"table": {
					"active": "Activado",
					"activeBars": "Bares activos",
					"actions": "Acciones",
					"delete": "Borrar",
					"duplicate": "Duplicado",
					"edit": "Para editar",
					"fiscalData": "Datos fiscales",
					"hasProductionRule": "Ficha de datos",
					"mountableDescription": "Producto Montable",
					"name": "Producto",
					"noOption": "No",
					"onDeleteProductMessage": "¿Desea eliminar el producto {{productName}}?",
					"value": "Precio",
					"yesOption": "Sí",
					"variable": "variable",
					"fiscalCode": "SKU"
				},
				"testEmission": {
					"loadingText": "cargando Texto",
					"success": "Datos fiscales probados con éxito",
					"successDescription": "No se encontraron errores en los datos presentados.",
					"testing": "Probando {{currentTest}}/{{longitud}}",
					"titleError": "Ups, encontramos algunos errores",
					"titleSuccess": "Prueba de datos fiscales: éxito",
					"titleTesting": "Prueba de datos fiscales",
					"updating": "Actualizando productos..."
				},
				"testFiscalData": "Probar datos fiscales",
				"uncheckAllItems": "Deseleccionar todos los productos ({{counter}})",
				"xlsxPicker": {
					"cell": {
						"falseHasAlcohol": "FALSO",
						"trueHasAlcohol": "VERDADERO"
					},
					"columns": {
						"bars": "Barras",
						"category": "Categoría",
						"cest": "Fiscal - CEST",
						"description": "Descripción",
						"fiscalCode": "SKU",
						"fiscalProductGroup": "Fiscal - Grupo fiscal",
						"fiscalProfile": "Fiscal - Perfil fiscal",
						"hasAlcohol": "¿Contiene alcohol?",
						"id": "ID del Producto",
						"image": "Imagen",
						"kind": "Tipo de producto",
						"menuCategory": "categoría de menú",
						"name": "Nombre",
						"ncm": "Fiscal - MNC",
						"price": "Precio",
						"products": "productos",
						"variablePrice": "precio variable",
						"beerBrand": "Marca de cerveza",
						"beerStyle": "Estilo de cerveza",
						"beerAbv": "ABV - Contenido de alcohol",
						"isStockable": "Almacenable",
						"systemProductId": "Producto del Sistema",
						"fileName": "productos_{{placeName}}"
					},
					"sheetDownload": "Descargar tabla de muestra",
					"sheetFeedback": {
						"errorMessage": "Hoja de cálculo no válida, descárguela de nuevo y realice los cambios necesarios.",
						"successMessage": "¡Hoja de trabajo válida!"
					},
					"sheetHumanizeErrorMessage": {
						"default": "Hubo un error al importar la hoja",
						"emptyHeaderCell": "Falta el nombre en las columnas",
						"emptySheet": "Esta hoja de trabajo está vacía",
						"sheetPoorlyFormatted": "Formatee la hoja de cálculo para la fuente Calibri, tamaño 11, elimine espacios, saltos de línea innecesarios y negrita",
						"unidentifieldColumn": "Error de nombres de columna",
						"verifyBaseSheet": ", consulte la plantilla de hoja de cálculo de muestra o utilícela como hoja de cálculo base."
					},
					"sheetNameExample": "(ejemplo)",
					"sheetNameInvalid": "(inválido)",
					"sheetXlsxPicker": "Elige una hoja de trabajo"
				},
				"filters": {
					"status": {
						"all": "Todos",
						"active": "Activo",
						"inactive": "Inactivo"
					}
				}
			},
			"supplies": {
				"pageTitle": "Suministros",
				"pageDescription": "Los suministros son todos los materiales que se utilizan para la producción de un determinado producto o para la creación de otro suministro. En esta pantalla es posible registrar y visualizar todos los suministros registrados en un lugar.",
				"searchPlaceholder": "Buscar suministros",
				"table": {
					"name": "Nombre",
					"productionRule": "Recetas y producción",
					"hasProductionRule": "¿Tiene ficha técnica?",
					"actions": "Acciones",
					"clickToEdit": "Haz clic para editar",
					"sku": "SKU",
					"yieldPercentage": "Rendimiento",
					"links": "Productos y suministros vinculados",
					"stocks": "Inventarios"
				},
				"supplyActionModal": {
					"title": {
						"supply": "Vínculos del suministro",
						"stock": "Vínculos del inventario"
					},
					"description": {
						"supply": "Relación de registro con los cuales este ítem está vinculado",
						"stock": "Relación de inventarios donde el producto está presente"
					},
					"seeProductButton": "Ver producto",
					"seeStockButton": "Ver inventario"
				},
				"deleteWarning": "¿Estás seguro de que deseas eliminar este ítem?",
				"addSupplies": "Agregar suministro",
				"editSupplies": "Editar suministro",
				"importSupplies": "Importar suministros",
				"exportToExcel": "Exportar a Excel",
				"addSuppliesModal": {
					"name": "Nombre",
					"unitMeasure": "Unidad de medida",
					"units": "Unidades",
					"errorMessage": "Este campo es obligatorio",
					"yieldPercentage": "Rendimiento"
				},
				"suppliesErrorsTableColumns": {
					"supply": "Suministro",
					"error": "Error"
				},
				"importModal": {
					"title": "Importar suministro",
					"sheetFileName": "Suministros",
					"conclude": "Concluir",
					"buttonText": "Elige una hoja de cálculo"
				},
				"step": {
					"supply": "Suministro",
					"ingredients": "Ingredientes"
				},
				"addInputModal": {
					"title": "Agregar suministro",
					"supply": "Suministro o producto",
					"name": "Nombre",
					"placeholderName": "Introduce el nombre del suministro",
					"sku": "SKU",
					"placeholderSKU": "Introduce el SKU",
					"image": "Foto",
					"descriptionImage": "Imagen cuadrada o 500x500 píxeles",
					"yieldPercentage": "Rendimiento",
					"basicStorageUnit": "Unidad de medida",
					"placeholderBasicStorageUnit": "Introduce la unidad de medida",
					"aboutIngredients": "Sobre los ingredientes",
					"ingredientsInfo": "Rellena los campos de ingredientes solo si el producto es una receta que utiliza otros suministros. Por ejemplo, la salsa de tomate necesita ingredientes, pero el tomate no.",
					"selectInput": "Selecciona un suministro o producto",
					"quantity": "Cantidad",
					"loss": "Pérdida",
					"addIngredient": "Agregar ingrediente"
				},
				"productRule": {
					"title": "Ficha técnica - {{productName}}",
					"generatedQuantity": "Cantidad generada",
					"tooltipMessage": "Para cambiar la cantidad generada es necesario eliminar la ficha técnica y crearla nuevamente.",
					"form": {
						"product": "Producto",
						"quantity": "Cantidad",
						"loss": "Pérdida"
					},
					"addAnotherSupply": "Agregar otro suministro",
					"hasProductionRuleError": "Atención, esta ficha técnica tiene un error. Elimina la ficha técnica y agrégala nuevamente.",
					"warnings": {
						"emptySupplies": "Selecciona un suministro",
						"emptyQuantity": "Agrega la cantidad del suministro",
						"repeatEntry": "Has agregado suministros repetidos"
					}
				},
				"cancel": "Cancelar",
				"conclude": "Concluir",
				"erase": "Borrar",
				"remove": "Eliminar",
				"yes": "Sí",
				"no": "No",
				"yesCaps": "SÍ",
				"noCaps": "NO",
				"edit": "Editar",
				"delete": "Eliminar",
				"link": "Vínculo",
				"links": "Vínculos",
				"deleteSelectedSupplies": "Eliminar suministros seleccionados",
				"deleteSelectedItens": "Eliminar ítems seleccionados",
				"deleteSupply": "Eliminar suministro",
				"deleteItems": "Eliminar ítems",
				"importSupply": "Importar suministro",
				"import": "Importar",
				"confirmDeleteMessage": {
					"multiple": "Al confirmar la acción, eliminas permanentemente {{quantity}} suministros. ¿Deseas continuar?",
					"single": "Al confirmar la acción, eliminas permanentemente el suministro {{supply}}. ¿Deseas continuar?"
				},
				"viewRules": "Ver recetas",
				"doesNotHave": "No posee",
				"copiedSuccessfully": "Copiado con éxito",
				"cannotDeleteSupply": "No es posible eliminar porque el suministro está vinculado a otros productos"
			},
			"duplicateMountableProduct": {
				"duplicateMountable": "Duplicar Montable",
				"createNewProduct": "Crear Nuevo Producto",
				"createNewProductDescription": "Duplica el producto montable y edita un nuevo producto",
				"importDuplicateInBatch": "Importar Duplicado en Lote",
				"importDuplicateInBatchDescription": "Importa el paso montable para productos ya creados",
				"importDuplicate": "Importar Duplicado",
				"selectProductsDisclaimer": "Selecciona los productos para los cuales deseas importar los datos montables",
				"linkToProducts": "Vincular a Productos",
				"addProductsToMountable": "Añadir productos para agregar la parte montable",
				"addProductsCount": "Añadir {{countProducts}} productos",
				"duplicateConfirmation": "Confirmación de Duplicado",
				"selectedProducts": "Se han seleccionado {{countProducts}} producto(s) para duplicar los pasos montables.",
				"finishStep": "¿Deseas finalizar la adición de los pasos?",
				"finishStepNote": "NOTA: si se seleccionaron productos montables, sus pasos actuales serán reemplazados.",
				"backStage": "Regresar Etapa",
				"confirmDuplicate": "Confirmar Duplicado",
				"successMessage": "Se han añadido pasos montables en productos de la lista."
			},
			"technicalSheet": {
				"title": "Hoja técnica",
				"modalDelete": {
					"title": "Borrar ficha técnica",
					"text": "Al confirmar la acción, elimina definitivamente la ficha técnica. ¿Desea continuar?",
					"okText": "Sí, quiero eliminar la ficha técnica"
				},
				"addInput": {
					"columns": {
						"inputName": "Entrada",
						"count": "Cantidad",
						"unitCostValue": "Coste unitario",
						"totalCost": "Coste total",
						"actions": "Acciones"
					},
					"warnings": {
						"withoutInput": "Seleccione una entrada",
						"withoutQuantity": "Añadir una cantidad",
						"alreadyExist": "La entrada ya existe en la lista de entradas, seleccione una entrada diferente"
					},
					"inputName": "Entrada",
					"count": "Cantidad",
					"loss": "Pérdida",
					"quantity": "La cantidad",
					"value": "Coste",
					"price": "Precio",
					"add": "Agregar"
				},
				"proportionalValue": {
					"grams": "Gramos",
					"measurement": "Unidad medible",
					"mililiters": "Mililitros",
					"quantity": "La cantidad"
				}
			}
		},
		"bars": {
			"activeProducts": "Productos Activos",
			"addBar": "Añadir barra",
			"cancel": "Cancelar",
			"delete": "Borrar",
			"deleteBar": "Eliminar barra",
			"deleteMessage": "¿Estás seguro de que quieres eliminar esta barra?",
			"editBar": "Barra de edición",
			"emptyMessage": "No hay elementos para mostrar",
			"inactiveProducts": "Productos Inactivos",
			"modal": {
				"barName": "Nombre de la barra",
				"barStock": "Material en barra",
				"addNewIp": "Agregar una nueva ip",
				"printerType": "Tipo",
				"printerOffline": "Offline",
				"numberOfLanes": "Número de vías",
				"numberOfLanesDescription": "Cantidad de vías impresas en la impresora después del pedido.",
				"menu": "Menú",
				"logoFicha": "Logo del comprobante",
				"logoFichaInfo": "Si no selecciona un logo para el comprobante en el bar, el logo impreso en el comprobante será el de {{placeName}}",
				"logoFichaDescription": "Imagen que aparecerá impresa en el comprobante.",
				"stockDescription": "El inventario seleccionado será utilizado por este bar.",
				"menuDescription": "El menú seleccionado será utilizado por este bar.",
				"barNamePlaceholder": "Escriba el nombre del bar",
				"barStockPlaceholder": "Seleccione",
				"menuPlaceholder": "Seleccione uno o más menús",
				"saveModifiedBar": "Guardar cambios",
				"addBar": "Añadir bar",
				"errors": {
					"printerTypeRequired": "El campo tipo de impresora es obligatorio",
					"printerNameRequired": "Campo nombre obligatorio",
					"printerStockRequired": "Campo inventario obligatorio",
					"pagesToPrintMin": "El campo N° de vías debe ser como mínimo {{min}}",
					"pagesToPrintMax": "El campo N° de vías debe ser como máximo {{max}}",
					"validIp": "El campo de IP debe ser válido",
					"requiredField": "Campo obligatorio",
					"maxLength": "El campo debe tener como máximo {{max}} caracteres",
					"pagseguroFieldsRequired": "Complete los datos de Pagseguro"
				},
				"addImage": "Agregar imagen",
				"fileTypeInfo": "Tipo de archivo: jpeg, pjpeg, png",
				"multiEc": {
					"alertTitle": "Atención",
					"warning": "Todos los terminales asociados a esta barra transaccionarán con la información proporcionada. Información incorrecta puede impedir transacciones!",
					"placeholder": "Escriba el",
					"pagseguroActivationCode": "Código de Activación Pagseguro",
					"checkBox": "Configurar terminales del cliente (EC del cliente)"
				}
			},
			"newBarButton": "Nueva barra",
			"printerIps": "ips de impresora",
			"search": "Buscar",
			"searchBarPlaceholder": "Introduzca el nombre de la barra",
			"searchProductPlaceholder": "Nombre del producto",
			"stock": "Inventario:",
			"tableRangeSettings": {
				"card": {
					"barsLabel": "Imprimir en barras",
					"title": "Ambiente",
					"subtitle": "Tablas {{desde}} a {{a}}"
				},
				"deleteModal": {
					"message": "¿Está seguro de que desea eliminar el intervalo de la tabla {{from}} a {{to}}? Esta acción no se puede deshacer.",
					"title": "Eliminar rango de tabla"
				},
				"drawer": {
					"title": "Rango de mesa"
				},
				"form": {
					"addIntervalBtn": "Agregar otro ambiente",
					"bars": {
						"label": "Bares que imprimirán órdenes desde este entorno",
						"placeholder": "Buscar por nombre",
						"selectedBar": "bar seleccionado",
						"selectedBars": "bares seleccionados"
					},
					"editingWarningTooltip": "No puedes agregar nuevos rangos en el modo de edición.",
					"errors": {
						"atLeastOneBar": "Debe seleccionar al menos una barra para imprimir los pedidos de las tablas anteriores. (rango {{número}})",
						"fromTableAlreadyUsed": "La primera tabla del rango (rango {{número}}) ya se usa en otro rango",
						"missingFromTable": "Escriba el número de la primera tabla del rango (rango {{número}})",
						"missingToTable": "Escriba el número de la última tabla del rango (rango {{número}})",
						"toTableAlreadyUsed": "La última tabla del rango (rango {{número}}) ya se usa en otro rango."
					},
					"generalWrapperLabel": "Rango {{número}}",
					"intervalWrapperLabel": "Rango de mesa",
					"removeIntervalBtn": "Eliminar rango",
					"status": {
						"errors": {
							"description": "No fue posible agregar el rango. Comprueba si no hay un número de tabla que ya se haya utilizado en otro rango.",
							"title": "Algo salió mal."
						},
						"success": {
							"titleCreating": "¡Rangos de tablas creados con éxito!",
							"titleEditing": "Actualizado correctamente"
						}
					}
				},
				"header": {
					"addBtn": "Agregar rango de tabla",
					"filter": {
						"label": "Filtrar por barra",
						"optionAllLabel": "Mostrar todo",
						"placeholder": "Seleccionar o buscar una barra"
					}
				},
				"tabs": {
					"generalSettings": "Configuraciones generales",
					"printByTableSettings": "Configurar impresión por mesa"
				}
			}
		},
		"inventoryControl": {
			"title": "Inventario",
			"description": "El inventario tiene un papel muy relevante para el negocio, ya que ayuda en el control de las mercancías, además de identificar pérdidas y posibles extravíos.",
			"emptyState": {
				"title": "Aún no tienes inventario",
				"infoEmpty": "Haga clic en agregar crear inventario para comenzar",
				"addNewInventory": "Nuevo inventario"
			},
			"homeInventoryControl": {
				"title": "Inventario",
				"buttonCreate": "Crear inventario",
				"description": "El inventario de stock tiene un papel muy relevante para el negocio, ayudando en el control de las mercancías, además de identificar pérdidas y posibles extravíos.",
				"mostRecent": {
					"titleSection": "Más reciente"
				},
				"inventoryHistory": {
					"input": {
						"search": "Buscar por",
						"placeholder": "Título, stock o stockista"
					},
					"select": {
						"filterByPeriod": "Filtrar por período",
						"filterByStatus": "Filtrar por estado",
						"allStatus": "Todos los status"
					},
					"titleTableColumns": {
						"inventoryTitle": "Título del inventario",
						"lastEditor": "Último editor",
						"lastEdition": "Última edición",
						"stockist": "Depósito",
						"stock": "Existencia",
						"categories": "Categorías",
						"status": "Estado",
						"actions": "Acciones"
					}
				}
			},
			"cardInventoryControl": {
				"cardInfo": {
					"stockist": "Distribuidor:",
					"editedIn": "Editado en:",
					"status": "Estado:",
					"statusTag": {
						"approved": "Aprobado",
						"open": "En abierto",
						"in_review": "En revisión",
						"reopened": "Recontado"
					}
				}
			},
			"stepperInventoryControl": {
				"steps": {
					"config": "Configuración",
					"count": "Listar y contar",
					"adjustLoss": "Ajustes y pérdidas",
					"resumeInventory": "Resumen del inventario",
					"approval": "Aprobación"
				},
				"stepsDescription": {
					"count": "Guarde el inventario durante el llenado para no perder su progreso",
					"resumeInventory": "Revise los artículos contados antes de enviar"
				},
				"fieldRequired": "Campo obligatorio"
			},
			"stepsInventoryControl": {
				"config": {
					"labels": {
						"titleInventory": "Dale un título al inventario",
						"exampleTitleInventory": "ej: 'Inventario de bebidas'",
						"stockistName": "Nombre del almacenista",
						"selectStock": "Selecciona el stock para crear el inventario",
						"selectCategory": "Selecciona las categorías"
					},
					"inventoryPlaceholder": "Ingrese el título del inventario",
					"stockPlaceholder": "Clic para seleccionar",
					"categoryPlaceholder": "Haga clic para seleccionar categorías"
				},
				"count": {
					"labels": {
						"count": "Cantidad",
						"unit": "Unidad",
						"price": "Precio de costo",
						"amount": "Valor total",
						"deleteCategory": "Eliminar categoría",
						"deleteSelectedProducts": "Eliminar seleccionados",
						"inventoryItems": "Artículos del inventario",
						"deleteItems": "Eliminar elementos",
						"modalDescription": "Al confirmar la acción, eliminarás permanentemente {{amount}} {{itemLabel}} del inventario. ¿Deseas continuar?",
						"modalDeleteCategoryMessage": "Al confirmar la acción, la categoría {{category}} se eliminará permanentemente. ¿Desea continuar?",
						"modalDeleteProductMessage": "Al confirmar la acción, el producto {{product}} se eliminará permanentemente. ¿Desea continuar?",
						"deleteSelectedItems": "Eliminar elementos seleccionados",
						"searchProduct": "Buscar producto",
						"item": {
							"single": "elemento",
							"plural": "elementos"
						}
					},
					"invalidCountConverted": "La cantidad en este campo no debe exceder o ser igual a la cantidad máxima de conversión registrada.",
					"filter": {
						"byProduct": "Organizar por producto",
						"byCategory": "Organizar por categoría"
					},
					"notification": {
						"success": "Elementos eliminados correctamente.",
						"error": "Se produjo un error al eliminar los elementos. Por favor, inténtalo de nuevo más tarde."
					}
				},
				"resume": {
					"tableColumns": {
						"category": "Categoría",
						"quantity": "Cantidad",
						"difference": "Diferencia",
						"system": "Sistema",
						"product": "Producto",
						"systemQuantity": "Cantidad del sistema",
						"count": "Conteo",
						"countDifference": "Diferencia en cantidad",
						"monetaryDifference": "Diferencia en {{currencyNarrowSymbol}}",
						"unit": "Unidad",
						"action": {
							"label": "Acción",
							"adjust": "Ajustamiento",
							"loss": "Pérdida"
						}
					}
				},
				"adjustLoss": {
					"tableColumns": {
						"category": "Categoría",
						"quantity": "Cantidad",
						"difference": "Diferencia",
						"system": "Sistema",
						"product": "Producto",
						"systemQuantity": "Cantidad del sistema",
						"count": "Conteo",
						"countDifference": "Diferencia en cantidad",
						"monetaryDifference": "Diferencia en {{currencyNarrowSymbol}}",
						"unit": "Unidad",
						"action": {
							"label": "Acción",
							"adjust": "Ajustamiento",
							"loss": "Pérdida"
						}
					}
				},
				"approval": {
					"exportExcel": "Descargar en Excel",
					"inconsistencyInventory": {
						"products": "Productos",
						"sumOfPositiveDifferences": "Suma de diferencias positivas",
						"sumOfNegativeDifferences": "Suma de diferencias negativas",
						"inconsistenciesByQuantity": "5 principales inconsistencias por cantidad",
						"inconsistenciesByDiffences": "5 principales inconsistencias por valor",
						"checkedProducts": "Productos verificados"
					},
					"inputPlaceholder": "Buscar producto",
					"select": {
						"all": "Mostrar todos los elementos",
						"onlyNegativeDifference": "Solo productos con diferencia negativa",
						"onlyPositiveDifference": "Solo productos con diferencia positiva",
						"onlyWithoutDifference": "Solo productos sin diferencia"
					},
					"tableColumns": {
						"category": "Categoría",
						"quantity": "Cantidad",
						"difference": "Diferencia",
						"system": "Sistema",
						"product": "Producto",
						"systemQuantity": "Cantidad del sistema",
						"count": "Conteo",
						"countDifference": "Diferencia en cantidad",
						"monetaryDifference": "Diferencia en {{currencyNarrowSymbol}}",
						"unit": "Unidad",
						"action": {
							"label": "Acción",
							"adjust": "Ajustamiento",
							"loss": "Pérdida"
						}
					},
					"searchProduct": "Buscar producto"
				}
			},
			"wrapperInventoryControl": {
				"titleWrapper": "Crear nuevo inventario",
				"titleButtons": {
					"sendInventory": "Enviar inventario",
					"approveInventory": "Aprobar inventario",
					"retellInventory": "Recontar",
					"downloadInExcel": "Descargar en excel"
				},
				"placeholders": {
					"keywordSearch": "Buscar por categoría, código o producto"
				},
				"headerInfos": {
					"name": "Nombre",
					"inventoryTitle": "Título del inventario",
					"createAt": "Fecha de creación",
					"lastEdtion": "Última edición",
					"detailsInventory": "Detalles del inventario",
					"stockist": "Encargado del inventario",
					"totalProducts": "Total de productos",
					"categoriesSelected": "Categorías seleccionadas",
					"storageAndCategoriesSelected": "Almacenamiento y categorías",
					"storageSelected": "Almacén seleccionado",
					"status": "Estado"
				},
				"seeMoreDetails": "Ver más detalles",
				"drawerInfos": {
					"seeDetails": "Ver detalles"
				}
			},
			"updateStatusMessage": {
				"success": {
					"approved": {
						"title": "¡Inventario completado!",
						"message": "Inventario completado"
					},
					"in_review": {
						"title": "¡Inventario enviado para revisión!",
						"message": "El inventario será revisado por un responsable"
					}
				},
				"error": {
					"approved": {
						"title": "¡Vaya, algo salió mal!",
						"message": "Inventario no completado"
					},
					"in_review": {
						"title": "¡Vaya, algo salió mal!",
						"message": "Inventario no enviado para revisión"
					}
				},
				"actions": {
					"goHome": "Volver a la página de inicio",
					"backToResume": "Volver al resumen",
					"createAnotherInventory": "Crear otro inventario"
				}
			}
		},
		"barsAndSectors": {
			"title": "Bares",
			"description": "Gestiona y personaliza las configuraciones de inventario, impresoras y menús de los bares.",
			"barsAndSectors": "Bares y Sectores",
			"bars": "Bares",
			"sectors": "Sectores",
			"generalSettings": "Configuraciones Generales",
			"printByTableSettings": "Configuración de ambientes y mesas",
			"editSector": "Editar sector",
			"createSector": "Crear sector",
			"createNewSector": "Crear nuevo sector",
			"newSector": "Nuevo sector",
			"searchPlaceholderSector": "Buscar por nombre de sector o bar",
			"searchPlaceholderAccess": "Buscar por nombre de acceso",
			"sectorName": "Nombre del sector",
			"sectorBars": "Bares del sector",
			"accessControl": "Control de acceso",
			"createAccess": "Crear acceso",
			"newAccess": "Nuevo acceso",
			"editAccess": "Editar acceso",
			"createNewAccess": "Crear nuevo acceso",
			"accessName": "Nombre del acceso",
			"initialDate": "Inicio",
			"endDate": "Fin",
			"range": "Rango de ZigCards",
			"zigCardsId": "ID ZigCard",
			"downloadModel": "Descargar el modelo",
			"selectFile": "Seleccionar un archivo",
			"selectFileDescription": "Tipo de archivo [.xlsx, .xls] hasta [500 mb].",
			"removeFile": "Remover archivo",
			"createAccessSuccess": "Acceso creado con éxito",
			"editAccessSuccess": "Acceso editado con éxito",
			"name": "Nombre",
			"initialDateHour": "Fecha y hora inicial",
			"endDateHour": "Fecha y hora final",
			"deleteSector": "Excluir sector",
			"deleteSectorSubtitle": "¿Está seguro de que desea excluir el sector?",
			"deleteSectorSuccess": "Sector excluído con éxito",
			"editSectorSuccess": "Sector editado con éxito",
			"createSectorSuccess": "Sector creado con éxito",
			"deleteAccessPolicy": "Excluir acceso",
			"deleteAccessPolicySubtitle": "¿Está seguro de que desea excluir el acceso?",
			"deleteAccessPolicySuccess": "Acceso excluído con éxito",
			"editAccessPolicySuccess": "Acceso editado con éxito",
			"createAccessPolicySuccess": "Acceso creado con éxito",
			"importAccessPolicyTagsSuccess": "Ids importadas con éxito",
			"accesses": "Accesos",
			"sectorAccesses": "Accesos del sector",
			"modelFileName": "modelo-de-hoja-de-cálculo",
			"noSectors": "No hay sectores registrados",
			"tagIdsError": "Agregue al menos un ID de ZigCard",
			"onlySpacesError": "El campo no puede contener solo espacios",
			"seeZigCards": "Ver ZigCards"
		},
		"kds": {
			"emptyKdsDescription": "El KDS aún no ha sido creado. Cuando esté disponible, se mostrará aquí.",
			"editKds": "Tus cambios han sido guardados.",
			"title": "Administrar KDS",
			"subtitle": "Configura el KDS para mejorar y organizar las operaciones de tu cocina.",
			"createdAt": "Creado el",
			"seeKds": "Ver KDS",
			"linkedBar": "Bar vinculado",
			"basic": "Básico",
			"main": "Principal",
			"general": "General",
			"mainTooltip": "El KDS Principal centraliza el control de pedidos, permitiéndote cambiar estados, cancelar, ver cancelaciones y seguir todos los pedidos.",
			"basicTooltip": "El KDS Básico muestra todos los pedidos dirigidos a él con estado 'abierto' y 'completado', sin permitir modificaciones ni la visualización de cancelaciones.",
			"confirmModal": {
				"title": "Tienes cambios no guardados",
				"description": "Para salir de la página sin perder tu progreso, guarda tus cambios. Si continúas sin guardar, se perderán todos los cambios.",
				"close": "Salir sin guardar"
			},
			"form": {
				"name": "Nombre del KDS",
				"linkedBar": "Bar vinculado",
				"status": "Cambio de estado",
				"timeManagement": "Gestión del tiempo",
				"readyTimeOrderLabel": "Tiempo para que un pedido sea considerado listo",
				"standardTimeOrderLabel": "Tiempo estándar por pedido (min.)",
				"originOrder": "Origen del pedido (delivery y otras integraciones)",
				"orderNumber": "Número de pedido",
				"customerName": "Nombre del cliente",
				"saveChanges": "Guardar cambios",
				"generalSettings": "Configuraciones generales",
				"timeSettings": "Configuraciones de tiempo",
				"orderCardSettings": "Configuraciones de la tarjeta de pedido"
			},
			"statusChangeTypes": {
				"auto": "Automáticamente",
				"manual": "Manual"
			},
			"timeManagementTypes": {
				"byProduct": "Usar tiempo por producto de la integración",
				"defaultTime": "Usar un estándar por pedido",
				"noManagement": "No usar tiempo"
			},
			"reports": {
				"title": "Informe",
				"description": "Sigue el rendimiento general de producción de tus KDS.",
				"averageAssemblyOrder": "Tiempo promedio de montaje de pedidos",
				"productionBySector": "Sector con mayor tiempo de producción",
				"top10FastestProducts": "Top 10 productos más rápidos",
				"slowestProducts": "Productos con mayor tiempo de producción",
				"top10LongestOrders": "Top 10 pedidos más largos",
				"order": "Pedido",
				"averageProductionTime": "Promedio de tiempo de producción de pedidos",
				"highestSectorProduction": "Sector con mayor tiempo de producción",
				"orderTable": {
					"orderNumber": "Número de pedido",
					"customer": "Cliente",
					"origin": "Origen",
					"local": "Ubicación",
					"date": "Fecha/hora"
				},
				"resumeDrawer": {
					"order": "Pedido",
					"title": "Resumen del pedido",
					"date": "Fecha y hora",
					"customer": "Cliente",
					"originOrder": "Origen del pedido",
					"locationOrder": "Ubicación del pedido",
					"table": {
						"quantity": "Cant.",
						"product": "Producto",
						"sector": "Sector",
						"time": "Tiempo"
					}
				},
				"noItemFound": "Ningún artículo encontrado"
			},
			"zigKds": {
				"title": "Gestión de KDS",
				"description": "Gestiona tus KDS, vincula productos a pantallas y rastrea pedidos.",
				"searchPlaceholder": "Buscar por...",
				"createNew": "Crear nuevo",
				"card": {
					"linkedBarLabel": "Bar(es) vinculado(s):",
					"linkedProductsLabel": "Productos Vinculados",
					"editButton": "Editar",
					"addScreenButton": "Agregar pantalla",
					"editScreen": "Editar pantalla",
					"deleteScreen": "Eliminar pantalla",
					"primary": "Primario",
					"secondary": "Secundario"
				},
				"emptyState": {
					"createNewKds": "Crear un nuevo KDS",
					"title": "Ningún KDS configurado aún",
					"description": "Aún no tienes ningún KDS. Registra y configura uno para rastrear tus pedidos en pantallas.",
					"noSearchResults": {
						"title": "KDS no encontrado",
						"description": "No encontramos ningún KDS con los términos buscados. Intenta ajustar tu búsqueda."
					}
				},
				"deleteScreenModal": {
					"title": "Eliminar pantalla",
					"confirmText": "¿Estás seguro de que deseas <highlight>eliminar</highlight> la pantalla {{screenName}}?",
					"warningText": "Al confirmar, todos los productos asociados a esta pantalla serán eliminados.",
					"cancelButton": "Volver",
					"confirmButton": "Confirmar"
				},
				"drawer": {
					"createTitle": "Crear nuevo KDS",
					"editTitle": "Editar KDS",
					"backButton": "Volver",
					"saveButton": "Guardar",
					"deleteButton": "Eliminar KDS"
				},
				"deleteKdsModal": {
					"title": "Eliminar KDS",
					"confirmText": "¿Estás seguro de que deseas <highlight>eliminar</highlight> el KDS {{kdsName}}?",
					"warningText": "Al confirmar, todas las pantallas vinculadas y productos asociados a este KDS serán eliminados.",
					"backButton": "Volver",
					"confirmButton": "Confirmar"
				},
				"configForm": {
					"kdsNameLabel": "Nombre del KDS",
					"kdsNamePlaceholder": "Describe el nombre del nuevo KDS",
					"linkedBarsLabel": "Bar(es) vinculado(s)",
					"linkedBarsPlaceholder": "Selecciona uno o más bares para vincular",
					"productsDisplayedLabel": "Productos mostrados",
					"productsDisplayedDescription": "Lista de todos los productos del bar que pueden ser mostrados en este KDS.",
					"emptyProductsTitle": "Ningún producto mostrado aún",
					"emptyProductsBullet1": "Registra productos en el bar vinculado para que aparezcan aquí.",
					"emptyProductsBullet2": "Vincula este KDS a un bar para cargar los productos.",
					"goToBarsButton": "Ir a bares y sectores",
					"products": "productos"
				},
				"tabs": {
					"configuration": "Configuración",
					"statusAndTime": "Estado y Tiempo"
				},
				"generalSettings": {
					"timeManagementTitle": "Gestión de tiempo",
					"statusUpdateTitle": "Actualización del estado del pedido",
					"cardInfoTitle": "Información mostrada en la tarjeta del pedido"
				},
				"screensPanel": {
					"configuredScreensLabel": "Pantallas configuradas",
					"addScreenButton": "Agregar pantalla",
					"unsavedWarningTitle": "KDS Principal No Guardado",
					"unsavedWarningMessage": "Para poder <strong>editar o agregar nuevas pantallas</strong>, necesitas <strong>guardar la configuración del KDS Principal a continuación.</strong>",
					"productsLabel": "Productos"
				},
				"productsPreview": {
					"searchPlaceholder": "Buscar por producto o categoría",
					"loadingMessage": "Cargando productos...",
					"noResultsMessage": "No se encontraron productos para la búsqueda.",
					"noProductsMessage": "No se encontraron productos para el bar seleccionado."
				},
				"settings": {
					"timeSettings": {
						"timerEnabled": {
							"label": "Cronómetro de tiempo del pedido",
							"description": "Cuenta el tiempo del pedido desde la creación hasta ser finalizado."
						},
						"productionTimeEnabled": {
							"label": "Tiempo de producción por producto",
							"description": "Muestra el tiempo estimado de preparación de cada producto."
						}
					},
					"cardInfoSettings": {
						"showOrderNumber": {
							"label": "Número del pedido",
							"description": "Muestra el identificador único del pedido."
						},
						"showOrigin": {
							"label": "Origen",
							"description": "Indica de dónde se realizó el pedido (POS, delivery, etc.)."
						},
						"showOrderTime": {
							"label": "Hora del pedido",
							"description": "Muestra la hora en que se creó el pedido"
						},
						"showCustomerTable": {
							"label": "Cliente/Mesa",
							"description": "Muestra el nombre del cliente o el número de mesa."
						},
						"showProductionTimeCard": {
							"label": "Tiempo de producción por producto",
							"description": "Muestra el tiempo estimado de preparación de cada artículo."
						},
						"showObservation": {
							"label": "Observación",
							"description": "Muestra observaciones adicionales del pedido."
						}
					},
					"statusModeOptions": {
						"manual": {
							"label": "Manual",
							"description": "Permite avanzar el estado del pedido manualmente"
						},
						"automatic": {
							"label": "Automático",
							"description": "Permite avanzar el estado del pedido después de un tiempo definido"
						}
					}
				},
				"notifications": {
					"kdsCreated": "KDS creado exitosamente",
					"kdsEdited": "KDS editado exitosamente",
					"kdsDeleted": "KDS eliminado exitosamente",
					"screenDeleted": "Pantalla eliminada exitosamente"
				}
			}
		}
	}
}
